/* eslint-disable */
import axios from "axios"
import BulkCandidateStageModal, { applicationId } from "./BulkCandidateStageModal"
import Multiselect from "multiselect-react-dropdown"
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react"
import DataTable from "react-data-table-component"
import {
  FaBusinessTime,
  FaChevronDown,
  FaHistory,
  FaMinus,
  FaPencilAlt,
  FaDownload,
  FaPlus,
  FaRegEdit,
  FaRegEye,
  FaRegTrashAlt,
  FaRedo,
    FaTimes, FaNewspaper,  
    FaPhoneAlt,
    FaWhatsapp,
    FaEnvelopeOpenText,
    FaRegEnvelope,
    FaInfoCircle,
    FaChartBar ,
    FaCog,
    FaCopy,
    FaTimesCircle,
    FaFilePdf,
    FaFileWord,
    FaPlug
} from "react-icons/fa"
import { FiMail, FiPhone, FiBriefcase } from "react-icons/fi";
import { IoIosSend } from "react-icons/io"
import "suneditor/dist/css/suneditor.min.css";
import { VscOpenPreview } from "react-icons/vsc";
import { Link, useLocation, useNavigate } from "react-router-dom"
import { convertISTtoEST, convertUTCtoEST,getUTCDateOnly   } from "ATSComponents/Common/TimeUtils" // adjust path
import {
  Button,
  Card,
  Col,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Button as RSButton,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap"
import Swal from "sweetalert2"
import { hasLegacyWordDocument } from "utils/fileValidation"

import CompanySelector from "ATSComponents/Common/CompanySelector"
import SuccessErrorPopup from "ATSComponents/Common/SuccessErrorPopup"
import EmailAC from "ATSComponents/Candidates/EmailAC"
import ResumePreviewPanel from "ATSComponents/Candidates/ResumePreviewPanel"
import PipelineHistoryTimeline from "ATSComponents/Candidates/PipelineHistoryTimeline"
import ScheduleInterviewDialog from "ATSComponents/Common/ScheduleInterviewDialog"
import { useForm } from "react-hook-form"

import UpgradePlanPopup from "common/Updradeplanpopup"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import deleteIcon from "../../assets/images/deleteIcon.png"
import documentIcon from "../../assets/images/documentIcon.png"
import feedbackIcon from "../../assets/images/feedback.png"
import Select, { components } from "react-select";
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"
import SunEditor from "suneditor-react"
import JobScreeningResultsModal from "./JobOrderScreeninResultModal"
import JobInformationModal from "./JobInformationModal"
import { MdRateReview } from "react-icons/md"
import {
  formatActivityValue,
  getActivityChangeValue,
  getActivityDescription,
  trackActivity,
  readableActivityField,
} from "../../utils/activityLog"
import { deliveryErrorMessage, deliverySummaryMessage, isSuccessfulDelivery } from "../../utils/deliveryResult"

const TimelineChanges = ({ record }) => {
  const rawChangeDetails = record?.change_details && typeof record.change_details === "object"
    ? record.change_details
    : {}
  const metadataFields = record?.metadata?.fields
  const metadataChanges = record?.metadata?.changes
  const details = Object.keys(rawChangeDetails).length > 0
    ? rawChangeDetails
    : metadataFields && typeof metadataFields === "object"
      ? metadataFields
      : metadataChanges && typeof metadataChanges === "object"
        ? metadataChanges
        : {}
  const normalizedDetails = details.changes && typeof details.changes === "object"
    ? details.changes
    : details
  const fieldSource = normalizedDetails.fields && typeof normalizedDetails.fields === "object"
    ? normalizedDetails.fields
    : normalizedDetails
  const structuredKeys = new Set([
    "fields",
    "recruiters", "access_permissions", "screening_questions", "talent_scan_questions",
  ])
  const fieldChanges = Object.entries(fieldSource).filter(([field, change]) =>
    !structuredKeys.has(field) && !/(^|_)(id)$|company_id/i.test(field) &&
    getActivityChangeValue(change, "old") !== undefined &&
    getActivityChangeValue(change, "new") !== undefined &&
    JSON.stringify(getActivityChangeValue(change, "old")) !== JSON.stringify(getActivityChangeValue(change, "new"))
  )
  const dateFields = /date|close/i
  const idBackedFields = new Set(["department", "position", "workplace_types", "category", "reporting_manager", "agent"])
  const formatValue = (field, value) => {
    if (value === null || value === undefined || value === "") return "—"
    if (typeof value === "boolean") return value ? "Enabled" : "Disabled"
    if (idBackedFields.has(field) && (typeof value === "number" || /^\d+$/.test(String(value)))) return "Changed"
    if (dateFields.test(field)) {
      const slashDate = String(value).match(/^(\d{2})[/-](\d{2})[/-](\d{4})/)
      const date = slashDate
        ? new Date(`${slashDate[3]}-${slashDate[2]}-${slashDate[1]}T00:00:00`)
        : new Date(value)
      if (!Number.isNaN(date.getTime())) {
        return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
      }
    }
    if (Array.isArray(value)) return `${value.length} item${value.length === 1 ? "" : "s"} updated`
    if (typeof value === "object") return "Updated"
    return String(value)
  }
  const htmlFields = new Set(["job_description", "roles_responsibility"])
  const renderFieldValue = (field, value) => {
    if (!htmlFields.has(field) || typeof value !== "string" || !/<[a-z][\s\S]*>/i.test(value)) {
      return formatValue(field, value)
    }
    const plainText = value
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p\s*>/gi, "\n")
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/gi, " ")
      .replace(/&amp;/gi, "&")
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .replace(/\n{3,}/g, "\n\n")
      .trim()
    if (!plainText) return "—"
    if (plainText.length > 180) {
      return <details className="activity-html-details"><summary>View full text</summary><span>{plainText}</span></details>
    }
    return <span className="activity-html-text">{plainText}</span>
  }
  const formatDate = value => {
    if (!value) return "—"
    const slashDate = String(value).match(/^(\d{2})[/-](\d{2})[/-](\d{4})/)
    const date = slashDate
      ? new Date(`${slashDate[3]}-${slashDate[2]}-${slashDate[1]}T00:00:00`)
      : new Date(value)
    return Number.isNaN(date.getTime())
      ? String(value)
      : date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
  }
  const formatTime = (value, timeZone) => {
    if (!value) return "—"
    const raw = String(value)
    const date = raw.includes("T") || raw.includes(" ") ? new Date(raw) : new Date(`1970-01-01T${raw}`)
    if (Number.isNaN(date.getTime())) return raw
    try {
      return new Intl.DateTimeFormat("en-US", {
        hour: "numeric", minute: "2-digit", hour12: true, ...(timeZone ? { timeZone } : {}),
      }).format(date)
    } catch {
      return raw
    }
  }
  const formatDateTime = (value, timeZone) => {
    if (!value) return "—"
    if (Number.isNaN(new Date(value).getTime())) return String(value)
    return `${formatDate(value)} ${formatTime(value, timeZone)}`
  }
  const readableValue = value => {
    if (value === null || value === undefined || value === "") return "—"
    if (typeof value === "boolean") return value ? "Enabled" : "Disabled"
    if (Array.isArray(value)) return value.map(item => personName(item) || String(item)).join(", ") || "—"
    if (typeof value === "object") return "Updated"
    return String(value)
  }
  const interview = details.interview && typeof details.interview === "object" ? details.interview : null
  const outreach = details.outreach && typeof details.outreach === "object" ? details.outreach : null
  const interviewChanges = interview?.changes || interview?.updated_fields || {}
  const interviewBefore = interview?.before || {}
  const interviewAfter = interview?.after || {}
  const interviewChangeRows = Object.keys({ ...interviewBefore, ...interviewAfter, ...interviewChanges })
    .filter(field => !/id$/i.test(field) && field !== "candidate_id" && field !== "job_id")
    .map(field => {
      const change = interviewChanges[field]
      const before = change ? getActivityChangeValue(change, "old") : interviewBefore[field]
      const after = change ? getActivityChangeValue(change, "new") : interviewAfter[field]
      return { field, before, after }
    })
    .filter(row => row.before !== undefined && row.after !== undefined && JSON.stringify(row.before) !== JSON.stringify(row.after))
  const interviewInfo = interview ? [
    ["Action", interview.action || record?.action_type || "Interview Scheduled"],
    ["Candidate", interview.candidate_name || record?.candidate_name],
    ["Job", interview.job_title || record?.job_title],
    ["Interview Type", interview.interview_type || interview.type],
    ["Date", formatDate(interview.interview_date || interview.date)],
    ["Start Time", formatTime(interview.start_time, interview.time_zone || interview.timezone)],
    ["End Time", formatTime(interview.end_time, interview.time_zone || interview.timezone)],
    ["Time Zone", interview.time_zone || interview.timezone],
    ["Status", interview.status || "Scheduled"],
  ].filter(([, value]) => value !== undefined && value !== null && value !== "") : []
  const outreachInfo = outreach ? [
    ["Action", outreach.action || "Bulk Outreach Scheduled"],
    ["Recipient Count", outreach.recipient_count ?? outreach.recipients_count],
    ["Subject", outreach.subject],
    ["From Address", outreach.from_address || outreach.sender_email],
    ["Status", outreach.status],
    ["Sent At", outreach.sent_at || outreach.completed_at],
    ["Successful Count", outreach.successful_count ?? outreach.success_count],
    ["Failed Count", outreach.failed_count],
    ["Failed Recipients", Array.isArray(outreach.failed_recipients) ? outreach.failed_recipients.map(personName).filter(Boolean).join(", ") : outreach.failed_recipients],
    ["Failure Reason", outreach.failure_reason || outreach.error],
  ].filter(([, value]) => value !== undefined && value !== null && value !== "") : []
  const personName = item => item?.name || item?.full_name || item?.user_name ||
    item?.recruiter_name || item?.display_name || (typeof item === "string" ? item : "")
  const personList = value => (Array.isArray(value) ? value : value ? [value] : [])
    .map(personName).filter(Boolean)
  const recruiters = details.recruiters || {}
  const permissions = details.access_permissions?.changed || details.access_permissions || []
  const permissionRows = Array.isArray(permissions) ? permissions : Object.values(permissions)
  const screening = details.screening_questions || {}
  const talentScan = details.talent_scan_questions || {}
  const skillConfiguration = talentScan.skill_configuration || details.skill_configuration || details.skills || {}
  const normalizeConfigurationEntries = value => {
    if (Array.isArray(value)) {
      return value.map((item, index) => {
        const data = item && typeof item === "object" ? item : {}
        const label = data.skill_name || data.round_name || data.section || data.round || data.name || data.skill || `Group ${index + 1}`
        return {
          key: data.skill_id ?? data.id ?? `index-${index}`,
          label,
          data,
        }
      })
    }
    if (value && typeof value === "object") {
      return Object.entries(value).map(([key, item]) => ({
        key,
        label: item?.skill_name || item?.round_name || item?.section || item?.round || item?.name || item?.skill || key,
        data: item && typeof item === "object" ? item : {},
      }))
    }
    return []
  }
  const skillBeforeEntries = normalizeConfigurationEntries(skillConfiguration.before)
  const skillAfterEntries = normalizeConfigurationEntries(skillConfiguration.after)
  const skillChangeRows = []
  const skillKeys = [...new Set([...skillBeforeEntries.map(item => item.key), ...skillAfterEntries.map(item => item.key)])]
  skillKeys.forEach(key => {
    const beforeEntry = skillBeforeEntries.find(item => item.key === key)
    const afterEntry = skillAfterEntries.find(item => item.key === key)
    const before = beforeEntry?.data || {}
    const after = afterEntry?.data || {}
    const skill = afterEntry?.label || beforeEntry?.label || "Skill"
    const fields = ["skill_name", "rating", "proficiency", "question_count", "no_of_questions", "duration", "cutoff", "cutoff_score", "beginner", "intermediate", "advanced", "beginner_question_count", "intermediate_question_count", "advanced_question_count", "beginner_ratio", "intermediate_ratio", "advanced_ratio"]
    fields.forEach(field => {
      const oldValue = field === "skill_name" ? beforeEntry?.label : before[field]
      const newValue = field === "skill_name" ? afterEntry?.label : after[field]
      if (oldValue !== undefined && newValue !== undefined && JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
        skillChangeRows.push({ skill, field, oldValue, newValue })
      }
    })
  })
  const screeningRoundCounts = talentScan.screening_round_counts || details.screening_round_counts || {}
  const roundBefore = normalizeConfigurationEntries(screeningRoundCounts.before)
  const roundAfter = normalizeConfigurationEntries(screeningRoundCounts.after)
  const screeningRoundRows = []
  const roundKeys = [...new Set([...roundBefore.map(item => item.key), ...roundAfter.map(item => item.key)])]
  roundKeys.forEach(key => {
    const beforeEntry = roundBefore.find(item => item.key === key)
    const afterEntry = roundAfter.find(item => item.key === key)
    const before = beforeEntry?.data || {}
    const after = afterEntry?.data || {}
    const round = afterEntry?.label || beforeEntry?.label || "Round"
    ;["enabled", "is_enabled", "round_enabled", "question_count", "no_of_questions", "duration", "total_score", "cutoff_score"].forEach(field => {
      const oldValue = before[field]
      const newValue = after[field]
      if (oldValue !== undefined && newValue !== undefined && JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
        screeningRoundRows.push({ round, field, oldValue, newValue })
      }
    })
  })
  const talentScanSections = [
    ["Profiling Questions", "profiling"],
    ["Technical Questions", "technical"],
    ["Manual Questions", "manual"],
    ["Generated Questions", "generated"],
  ].map(([label, key]) => {
    const before = talentScan.before?.[key]
    const after = talentScan.after?.[key]
    return before !== undefined || after !== undefined ? { label, before, after } : null
  }).filter(item => item && JSON.stringify(item.before) !== JSON.stringify(item.after))
  const permissionRowsWithChanges = permissionRows.filter(row => {
    const oldPermissions = row?.old || row?.before
    const newPermissions = row?.new || row?.after
    if (oldPermissions && newPermissions) {
      return [...new Set([...Object.keys(oldPermissions), ...Object.keys(newPermissions)])]
        .some(key => !/id$/i.test(key) && JSON.stringify(oldPermissions[key]) !== JSON.stringify(newPermissions[key]))
    }
    return Object.entries(row?.changes || row?.permissions || {}).some(([key, value]) =>
      !/id$/i.test(key) && value && typeof value === "object" &&
      value.old !== undefined && value.new !== undefined &&
      JSON.stringify(value.old) !== JSON.stringify(value.new)
    )
  })
  const questionText = question => question?.text || question?.question_text || ""
  const questionList = value => (Array.isArray(value) ? value : value ? [value] : [])
    .filter(question => question && typeof question === "object")
  const hasDetails = fieldChanges.length || personList(recruiters.added).length ||
    personList(recruiters.removed).length || permissionRowsWithChanges.length ||
    questionList(screening.added).length || questionList(screening.edited).length ||
    questionList(screening.deleted).length || questionList(talentScan.generated).length ||
    questionList(talentScan.manual).length || questionList(talentScan.screening).length ||
    skillChangeRows.length || screeningRoundRows.length || talentScanSections.length ||
    interviewInfo.length || outreachInfo.length
  const renderEventValue = (label, value, formatter = readableValue) => {
    const rendered = formatter(value)
    if ((label === "Subject" || label === "Failure Reason") && String(value).length > 100) {
      return <details className="activity-inline-details"><summary>View details</summary><span>{rendered}</span></details>
    }
    return rendered
  }
  const renderQuestions = (title, questions) => {
    const list = questionList(questions)
    if (!list.length) return null
    return (
      <section className="activity-detail-section">
        <h6>{title}</h6>
        <div className="activity-question-list">
          {list.map((question, index) => {
            const text = questionText(question) || "Question details unavailable"
            const beforeText = typeof question?.before === "object" ? question.before?.text : question?.before
            const afterText = typeof question?.after === "object" ? question.after?.text : question?.after
            return (
              <details className="activity-question" open key={`${title}-${index}`}>
                <summary>{text}</summary>
                <div className="activity-question-content">
                  {title.includes("Edited") && (beforeText !== undefined || afterText !== undefined) ? <>
                    <div><span>Before</span><strong>{beforeText || "Question details unavailable"}</strong></div>
                    <div><span>After</span><strong>{afterText || text || "Question details unavailable"}</strong></div>
                  </> : <div><span>Question</span><strong>{text || "Question details unavailable"}</strong></div>}
                  <div><span>Section</span><strong>{readableValue(question.section)}</strong></div>
                  <div><span>Skill</span><strong>{readableValue(question.skill)}</strong></div>
                  <div><span>Level</span><strong>{readableValue(question.level)}</strong></div>
                </div>
              </details>
            )
          })}
        </div>
      </section>
    )
  }

  if (!hasDetails) return <div className="activity-detail-empty">No detailed changes recorded.</div>
  return (
    <div className="activity-detail-sections">
      {interviewInfo.length > 0 && <section className="activity-detail-section">
        <h6>Interview Activity</h6>
        <div className="activity-event-table">
          {interviewInfo.map(([label, value]) => <div key={label}><span>{label}</span><strong>{renderEventValue(label, value, item => label === "Date" ? formatDate(item) : label.includes("Time") ? formatTime(item, interview.time_zone || interview.timezone) : readableValue(item))}</strong></div>)}
        </div>
        {interviewChangeRows.length > 0 && <div className="activity-update-table">
          <div className="activity-update-header"><span>Field</span><span>Before</span><span>After</span></div>
          {interviewChangeRows.map(row => <div key={row.field}><strong>{readableActivityField(row.field)}</strong><span>{row.field.includes("date") ? formatDate(row.before) : readableValue(row.before)}</span><span>{row.field.includes("date") ? formatDate(row.after) : readableValue(row.after)}</span></div>)}
        </div>}
      </section>}
      {outreachInfo.length > 0 && <section className="activity-detail-section">
        <h6>Bulk Outreach</h6>
        <div className="activity-event-table">
          {outreachInfo.map(([label, value]) => <div key={label}><span>{label}</span><strong>{renderEventValue(label, value, item => label === "Sent At" ? formatDateTime(item, outreach.time_zone || outreach.timezone) : readableValue(item))}</strong></div>)}
        </div>
      </section>}
      {fieldChanges.length > 0 && <section className="activity-detail-section">
        <h6>Field Changes</h6>
        <div className="activity-before-after-table">
          <div className="activity-table-header"><span>Field</span><span>Before</span><span>After</span></div>
          {fieldChanges.map(([field, change]) => (
            <div className="activity-table-row" key={field}>
              <strong>{readableActivityField(field)}</strong>
              <span>{renderFieldValue(field, getActivityChangeValue(change, "old"))}</span>
              <span>{renderFieldValue(field, getActivityChangeValue(change, "new"))}</span>
            </div>
          ))}
        </div>
      </section>}
      {skillChangeRows.length > 0 && <section className="activity-detail-section">
        <h6>Skill Configuration Changes</h6>
        <div className="activity-before-after-table skill-change-table">
          <div className="activity-table-header"><span>Skill</span><span>Field</span><span>Before</span><span>After</span></div>
          {skillChangeRows.map(row => <div className="activity-table-row" key={`${row.skill}-${row.field}`}>
            <strong>{row.skill}</strong><span>{readableActivityField(row.field)}</span><span>{formatValue(row.field, row.oldValue)}</span><span>{formatValue(row.field, row.newValue)}</span>
          </div>)}
        </div>
      </section>}
      {screeningRoundRows.length > 0 && <section className="activity-detail-section">
        <h6>Screening Round Configuration</h6>
        <div className="activity-before-after-table skill-change-table">
          <div className="activity-table-header"><span>Round</span><span>Field</span><span>Before</span><span>After</span></div>
          {screeningRoundRows.map(row => <div className="activity-table-row" key={`${row.round}-${row.field}`}>
            <strong>{row.round}</strong><span>{readableActivityField(row.field)}</span><span>{formatValue(row.field, row.oldValue)}</span><span>{formatValue(row.field, row.newValue)}</span>
          </div>)}
        </div>
      </section>}
      {(personList(recruiters.added).length || personList(recruiters.removed).length) > 0 && <section className="activity-detail-section">
        <h6>Recruiters</h6>
        <div className="activity-before-after-table recruiter-change-table">
          <div className="activity-table-header"><span>Action</span><span>Recruiter</span></div>
          {personList(recruiters.added).map(name => <div className="activity-table-row" key={`added-${name}`}><strong>Added</strong><span>{name}</span></div>)}
          {personList(recruiters.removed).map(name => <div className="activity-table-row" key={`removed-${name}`}><strong>Removed</strong><span>{name}</span></div>)}
        </div>
      </section>}
      {talentScanSections.length > 0 && <section className="activity-detail-section">
        <h6>TalentScan and Manual Questions</h6>
        <div className="activity-before-after-table talent-change-table">
          <div className="activity-table-header"><span>Section</span><span>Before</span><span>After</span></div>
          {talentScanSections.map(row => <div className="activity-table-row" key={row.label}>
            <strong>{row.label}</strong><span>{formatValue(row.label, row.before)}</span><span>{formatValue(row.label, row.after)}</span>
          </div>)}
        </div>
      </section>}
      {permissionRowsWithChanges.length > 0 && <section className="activity-detail-section">
        <h6>Access Permissions</h6>
        <div className="activity-before-after-table permission-change-table">
          <div className="activity-table-header"><span>User</span><span>Permission</span><span>Before</span><span>After</span></div>
          {permissionRowsWithChanges.map((row, index) => {
            const oldPermissions = row?.old || row?.before
            const newPermissions = row?.new || row?.after
            const entries = oldPermissions && newPermissions
              ? [...new Set([...Object.keys(oldPermissions), ...Object.keys(newPermissions)])]
                .filter(key => !/id$/i.test(key) && JSON.stringify(oldPermissions[key]) !== JSON.stringify(newPermissions[key]))
                .map(key => [key, { old: oldPermissions[key], new: newPermissions[key] }])
              : Object.entries(row?.changes || row?.permissions || {}).filter(([key, value]) =>
                !/id$/i.test(key) && value && typeof value === "object" &&
                value.old !== undefined && value.new !== undefined &&
                JSON.stringify(value.old) !== JSON.stringify(value.new)
              )
            if (!entries.length) return null
            return entries.map(([field, change]) => <div className="activity-table-row" key={`${row?.user_id || index}-${field}`}>
              <strong>{personName(row) || row?.user_name || "User"}</strong>
              <span>{readableActivityField(field)}</span>
              <span>{formatValue(field, getActivityChangeValue(change, "old"))}</span>
              <span>{formatValue(field, getActivityChangeValue(change, "new"))}</span>
            </div>)
          })}
        </div>
      </section>}
      {renderQuestions("Screening Agent Questions", screening.added)}
      {renderQuestions("Manual Questions Edited", screening.edited)}
      {renderQuestions("Manual Questions Deleted", screening.deleted)}
      {renderQuestions("AI Generated Questions", talentScan.generated)}
      {renderQuestions("Manual Questions Added", talentScan.manual)}
      {renderQuestions("First Screening Questions", talentScan.screening?.first || talentScan.screening?.first_screening)}
      {renderQuestions("Second Screening Questions", talentScan.screening?.second || talentScan.screening?.second_screening)}
    </div>
  )
}

const TimelineMetadata = ({ record }) => {
  const metadata = record?.metadata && typeof record.metadata === "object"
    ? Object.entries(record.metadata).filter(([key, value]) => key !== "changes" && value !== null && value !== "" && typeof value !== "object")
    : []
  if (!metadata.length) return null
  return (
    <div className="action-timeline-detail-grid">
      {metadata.map(([key, value]) => (
        <div className="action-timeline-detail" key={key}>
          <span>{readableActivityField(key)}</span>
          <strong>{formatActivityValue(value)}</strong>
        </div>
      ))}
    </div>
  )
}

const getTimelineAction = record => record?.action_type || record?.action || record?.event_type || "Action"
const getTimelineDate = record => record?.action_date || record?.created_at || record?.timestamp || "Date unavailable"
const getTimelineActor = record => record?.actioned_by_name || record?.created_by_name || record?.user_name || "System"

const isQuestionGenerationRecord = record =>
  ["TalentScan Questions Generated", "Screening Questions Generated"].includes(record?.action_type)

const QuestionGenerationDetails = ({ record }) => {
  const details = record?.change_details || {}
  const before = details.before && typeof details.before === "object" ? details.before : {}
  const after = details.after && typeof details.after === "object" ? details.after : {}
  const isTalentScan = record?.action_type === "TalentScan Questions Generated"
  const display = value => {
    if (value === null || value === undefined || value === "") return "—"
    if (typeof value === "boolean") return value ? "Enabled" : "Disabled"
    if (Array.isArray(value)) return `${value.length} item${value.length === 1 ? "" : "s"}`
    if (typeof value === "object") return "Updated"
    return String(value)
  }
  const normalizeQuestions = value => {
    if (Array.isArray(value)) return value.map(question => typeof question === "string" ? { text: question } : question).filter(Boolean)
    if (Array.isArray(value?.generated_questions)) return normalizeQuestions(value.generated_questions)
    return []
  }
  const groupQuestions = (value, groupKey) => {
    const groups = {}
    const add = (group, question) => {
      const normalized = typeof question === "string" ? { text: question } : question
      if (!normalized || typeof normalized !== "object") return
      const name = normalized[groupKey] || group || "Other"
      if (!groups[name]) groups[name] = []
      groups[name].push(normalized)
    }
    if (Array.isArray(value) || Array.isArray(value?.generated_questions)) {
      normalizeQuestions(value).forEach(question => add(question[groupKey], question))
    } else if (value && typeof value === "object") {
      Object.entries(value).forEach(([group, list]) => {
        if (Array.isArray(list)) list.forEach(question => add(group, question))
        else if (list?.questions && typeof list.questions === "object") {
          Object.entries(list.questions).forEach(([level, questions]) => {
            if (Array.isArray(questions)) questions.forEach(question => add(group, { text: question, level }))
          })
        }
      })
    }
    return Object.entries(groups).map(([name, questions]) => ({ name, questions }))
  }
  const questionText = question => question?.text || "Question details unavailable"
  const renderQuestionList = questions => (
    <ol className="question-activity-list">
      {questions.map((question, index) => <li key={index}>
        <strong>{questionText(question)}</strong>
        <span>Level: {display(question?.level)}</span>
        {question?.skill && <span>Skill: {display(question.skill)}</span>}
        {question?.section && <span>Section: {display(question.section)}</span>}
      </li>)}
    </ol>
  )
  const renderEditedQuestionList = questions => (
    <ol className="question-activity-list">
      {questions.map((question, index) => {
        const beforeText = typeof question?.before === "object" ? question.before?.text : question?.before
        const afterText = typeof question?.after === "object" ? question.after?.text : question?.after
        return <li key={index}>
          <strong>{questionText(question)}</strong>
          {(beforeText !== undefined || afterText !== undefined) && <>
            <span>Before: {beforeText || "Question details unavailable"}</span>
            <span>After: {afterText || questionText(question) || "Question details unavailable"}</span>
          </>}
          <span>Level: {display(question?.level)}</span>
          {question?.skill && <span>Skill: {display(question.skill)}</span>}
          {question?.section && <span>Section: {display(question.section)}</span>}
        </li>
      })}
    </ol>
  )
  const renderGroups = (title, beforeGroups, afterGroups) => {
    const names = [...new Set([...beforeGroups.map(group => group.name), ...afterGroups.map(group => group.name)])]
    if (!names.length) return null
    return <section className="question-activity-panel after">
      <h6>{title}</h6>
      <div className="question-activity-count-table">
        <div><span>{isTalentScan ? "Skill" : "Round"}</span><span>Before</span><span>After</span><span>Added</span><span>Deleted</span></div>
        {names.map(name => {
          const oldGroup = beforeGroups.find(group => group.name === name)
          const newGroup = afterGroups.find(group => group.name === name)
          const oldCount = oldGroup?.questions.length || 0
          const newCount = newGroup?.questions.length || 0
          return <div key={name}><strong>{name}</strong><span>{oldCount}</span><span>{newCount}</span><span>{Math.max(newCount - oldCount, 0)}</span><span>{Math.max(oldCount - newCount, 0)}</span></div>
        })}
      </div>
      {names.map(name => {
        const oldGroup = beforeGroups.find(group => group.name === name)
        const newGroup = afterGroups.find(group => group.name === name)
        if (!newGroup?.questions.length) return null
        const delta = newGroup.questions.length - (oldGroup?.questions.length || 0)
        return <div className="question-activity-group" key={`questions-${name}`}>
          <strong>{name}</strong>
          <span>{delta > 0 ? `${delta} questions added` : `${newGroup.questions.length} questions`}</span>
        </div>
      })}
    </section>
  }
  const screening = details.screening_questions || {}
  const talentScan = details.talent_scan_questions || {}
  const normalizeConfigEntries = value => {
    if (Array.isArray(value)) {
      return value.map((item, index) => {
        const data = item && typeof item === "object" ? item : {}
        return {
          key: data.skill_id ?? data.id ?? `index-${index}`,
          label: data.skill_name || data.round_name || data.section || data.round || data.name || data.skill || `Group ${index + 1}`,
          data,
        }
      })
    }
    if (value && typeof value === "object") {
      return Object.entries(value).map(([key, item]) => ({
        key,
        label: item?.skill_name || item?.round_name || item?.section || item?.round || item?.name || item?.skill || key,
        data: item && typeof item === "object" ? item : {},
      }))
    }
    return []
  }
  const comparisonRows = (beforeValue, afterValue, fields) => {
    const beforeEntries = normalizeConfigEntries(beforeValue)
    const afterEntries = normalizeConfigEntries(afterValue)
    const keys = [...new Set([...beforeEntries.map(item => item.key), ...afterEntries.map(item => item.key)])]
    return keys.flatMap(key => {
      const beforeEntry = beforeEntries.find(item => item.key === key)
      const afterEntry = afterEntries.find(item => item.key === key)
      const beforeData = beforeEntry?.data || {}
      const afterData = afterEntry?.data || {}
      const group = afterEntry?.label || beforeEntry?.label || "Group"
      return fields.flatMap(field => {
        const oldValue = field === "skill_name" ? beforeEntry?.label : beforeData[field]
        const newValue = field === "skill_name" ? afterEntry?.label : afterData[field]
        return oldValue !== undefined && newValue !== undefined && JSON.stringify(oldValue) !== JSON.stringify(newValue)
          ? [{ group, field, oldValue, newValue }]
          : []
      })
    })
  }
  const skillRows = comparisonRows(
    details.skill_configuration?.before || talentScan.skill_configuration?.before,
    details.skill_configuration?.after || talentScan.skill_configuration?.after,
    ["skill_name", "rating", "proficiency", "question_count", "no_of_questions", "duration", "cutoff", "beginner", "intermediate", "advanced", "beginner_question_count", "intermediate_question_count", "advanced_question_count", "beginner_ratio", "intermediate_ratio", "advanced_ratio"]
  )
  const screeningRoundRows = comparisonRows(
    talentScan.screening_round_counts?.before || details.screening_round_counts?.before,
    talentScan.screening_round_counts?.after || details.screening_round_counts?.after,
    ["enabled", "is_enabled", "round_enabled", "question_count", "no_of_questions", "duration", "total_score", "cutoff_score"]
  )
  const beforeScreening = groupQuestions(screening.before || before.question_settings, "section")
  const afterScreening = groupQuestions(screening.after || after.generated_questions, "section")
  const beforeTalent = groupQuestions(talentScan.before || before.skills, "skill")
  const afterTalent = groupQuestions(talentScan.after || after.generated_questions, "skill")
  const generated = Array.isArray(talentScan.generated) ? normalizeQuestions(talentScan.generated) : []
  // Keep question ownership explicit: manual additions come only from the
  // dedicated manual array, while edits and deletions come from screening.
  const manualAdded = Array.isArray(talentScan.manual) ? normalizeQuestions(talentScan.manual) : []
  const manualEdited = Array.isArray(screening.edited) ? normalizeQuestions(screening.edited) : []
  const manualDeleted = Array.isArray(screening.deleted) ? normalizeQuestions(screening.deleted) : []
  const hasDetails = skillRows.length || screeningRoundRows.length || beforeScreening.length || afterScreening.length || beforeTalent.length || afterTalent.length ||
    generated.length || manualAdded.length || manualEdited.length || manualDeleted.length
  const beforeTotal = [...beforeScreening, ...beforeTalent].reduce((total, group) => total + group.questions.length, 0)
  const snapshotAfterTotal = [...afterScreening, ...afterTalent].reduce((total, group) => total + group.questions.length, 0)
  const afterTotal = Math.max(snapshotAfterTotal, generated.length)
  const addedTotal = Math.max(afterTotal - beforeTotal, 0) + manualAdded.length
  if (!hasDetails) {
    return <div className="question-activity-empty">No question details available.</div>
  }
  return (
    <div className="question-activity-details">
      <div className="question-activity-title-row">
        <span className="question-activity-icon"><i className="pi pi-sparkles" /></span>
        <div><h5>{details.heading || (isTalentScan ? "TalentScan Questions" : "Screening Agent Questions")}</h5><span>Question generation snapshot</span></div>
      </div>
      <div className="question-activity-stats">
        <div><span>Before</span><strong>{beforeTotal}</strong><small>questions</small></div>
        <div className="is-positive"><span>After</span><strong>{afterTotal}</strong><small>questions</small></div>
        <div className="is-accent"><span>Added</span><strong>{addedTotal}</strong><small>questions</small></div>
        <div><span>Groups</span><strong>{new Set([...beforeScreening, ...afterScreening, ...beforeTalent, ...afterTalent].map(group => group.name)).size}</strong><small>sections</small></div>
      </div>
      {skillRows.length > 0 && <section className="question-activity-panel after">
        <h6>Skill Configuration Changes</h6>
        <div className="question-activity-count-table activity-before-after-table">
          <div><span>Skill</span><span>Field</span><span>Before</span><span>After</span></div>
          {skillRows.map(row => <div key={`${row.group}-${row.field}`}><strong>{row.group}</strong><span>{readableActivityField(row.field)}</span><span>{display(row.oldValue)}</span><span>{display(row.newValue)}</span></div>)}
        </div>
      </section>}
      {screeningRoundRows.length > 0 && <section className="question-activity-panel after">
        <h6>Screening Round Configuration</h6>
        <div className="question-activity-count-table activity-before-after-table">
          <div><span>Round</span><span>Field</span><span>Before</span><span>After</span></div>
          {screeningRoundRows.map(row => <div key={`${row.group}-${row.field}`}><strong>{row.group}</strong><span>{readableActivityField(row.field)}</span><span>{display(row.oldValue)}</span><span>{display(row.newValue)}</span></div>)}
        </div>
      </section>}
      {renderGroups(isTalentScan ? "TalentScan Questions" : "Screening Agent Questions", isTalentScan ? beforeTalent : beforeScreening, isTalentScan ? afterTalent : afterScreening)}
      {generated.length > 0 && <section className="question-activity-panel after"><h6>Generated Questions</h6>{renderQuestionList(generated)}</section>}
      {manualAdded.length > 0 && <section className="question-activity-panel after"><h6>Manual Questions Added</h6>{renderQuestionList(manualAdded)}</section>}
      {manualEdited.length > 0 && <section className="question-activity-panel after"><h6>Manual Questions Edited</h6>{renderEditedQuestionList(manualEdited)}</section>}
      {manualDeleted.length > 0 && <section className="question-activity-panel before"><h6>Manual Questions Deleted</h6>{renderQuestionList(manualDeleted)}</section>}
    </div>
  )
}

const recordingCache = {}
const apiRequestCache = new Map()

const getSessionToken = () => {
  try {
    const userInfo = JSON.parse(sessionStorage.getItem("user-info") || "{}")
    return userInfo?.token || userInfo?.access_token || ""
  } catch {
    return ""
  }
}

const SmtpTestButton = ({ companyId }) => {
  const [testing, setTesting] = useState(false);

  const handleTest = async () => {
    if (!companyId) {
      Swal.fire({ icon: "warning", title: "Company not selected", text: "Select a company before testing SMTP." });
      return;
    }

    setTesting(true);
    try {
      const response = await axios.get(`/api/v1/smtp-accounts/?page=1&size=100&company_id=${companyId}`);
      const records = Array.isArray(response.data)
        ? response.data
        : response.data?.results || [];

      const userInfo = JSON.parse(sessionStorage.getItem("user-info") || "{}");
      const loggedInEmail = (
        userInfo?.user_details?.email || userInfo?.email || userInfo?.user_email || ""
      ).trim();

      if (!loggedInEmail) {
        throw new Error("The logged-in user email is not available.");
      }

      const normalizedLoggedInEmail = loggedInEmail.toLowerCase();
      const smtpWithCredentials = item => Boolean(item?.password || item?.watch_word);
      const smtpMatchesUser = item => [item?.from_email, item?.username, item?.email]
        .some(value => String(value || "").trim().toLowerCase() === normalizedLoggedInEmail);
      const smtp = records.find(item => smtpMatchesUser(item) && smtpWithCredentials(item))
        || records.find(item => smtpMatchesUser(item))
        || records.find(item => item.is_primary)
        || records[0];

      if (!smtp) {
        throw new Error("No SMTP account is configured for this company.");
      }

      const testResponse = await axios.post("/api/v1/company-smtp/test/", {
        company_id: companyId,
        outgoing_server: smtp.outgoing_server,
        port: smtp.port,
        username: smtp.username,
        password: smtp.password || smtp.watch_word,
        from_email: smtp.from_email,
        to_email: smtp.from_email,
        use_tls: !!smtp.use_tls,
        use_ssl: !!smtp.use_ssl,
      });

      Swal.fire({
        icon: "success",
        title: "SMTP Test Successful",
        text: testResponse.data?.message || "Test email sent successfully.",
        confirmButtonText: "OK",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "SMTP Test Failed",
        text: error?.response?.data?.error || error?.message || "Unable to send the SMTP test email.",
        confirmButtonText: "OK",
      });
    } finally {
      setTesting(false);
    }
  };

  return (
    <Button
      type="button"
      onClick={handleTest}
      disabled={testing}
      title="Test the configured SMTP connection"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        background: "#fff",
        color: "#1a5fa8",
        border: "1px solid #1a5fa8",
        borderRadius: 6,
        padding: "6px 14px",
        fontSize: 14,
        fontWeight: 400,
        whiteSpace: "nowrap",
        height: "32px",
      }}
    >
      <FaPlug /> {testing ? "Testing..." : "Test SMTP"}
    </Button>
  );
};

const formatUTCDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();
  
  let hours = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  
  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};
const CommunicationRecordingPlayer = memo(({ src, currentPlayingRef }) => {
  const [audioSrc, setAudioSrc] = useState(recordingCache[src] || null)
  const [loading, setLoading] = useState(!recordingCache[src])
  const [error, setError] = useState(false)
  const audioRef = useRef(null)

  useEffect(() => {
    if (!src) return

    if (recordingCache[src]) {
      setAudioSrc(recordingCache[src])
      setLoading(false)
      return
    }

    const fetchAudio = async () => {
      try {
        const response = await axios.get(src, { responseType: "blob" })
        if (!response.data || response.data.size < 500) {
          setError(true)
          return
        }

        const blobUrl = URL.createObjectURL(response.data)
        recordingCache[src] = blobUrl
        setAudioSrc(blobUrl)
      } catch (err) {
        console.error("Audio fetch failed:", err)
        setError(true)
      } finally {
        setLoading(false)
      }
    }

    fetchAudio()
  }, [src])

  const handlePlay = () => {
    if (currentPlayingRef.current && currentPlayingRef.current !== audioRef.current) {
      currentPlayingRef.current.pause()
    }
    currentPlayingRef.current = audioRef.current
  }

  if (error) {
    return (
      <div style={{ fontSize: 12, color: "#b91c1c", padding: "8px 0" }}>
        Audio unavailable
      </div>
    )
  }

  return (
    <div style={{ width: "100%" }}>
      {loading && (
        <div style={{ fontSize: 12, color: "#64748b", padding: "6px 0" }}>
          Loading audio...
        </div>
      )}
      {audioSrc && (
        <audio
          ref={audioRef}
          controls
          preload="metadata"
          onPlay={handlePlay}
          style={{ width: "100%", display: loading ? "none" : "block" }}
          src={audioSrc}
        />
      )}
    </div>
  )
})

const getCachedRequest = (key, request, persist = false) => {
  if (apiRequestCache.has(key)) {
    return apiRequestCache.get(key)
  }

  const promise = request().catch(error => {
    apiRequestCache.delete(key)
    throw error
  })

  if (!persist) {
    promise.then(
      () => apiRequestCache.delete(key),
      () => apiRequestCache.delete(key)
    )
  }

  apiRequestCache.set(key, promise)
  return promise
}
const escapeBulkEditHtml = value =>
  String(value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")

const flattenBulkEditErrors = (errors, prefix = "") => {
  if (errors == null) return []
  if (typeof errors === "string") return [prefix ? `${prefix}: ${errors}` : errors]
  if (Array.isArray(errors)) {
    const allText = errors.every(item => typeof item === "string")
    if (allText) return [prefix ? `${prefix}: ${errors.join(", ")}` : errors.join(", ")]
    return errors.flatMap(item => flattenBulkEditErrors(item, prefix))
  }
  if (typeof errors === "object") {
    return Object.entries(errors).flatMap(([field, value]) =>
      flattenBulkEditErrors(value, prefix ? `${prefix}.${field}` : field)
    )
  }
  return [String(errors)]
}

const candidateColumnOptions = [
  { key: "job_orders", label: "Job Orders" },
  { key: "is_selected", label: "Is Selected" },
  { key: "candidate_added_by", label: "Added In Database" },
  { key: "resume_score", label: "Resume Score" },
  { key: "agent_status", label: "Agent Status" },
]

const defaultCandidateColumnVisibility = {
  job_orders: false,
  is_selected: true,
  candidate_added_by: false,
  resume_score: false,
  agent_status: true,
}

const JobOrdersView = ({ isMyJobsView = false, archivedOnly = false }) => {
  document.title = archivedOnly ? "ATS - Archived Job Orders" : isMyJobsView ? "ATS - My Job Orders" : "ATS - Job Orders";
  const navigate = useNavigate()
  const location = useLocation()
  const restoreCandidateViewRef = useRef(false)
  const [pipelineLogsModal, setPipelineLogsModal] = useState(false);
  const [pipelineLogsCandidate, setPipelineLogsCandidate] = useState(null);
  const [consentStatusFilterMap, setConsentStatusFilterMap] = useState({})
  const [emailSentFilterMap, setEmailSentFilterMap] = useState({})
  const [sendTestFilterMap, setSendTestFilterMap] = useState({})
  const [hrmsStatusFilterMap, setHrmsStatusFilterMap] = useState({})
  const [hrmsSentCountMap, setHrmsSentCountMap] = useState({})
  const [testResultsModal, setTestResultsModal] = useState(false)
  const [testResultsCandidate, setTestResultsCandidate] = useState(null)
  const [viewingTestResultMap, setViewingTestResultMap] = useState({})
  const [viewCandidateIndex, setViewCandidateIndex] = useState(null)
  const [viewCandidateJobId, setViewCandidateJobId] = useState(null)
  const [screeningResultsModal, setScreeningResultsModal] = useState(false);
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [screeningResultsJob, setScreeningResultsJob] = useState(null);
  const openTestResultsModal = (candidate) => {
    setTestResultsCandidate(candidate)
    setTestResultsModal(true)
  }
  const ensureValidCompanySelected = () => {
  if (!companyId || companyId === "all") {
    Swal.fire({
      icon: "warning",
      title: "Select a Company",
      text: "Please select a valid company before proceeding.",
      confirmButtonText: "OK",
    })
    return false
  }
  return true
}

  const formatHistoryDateTime = value => {
    if (!value) return "--"
    const parsed = new Date(value)
    if (Number.isNaN(parsed.getTime())) return value
    return parsed.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
  }
  const getCandidateFeedbacks = (row = {}) => {
    if (Array.isArray(row.interview_feedbacks) && row.interview_feedbacks.length) {
      return row.interview_feedbacks
    }

    const hasOldFeedback = [row.feedback, row.feedback_reasons, row.feedback_notes]
      .some(value => value !== null && value !== undefined && String(value).trim() !== "")

    if (!hasOldFeedback) return []

    return [{
      feedback: row.feedback,
      recommendation: row.feedback_reasons,
      recommendation_display: row.feedback_reasons,
      feedback_notes: row.feedback_notes,
      candidate_name: `${row.first_name || ""} ${row.last_name || ""}`.trim(),
    }]
  }

  const getRecommendationLabel = value => ({
    strong_hire: "Strong Hire",
    hire: "Hire",
    hold: "Hold",
    no_hire: "No Hire",
    candidate_no_show: "Candidate Did Not Attend",
  }[value] || value || "--")

  const getFeedbackPanelNames = feedbacks =>
    [...new Set((feedbacks || []).map(item => item.panel_name).filter(Boolean))]
  const getFeedbackSubmittedBy = item => {
      const name = String(item?.panel_name || "").trim()
      const email = String(item?.panel_email || "").trim()
      return name || email || "--"
    }
  const formatFeedbackDateTime = value => {
    if (!value) return "--"
    const parsed = new Date(value)
    if (Number.isNaN(parsed.getTime())) return value
    return parsed.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
  }

  const formatFeedbackDate = value => {
    if (!value) return "--"
    const parsed = new Date(value)
    if (Number.isNaN(parsed.getTime())) return value
    return parsed.toLocaleDateString("en-GB")
  }
const sectionLabel = {
  margin: "0 0 8px",
  fontSize: 11,
  fontWeight: 800,
  textTransform: "uppercase",
  letterSpacing: "0.07em",
  color: "#94a3b8",
};

const sectionDivider = {
  border: "1px solid #e6e9f0",
  borderRadius: 12,
  padding: "14px 16px",
  marginBottom: 14,
  background: "#fbfbfe",
};

const skillColors = {
  blue: { bg: "#E6F1FB", color: "#0C447C", border: "#B5D4F4" },
  teal: { bg: "#E1F5EE", color: "#085041", border: "#9FE1CB" },
  gray: { bg: "#F1EFE8", color: "#444441", border: "#D3D1C7" },
};

const SkillPill = ({ label, color = "gray" }) => {
  const c = skillColors[color];
  return (
    <span style={{
      fontSize: 13, padding: "3px 10px", borderRadius: 99,
      background: c.bg, color: c.color, border: `0.5px solid ${c.border}`,
    }}>
      {label}
    </span>
  );
};
  const formatExportDateTime = value => {
    if (!value) return "--"
    const parsed = new Date(value)
    if (Number.isNaN(parsed.getTime())) return value
    const day = String(parsed.getDate()).padStart(2, "0")
    const month = String(parsed.getMonth() + 1).padStart(2, "0")
    const year = parsed.getFullYear()
    let hours = parsed.getHours()
    const minutes = String(parsed.getMinutes()).padStart(2, "0")
    const ampm = hours >= 12 ? "PM" : "AM"
    hours = hours % 12
    hours = hours || 12
    const hourText = String(hours).padStart(2, "0")
    return `${day}-${month}-${year} ${hourText}:${minutes} ${ampm}`
  }

  const getRecordingPlayUrl = url => {
    if (!url) return null
    return `https://ats.bharatpayroll.com/qxbox/api/v1/play-recording/?url=${encodeURIComponent(url)}`
  }

  const communicationCurrentPlayingRef = useRef(null)
const getUploadSuccessFiles = data => {
  const result = data?.result || data?.data?.result || data;
  return Array.isArray(result?.created) ? result.created : [];
};
  const getCallRecordingKey = (call = {}, recording = {}, index = 0) =>
    [
      call?.id || call?.calldate || call?.created_at || "call",
      recording?.id || recording?.recording_url || recording?.url || call?.recording_url || index,
    ].join("-")

  const updateCallRecordingComment = (recordingKey, comment) => {
    setCallRecordingComments(prev => ({
      ...prev,
      [recordingKey]: comment,
    }))
  }

  const updateCallRecordingCommentDraft = (recordingKey, comment) => {
    setCallRecordingCommentDrafts(prev => ({
      ...prev,
      [recordingKey]: comment,
    }))
  }

  const getCallRecordingCommentDraft = recordingKey =>
    callRecordingCommentDrafts[recordingKey] ?? callRecordingComments[recordingKey] ?? ""

const writeCallRecordingComment = async (recordingKey, callId) => {
  const comment = getCallRecordingCommentDraft(recordingKey);
  if (!comment?.trim()) return;

  try {
    await axios.patch(`/api/v1/call-logs/${callId}/comment/`, {
      comments: comment,
    });

    // Re-fetch communication history to get updated comments
    if (communicationHistoryCandidate) {
      const jobCandidateId = communicationHistoryCandidate?.job_candidate_id || communicationHistoryCandidate?.id;
      if (jobCandidateId) {
        const historyRes = await axios.get(`/api/v1/candidate-communication-history/${jobCandidateId}/`);
        const { emails, whatsapp, calls } = getCommunicationBuckets(historyRes);

        setCandidateEmailHistory(emails);
        setCandidateWhatsappHistory(whatsapp);
        setCandidateCallHistory(calls);

        // Rebuild comments from refreshed data
        const existingComments = {};
        calls.forEach(call => {
          const key = getCallRecordingKey(call, call, 0);
          if (call.comments) {
            existingComments[key] = call.comments;
          }
          (call.recordings || []).forEach((rec, idx) => {
            const recKey = getCallRecordingKey(call, rec, idx);
            if (rec.comments) {
              existingComments[recKey] = rec.comments;
            }
          });
        });
        setCallRecordingComments(existingComments);
        setCallRecordingCommentDrafts(existingComments);
      }
    }

    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: "Comment saved.",
      showConfirmButton: false,
      timer: 1500,
    });
  } catch (err) {
    Swal.fire("Error", err?.response?.data?.message || "Failed to save comment.", "error");
  }
};
  const openCallRecordingDetail = ({ call, recording, recordingKey, recordingIndex, playUrl }) => {
    setSelectedCallRecordingDetail({
      call,
      recording,
      recordingKey,
      recordingIndex,
      playUrl,
    })
    setCallRecordingDetailModal(true)
  }

  const getNestedArray = value => {
    if (Array.isArray(value)) return value
    if (Array.isArray(value?.results)) return value.results
    if (Array.isArray(value?.data)) return value.data
    if (Array.isArray(value?.data?.results)) return value.data.results
    return []
  }

  const getFirstAvailableArray = (...values) => {
    for (const value of values) {
      const arr = getNestedArray(value)
      if (arr.length) return arr
    }
    return []
  }

  const toLowerText = value => String(value || "").trim().toLowerCase()

  const looksLikeHtml = value =>
    typeof value === "string" && /<\/?[a-z][\s\S]*>/i.test(value)

  const getResponsiveEmailHtml = value => {
    if (typeof value !== "string") return ""

    let normalizedHtml = value
      .replace(/<style[\s\S]*?<\/style>/gi, "")
      .replace(/width="700"/gi, 'width="100%"')
      .replace(/width:\s*700px/gi, "width:100%")
      .replace(/max-width:\s*700px/gi, "max-width:100%")
      .replace(/font-size:\s*(?:1[3-9]|[2-9]\d)px\s*!important/gi, "font-size:12px !important")
      .replace(/font-size:\s*(?:1[3-9]|[2-9]\d)px/gi, "font-size:12px")
      .replace(/line-height:\s*(?:1\.[6-9]|[2-9](?:\.\d+)?)(?:\s*!important)?/gi, "line-height:1.4 !important")
      .replace(/padding:\s*(?:1[6-9]|[2-9]\d)px/gi, "padding:10px")

    if (typeof document !== "undefined") {
      const wrapper = document.createElement("div")
      wrapper.innerHTML = normalizedHtml
      wrapper.querySelectorAll("a, button, div, td").forEach(element => {
        const text = String(element.textContent || "").replace(/\s+/g, " ").trim().toLowerCase()
        const isPreviewAction =
          text === "interview invitation" ||
          text === "book your slot" ||
          text === "book slot" ||
          text === "join the meeting" ||
          text === "give feedback"

        if (!isPreviewAction) return

        element.style.display = "inline-block"
        element.style.width = "auto"
        element.style.minWidth = text.includes("interview") ? "135px" : "120px"
        element.style.maxWidth = "180px"
        element.style.padding = "6px 14px"
        element.style.margin = "6px auto"
        element.style.borderRadius = "4px"
        element.style.textAlign = "center"
        element.style.lineHeight = "1.2"
        element.style.fontSize = "12px"
        element.style.fontWeight = "700"

        if (element.parentElement) {
          element.parentElement.style.textAlign = "center"
        }
      })
      normalizedHtml = wrapper.innerHTML
    }

    return `
      <style>
        html,
        body {
          margin: 0;
          padding: 0;
          overflow: visible !important;
        }
        .communication-email-preview-content {
          margin: 0;
          padding: 0;
          background: #ffffff;
          overflow: visible;
          font-family: Arial, sans-serif;
          font-size: 12px !important;
          line-height: 1.45 !important;
          color: #334155;
        }
        .communication-email-preview-content * {
          box-sizing: border-box;
          max-width: 100%;
        }
        .communication-email-preview-content table,
        .communication-email-preview-content td,
        .communication-email-preview-content th,
        .communication-email-preview-content p,
        .communication-email-preview-content span,
        .communication-email-preview-content li {
          font-size: 12px !important;
          line-height: 1.45 !important;
        }
        .communication-email-preview-content div {
          font-size: 12px !important;
          line-height: 1.45 !important;
        }
        .communication-email-preview-content h1,
        .communication-email-preview-content h2,
        .communication-email-preview-content h3 {
          font-size: 14px !important;
          line-height: 1.35 !important;
          margin: 0 0 8px !important;
        }
        .communication-email-preview-content [style*="background"] {
          font-size: 14px !important;
          line-height: 1.35 !important;
        }
        .communication-email-preview-content b,
        .communication-email-preview-content strong {
          font-size: inherit !important;
        }
        .communication-email-preview-content table {
          width: 100% !important;
          max-width: 100% !important;
        }
        .communication-email-preview-content td,
        .communication-email-preview-content th,
        .communication-email-preview-content img {
          max-width: 100% !important;
        }
        .communication-email-preview-content a {
          word-break: break-word;
        }
        .communication-email-preview-content a[style*="background"],
        .communication-email-preview-content button[style*="background"] {
          display: inline-block !important;
          width: auto !important;
          min-width: 120px !important;
          max-width: 180px !important;
          padding: 6px 14px !important;
          margin: 6px auto !important;
          text-align: center !important;
          font-size: 12px !important;
          line-height: 1.2 !important;
        }
        .communication-email-preview-content td[style*="background"]:has(a),
        .communication-email-preview-content td[style*="background-color"]:has(a) {
          display: table !important;
          width: 220px !important;
          max-width: 220px !important;
          margin: 8px auto !important;
        }
      </style>
      <div class="communication-email-preview-content">${normalizedHtml}</div>
    `
  }

  const disableCommunicationActionLinks = value => {
    if (typeof value !== "string" || typeof document === "undefined") return value || ""

    const wrapper = document.createElement("div")
    wrapper.innerHTML = value

    wrapper.querySelectorAll("a, button").forEach(element => {
      const text = String(element.textContent || "").toLowerCase()
      const href = String(element.getAttribute("href") || "").toLowerCase()
      const isConsentOrUnsubscribe =
        text.includes("consent") ||
        text.includes("unsubscribe") ||
        href.includes("consent") ||
        href.includes("unsubscribe")

      if (!isConsentOrUnsubscribe) return

      element.removeAttribute("href")
      element.removeAttribute("target")
      element.setAttribute("aria-disabled", "true")
      element.setAttribute("title", "This action is disabled in communication history")
      element.style.pointerEvents = "none"
      element.style.cursor = "not-allowed"
      element.style.opacity = "0.75"
    })

    return wrapper.innerHTML
  }

  const getCommunicationHistoryEmailHtml = value =>
    getResponsiveEmailHtml(disableCommunicationActionLinks(value))

  const getCommunicationBuckets = payload => {
    const data = payload?.data || payload || {}

    const historyRows = getNestedArray(data?.history)
    if (historyRows.length) {
      const buckets = historyRows.reduce(
        (acc, item) => {
          const type = toLowerText(item?.type)

          if (type === "whatsapp") {
            acc.whatsapp.push(item)
          } else if (type === "sms") {
            acc.sms.push(item)
          } else if (type === "call") {
            acc.calls.push(item)
          } else if (type === "email") {
            acc.emails.push(item)
          }

          return acc
        },
        { emails: [], whatsapp: [], sms: [], calls: [] }
      )
      return buckets
    }

    const emails = getFirstAvailableArray(
      data?.emails,
      data?.email_history,
      data?.mail_history
    )

    const whatsapp = getFirstAvailableArray(
      data?.whatsapp,
      data?.whatsapp_history,
      data?.whatsapp_logs
    )

    const calls = getFirstAvailableArray(
      data?.calls,
      data?.call_history,
      data?.call_logs
    )

    const sms = getFirstAvailableArray(data?.sms, data?.sms_history, data?.sms_logs)
    if (emails.length || whatsapp.length || sms.length || calls.length) {
      return { emails, whatsapp, sms, calls }
    }

    const combinedRows = getNestedArray(data)
    if (!combinedRows.length) {
      return { emails: [], whatsapp: [], sms: [], calls: [] }
    }

    return combinedRows.reduce(
      (acc, item) => {
        const channel = toLowerText(item?.channel || item?.type || item?.communication_type)
        if (channel.includes("whatsapp")) {
          acc.whatsapp.push(item)
        } else if (channel.includes("sms")) {
          acc.sms.push(item)
        } else if (
          channel.includes("call") ||
          channel.includes("phone") ||
          item?.dst ||
          item?.extension
        ) {
          acc.calls.push(item)
        } else {
          acc.emails.push(item)
        }
        return acc
      },
        { emails: [], whatsapp: [], sms: [], calls: [] }
    )
  }

  // ---------- UI / feedback ----------
  const [errorMessage, setErrorMessage] = useState("")
    const [reason, setReason] = useState("");
  const [errorAlert, setErrorAlert] = useState(false)
    const [selectedRowId, setSelectedRowId] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false)
    const [showUpgradePopup, setShowUpgradePopup] = useState(false);
  const handleCloseErrorModal = () => setErrorAlert(false)
    const [clearedWebsiteRows, setClearedWebsiteRows] = useState(new Set());
  const [sendForApprovalModal, setSendForApprovalModal] = useState(false);
  const [selectedCandidateForApproval, setSelectedCandidateForApproval] =
    useState(null)
    const [approvalReason, setApprovalReason] = useState("");
    const [isSendingForApproval, setIsSendingForApproval] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editField, setEditField] = useState(""); 
    const [editValue, setEditValue] = useState("");
    const [candidateToEdit, setCandidateToEdit] = useState(null);
    const editInputRef = useRef(null);
    const [validationError, setValidationError] = useState("");

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showJobDetailsModal, setShowJobDetailsModal] = useState(false);
  const [candidateNameToDelete, setCandidateNameToDelete] = useState("");
    const [selectedJobDetails, setSelectedJobDetails] = useState(null);
  const [hoveredJobId, setHoveredJobId] = useState(null);
  const [hoverTimeout, setHoverTimeout] = useState(null);
    const [copySuccess, setCopySuccess] = useState(false);
  const [candidateStatusModal, setCandidateStatusModal] = useState(false);
  const [bulkStageJobId, setBulkStageJobId] = useState(null);
    const [selectedCandidateForStatus, setSelectedCandidateForStatus] = useState(null);
    const [selectedCandidateStatusId, setSelectedCandidateStatusId] = useState("");
  const [candidateRejectedRound, setCandidateRejectedRound] = useState("");
  const [candidateStatusError, setCandidateStatusError] = useState("");
  const [candidateStatusLoader, setCandidateStatusLoader] = useState(false);
  const [candidateStatusDetailsLoader, setCandidateStatusDetailsLoader] = useState(false);
  const [candidateStatusDetailsSaving, setCandidateStatusDetailsSaving] = useState(false);
  const [isCandidateStatusDetailsEdit, setIsCandidateStatusDetailsEdit] = useState(false);
  const [candidateStatusDetailsDraft, setCandidateStatusDetailsDraft] = useState({});
  const [candidateStatusLocationNameMap, setCandidateStatusLocationNameMap] = useState({});
  const [candidateStatusSourceOptions, setCandidateStatusSourceOptions] = useState([]);
  const [candidateStatusSourcesLoading, setCandidateStatusSourcesLoading] = useState(false);
  const [stagesList, setStagesList] = useState([]);
  const [showConfirmSendTestModal, setShowConfirmSendTestModal] = useState(false);
  const [confirmSendTestCandidate, setConfirmSendTestCandidate] = useState(null);
  const [confirmSendTestJob, setConfirmSendTestJob] = useState(null);
  const [candidateTabMap, setCandidateTabMap] = useState({});
  const candidateColumnPreferenceKey = `job-orders-candidate-columns:${JSON.parse(sessionStorage.getItem("user-info") || "{}")?.user_details?.user_id ?? "anonymous"}`
  const [candidateColumnVisibility, setCandidateColumnVisibility] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(candidateColumnPreferenceKey) || "{}")
      return { ...defaultCandidateColumnVisibility, ...saved }
    } catch {
      return defaultCandidateColumnVisibility
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(candidateColumnPreferenceKey, JSON.stringify(candidateColumnVisibility))
    } catch {
      // Keep the column controls usable when browser storage is unavailable.
    }
  }, [candidateColumnPreferenceKey, candidateColumnVisibility])
  const [candidateColumnsDropdownOpen, setCandidateColumnsDropdownOpen] = useState({});
  const [candidateColumnsDropdownPosition, setCandidateColumnsDropdownPosition] = useState({});
  const candidateSortByJobRef = useRef({});
  const [showOutreachResultsModal, setShowOutreachResultsModal] = useState(false);
  const [communicationHistoryModal, setCommunicationHistoryModal] = useState(false)
  const [communicationHistoryTab, setCommunicationHistoryTab] = useState("calls")
  const [communicationHistoryCandidate, setCommunicationHistoryCandidate] = useState(null)
  const [communicationHistoryLoading, setCommunicationHistoryLoading] = useState(false)
  const [communicationHistoryError, setCommunicationHistoryError] = useState("")
  const [candidateCommunicationHistory, setCandidateCommunicationHistory] = useState([])
  const [interviewEmailTemplates, setInterviewEmailTemplates] = useState([])
  const [interviewEmailTemplateCount, setInterviewEmailTemplateCount] = useState(0)
  const [candidateEmailHistory, setCandidateEmailHistory] = useState([])
  const [candidateCallHistory, setCandidateCallHistory] = useState([])
  const [candidateWhatsappHistory, setCandidateWhatsappHistory] = useState([])
  const [candidateSmsHistory, setCandidateSmsHistory] = useState([])
  const [candidateSmsTotal, setCandidateSmsTotal] = useState(0)
  const [callRecordingComments, setCallRecordingComments] = useState({})
  const [callRecordingCommentDrafts, setCallRecordingCommentDrafts] = useState({})
  const [callRecordingDetailModal, setCallRecordingDetailModal] = useState(false)
  const [selectedCallRecordingDetail, setSelectedCallRecordingDetail] = useState(null)
  const [pipelineStages, setPipelineStages] = useState([]);
      const [selectedPipelineStage, setSelectedPipelineStage] = useState({});
      const [pipelineStageDropdownOpen, setPipelineStageDropdownOpen] = useState({});
        const [offerLetterSubject, setOfferLetterSubject] = useState("");
        const fetchPipelineStages = async () => {
        try {
          let page = 1;
          let hasNextPage = true;
          const stageMap = new Map();

          while (hasNextPage) {
            const response = await axios.get(`/api/v1/stages/?page=${page}&size=100`);
            const data = response.data;
            const rows = Array.isArray(data) ? data : data?.results || [];

            rows.forEach(stage => {
              const id = stage?.id ?? stage?.stage_id ?? stage?.name;
              const name = stage?.name ?? stage?.stage_name ?? stage?.label;
              if (id && name) stageMap.set(String(id), { ...stage, id, name });
            });

            hasNextPage = Boolean(data?.next) && rows.length > 0;
            page += 1;
            if (page > 25) hasNextPage = false;
          }

          setPipelineStages(Array.from(stageMap.values()));
        } catch (err) {
          console.error("Failed to fetch pipeline stages", err);
        }
      };
      useEffect(() => {
        fetchPipelineStages();
      }, []);

      const getSelectedPipelineStages = jobId => {
        const value = selectedPipelineStage[jobId]
        if (Array.isArray(value)) return value.filter(Boolean)
        if (typeof value === "string" && value.trim()) {
          return value.split(",").map(stage => stage.trim()).filter(Boolean)
        }
        return []
      }

      const serializePipelineStages = stages => {
        if (Array.isArray(stages)) {
          return stages.map(stage => String(stage).trim()).filter(Boolean).join(",")
        }
        if (typeof stages === "string") {
          return stages.split(",").map(stage => stage.trim()).filter(Boolean).join(",")
        }
        return ""
      }

      const formatDisplayName = name =>
        name && name !== "-"
          ? String(name)
              .toLowerCase()
              .replace(/\b\w/g, char => char.toUpperCase())
          : name || "-"

const [offerLetterCC, setOfferLetterCC] = useState("");
  const buildConsentScheduleUrl = (job, consentToken = "") => {
    const params = new URLSearchParams();
    if (job?.id || job?.job_id) params.set("job_id", String(job?.id || job?.job_id));
    if (consentToken) params.set("consent_token", consentToken);

    const query = params.toString();
    return `${window.location.origin}/consent-schedule/${query ? `?${query}` : ""}`;
  };

  const buildConsentUnsubscribeUrl = (job) => {
  const params = new URLSearchParams();
  const companyName = job?.company_name || job?.client_name || "";
  const recruiterName = Array.isArray(job?.recruiters_names)
    ? job.recruiters_names.join(", ")
    : job?.created_by_name || "";
  const locationValue = Array.isArray(job?.location)
    ? job.location.join(", ")
    : job?.location || "";
  const skillsValue = Array.isArray(job?.skills)
    ? job.skills
    : typeof job?.skills === "string"
      ? job.skills.split(",").map(skill => skill.trim()).filter(Boolean)
      : [];

  if (job?.job_title) params.set("job_title", job.job_title);
  if (companyName) params.set("company_name", companyName);
  if (recruiterName) params.set("recruiter_name", recruiterName);
  if (locationValue) params.set("location", locationValue);
  if (job?.min_exp !== undefined && job?.min_exp !== null) params.set("min_exp", String(job.min_exp));
  if (job?.max_exp !== undefined && job?.max_exp !== null) params.set("max_exp", String(job.max_exp));
  if (job?.job_type || job?.employment_type || job?.type) {
    params.set("job_type", job?.job_type || job?.employment_type || job?.type);
  }
  if (job?.job_description) params.set("jd", job.job_description);
  if (skillsValue.length) params.set("skills", JSON.stringify(skillsValue));
  const query = params.toString();
  return `${window.location.origin}/consent-unsubscribe/`;
};

  const buildReviewQuestionsLink = (job, selectedCompanyId = "") => {
    const params = new URLSearchParams();
    if (job?.id) params.set("job_id", String(job.id));

    return `${window.location.origin}/job-owner-screening-questions?${params.toString()}`;
  };

  const [outreachAnalytics, setOutreachAnalytics] = useState(null);
  const [outreachAnalyticsLoading, setOutreachAnalyticsLoading] = useState(false);
  const [outreachAnalyticsError, setOutreachAnalyticsError] = useState("");

  const formatPercent = (value, total) => {
    if (!total) return "";
    return `${((value / total) * 100).toFixed(1)}%`;
  };

  const formatLabel = (value = "") =>
    value
      .replace(/_/g, " ")
      .replace(/\b\w/g, char => char.toUpperCase());

  const normalizeReminderText = (value) =>
    cleanOutreachValue(value)
      .replace(/Ã¯Â¿Â½/g, "-")
      .replace(/ï¿½/g, "-")
      .replace(/\s*-\s*/g, " - ");

  const cleanOutreachValue = (value) => {
    if (value === null || value === undefined) return "-";
    const text = String(value).trim();
    if (!text || text === "ï¿½" || text === "") return "-";
    return text;
  };

  const getCandidatePipelineStatus = candidate => {
    const stage =
      candidate?.candidate_pipeline_stage ||
      candidate?.pipeline_status ||
      candidate?.candidate_status ||
      candidate?.stage_name ||
      candidate?.application_status ||
      candidate?.status ||
      "--"

    if (String(stage).toLowerCase().trim() !== "rejected") return stage

    return candidate?.rejected_round
      ? `Rejected (${candidate.rejected_round})`
      : "Rejected (Not specified)"
  }

  const getCandidatePipelineLogs = candidate => {
    const logs = Array.isArray(candidate?.pipeline_logs) ? candidate.pipeline_logs : []
    if (!logs.length) return "--"
    return logs.map(log => {
      const stage = log?.to_stage || log?.stage || log?.stage_name || "Stage update"
      const reason = log?.reason || log?.remarks || log?.comment
      const date = log?.created_at || log?.updated_at || log?.date
      const formattedDate = date ? formatExportDateTime(date) : ""
      return [stage, reason, formattedDate].filter(Boolean).join(" - ")
    }).join("\n")
  }

  const sanitizeExportFileName = value =>
    String(value || "job_candidates")
      .trim()
      .replace(/[\\/:*?"<>|]+/g, "_")
      .replace(/\s+/g, "_")

  const getStatusBadge = (status) => {
    const normalized = String(status || "").toLowerCase();

    if (normalized === "accepted") return { text: "Accepted", bg: "#dcfce7", color: "#16a34a" };
    if (normalized === "rejected" || normalized === "declined") return { text: "Declined", bg: "#fee2e2", color: "#ef4444" };
    if (normalized === "pending") return { text: "Pending", bg: "#fef3c7", color: "#d97706" };
    if (normalized === "scheduled") return { text: "Scheduled", bg: "#e0e7ff", color: "#4f46e5" };
    return { text: status || "", bg: "#f8fafc", color: "#94a3b8" };
  };

  const getScreeningBadge = (status) => {
    const normalized = String(status || "").toLowerCase();

    if (normalized === "passed") return { text: "Passed", bg: "#dcfce7", color: "#10b981" };
    if (normalized === "failed") return { text: "Failed", bg: "#fee2e2", color: "#ef4444" };
    if (normalized === "scheduled") return { text: "Scheduled", bg: "#e0e7ff", color: "#4f46e5" };
    if (normalized === "completed") return { text: "Completed", bg: "#e0f2fe", color: "#0284c7" };
    if (normalized === "pending") return { text: "Pending", bg: "#fef3c7", color: "#d97706" };
    return { text: status || "", bg: "#f8fafc", color: "#94a3b8" };
  };

  const getTrackerAction = (candidate) => {
    const consentStatus = String(candidate?.consent_status || "").toLowerCase();
    const s1Status = String(candidate?.s1_status || "").toLowerCase();
    const s2Status = String(candidate?.s2_status || "").toLowerCase();
    const trackerStatus = String(candidate?.tracker_status || "").toLowerCase();

    if (consentStatus === "accepted" && s2Status === "passed") return "Ready";
    if (consentStatus === "accepted" && s1Status === "passed") return "S2 Live";
    if (consentStatus === "accepted") return "S1 Live";
    if (consentStatus === "rejected" || consentStatus === "declined") return "Suppressed";
    if (trackerStatus === "active") return "Waiting";
    return "";
  };

  const outreachSummaryCards = useMemo(() => {
    const overview = outreachAnalytics?.overview || {};
    const funnel = outreachAnalytics?.consent_funnel || {};
    const screening = outreachAnalytics?.screening_progress || {};
    const sent = Number(overview.sent || 0);
    const totalConsent = Number(funnel.total || 0);
    const s1Count = Number(screening?.s1?.count || 0);
    const s2Count = Number(screening?.s2?.count || 0);

    return [
      { value: String(sent), label: "TOTAL SENT", sub: "", accent: "#4f6df5", bg: "#f6f8ff" },
      { value: String(overview.delivered || 0), label: "DELIVERED", sub: formatPercent(Number(overview.delivered || 0), sent), accent: "#06b6d4", bg: "#f3fcff" },
      { value: String(overview.opened || 0), label: "OPENED", sub: formatPercent(Number(overview.opened || 0), sent), accent: "#7c5cff", bg: "#f7f5ff" },
      { value: String(funnel.accepted || 0), label: "ACCEPTED", sub: formatPercent(Number(funnel.accepted || 0), totalConsent), accent: "#10b981", bg: "#f0fdf8" },
      { value: String(funnel.rejected || 0), label: "REJECTED", sub: formatPercent(Number(funnel.rejected || 0), totalConsent), accent: "#ef4444", bg: "#fff5f5" },
      { value: String(funnel.pending || 0), label: "PENDING", sub: formatPercent(Number(funnel.pending || 0), totalConsent), accent: "#f59e0b", bg: "#fffaf0" },
      // { value: String(funnel.s1_pass || 0), label: "S1 PASS", sub: formatPercent(Number(funnel.s1_pass || 0), s1Count), accent: "#4169e1", bg: "#f5f8ff" },
      { value: String(funnel.s2_pass || 0), label: "SCREENING PASS", sub: formatPercent(Number(funnel.s2_pass || 0), s2Count), accent: "#8b5cf6", bg: "#faf5ff" },
    ];
  }, [outreachAnalytics]);

  const outreachChannelsTable = useMemo(() => {
    const channelPerformance = outreachAnalytics?.channel_performance || {};

    return [
      { channel: "Email", sent: channelPerformance?.email?.sent ?? 0, delivered: channelPerformance?.email?.delivered ?? 0, opened: channelPerformance?.email?.opened ?? 0, responded: channelPerformance?.email?.responded ?? 0, icon: "Email" },
      { channel: "WhatsApp", sent: channelPerformance?.whatsapp?.sent ?? 0, delivered: channelPerformance?.whatsapp?.delivered ?? 0, opened: channelPerformance?.whatsapp?.opened ?? 0, responded: channelPerformance?.whatsapp?.responded ?? 0, icon: "WhatsApp" },
      { channel: "Combined", sent: channelPerformance?.combined?.sent ?? 0, delivered: channelPerformance?.combined?.delivered ?? 0, opened: channelPerformance?.combined?.opened ?? 0, responded: channelPerformance?.combined?.responded ?? 0, icon: "Combined" },
    ];
  }, [outreachAnalytics]);

  const outreachReminderRows = useMemo(() => {
    const reminderTones = ["#4f6df5", "#10b981", "#14b8a6", "#0ea5e9", "#94a3b8"];
    const reminderBgs = ["#eef2ff", "#ecfdf5", "#f0fdfa", "#f0f9ff", "#f8fafc"];

    return (outreachAnalytics?.reminder_breakdown || []).map((row, index) => ({
      label: `${formatLabel(row.label)}  Attempt ${row.attempt}`,
      status: `SENT  ${row.sent ?? 0}${Number(row.failed || 0) ? `  FAILED ${row.failed}` : ""}`,
      tone: reminderTones[index % reminderTones.length],
      bg: reminderBgs[index % reminderBgs.length],
    }));
  }, [outreachAnalytics]);

  const outreachTrackerRows = useMemo(() => {
    return (outreachAnalytics?.candidate_list || []).map(candidate => ({
      name: candidate?.name?.trim() || "Candidate",
      email: candidate?.email || "",
      phone: candidate?.phone?.trim() || "",
      emailStatus: candidate?.mail_sent ? (candidate?.mail_delivered ? "Delivered" : "Sent") : "",
      whatsappStatus: "",
      smsStatus: "",
      reminders: candidate?.attempt_count ?? 0,
      consent: getStatusBadge(candidate?.consent_status),
      s1: getScreeningBadge(candidate?.s1_status),
      s2: getScreeningBadge(candidate?.s2_status),
      action: getTrackerAction(candidate),
    }));
  }, [outreachAnalytics]);

  const outreachScreeningSections = useMemo(() => {
    const screening = outreachAnalytics?.screening_progress || {};

    return [
      // {
      //   title: "Screening 1 - Basic & Personal",
      //   accent: "#4f6df5",
      //   rows: [
      //     { label: "Scheduled", value: Number(screening?.s1?.scheduled || 0), color: "#4f6df5" },
      //     { label: "Completed", value: Number(screening?.s1?.completed || 0), color: "#06b6d4" },
      //     { label: "Passed", value: Number(screening?.s1?.passed || 0), color: "#10b981" },
      //     { label: "Failed", value: Number(screening?.s1?.failed || 0), color: "#e11d48" },
      //   ],
      // },
      {
        title: "Screening Results",
        accent: "#8b5cf6",
        rows: [
          { label: "Eligible", value: Number(screening?.s2?.count || 0), color: "#8b5cf6" },
          { label: "Completed", value: Number(screening?.s2?.completed || 0), color: "#06b6d4" },
          { label: "Passed", value: Number(screening?.s2?.passed || 0), color: "#10b981" },
          { label: "Failed", value: Number(screening?.s2?.failed || 0), color: "#e11d48" },
        ],
      },
    ];
  }, [outreachAnalytics]);

  const outreachFooterStats = useMemo(() => {
    const funnel = outreachAnalytics?.consent_funnel || {};
    return {
      total: Number(outreachAnalytics?.candidates_count || outreachTrackerRows.length || 0),
      accepted: Number(funnel.accepted || 0),
      declined: Number(funnel.rejected || 0),
      pending: Number(funnel.pending || 0),
      s1Passed: Number(funnel.s1_pass || 0),
      s2Passed: Number(funnel.s2_pass || 0),
    };
  }, [outreachAnalytics, outreachTrackerRows.length]);

  const exportOutreachResultsToExcel = async () => {
    const jobTitle = configureCallJob?.job_title || "Outreach_Results";
    const trackerExportRows = outreachTrackerRows.map(row => ({
      Candidate: cleanOutreachValue(row.name),
      Email: cleanOutreachValue(row.email),
      Phone: cleanOutreachValue(row.phone),
      Email_Status: cleanOutreachValue(row.emailStatus),
      WhatsApp_Status: cleanOutreachValue(row.whatsappStatus),
      SMS_Status: cleanOutreachValue(row.smsStatus),
      Reminders: row.reminders,
      Consent: cleanOutreachValue(row.consent.text),
      Screening_1: cleanOutreachValue(row.s1.text),
      Screening_2: cleanOutreachValue(row.s2.text),
      Action: cleanOutreachValue(row.action),
    }));

    const summaryExportRows = outreachSummaryCards.map(card => ({
      Metric: card.label,
      Value: card.value,
      Percentage: card.sub || "",
    }));

    const channelExportRows = outreachChannelsTable.map(row => ({
      Channel: row.channel,
      Sent: row.sent,
      Delivered: row.delivered,
      Opened: row.opened,
      Responded: row.responded,
    }));

    const reminderExportRows = outreachReminderRows.map(row => ({
      Reminder: normalizeReminderText(row.label),
      Status: normalizeReminderText(row.status),
    }));

    const safeJobTitle = jobTitle.replace(/[\\/:*?"<>|]/g, "_");

    const xlsx = await import("xlsx");
    const workbook = xlsx.utils.book_new();

    xlsx.utils.book_append_sheet(workbook, xlsx.utils.json_to_sheet(summaryExportRows), "Summary");
    xlsx.utils.book_append_sheet(workbook, xlsx.utils.json_to_sheet(channelExportRows), "Channels");
    xlsx.utils.book_append_sheet(workbook, xlsx.utils.json_to_sheet(reminderExportRows), "Reminders");
    xlsx.utils.book_append_sheet(workbook, xlsx.utils.json_to_sheet(trackerExportRows), "Candidates");

    xlsx.writeFile(workbook, `${safeJobTitle}_Outreach_Results.xlsx`);
  };

  // ---------- consent detail modal state ----------
  const [consentDetailModal, setConsentDetailModal] = useState(false);
  const [consentDetailData, setConsentDetailData] = useState(null);
  const [consentDetailLoading, setConsentDetailLoading] = useState(false);
  const [consentDetailTab, setConsentDetailTab] = useState("calling");
  // Bulk Outreach state  (outreachTab already exists — skip if so)
    const [outreachTab, setOutreachTab] = useState("compose");
    const [outreachChannels, setOutreachChannels]= useState({ email: true, whatsapp: true, sms: false });
    const [outreachSubject, setOutreachSubject] = useState("");
    const [outreachBody, setOutreachBody]  = useState("");
    const [outreachPayloadBody, setOutreachPayloadBody] = useState("");
    const [outreachFrequency, setOutreachFrequency]  = useState("daily");
    const [outreachMaxReminders, setOutreachMaxReminders] = useState(5);
    const [outreachAutoStop, setOutreachAutoStop]  = useState({ accept: true, decline: true, max: true });
    const [isSendingOutreach, setIsSendingOutreach]  = useState(false);
    const [showBulkOutreachModal  , setShowBulkOutreachModal ] = useState(false);
    const stopBulkOutreachEventPropagation = event => {
      event.stopPropagation();
    };
    const [showSendForReviewModal, setShowSendForReviewModal] = useState(false);
    const [reviewQuestionJob, setReviewQuestionJob] = useState(null);
    const [reviewCompanyId, setReviewCompanyId] = useState("");
    const [reviewEmployeeOptions, setReviewEmployeeOptions] = useState([]);
    const [reviewEmployeesLoading, setReviewEmployeesLoading] = useState(false);
    const [reviewSelectedEmployee, setReviewSelectedEmployee] = useState(null);
    const [reviewSending, setReviewSending] = useState(false);

  const toggleCandidateColumnsDropdown = jobId => {
    const anchor = document.getElementById(`candidate-columns-trigger-${jobId}`)
    const rect = anchor?.getBoundingClientRect()
    if (rect) {
      const menuHeight = 320
      const gap = 6
      const opensBelow = rect.bottom + gap + menuHeight <= window.innerHeight
      setCandidateColumnsDropdownPosition(prev => ({
        ...prev,
        [jobId]: {
          top: opensBelow ? rect.bottom + gap : Math.max(8, rect.top - menuHeight - gap),
          left: Math.max(8, Math.min(rect.right - 220, window.innerWidth - 228)),
        },
      }))
    }
    setCandidateColumnsDropdownOpen(prev => ({
      ...prev,
      [jobId]: !prev[jobId],
    }))
  }

  const handleCandidateColumnVisibilityChange = (columnKey, checked) => {
    setCandidateColumnVisibility(prev => ({
      ...prev,
      [columnKey]: checked,
    }))
  }



  const getConsentStatus = candidate => {
      const consentData = candidate?.consent_data ?? candidate
      const entries = Array.isArray(consentData) ? consentData.flat(Infinity) : []
      const records = entries.filter(item => item && typeof item === "object")
      if (!records.length) return "Not Sent"

      const latest = [...records].sort(
        (a, b) =>
          new Date(b.created_at || b.consent_given_at || 0).getTime() -
          new Date(a.created_at || a.consent_given_at || 0).getTime()
      )[0]
      const latestConsent = latest?.consent_given;
      const latestStatus = latest?.status?.toLowerCase();
      if (latestConsent === true || latestConsent === "true") return "Sent";
      if (latestConsent === false || latestConsent === "false") return "Rejected";
      if (latestStatus === "accepted") return "Sent";
      if (latestStatus === "rejected") return "Rejected";
      return "Pending";
    };

  // const fetchConsentDetails = (candidateRow) => {
  //   setConsentDetailModal(true);
  //   setConsentDetailLoading(true);
  //   setConsentDetailData(null);

  //   const raw = Array.isArray(candidateRow.consent_data) ? candidateRow.consent_data : [];
  //   const entries = raw.flat(Infinity).filter(c => c && typeof c === "object" && "consent_given" in c);
  //   const sorted = entries;

  //   const latestStatus = getConsentStatus(candidateRow.consent_data);

  //   setConsentDetailData({
  //     candidate_name: `${candidateRow.first_name || ""} ${candidateRow.last_name || ""}`.trim() || "Candidate",
  //     email: candidateRow.email || "--",
  //     phone: candidateRow.mobile_phone || "--",
  //     status: latestStatus,
  //     times_sent: entries.length,
  //     last_sent_date: sorted[0]?.created_at || null,
  //     consent_date: sorted.find(c => c.consent_given === true)?.created_at || sorted.find(c => c.consent_given === false)?.created_at || null,
  //     sent_by_name: candidateRow.sent_by_name || "--",
  //     history: sorted,
  //   });
  //   setConsentDetailLoading(false);
  // };

  const [screeningHistoryTab, setScreeningHistoryTab] = useState("calling");

  // ---------- capture resumes state ----------
  const fetchConsentDetails = async (candidateRow) => {
  setConsentDetailModal(true);
  setConsentDetailLoading(true);
  setConsentDetailData(null);
  setConsentDetailTab("calling");

  try {
    const timelineRes = await axios.get(
      `/api/v1/candidate-consent-timeline/${candidateRow.job_candidate_id}/`
    );

    const timeline = timelineRes.data?.timeline || [];

    const latestStatus = getConsentStatus(candidateRow);

    setConsentDetailData({
      candidate_name: `${candidateRow.first_name || ""} ${candidateRow.last_name || ""}`.trim() || "Candidate",
      email: candidateRow.email || "--",
      phone: candidateRow.mobile_phone || "--",
      status: latestStatus,
      times_sent: timeline.filter(t => t.event === "consent_sent").length,
      last_sent_date: timeline.find(t => t.event === "consent_sent")?.timestamp || null,
      sent_by_name: candidateRow.sent_by_name || "--",
      timeline, // ✅ NEW
      talent_scan_history: timelineRes.data?.talent_scan_history || [],
    });
  } catch (e) {
    setConsentDetailData({ error: true });
  } finally {
    setConsentDetailLoading(false);
  }
};  
  const [captureResumeDropdown, setCaptureResumeDropdown] = useState({});
  const [captureResumeDropdownPosition, setCaptureResumeDropdownPosition] = useState({});
  const [captureResumeFilters, setCaptureResumeFilters] = useState({});
  const [captureResumeLoading, setCaptureResumeLoading] = useState({});
  const [resumeScoreMap, setResumeScoreMap] = useState({});
  const [resumeReasonModal, setResumeReasonModal] = useState(false);
  const [resumeReasonData, setResumeReasonData] = useState(null);

  const toggleCaptureDropdown = (jobId) => {
    const isOpen = !captureResumeDropdown[jobId];
    if (isOpen && typeof document !== "undefined") {
      const trigger = document.getElementById(`filter-resumes-trigger-${jobId}`);
      if (trigger) {
        const rect = trigger.getBoundingClientRect();
        const width = Math.min(360, window.innerWidth - 32);
        const availableBelow = Math.max(160, window.innerHeight - rect.bottom - 12);
        const openLeft = availableBelow < 260 && rect.left >= width + 16;
        const availableHeight = Math.min(520, openLeft ? window.innerHeight - 24 : availableBelow);
        const top = openLeft
          ? Math.min(Math.max(12, rect.top), Math.max(12, window.innerHeight - availableHeight - 12))
          : rect.bottom + 6;
        const left = openLeft
          ? Math.max(16, rect.left - width - 8)
          : Math.min(Math.max(16, rect.right - width), Math.max(16, window.innerWidth - width - 16));
        setCaptureResumeDropdownPosition(prev => ({
          ...prev,
          [jobId]: { top, left, width, maxHeight: availableHeight },
        }));
      }
    }
    setCaptureResumeDropdown(prev => ({ ...prev, [jobId]: isOpen }));
  };

  const initFiltersForJob = (job) => {
    const jobId = job.id;
    if (!captureResumeFilters[jobId]) {
      const jobLocations = job.location
        ? (Array.isArray(job.location) ? job.location : job.location.split(",").map(l => l.trim()).filter(Boolean))
        : [];
      setCaptureResumeFilters(prev => ({
        ...prev,
        [jobId]: {
          experience: { checked: false, min: job.min_exp || "", max: job.max_exp || "" },
          skills: { checked: false, value: job.skills?.join(", ") || "" },
          location: { checked: false, values: jobLocations, newLoc: "" },
        },
      }));
    }
  };

  const handleFilterCheckbox = (jobId, filterKey) => {
    setCaptureResumeFilters(prev => ({
      ...prev,
      [jobId]: {
        ...prev[jobId],
        [filterKey]: {
          ...prev[jobId][filterKey],
          checked: !prev[jobId][filterKey].checked,
        },
      },
    }));
  };

  const handleFilterFieldChange = (jobId, filterKey, field, value) => {
    setCaptureResumeFilters(prev => ({
      ...prev,
      [jobId]: {
        ...prev[jobId],
        [filterKey]: {
          ...prev[jobId][filterKey],
          [field]: value,
        },
      },
    }));
  };

  const locInputRefs = useRef({});
  const pipelineStageListRefs = useRef({})
  const pipelineStageDropdownRefs = useRef({}) 

  const handleAddLocation = (jobId) => {
    const inputVal = (locInputRefs.current[jobId]?.value || "").trim();
    if (!inputVal) return;
    setCaptureResumeFilters(prev => {
      const loc = prev[jobId]?.location || {};
      const existing = loc.values || [];
      if (existing.includes(inputVal)) return prev;
      return {
        ...prev,
        [jobId]: {
          ...prev[jobId],
          location: { ...loc, values: [...existing, inputVal] },
        },
      };
    });
    if (locInputRefs.current[jobId]) {
      locInputRefs.current[jobId].value = "";
      locInputRefs.current[jobId].focus();
    }
  };

  const handleRemoveLocation = (jobId, locToRemove) => {
    setCaptureResumeFilters(prev => {
      const loc = prev[jobId]?.location || {};
      return {
        ...prev,
        [jobId]: {
          ...prev[jobId],
          location: { ...loc, values: (loc.values || []).filter(l => l !== locToRemove) },
        },
      };
    });
  };

  const handleCaptureResumes = async (jobId) => {
    setCaptureResumeLoading(prev => ({ ...prev, [jobId]: true }));
    try {
      const filters = captureResumeFilters[jobId] || {};
      const payload = { job_id: jobId };

      if (filters.skills?.checked && filters.skills?.value) {
        payload.skills = filters.skills.value.split(",").map(s => s.trim()).filter(Boolean);
      }
      if (filters.experience?.checked) {
        payload.experience = true;
        if (filters.experience.min) payload.min_exp = filters.experience.min;
        if (filters.experience.max) payload.max_exp = filters.experience.max;
      }
      if (filters.location?.checked && filters.location?.values?.length > 0) {
        payload.location = filters.location.values.join(", ");
      }

      const { data } = await axios.post(`/api/v1/rank-candidates/`, payload);

      // Refresh candidates
      const page = currentPageMap[jobId] ?? 1;
      const size = perPageMap[jobId] ?? 10;
      const search = searchMap[jobId] ?? "";
      await getCandidateDetails(jobId, page, size, search,fromDateMap?.[jobId] || "",toDateMap?.[jobId] || "");

      Swal.fire({
        title: "Success!",
        text: data.message || "Resumes ranked successfully.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error("Error ranking candidates:", err);
      Swal.fire("Error", err?.response?.data?.message || "Failed to rank candidates.", "error");
    } finally {
      setCaptureResumeLoading(prev => ({ ...prev, [jobId]: false }));
    }
  };

// <<<<<<< Updated upstream
// =======
  // ---------- screening configuration modal ----------
  const [configureCallStep, setConfigureCallStep] = useState("second"); // "first" | "second"
  const [firstScreeningData, setFirstScreeningData] = useState([]);
  const [firstScreeningLoading, setFirstScreeningLoading] = useState(false);

  // voices
  const [voiceOptions, setVoiceOptions] = useState([]);
  const fetchVoices = async () => {
    try {
      const response = await axios.get("/api/v1/voices/");
      if (response.data) {
        setVoiceOptions(response.data.map(v => ({ value: v.voice_code, label: v.name, language_code: v.language_code, audio_file: v.audio_file })));
      }
    } catch (err) {
      console.error("Error fetching voices:", err);
    }
  };
  useEffect(() => { fetchVoices(); }, []);

  const fetchFirstScreeningData = async (jobCandidateIds) => {
    setFirstScreeningLoading(true);
    try {
      const response = await axios.get("/api/v1/call-records/", {
        params: { job_candidate_id: jobCandidateIds.join(","), page: 1, size: 50 },
      });
      setFirstScreeningData(response.data?.data || []);
    } catch (err) {
      console.error("Error fetching first screening data:", err);
      setFirstScreeningData([]);
    } finally {
      setFirstScreeningLoading(false);
    }
  };

// >>>>>>> Stashed changes
  // ---------- configure call modal state ----------
  const [selectedCandidateRows, setSelectedCandidateRows] = useState({});
  const [selectedCandidateRowData, setSelectedCandidateRowData] = useState({});
  const bulkStageSelection = Object.fromEntries(Object.entries(selectedCandidateRows).map(([jobId, ids]) => [
    jobId, [...new Set(ids.map(id => applicationId(selectedCandidateRowData[jobId]?.[id]?.bulk_application_id)).filter(Boolean))],
  ]));
  const [scheduleInterviewModalOpen, setScheduleInterviewModalOpen] = useState(false);
  const [scheduleInterviewJob, setScheduleInterviewJob] = useState(null);
  const [scheduleInterviewCandidate, setScheduleInterviewCandidate] = useState(null);
  const [scheduleInterviewCandidates, setScheduleInterviewCandidates] = useState([]);
  const [scheduleReviewModal, setScheduleReviewModal] = useState(false);
  const [scheduleReviewJob, setScheduleReviewJob] = useState(null);
  const [scheduleReviewRows, setScheduleReviewRows] = useState([]);
  const [scheduleReviewSaving, setScheduleReviewSaving] = useState(false);
  const [scheduleReviewError, setScheduleReviewError] = useState("");
  const [candidateReviewAction, setCandidateReviewAction] = useState("interview");
  const candidateReviewResolver = useRef(null);
  const [reviewedEmailRequest, setReviewedEmailRequest] = useState(null);
  const candidateReviewActionLabel = candidateReviewAction === "email" ? "Send Email"
    : candidateReviewAction === "outreach" ? "Bulk Outreach" : "Schedule Interview";
  const now = new Date();
  const currentTime = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    now.getHours(),
    now.getMinutes(),
    0
  );
  const [configureCallModal, setConfigureCallModal] = useState(false);
  const [configureCallData, setConfigureCallData] = useState({
    testType: null,
    agent: null,
    source: null,
    scheduleDate: null,
    firstScreeningQuestions: [""],
    secondScreeningQuestions: {},
  });
  const testTypeOptions = [
    { value: "telephonic_test", label: "Telephonic Test" },
  ];
  const [agentOptions, setAgentOptions] = useState([]);
  const fetchAgents = async () => {
    try {
      const response = await getCachedRequest(
        "agents-dropdown",
        () => axios.get("/api/v1/agents/", { params: { dropdown: true } }),
        true
      );
      const agents = response?.data?.data || [];
      setAgentOptions(agents.map(a => ({ value: a.id, label: a.bot_name, voice_code: a.voice_code, agent_id: a.agent_id })));
    } catch (err) {
      console.error("Error fetching agents:", err);
    }
  };
  useEffect(() => {
    fetchAgents();
  }, []);
  const sourceOptions = [
    { value: "Vitel Global", label: "Vitel Global" },
  ];
  const [configureCallJob, setConfigureCallJob] = useState(null);
  const [loadingCreateCall, setLoadingCreateCall] = useState(false);
  const [originalSecondSQ, setOriginalSecondSQ] = useState({});

  const confirmRecordingAvailability = async (company, selectedCandidates) => {
    const recordingEnabled = company?.interview_recording_attachment_enabled === true
    if (!recordingEnabled) return true

    const companyIdForCheck = company?.id ?? company?.company_id
    const candidateIds = selectedCandidates
      .map(candidate => candidate?.candidate_id || candidate?.candidate || candidate?.id)
      .map(id => String(id || "").trim())
      .filter(Boolean)
      .filter((id, index, ids) => ids.indexOf(id) === index)
    try {
      const response = await axios.post("/api/v1/events/recording-check/", {
        company_id: companyIdForCheck,
        candidate_ids: candidateIds,
      })
      const data = response.data || {}
      if (data.requires_confirmation === true) {
        const result = await Swal.fire({
          icon: "warning",
          title: "No recording available",
          text: "No interview recording is available. Continue without attaching a recording?",
          showDenyButton: true,
          confirmButtonText: "Continue",
          denyButtonText: "Click to call",
        })
        if (result.isDenied) {
          await initiateCandidateCall(selectedCandidates?.[0])
          return false
        }
        return result.isConfirmed
      }
      return true
    } catch (error) {
      await Swal.fire({ icon: "error", title: "Unable to check recording", text: error?.response?.data?.detail || error?.response?.data?.message || "Please try again." })
      return false
    }
  }

  const initiateCandidateCall = async candidate => {
    const jobCandidateId = candidate?.job_candidate_id
    if (!jobCandidateId) {
      await Swal.fire("Warning", "Candidate ID not found.", "warning")
      return
    }
    try {
      const response = await axios.post("/api/v1/vitel/click2call/", {
        job_candidate_id: jobCandidateId,
      })
      const callUrl = response?.data?.data?.click_to_call_url
      await Swal.fire({
        title: "Call initiated",
        text: response?.data?.message || "Call initiated successfully.",
        icon: "success",
        confirmButtonText: "OK",
      })
      if (callUrl) await fetch(callUrl, { mode: "no-cors" })
    } catch (error) {
      await Swal.fire("Error", error?.response?.data?.message || "Failed to initiate call.", "error")
    }
  }

  const openScheduleInterviewForJob = async (job, candidates = []) => {
    const jobId = getJobRowId(job);
    const selectedIds = selectedCandidateRows[jobId] || [];

    if (selectedIds.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Candidate Selected",
        text: "Please select at least one candidate before scheduling an interview.",
        confirmButtonText: "OK",
      });
      return;
    }

    if (!job?.jd_document) {
      await Swal.fire({
        icon: "warning",
        title: "Job Description Document Missing",
        text: "No job description document is attached to this job order. You can still proceed with scheduling the interview.",
        confirmButtonText: "Continue Scheduling",
      });
    }

    if (selectedIds.length > 10) {
      Swal.fire({
        icon: "warning",
        title: "Candidate Limit Exceeded",
        text: "You can schedule interviews for a maximum of 10 candidates at a time. Please select 10 or fewer candidates.",
        confirmButtonText: "OK",
      });
      return;
    }

    const cachedSelectedCandidates = selectedIds
      .map(id => selectedCandidateRowData[jobId]?.[id])
      .filter(Boolean);
    const currentPageSelectedCandidates = candidates.filter(candidate =>
      selectedIds.some(id => String(getCandidateRowId(candidate)) === String(id))
    );
    let selectedCandidates = selectedIds
      .map(id => (
        cachedSelectedCandidates.find(candidate => String(getCandidateRowId(candidate)) === String(id)) ||
        currentPageSelectedCandidates.find(candidate => String(getCandidateRowId(candidate)) === String(id))
      ))
      .filter(Boolean);

    if (selectedCandidates.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Candidates Not Found",
        text: "Unable to find the selected candidates. Please refresh and try again.",
      });
      return;
    }

    if (selectedCandidates.length > 10) {
      Swal.fire({
        icon: "warning",
        title: "Candidate Limit Exceeded",
        text: "You can schedule interviews for a maximum of 10 candidates at a time. Please select 10 or fewer candidates.",
        confirmButtonText: "OK",
      });
      return;
    }

    if (recordingCheckInFlight.current) return
    if (selectedCompanyLoading) {
      await Swal.fire({
        icon: "info",
        title: "Loading company settings",
        text: "Please wait while the selected company's settings load.",
        confirmButtonText: "OK",
      })
      return
    }
    recordingCheckInFlight.current = true
    let recordingConfirmed
    try {
      console.log("Company details:", selectedCompanyDetails)
      console.log(
        "Recording enabled:",
        selectedCompanyDetails?.interview_recording_attachment_enabled
      )
      recordingConfirmed = await confirmRecordingAvailability(selectedCompanyDetails, selectedCandidates)
    } finally {
      recordingCheckInFlight.current = false
    }
    if (!recordingConfirmed) return

    const reviewChoice = await confirmCandidateReview();
    if (!reviewChoice.isConfirmed && !reviewChoice.isDenied) return;

    // Validate all selected candidates with one batch request instead of
    // fetching each candidate detail endpoint separately.
    const candidateIds = selectedCandidates
      .map(candidate => candidate?.candidate_id || candidate?.candidate || candidate?.id)
      .map(id => String(id || "").trim())
      .filter(Boolean)
      .filter((id, index, ids) => ids.indexOf(id) === index);
    let salaryDetailsResponse;
    try {
      salaryDetailsResponse = await axios.get("/api/v1/candidates/salary-details/", {
        params: { candidate_ids: candidateIds.join(",") },
      });
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Unable to Validate Candidate Details",
        text: "Candidate salary details could not be loaded. Please try again.",
        confirmButtonText: "OK",
      });
      return;
    }

    const salaryDetails = Array.isArray(salaryDetailsResponse?.data?.results)
      ? salaryDetailsResponse.data.results
      : [];
    const salaryDetailsById = new Map(
      salaryDetails.map(details => [String(details?.candidate_id), details])
    );
    const notFoundCandidate = selectedCandidates.find(candidate => {
      const candidateId = candidate?.candidate_id || candidate?.candidate || candidate?.id;
      const details = salaryDetailsById.get(String(candidateId));
      return !details || details.found === false;
    });

    if (notFoundCandidate) {
      const candidateName = getCandidateFullName(notFoundCandidate) || "Candidate";
      await Swal.fire({
        icon: "error",
        title: "Candidate Details Not Found",
        text: `Salary details for ${candidateName} could not be found. Please refresh the candidate list and try again.`,
        confirmButtonText: "OK",
      });
      return;
    }

    selectedCandidates = selectedCandidates.map(candidate => {
      const candidateId = candidate?.candidate_id || candidate?.candidate || candidate?.id;
      const details = salaryDetailsById.get(String(candidateId));
      return details ? { ...candidate, ...details } : candidate;
    });

    const isMissingSalary = value => {
      const text = String(value ?? "").trim().toLowerCase();
      return !text || ["--", "-", "n/a", "na", "null", "undefined"].includes(text);
    };
    const missingSalaryCandidates = selectedCandidates.filter(candidate =>
      isMissingSalary(candidate.current_salary ?? candidate.currentSalary ?? candidate.current_ctc) ||
      isMissingSalary(candidate.expected_salary ?? candidate.expectedSalary ?? candidate.expected_ctc)
    );
    if (reviewChoice.isDenied && missingSalaryCandidates.length) {
      const salaryTableRows = missingSalaryCandidates
        .map((candidate, index) => {
          const candidateName = String(getCandidateFullName(candidate) || "Candidate")
            .replace(/[&<>"']/g, character => ({
              "&": "&amp;",
              "<": "&lt;",
              ">": "&gt;",
              '"': "&quot;",
              "'": "&#39;",
            }[character]))
          return `<tr><td>${index + 1}</td><td>${candidateName}</td><td><span class="salary-missing-status">Missing</span></td></tr>`
        })
        .join("")
      const salaryChoice = await Swal.fire({
        icon: "warning",
        title: "Salary Details Missing",
        html: `<div class="salary-missing-alert">
          <p class="salary-missing-intro">Please update the current and expected salary details for these candidates:</p>
          <div class="salary-missing-table-wrap">
            <table class="salary-missing-table">
              <thead><tr><th>S.No.</th><th>Candidate</th><th>Status</th></tr></thead>
              <tbody>${salaryTableRows}</tbody>
            </table>
          </div>
        </div>`,
        confirmButtonText: "Review Details",
        showCancelButton: true,
        cancelButtonText: "Cancel",
      });
      if (!salaryChoice.isConfirmed) return;
    }
    if (reviewChoice.isDenied && !missingSalaryCandidates.length) {
      proceedToScheduleInterview(job, selectedCandidates);
      return;
    }
    openScheduleCandidateReview(job, selectedCandidates);
  };

  const getScheduleReviewRow = (candidate, job) => ({
    ...candidate,
    candidate_id: candidate?.candidate_id || candidate?.candidate || candidate?.id,
    job_candidate_id: candidate?.job_candidate_id,
    row_id: getCandidateRowId(candidate),
    job_id: candidate?.job_id || job?.job_id || job?.id,
    job_title: candidate?.job_title || job?.job_title,
    company_id: candidate?.company_id || job?.company_id || companyId,
    first_name: candidate?.first_name || candidate?.candidate_name || "",
    middle_name: candidate?.middle_name || "",
    last_name: candidate?.last_name || "",
    email: candidate?.email || candidate?.candidate_email || candidate?.job_candidate__candidate_email || "",
    current_salary: candidate?.current_salary ?? candidate?.currentSalary ?? candidate?.current_ctc ?? candidate?.currentCTC ?? "",
    expected_salary: candidate?.expected_salary ?? candidate?.expectedSalary ?? candidate?.expected_ctc ?? candidate?.expectedCTC ?? "",
    notice_period: candidate?.notice_period ?? candidate?.noticePeriod ?? "",
    __originalValues: {
      first_name: candidate?.first_name || candidate?.candidate_name || "",
      middle_name: candidate?.middle_name || "",
      last_name: candidate?.last_name || "",
      email: candidate?.email || candidate?.candidate_email || candidate?.job_candidate__candidate_email || "",
      current_salary: candidate?.current_salary ?? candidate?.currentSalary ?? candidate?.current_ctc ?? candidate?.currentCTC ?? "",
      expected_salary: candidate?.expected_salary ?? candidate?.expectedSalary ?? candidate?.expected_ctc ?? candidate?.expectedCTC ?? "",
      notice_period: candidate?.notice_period ?? candidate?.noticePeriod ?? "",
    },
  });

  const openScheduleCandidateReview = (job, selectedCandidates) => {
    setCandidateReviewAction("interview");
    setScheduleReviewJob(job);
    setScheduleReviewRows(selectedCandidates.map(candidate => getScheduleReviewRow(candidate, job)));
    setScheduleReviewError("");
    setScheduleReviewModal(true);
  };

  const confirmCandidateReview = () => Swal.fire({
    icon: "question",
    title: "Review Candidate Details?",
    text: "Do you wish to review the selected candidates' details before continuing?",
    showDenyButton: true,
    confirmButtonText: "Yes, Review Details",
    denyButtonText: "No, Continue",
    showCloseButton: true,
    allowOutsideClick: false,
  });

  const reviewCandidatesBeforeAction = async (job, candidates, action) => {
    if (!candidates.length) {
      Swal.fire({ icon: "warning", title: "No Candidates Selected", text: "Please select at least one candidate." });
      return Promise.resolve(false);
    }
    const reviewChoice = await confirmCandidateReview();
    if (reviewChoice.isDenied) {
      if (action === "email") {
        setReviewedEmailRequest({
          jobId: getJobRowId(job), job, candidates, requestId: Date.now(),
        });
        return false;
      }
      return candidates;
    }
    if (!reviewChoice.isConfirmed) return false;
    let reviewedCandidates;
    try {
      const candidateIds = [...new Set(candidates.map(candidate =>
        String(candidate.candidate_id || candidate.candidate || candidate.id)
      ))].join(",");
      const response = await axios.get("/api/v1/candidates/salary-details/", {
        params: { candidate_ids: candidateIds },
      });
      const detailsById = new Map((response.data?.results || []).map(details =>
        [String(details.candidate_id), details]
      ));
      reviewedCandidates = candidates.map(candidate => {
        const id = String(candidate.candidate_id || candidate.candidate || candidate.id);
        const details = detailsById.get(id);
        if (!details || details.found === false) {
          throw new Error(`Details for ${getCandidateFullName(candidate) || id} could not be found.`);
        }
        return { ...candidate, ...details };
      });
    } catch (error) {
      await Swal.fire({ icon: "error", title: "Unable to Load Candidate Details",
        text: error.response?.data?.message || error.message || "Please try again." });
      return false;
    }
    return new Promise(resolve => {
      candidateReviewResolver.current = resolve;
      openScheduleCandidateReview(job, reviewedCandidates);
      setCandidateReviewAction(action);
    });
  };

  const closeScheduleCandidateReview = () => {
    if (scheduleReviewSaving) return;
    candidateReviewResolver.current?.(false);
    candidateReviewResolver.current = null;
    setScheduleReviewModal(false);
    setScheduleReviewJob(null);
    setScheduleReviewRows([]);
    setScheduleReviewError("");
  };

  const handleScheduleReviewChange = (index, field, value) => {
    setScheduleReviewRows(prev =>
      prev.map((row, rowIndex) =>
        rowIndex === index ? { ...row, [field]: value } : row
      )
    );
    setScheduleReviewError("");
  };

  const validateScheduleReviewRows = rows => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmpty = value => value === null || value === undefined || String(value).trim() === "";

    for (const [index, row] of rows.entries()) {
      const candidateLabel = getCandidateFullName(row) || `Candidate ${index + 1}`;
      if (isEmpty(row.first_name)) return `${candidateLabel}: first name is required.`;
      if (isEmpty(row.email) || !emailRegex.test(String(row.email).trim())) {
        return `${candidateLabel}: valid email is required.`;
      }
      if (isEmpty(row.current_salary)) return `${candidateLabel}: current salary is required.`;
      if (isEmpty(row.expected_salary)) return `${candidateLabel}: expected salary is required.`;
      if (isEmpty(row.notice_period)) return `${candidateLabel}: notice period is required.`;
    }

    return "";
  };

  const saveScheduleReviewAndOpenInterview = async () => {
    const validationMessage = validateScheduleReviewRows(scheduleReviewRows);
    if (validationMessage) {
      setScheduleReviewError(validationMessage);
      return;
    }

    try {
      setScheduleReviewSaving(true);
      setScheduleReviewError("");
      const normalizeScheduleReviewValue = value => String(value ?? "").trim();
      const buildPayload = (row, changedOnly = true) => {
        const p = {};
        const add = (key, val) => {
          const v = normalizeScheduleReviewValue(val);
          const original = normalizeScheduleReviewValue(row.__originalValues?.[key]);
          if (!changedOnly || v !== original) p[key] = v;
        };
        add("first_name",       row.first_name);
        add("middle_name",      row.middle_name);
        add("last_name",        row.last_name);
        add("email",            row.email);
        add("current_salary",   row.current_salary);
        add("expected_salary",  row.expected_salary);
        add("notice_period",    row.notice_period);
        return p;
      };
      const getRowCandidateId = row => row.candidate_id || row.candidate || row.id;
      const rowUpdates = scheduleReviewRows
        .map(row => ({
          row,
          candidateId: getRowCandidateId(row),
          payload: buildPayload(row),
        }))
        .filter(update => update.candidateId && Object.keys(update.payload).length > 0);

      let updatedCandidates = scheduleReviewRows;
      if (rowUpdates.length === 0) {
        await Swal.fire({
          icon: "info",
          title: "No Changes Found",
          text: `Candidate details are already up to date. Continuing to ${candidateReviewActionLabel}.`,
          confirmButtonText: "Continue",
        });
      } else {
        const candidates = Object.fromEntries(
          rowUpdates.map(update => [String(update.candidateId), update.payload])
        );
        const candidateIds = Object.keys(candidates).join(",");
        const response = await axios.patch(
          `/api/v1/candidates/${candidateIds}/`,
          { candidates },
          { headers: { "Content-Type": "application/json" } }
        );
        const data = response?.data || {};
        const requestedIds = Object.keys(candidates);
        const singleCandidateConfirmed = requestedIds.length === 1 &&
          String(data.candidate_id) === requestedIds[0] &&
          Object.entries(candidates[requestedIds[0]]).every(([field, value]) =>
            String(data[field] ?? "").trim() === String(value ?? "").trim()
          );
        const updatedCount = singleCandidateConfirmed ? 1 : Number(data.updated_count);
        const missingIds = Array.isArray(data.missing_candidate_ids)
          ? data.missing_candidate_ids.map(String) : [];
        const candidateErrors = data.errors || data.validation_errors || {};
        const serverCandidates = singleCandidateConfirmed
          ? [{ candidate_id: data.candidate_id, data }]
          : Array.isArray(data.candidates) ? data.candidates : [];
        const serverById = new Map(serverCandidates.map(candidate => [
          String(candidate.candidate_id), candidate.data || {},
        ]));
        const allSaved = updatedCount === requestedIds.length &&
          missingIds.length === 0 && Object.keys(candidateErrors).length === 0;
        updatedCandidates = scheduleReviewRows.map(row => {
          const id = String(getRowCandidateId(row));
          if (!candidates[id] || (!allSaved && !serverById.has(id)) ||
              missingIds.includes(id) || candidateErrors[id]) return row;
          return {
            ...row, ...candidates[id], ...serverById.get(id),
            __originalValues: { ...row.__originalValues, ...candidates[id] },
          };
        });
        if (!allSaved) {
          setScheduleReviewRows(updatedCandidates);
          const jobId = getJobRowId(scheduleReviewJob);
          getCandidateDetails(jobId, currentPageMap[jobId] ?? 1, perPageMap[jobId] ?? 10,
            searchMap[jobId] ?? "", fromDateMap?.[jobId] || "", toDateMap?.[jobId] || "");
          const details = rowUpdates.flatMap(update => {
            const id = String(update.candidateId);
            const errors = candidateErrors[id];
            if (!errors && !missingIds.includes(id)) return [];
            const label = getCandidateFullName(update.row) || "Candidate";
            return [`${label} (${id}): ${missingIds.includes(id)
              ? "Candidate not found."
              : flattenBulkEditErrors(errors).join("; ")}`];
          });
          setScheduleReviewError(details.join(" | ") ||
            `${Number.isFinite(updatedCount) ? `${updatedCount} candidate(s) updated.` : "The API did not return an update count."} The API did not confirm all updates. Review the details and retry.`);
          await Swal.fire({
            icon: "warning",
            title: "Updates Not Fully Confirmed",
            text: details.join("\n") || "Not all candidate updates were confirmed. Review the details before scheduling.",
            confirmButtonText: "Review Details",
          });
          return;
        }
        await Swal.fire({
          icon: "success",
          title: "Candidate Details Updated",
          text: `${updatedCount} candidate(s) updated successfully. Continuing to ${candidateReviewActionLabel}.`,
          confirmButtonText: "Continue",
          timer: 1600,
          timerProgressBar: true,
        });
      }

      const job = scheduleReviewJob;
      const jobId = getJobRowId(job);
      setCandidateDataMap(prev => ({ ...prev, [jobId]: (prev[jobId] || []).map(candidate =>
        updatedCandidates.find(updated => String(getCandidateRowId(updated)) === String(getCandidateRowId(candidate))) || candidate
      ) }));
      setSelectedCandidateRowData(prev => ({
        ...prev,
        [jobId]: {
          ...(prev[jobId] || {}),
          ...Object.fromEntries(updatedCandidates.map(candidate => [getCandidateRowId(candidate), candidate])),
        },
      }));

      await getCandidateDetails(
        jobId,
        currentPageMap[jobId] ?? 1,
        perPageMap[jobId] ?? 10,
        searchMap[jobId] ?? "",
        fromDateMap?.[jobId] || "",
        toDateMap?.[jobId] || ""
      );

      if (jobId && candidateReviewAction === "interview") {
        setSelectedCandidateRows(prev => {
          const updated = { ...prev };
          delete updated[jobId];
          return updated;
        });
        setSelectedCandidateRowData(prev => {
          const updated = { ...prev };
          delete updated[jobId];
          return updated;
        });
      }

      setScheduleReviewModal(false);
      setScheduleReviewJob(null);
      setScheduleReviewRows([]);
      if (candidateReviewAction === "interview") {
        proceedToScheduleInterview(job, updatedCandidates);
      } else if (candidateReviewAction === "email") {
        candidateReviewResolver.current?.(false);
        candidateReviewResolver.current = null;
        setReviewedEmailRequest({ jobId, job, candidates: updatedCandidates, requestId: Date.now() });
      } else {
        candidateReviewResolver.current?.(updatedCandidates);
        candidateReviewResolver.current = null;
      }
    } catch (error) {
      console.error("Failed to update candidate details before scheduling", error);
      const data = error?.response?.data;
      const status = error?.response?.status;
      const detailText = flattenBulkEditErrors(data?.details || data?.errors || data).join("; ");
      const candidateErrors = data?.errors?.candidates || data?.errors ||
        data?.validation_errors || data?.candidates || {};
      const candidateDetails = scheduleReviewRows.flatMap(row => {
        const id = String(row.candidate_id || row.candidate || row.id);
        if (!candidateErrors[id]) return [];
        return [`${getCandidateFullName(row) || "Candidate"} (${id}): ${flattenBulkEditErrors(candidateErrors[id]).join("; ")}`];
      }).join(" | ");
      setScheduleReviewError(
        status === 403
          ? "You do not have permission to update candidate details."
          : candidateDetails || data?.message ||
            data?.error ||
            detailText ||
            "Unable to update candidate details. Please check the values and try again."
      );
    } finally {
      setScheduleReviewSaving(false);
    }
  };

  // opens the real schedule dialog
  const proceedToScheduleInterview = (job, selectedCandidates) => {
    setScheduleInterviewJob(job);
    setScheduleInterviewCandidates(
      selectedCandidates.map(candidate => ({
        ...candidate,
        job_id: candidate?.job_id || job?.job_id || job?.id,
        job_title: candidate?.job_title || job?.job_title,
        company_id: candidate?.company_id || job?.company_id || companyId,
      }))
    );
    setScheduleInterviewCandidate({
      ...selectedCandidates[0],
      job_id: selectedCandidates[0]?.job_id || job?.job_id || job?.id,
      job_title: selectedCandidates[0]?.job_title || job?.job_title,
      company_id: selectedCandidates[0]?.company_id || job?.company_id || companyId,
    });
    setScheduleInterviewModalOpen(true);
  };

  useEffect(() => {
    const fetchOutreachAnalytics = async () => {
      if (!showOutreachResultsModal || !configureCallJob?.id) return;

      setOutreachAnalyticsLoading(true);
      setOutreachAnalyticsError("");

      try {
        const response = await axios.get("/api/v1/notifications-analytics-view/", {
          params: { job_id: configureCallJob.id },
        });
        setOutreachAnalytics(response.data || null);
      } catch (error) {
        setOutreachAnalytics(null);
        setOutreachAnalyticsError(
          error?.response?.data?.message || "Failed to load outreach analytics."
        );
      } finally {
        setOutreachAnalyticsLoading(false);
      }
    };

    fetchOutreachAnalytics();
  }, [showOutreachResultsModal, configureCallJob?.id]);

  useEffect(() => {
  const fetchReviewEmployees = async () => {
      if (!showSendForReviewModal || !reviewCompanyId) return;

    setReviewEmployeesLoading(true);
    try {
        const response = await axios.get(`/api/v1/get-all-recruiters/?company_id=${reviewCompanyId}`);
      const options = (response.data || []).map(user => ({
        value: user.id,
          label: `${user.first_name || ""} ${user.middle_name || ""} ${user.last_name || ""}`.trim() || user.email || "User",
      }));
      setReviewEmployeeOptions(options);
    } catch (error) {
      setReviewEmployeeOptions([]);
      Swal.fire({
        icon: "error",
        title: "Employees Load Failed",
        text: error?.response?.data?.message || "Unable to load employees.",
      });
    } finally {
      setReviewEmployeesLoading(false);
    }
  };

  fetchReviewEmployees();
  }, [showSendForReviewModal, reviewCompanyId]);

  const handleOpenSendForReviewModal = (job) => {
    setReviewQuestionJob(job);
    setReviewCompanyId(job?.company_id || companyId || "");
    setReviewSelectedEmployee(null);
    setReviewEmployeeOptions([]);
    setShowSendForReviewModal(true);
  };

  const handleCloseSendForReviewModal = () => {
    setShowSendForReviewModal(false);
    setReviewQuestionJob(null);
    setReviewCompanyId("");
    setReviewSelectedEmployee(null);
    setReviewEmployeeOptions([]);
  };

  const handleSendForReview = async () => {
    if (!reviewCompanyId) {
      Swal.fire({
        icon: "warning",
        title: "Select Company",
        text: "Please select a company.",
      });
      return;
    }

    if (!reviewSelectedEmployee) {
      Swal.fire({
        icon: "warning",
        title: "Select Employee",
        text: "Please select an employee.",
      });
      return;
    }

    setReviewSending(true);

    try {
      const response = await axios.post("/api/v1/review-questions-mail/", {
        job_id: reviewQuestionJob?.id || reviewQuestionJob?.job_id,
        user_ids: [reviewSelectedEmployee.value],
        review_link: buildReviewQuestionsLink(reviewQuestionJob, reviewCompanyId),
      });

      if (!isSuccessfulDelivery(response, [200, 201, 202])) {
        throw Object.assign(new Error(deliveryErrorMessage(response.data)), { response });
      }

      await Swal.fire({
        icon: "success",
        title: "Review Link Sent",
        text: response?.data?.message || "Review questions mail sent successfully.",
        confirmButtonText: "OK",
      });

      handleCloseSendForReviewModal();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Send Failed",
        text:
          deliveryErrorMessage(error?.response?.data),
        confirmButtonText: "OK",
      });
    } finally {
      setReviewSending(false);
    }
  };
  const handleConfigureCallOpen = (job) => {
    const fq = job?.first_screening_questions || {};
    const firstScreening = Object.values(fq).filter(q => typeof q === "string" && q.trim() !== "");
    const firstScreeningArr = firstScreening.length > 0 ? firstScreening : [""];

    const sq = job?.second_screening_questions || {};
    const secondSQ = {};
    Object.entries(sq).forEach(([category, questions]) => {
      secondSQ[category] = Array.isArray(questions) && questions.length > 0 ? questions : [""];
    });

    const consentUrl = buildConsentScheduleUrl(job);

    setConfigureCallJob(job);
    setOriginalSecondSQ(JSON.parse(JSON.stringify(secondSQ)));
    setConfigureCallData({
      testType: testTypeOptions[0],
      agent: null,
      source: null,
      scheduleDate: null,
      firstScreeningQuestions: firstScreeningArr,
      secondScreeningQuestions: secondSQ,
    });
    setConfigureCallStep("second");
    setConfigureCallModal(true);
  };
  const handleAddSecondSQ = (category) => {
    setConfigureCallData(prev => ({
      ...prev,
      secondScreeningQuestions: {
        ...prev.secondScreeningQuestions,
        [category]: [...(prev.secondScreeningQuestions[category] || []), ""],
      },
    }));
  };

  const handleEditSecondSQ = (category, index, value) => {
    setConfigureCallData(prev => ({
      ...prev,
      secondScreeningQuestions: {
        ...prev.secondScreeningQuestions,
        [category]: prev.secondScreeningQuestions[category].map((q, i) => (i === index ? value : q)),
      },
    }));
  };

  const handleRemoveSecondSQ = (category, index) => {
    setConfigureCallData(prev => ({
      ...prev,
      secondScreeningQuestions: {
        ...prev.secondScreeningQuestions,
        [category]: prev.secondScreeningQuestions[category].filter((_, i) => i !== index),
      },
    }));
  };

  // first screening question handlers
  const handleAddFirstSQ = () => {
    setConfigureCallData(prev => ({
      ...prev,
      firstScreeningQuestions: [...prev.firstScreeningQuestions, ""],
    }));
  };
  const handleEditFirstSQ = (index, value) => {
    setConfigureCallData(prev => ({
      ...prev,
      firstScreeningQuestions: prev.firstScreeningQuestions.map((q, i) => (i === index ? value : q)),
    }));
  };
  const handleRemoveFirstSQ = (index) => {
    setConfigureCallData(prev => ({
      ...prev,
      firstScreeningQuestions: prev.firstScreeningQuestions.filter((_, i) => i !== index),
    }));
  };

  const handleConfigureCallClose = () => {
    setConfigureCallModal(false);
    setConfigureCallStep("first");
    setFirstScreeningData([]);
  };

  const [loadingInitiateCall, setLoadingInitiateCall] = useState(false);
  const handleInitiateFirstScreening = async () => {
    const jobId = configureCallJob?.id;
    const candidateIds = selectedCandidateRows[jobId] || [];

    if (!jobId || candidateIds.length === 0) {
      Swal.fire("Warning", "Please select at least one candidate.", "warning");
      return;
    }
    if (!configureCallData?.agent) {
      Swal.fire("Warning", "Please select an agent.", "warning");
      return;
    }
    if (!configureCallData?.agent?.voice_code) {
      Swal.fire({
        icon: "warning",
        title: "Voice Not Configured",
        html: `The selected agent does not have a voice configured.<br/><br/><small style="color:#6c757d;"><strong>Note:</strong> Go to <b>Agent Creation</b> to configure a voice.</small>`,
        confirmButtonText: "OK",
      });
      return;
    }

    const questions = configureCallData?.firstScreeningQuestions?.filter(q => q.trim() !== "");

    setLoadingInitiateCall(true);
    try {
      await axios.patch("/api/v1/update-screening-questions/", {
        job_id: jobId,
        first_screening_questions: Object.fromEntries(questions.map((q, i) => [String(i + 1), q])),
      });

      const consentLink = `${window.location.origin}/callconsent`;
      const response = await axios.post("api/v1/send-consent-mail/", {
        job_candidate_id: candidateIds.join(","),
        agent_id: configureCallData.agent.agent_id || configureCallData.agent.value,
        questions: { questions },
        interview_round: "primary",
        consent_link: consentLink,
        ...(configureCallData.source ? { source: configureCallData.source.value } : {}),
      });
     const { skipped = [] } = response.data || {};
      if (!isSuccessfulDelivery(response, [200, 201, 202]) || skipped.length > 0) {
        await Swal.fire({
          title: "Consent delivery failed",
          text: deliveryErrorMessage({
            ...response.data,
            message: response.data?.message || skipped.map(item => item?.reason).filter(Boolean).join("; "),
          }),
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }
      if (skipped.length > 0) {
        const reasons = skipped.map(item => `${item.reason}`).join("<br/>");
        await Swal.fire({
          title: "Action Not Allowed",
          html: reasons,
          icon: "warning",
          confirmButtonText: "OK",
        });
      } 
      else {
        await Swal.fire({
          title: "Success!",
          text: "Consent request sent successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
      }
      setSelectedCandidateRows(prev => {
        const updated = { ...prev };
        delete updated[jobId];
        return updated;
      });
      setSelectedCandidateRowData(prev => {
        const updated = { ...prev };
        delete updated[jobId];
        return updated;
      });
      handleConfigureCallClose();
      getCandidateDetails(jobId);
    } catch (error) {
      const msg = error?.response?.data?.error || error?.response?.data?.message || "Failed to initiate call.";
      Swal.fire("Error", msg, "error");
    } finally {
      setLoadingInitiateCall(false);
    }
  };

  // ---------- phone call confirmation modal state ----------
  const handleCreateCall = async () => {
  const jobId = configureCallJob?.id;
  const candidateIds = selectedCandidateRows[jobId] || [];

  if (!jobId || candidateIds.length === 0) {
    Swal.fire("Warning", "Please select at least one candidate.", "warning");
    return;
  }

  const agentId = configureCallData.agent?.value;
  if (!agentId) {
    Swal.fire("Warning", "Please select an agent.", "warning");
    return;
  }

  if (!configureCallData.agent?.voice_code) {
    Swal.fire({
      icon: "warning",
      title: "Voice Not Configured",
      html: `The selected agent does not have a voice configured. Please assign a voice to this agent before sending consent.<br/><br/><small style="color:#6c757d;"><strong>Note : </strong>To configure a voice, go to <b>Agent Creation</b> and add the voice  for this agent.</small>`,
      confirmButtonText: "OK",
    });
    return;
  }

  const questions = {};
  Object.entries(configureCallData.secondScreeningQuestions).forEach(([category, qs]) => {
    const filtered = qs.filter(q => q.trim() !== "");
    if (filtered.length > 0) {
      questions[category] = filtered;
    }
  });

  let scheduledDateTime = null;

  if (configureCallData.scheduleDate) {
    const d = configureCallData.scheduleDate;
    const pad = (n) => String(n).padStart(2, "0");

    scheduledDateTime = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
      d.getDate()
    )}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}Z`;
  }

  setLoadingCreateCall(true);

  try {
    // Step 1: Call PATCH only if second screening questions were modified
    const hasChanged = JSON.stringify(questions) !== JSON.stringify(
      Object.fromEntries(
        Object.entries(originalSecondSQ).map(([cat, qs]) => {
          const filtered = qs.filter(q => q.trim() !== "");
          return filtered.length > 0 ? [cat, filtered] : null;
        }).filter(Boolean)
      )
    );

    if (hasChanged && Object.keys(questions).length > 0) {
      await axios.patch("/api/v1/update-screening-questions/", {
        job_id: jobId,
        second_screening_questions: questions,
      });
    }

    // Step 2: Send consent mail
    const consentLink = `${window.location.origin}/callconsent`;

    const response = await axios.post("api/v1/send-consent-mail/", {
      job_candidate_id: candidateIds.join(","),
      agent_id: configureCallData.agent?.agent_id || agentId,
      questions,
      interview_round: "secondary",
      consent_link: consentLink,
      ...(scheduledDateTime ? { scheduled_date_time: scheduledDateTime } : {}),
      ...(configureCallData.source ? { source: configureCallData.source.value } : {}),
    });

    const { skipped = [] } = response.data || {};
    if (!isSuccessfulDelivery(response, [200, 201, 202]) || skipped.length > 0) {
      await Swal.fire({
        title: "Consent delivery failed",
        text: deliveryErrorMessage({
          ...response.data,
          message: response.data?.message || skipped.map(item => item?.reason).filter(Boolean).join("; "),
        }),
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

                if (skipped.length > 0) {
                const rows = skipped.map((item, index) => {
                    const name = item?.candidate || `Candidate ${index + 1}`;
                    const reason = item?.reason || "N/A";

                    return `
                    <tr>
                        <td style="padding:10px;border:1px solid #e5e7eb;font-weight:500;">
                        ${name}
                        </td>
                        <td style="padding:10px;border:1px solid #e5e7eb;color:#ef4444;">
                        ${reason}
                        </td>
                    </tr>
                    `;
                }).join("");

                const tableHtml = `
                    <div style="max-height:320px;overflow:auto;border-radius:8px;">
                    <table style="width:100%;border-collapse:collapse;font-size:13px;">
                        
                        <thead style="background:#f8fafc;">
                        <tr>
                            <th style="padding:10px;border:1px solid #e5e7eb;text-align:center;">
                            Candidate Name
                            </th>
                            <th style="padding:10px;border:1px solid #e5e7eb;text-align:center;">
                            Reason
                            </th>
                        </tr>
                        </thead>

                        <tbody>
                        ${rows}
                        </tbody>

                    </table>
                    </div>
                `;

                await Swal.fire({
                    title: "⚠️ Skipped Candidates",
                    html: tableHtml,
                    icon: "warning",
                    width: 720,
                    confirmButtonText: "OK",
                });
                }
    else {
      await Swal.fire({
        title: "Success!",
        text: "Consent request sent successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });
    }
    setSelectedCandidateRows(prev => {
      const updated = { ...prev };
      delete updated[jobId];
      return updated;
    });
    setSelectedCandidateRowData(prev => {
      const updated = { ...prev };
      delete updated[jobId];
      return updated;
    });
    handleConfigureCallClose();
    getCandidateDetails(jobId);
  } catch (err) {
    console.error("Error sending consent request:", err);

    Swal.fire(
      "Error",
      err?.response?.data?.message || "Failed to send consent request.",
      "error"
    );
  } finally {
    setLoadingCreateCall(false);
  }
};
  const [phoneCallModal, setPhoneCallModal] = useState(false);
  const [phoneCallCandidate, setPhoneCallCandidate] = useState(null);
  const [phoneCallLoading, setPhoneCallLoading] = useState(false);

  const handlePhoneCallOpen = (row) => {
     if (!row?.mobile_phone && !row?.candidate_phone) {
    Swal.fire({
      icon: "warning",
      title: "Phone Number Missing",
      html: `Cannot initiate call — <strong>${row?.first_name || ""}</strong> <strong>${row?.last_name || ""}</strong> does not have a phone number.`,
      confirmButtonText: "OK",
    });
    return;
  }
    setPhoneCallCandidate(row);
    setPhoneCallModal(true);
  };
  const handlePhoneCallClose = () => {
    setPhoneCallModal(false);
    setPhoneCallCandidate(null);
  };
  const handlePhoneCallProceed = async () => {
    const jobCandidateId = phoneCallCandidate?.job_candidate_id;
    if (!jobCandidateId) {
      Swal.fire("Warning", "Candidate ID not found.", "warning");
      return;
    }
    try {
      setPhoneCallLoading(true);
      const response = await axios.post("/api/v1/vitel/click2call/", {
        job_candidate_id: jobCandidateId,
      });
      const callUrl = response?.data?.data?.click_to_call_url;
      const message = response?.data?.message || "Call initiated successfully.";
      setPhoneCallModal(false);
      setPhoneCallCandidate(null);
      Swal.fire({
        title: "Success!",
        text: message,
        icon: "success",
        confirmButtonText: "OK",
      }).then(async (result) => {
        if (result.isConfirmed && callUrl) {
          try {
            await fetch(callUrl, { mode: "no-cors" });
          } catch (e) {
            console.error("Error triggering call URL:", e);
          }
        }
      });
    } catch (err) {
      console.error("Error in click2call:", err);
      Swal.fire("Error", err?.response?.data?.message || "Failed to initiate call.", "error");
    } finally {
      setPhoneCallLoading(false);
    }
  };

  const fetchStages = async () => {
    try {
                const response = await axios.get("api/v1/get-all-stages/", {
                
                });
                setStagesList(response.data.results || []);
    } catch (err) {
                console.error("Failed to fetch stages", err);
    }
        };

  useEffect(() => {
            fetchStages();
        }, []);
//   const handleCopyContent = () => {
//     if (!selectedJobDetails) return;
//     const modalBody = document.querySelector('.modal-body');
//     if (!modalBody) return;
//     const contentToCopy = Array.from(modalBody.querySelectorAll('*'))
//       .map(el => {
//             if (el.tagName === 'A') return `${el.textContent}: ${el.href}`;
//             return el.textContent || '';
//       })
//         .filter(text => text.trim() !== '')
//         .join('\n\n');
//     navigator.clipboard.writeText(contentToCopy)
//       .then(() => {
//             setCopySuccess(true);
//             setTimeout(() => setCopySuccess(false), 2000); 
//       })
//         .catch((err) => {
//             console.error("Failed to copy: ", err);
//             alert("Failed to copy content. Please try again.");
//         });
// };
const handleCopyContent = () => {
  if (!selectedJobDetails) return;

  const modalBody = document.querySelector(".modal-body");
  if (!modalBody) return;

  const contentToCopy = Array.from(modalBody.querySelectorAll("*"))
    .map((el) => {
      if (el.tagName === "A") return `${el.textContent}: ${el.href}`;
      return el.textContent || "";
    })
    .filter((text) => text.trim() !== "")
    .join("\n\n");

  navigator.clipboard.writeText(contentToCopy)
    .then(() => {
      Swal.fire({
        icon: "success",
        title: "Copied!",
        text: "Job details copied successfully.",
        showConfirmButton: false,
        timer: 1500,
      });
    })
    .catch((err) => {
      console.error("Failed to copy: ", err);
      Swal.fire({
        icon: "error",
        title: "Copy failed",
        text: "Unable to copy content. Please try again.",
      });
    });
};

   const copyToClipboard = (url) => {
    if (!url) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Link not available.',
        });
        return;
    }

    navigator.clipboard.writeText(url)
      .then(() => {
        Swal.fire({
            icon: 'success',
            title: 'Copied!',
            text: 'Link copied successfully!',
          showConfirmButton: false,
            timer: 1500
        });
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to copy Link.',
        });
        });
    };
  const CustomLoader = () => (
    <OrgTableShimmer columns={6} rows={5} titleWidth="210px" />
  )

  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: "All",
  }

  // ---------- top-level job list ----------
  const [jobOrdersData, setJobOrdersData] = useState([])
  const [loadingJobs, setLoadingJobs] = useState(false)
  const [selectedJobs, setSelectedJobs] = useState([])

  const [totalRows, setTotalRows] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
    const [SelectedJob, setSelectedJob] = useState(false);

  // filter status & list
  const [jobStatusList, setJobStatusList] = useState([])
  const [selectedStatusIdFilter, setSelectedStatusIdFilter] = useState("")

  // company
  const userInfos = JSON.parse(sessionStorage.getItem("user-info") || "{}")
  const companies = userInfos?.user_details?.companies_data || [];
  const getCompanyDomainById = id =>
    companies?.find(c => String(c.company_id) === String(id))?.company_domain ?? null
  const hasVgus = companies.some(
    (c) => c.company_domain === "vgus"
  );
  const loggedInEmail = (
    userInfos?.user_details?.email || userInfos?.email || userInfos?.user_email || ""
  ).trim().toLowerCase()
  const canViewScreeningResults = [
    "anwar@pranathiss.com",
    "pssadmin@bharatpayroll.com",
  ].includes(loggedInEmail)
 useEffect(() => {
  if (hasVgus) {
    setCandidateColumnVisibility(prev => ({
      ...prev,
      resume_score: true,
      is_selected: false,
    }))
  }
}, [hasVgus])
  const extension = userInfos?.user_details?.extension
  const formatTestDate = value => (hasVgus ? convertUTCtoEST(value) : getUTCDateOnly(value));
  const [fromDateMap, setFromDateMap] = useState({})
  const [toDateMap, setToDateMap] = useState({})
  const restoredCompanyState = location.state || {}
  const hasRestoredCompanyId = Object.prototype.hasOwnProperty.call(
    restoredCompanyState,
    "selectedCompanyId"
  )
  const restoredCompanyId = hasRestoredCompanyId
    ? restoredCompanyState.selectedCompanyId
    : restoredCompanyState.companyId
  const intialcompanyId =
    restoredCompanyId !== undefined
      ? restoredCompanyId
      : userInfos?.user_details?.companies_data?.[0]?.company_id ?? null
  const [companyId, setCompanyId] = useState(intialcompanyId)
  const [selectedCompanyDetails, setSelectedCompanyDetails] = useState(null)
  const [selectedCompanyLoading, setSelectedCompanyLoading] = useState(false)
  const recordingCheckInFlight = useRef(false)
  useEffect(() => {
    const numericCompanyId = Number(companyId)
    if (!Number.isFinite(numericCompanyId) || numericCompanyId <= 0) {
      setSelectedCompanyDetails(null)
      setSelectedCompanyLoading(false)
      return undefined
    }

    let cancelled = false
    setSelectedCompanyDetails(null)
    setSelectedCompanyLoading(true)
    axios
      .get(`/api/v1/companyv1?company_id=${numericCompanyId}`)
      .then(response => {
        if (!cancelled) {
          const payload = response.data?.message ?? response.data;
          const companyRecords = Array.isArray(payload) ? payload : [payload];
          const companyDetails = companyRecords.find(company =>
            String(company?.company_id ?? company?.id) === String(numericCompanyId)
          );

          if (companyDetails) {
            setSelectedCompanyDetails(companyDetails)
          } else {
            console.warn(
              "Company details response did not match the selected company:",
              { requestedCompanyId: numericCompanyId, response: response.data }
            )
            setSelectedCompanyDetails(null)
          }
        }
      })
      .catch(error => {
        if (!cancelled) {
          setSelectedCompanyDetails(null)
          console.error("Error loading selected company details:", error)
        }
      })
      .finally(() => {
        if (!cancelled) setSelectedCompanyLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [companyId])
  useEffect(() => {
    setSelectedCandidateRows({})
    setSelectedCandidateRowData({})
    setBulkStageJobId(null)
    setExpandedRowId(null)
    setCandidateDataMap({})
    setCandidateResponseMessageMap({})
    setCurrentPageMap({})
    setPerPageMap({})
    setTotalRowsMap({})
    setSearchMap({})
    setRecruiterFilterMap({})
    setFromDateMap({})
    setToDateMap({})
    setConsentStatusFilterMap({})
    setEmailSentFilterMap({})
    setSendTestFilterMap({})
    setHrmsStatusFilterMap({})
    setHrmsSentCountMap({})
    setCandidateTabMap({})
    // The candidate panel is guarded by these refs. Clear them with the
    // company-scoped data so a matching job id can be fetched again.
    candidateDetailRequestRef.current = {}
    candidatesFetchedRef.current = {}
  }, [companyId, loggedInEmail])

  // ---------- candidate caches & per-job state ----------
  const [candidateDataMap, setCandidateDataMap] = useState({}) // jobId -> [candidates]
  const [loadingCandidatesMap, setLoadingCandidatesMap] = useState({}) // jobId -> bool
  const [candidateTalentScanResultMap, setCandidateTalentScanResultMap] = useState({}) 
  const [loadingTalentScanResultMap, setLoadingTalentScanResultMap] = useState({}) 

  // per-job pagination, per-job perPage, per-job total, per-job search
  const [currentPageMap, setCurrentPageMap] = useState({}) // jobId -> page
  const [perPageMap, setPerPageMap] = useState({}) // jobId -> perPage
  const [totalRowsMap, setTotalRowsMap] = useState({}) // jobId -> total
  const [searchMap, setSearchMap] = useState({}) // jobId -> last applied search
  const [recruiterFilterMap, setRecruiterFilterMap] = useState({}) // jobId -> recruiter IDs who added candidates
  const [recruiterOptions, setRecruiterOptions] = useState([])
  const [recruitersLoading, setRecruitersLoading] = useState(false)
  const [candidateResponseMessageMap, setCandidateResponseMessageMap] = useState({})
  const [candidateFilterResetKeyMap, setCandidateFilterResetKeyMap] = useState({})
  const candidateDetailRequestRef = useRef({})
  const candidatesFetchedRef = useRef({})

  // helper getters
  const getJobCurrentPage = jobId => currentPageMap[jobId] ?? 1
  const getJobPerPage = jobId => perPageMap[jobId] ?? 10
  const getJobTotalRows = jobId => totalRowsMap[jobId] ?? 0
  const resetCandidateFiltersForJob = jobId => {
    setSearchMap(prev => ({ ...prev, [jobId]: "" }))
    setRecruiterFilterMap(prev => ({ ...prev, [jobId]: [] }))
    setFromDateMap(prev => ({ ...prev, [jobId]: "" }))
    setToDateMap(prev => ({ ...prev, [jobId]: "" }))
    setConsentStatusFilterMap(prev => ({ ...prev, [jobId]: "" }))
    setEmailSentFilterMap(prev => ({ ...prev, [jobId]: false }))
    setSendTestFilterMap(prev => ({ ...prev, [jobId]: false }))
    setHrmsStatusFilterMap(prev => ({ ...prev, [jobId]: "" }))
    setHrmsSentCountMap(prev => ({ ...prev, [jobId]: 0 }))
    setCurrentPageMap(prev => ({ ...prev, [jobId]: 1 }))
    setCandidateFilterResetKeyMap(prev => ({
      ...prev,
      [jobId]: (prev[jobId] || 0) + 1,
    }))
  }

  useEffect(() => {
    let cancelled = false
    const fetchRecruiters = async () => {
      setRecruitersLoading(true)
      try {
        const response = await axios.get("/api/v1/ats-users/", {
          params: companyId ? { company_id: companyId } : {},
        })
        const users = Array.isArray(response?.data?.users)
          ? response.data.users
          : Array.isArray(response?.data?.results)
            ? response.data.results
            : Array.isArray(response?.data)
              ? response.data
              : []
        if (!cancelled) {
          setRecruiterOptions(
            users
              .map(user => ({
                value: String(user?.id ?? user?.user_id ?? user?.pk ?? ""),
                label:
                  [user?.first_name, user?.middle_name, user?.last_name]
                    .filter(Boolean)
                    .join(" ") || user?.full_name || user?.name || user?.email || "Unnamed recruiter",
              }))
              .filter(option => option.value)
          )
        }
      } catch (error) {
        if (!cancelled) setRecruiterOptions([])
        console.error("Failed to fetch recruiters", error)
      } finally {
        if (!cancelled) setRecruitersLoading(false)
      }
    }
    fetchRecruiters()
    return () => {
      cancelled = true
    }
  }, [companyId])

  // ---------- modals/other states ----------
  const [AddCandidateModal, setAddCandidateModal] = useState(false)
  const [offerLetterModal, setOfferLetterModal] = useState(false);
  const [offerLetterCandidate, setOfferLetterCandidate] = useState(null);
  const [offerLetterJob, setOfferLetterJob] = useState(null);
  const [isSendingOfferLetter, setIsSendingOfferLetter] = useState(false);
  const [offerLetterContent, setOfferLetterContent] = useState("");
  const closeOfferLetterModal = () => {
    setOfferLetterModal(false);
    setOfferLetterCandidate(null);
    setOfferLetterJob(null);
    setOfferLetterContent("");
    setOfferLetterSubject("");
    setOfferLetterCC("");
  };

  const handleSendOfferLetter = async () => {
    const jobCandidateId = offerLetterCandidate?.job_candidate_id;
    const candidateEmail = offerLetterCandidate?.email || offerLetterCandidate?.candidate_email || "";

    if (!candidateEmail) {
      Swal.fire("Validation", "Candidate email is missing.", "warning");
      return;
    }

    if (!offerLetterSubject?.trim()) {
      Swal.fire("Validation", "Subject is required.", "warning");
      return;
    }

    if (!offerLetterContent?.trim()) {
      Swal.fire("Validation", "Offer letter content is required.", "warning");
      return;
    }

    if (!jobCandidateId) {
      Swal.fire("Warning", "Candidate ID not found.", "warning");
      return;
    }

    setIsSendingOfferLetter(true);

    try {
      await axios.post("/api/v1/send-offer-letter/", {
        job_candidate_id: jobCandidateId,
        subject: offerLetterSubject.trim(),
        cc: offerLetterCC.trim(),
        offer_letter: offerLetterContent,
      });

      Swal.fire({
        icon: "success",
        title: "Offer Letter Sent",
        timer: 1500,
        showConfirmButton: false,
      });

      closeOfferLetterModal();
    } catch (err) {
      Swal.fire(
        "Error",
        err?.response?.data?.message || "Failed to send offer letter.",
        "error"
      );
    } finally {
      setIsSendingOfferLetter(false);
    }
  };
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { register, getValues } = useForm()
  const [selectedFiles, setSelectedFiles] = useState([])
  const activeParsingTaskIdRef = useRef("");
  const parsingCancelledRef = useRef(false);
  const [selectedJobForUpload, setSelectedJobForUpload] = useState(null)
  const [addCandidateProgress, setAddCandidateProgress] = useState({ percent: 0 })
  // console.log(selectedJobForUpload)

  // delete job modal
  const [showDeleteJobModal, setShowDeleteJobModal] = useState(false)
  const [showDeleteCandidateModal, setShowDeleteCandidateModal] =
    useState(false)
  const [candidateDeleteId, setcandidateDeleteId] = useState(null)
    const [SelectedJobIdFromCandidate, setSelectedJobIdFromCandidate] = useState(null)
  const [CandidateDeleteLoader, setCandidateDeleteLoader] = useState(null)
  const [ViewCandidatePopupShow, setViewCandidatePopupShow] = useState(false)
  const [showDetailsModal, setShowDetailsModal] = useState(false);
const [selectedCandidateForDetails, setSelectedCandidateForDetails] = useState(null);
  const [actionTimelineModal, setActionTimelineModal] = useState({ open: false, kind: "", title: "", records: [], jobId: null, page: 1, size: 10, count: 0 });
  const [questionReviewHistoryModal, setQuestionReviewHistoryModal] = useState({ open: false, jobId: null, records: [], loading: false, error: "" });
  const [questionActivityRecord, setQuestionActivityRecord] = useState(null)
  const actionTimelineAbortRef = useRef(null);


  const [selectDate, setSelectDate] = useState()
  const dateChange = date => {
    setSelectDate(date)
  }

  const handleCandidateDlink = data => {
    // console.log(data)
    setSelectedJobIdFromCandidate(data.job_id)
    setShowDeleteCandidateModal(true)
    setcandidateDeleteId(data.job_candidate_id)
    setCandidateNameToDelete(
      [data.first_name, data.middle_name, data.last_name]
        .filter(Boolean)
        .join(" ")
    );
  }
  const [jobToDelete, setJobToDelete] = useState(null)
  const [deleteLoader, setDeleteLoader] = useState(false)

  // send test modal
  const [showSendTestModal, setShowSendTestModal] = useState(false)
  const [sendTestJobId, setSendTestJobId] = useState(null)
  const [sendTestCandidateId, setSendTestCandidateId] = useState(null)

  // telephonic modal
  const [showTelephonicModal, setShowTelephonicModal] = useState(false)
  const [telephonicJob, setTelephonicJob] = useState(null)

  // HRMS modal
  const [showHrmsModal, setShowHrmsModal] = useState(false)
  const [hrmsPayload, setHrmsPayload] = useState(null)
  const [hrmsCompanyId, setHrmsCompanyId] = useState(null)

  // status modal
  const [statusModal, setStatusModal] = useState(false)
  const [selectedJobForStatus, setSelectedJobForStatus] = useState(null)
  // console.log(selectedJobForStatus)
  const [selectedStatusId, setSelectedStatusId] = useState("")

  // add-candidate multiselect state
  const [candidateListingData, setcandidateListingData] = useState([])
  const [internalEmpSelectedValues1, setInternalEmpSelectedValues1] = useState(
    []
  )
  const [userDrop, setusersdrop] = useState([])

  // ---------- initial fetches ----------
  useEffect(() => {
    fetchStatuses()
  }, [])

  const [selectedCandidate, setSelectedCandidate] = useState(null)
  const [jobCandidateDetailsTab, setJobCandidateDetailsTab] = useState("skills")
  const [candidateDetailPanel, setCandidateDetailPanel] = useState("contact")
  const [joiningDate, setJoiningDate] = useState(new Date())
  const [isLoading,setIsLoading]=useState(false)
useEffect(() => {
  if (showEditModal) {
    setValidationError("");
    setTimeout(() => {
      editInputRef.current?.focus();
    }, 0);
  }
}, [showEditModal]);

const handleUpdateCandidateField = async (candidateId, field, value) => {
  const trimmedValue = String(value ?? "").trim();
   if (!hasVgus) {
  if (field === "mobile_phone") {
   const phoneRegex = /^[0-9]{10}$/;
  if (!phoneRegex.test(trimmedValue)) {
    return Swal.fire({
      icon: "error",
      title: "Invalid Phone Number",
      text: "Phone number must be exactly 10 digits and contain only numbers.",
    });
  }
  }
  if (field === "email") {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(trimmedValue)) {
      return Swal.fire({
        icon: "error",
        title: "Invalid Email",
        text: "Please enter a valid email address.",
      });
    }
  }}
  if (field === "total_experience") {
    const experienceValue = Number(trimmedValue);
    if (!trimmedValue || !Number.isFinite(experienceValue) || experienceValue < 0) {
      return Swal.fire({
        icon: "error",
        title: "Invalid Experience",
        text: "Experience must be a valid non-negative number.",
      });
    }
  }
  try {
    setIsLoading(true);

    const payloadKey = field === "mobile_phone"
      ? "candidate_phone"
      : field === "total_experience"
        ? "total_experience"
        : "candidate_email";
    const payload = {
      [payloadKey]: trimmedValue,
      company:companyId
    };

    const response = await axios.patch(
      `/api/v1/candidate-job-links/${candidateId}/`,
      payload
    );

    if (response.status === 200) {
      void trackActivity({
        module: "Candidates",
        action: "Candidate Updated",
        recordType: "candidate",
        recordId: candidateId,
        companyId,
        metadata: {
          changes: {
            [payloadKey]: { old: candidateToEdit?.[payloadKey] ?? null, new: trimmedValue },
          },
          changedPayload: payload,
          jobId: candidateToEdit?.job_id,
          source: "candidate-inline-edit",
        },
      })
      setShowEditModal(false);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: `${field === "mobile_phone" ? "Phone number" : field === "total_experience" ? "Experience" : "Email"} updated successfully.`,
        timer: 1500,
        showConfirmButton: false,
      });

      const jobId = candidateToEdit.job_id;
      resetCandidateFiltersForJob(jobId);
      getCandidateDetails(jobId, 1, perPageMap[jobId] ?? 10, "", "", "", "", false, false);
    }
  } 
      catch (error) {
      console.error(`Error updating ${field}:`, error);

      let errorMessage = `Failed to update ${field}.`;

      if (error.response?.data) {
        if (error.response.data.details) {
          errorMessage = Object.entries(error.response.data.details)
            .map(([f, messages]) => `${f}: ${messages.join(", ")}`)
            .join("; ");
        }
        else if (error.response.data.error) {
          errorMessage = error.response.data.error;
        }
        else if (error.response.data.message) {
          errorMessage = error.response.data.message;
        }
      }

      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
      });
} finally {
    setIsLoading(false);
  }
};



  const ViewCandidateInfo = (candidate, jobId) => {
    const candidates = candidateDataMap[jobId] ?? []
    const index = candidates.findIndex(c => getCandidateRowId(c) === getCandidateRowId(candidate))
    setSelectedCandidate(candidate)
    setViewCandidateIndex(index)
    setViewCandidateJobId(jobId)
    setJobCandidateDetailsTab("skills")
    setCandidateDetailPanel("contact")
    setViewCandidatePopupShow(true)
  }

  const normalizeCandidateList = value => {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (typeof value === "string") {
      return value
        .split(",")
        .map(item => item.trim())
        .filter(Boolean);
    }
    return [];
  };

  const getSelectedCandidateListValue = (...keys) => {
    for (const key of keys) {
      const values = normalizeCandidateList(selectedCandidate?.[key]);
      if (values.length) return values;
    }
    return [];
  };

  const selectedPrimarySkills = getSelectedCandidateListValue("primary_skills", "primary_skill_names");
  const selectedSecondarySkills = getSelectedCandidateListValue("secondary_skills", "secondary_skill_names");
  const selectedOtherSkills = getSelectedCandidateListValue("other_skills", "other_skill_names", "skills");
  const selectedEducationHistory = normalizeCandidateList(selectedCandidate?.education || selectedCandidate?.education_history);
  const selectedEmploymentHistory = normalizeCandidateList(selectedCandidate?.employment || selectedCandidate?.employment_history);
  const selectedCertificateHistory = normalizeCandidateList(selectedCandidate?.certificates || selectedCandidate?.certifications);
  const renderCandidateSkillPills = skills =>
    skills.length > 0 ? (
      skills.map((skill, index) => (
        <span
          key={`${skill}-${index}`}
          style={{
            backgroundColor: "#e9ecef",
            color: "#212529",
            padding: "0.35rem 0.75rem",
            borderRadius: "8px",
            fontSize: "0.9rem",
            fontWeight: "500",
            marginRight: "0.5rem",
            display: "inline-block",
            marginBottom: "0.4rem",
          }}
        >
          {skill}
        </span>
      ))
    ) : (
      <span className="text-muted">-</span>
    );

  const renderCandidateHistoryItems = (items, type) => {
    if (!items.length) {
      return <div className="text-muted small">No records found.</div>;
    }

    return items.map((item, index) => (
      <div
        className="ats-candidate-history-item"
        key={`${type}-${index}`}
        style={{
          borderBottom: index === items.length - 1 ? "none" : "1px solid #eef0f2",
          padding: "0.7rem 0",
        }}
      >
        {type === "education" && (
          <>
            <div className="fw-semibold">{item.degree || "-"}</div>
            <div className="small text-muted">{item.school_name || "-"}</div>
            <div className="small">
              {[item.field_of_study, item.end_year].filter(Boolean).join(" | ") || "-"}
            </div>
          </>
        )}

        {type === "employment" && (
          <>
            <div className="fw-semibold">{item.job_title || "-"}</div>
            <div className="small text-muted">{item.company_name || "-"}</div>
            <div className="small">
              {[item.start_date, item.end_date || ""].filter(Boolean).join(" - ") || "-"}
            </div>
          </>
        )}

        {type === "certificates" && (
          <div className="fw-semibold">
            {item.certificate_name || item.name || item.title || "-"}
          </div>
        )}
      </div>
    ));
  };

  const getCandidateResumeTypeLabel = resumeUrl => {
    if (!resumeUrl) return "";
    const extension = String(resumeUrl).split("?")[0].split(".").pop();
    return extension ? extension.toUpperCase() : "FILE";
  };

  const jobCandidateDetailTabs = [
    { key: "skills", label: "Skills" },
    { key: "education", label: `Education (${selectedEducationHistory.length})` },
    { key: "employment", label: `Employment (${selectedEmploymentHistory.length})` },
    { key: "certificates", label: `Certificates (${selectedCertificateHistory.length})` },
    { key: "resume", label: "Resume" },
  ];

  const jobCandidateTabButtonStyle = isActive => ({
    border: "1px solid #dee2e6",
    borderBottomColor: isActive ? "#ffffff" : "#dee2e6",
    backgroundColor: isActive ? "#ffffff" : "#f8f9fa",
    color: isActive ? "#0d6efd" : "#495057",
    padding: "0.65rem 0.9rem",
    fontWeight: 700,
    borderRadius: "8px 8px 0 0",
    marginRight: "0.35rem",
    marginBottom: "-1px",
  });

  const renderJobCandidateDetailsTabs = () => (
    <div
      style={{
        border: "1px solid #dee2e6",
        borderRadius: "10px",
        backgroundColor: "#ffffff",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "0.25rem",
          padding: "0.75rem 0.75rem 0",
          borderBottom: "1px solid #dee2e6",
        }}
      >
        {jobCandidateDetailTabs.map(tab => (
          <button
            key={tab.key}
            type="button"
            style={jobCandidateTabButtonStyle(jobCandidateDetailsTab === tab.key)}
            onClick={() => setJobCandidateDetailsTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div style={{ padding: "1rem" }}>
        {jobCandidateDetailsTab === "skills" && (
          <>
            <h6 className="fw-bold mb-2">Primary Skills ({selectedPrimarySkills.length})</h6>
            <div className="mb-3">{renderCandidateSkillPills(selectedPrimarySkills)}</div>
            <h6 className="fw-bold mb-2">Secondary Skills ({selectedSecondarySkills.length})</h6>
            <div className="mb-3">{renderCandidateSkillPills(selectedSecondarySkills)}</div>
            <h6 className="fw-bold mb-2">Other Skills ({selectedOtherSkills.length})</h6>
            <div>{renderCandidateSkillPills(selectedOtherSkills)}</div>
          </>
        )}

        {jobCandidateDetailsTab === "education" && renderCandidateHistoryItems(selectedEducationHistory, "education")}
        {jobCandidateDetailsTab === "employment" && renderCandidateHistoryItems(selectedEmploymentHistory, "employment")}
        {jobCandidateDetailsTab === "certificates" && renderCandidateHistoryItems(selectedCertificateHistory, "certificates")}

        {jobCandidateDetailsTab === "resume" && (
          <ResumePreviewPanel resumeUrl={selectedCandidate?.resume} height="520px" minHeight="520px" />
        )}
      </div>
    </div>
  );

    const [selectedCategoryName, setSelectedCategoryName] = useState("");

  useEffect(() => {
    if (companyId) {
      getJobOrders(companyId, 1, perPage)
    } else {
      // if companyId is not set, still try to fetch (depending on backend)
      getJobOrders(null, 1, perPage)
    }
  }, [companyId, selectedStatusIdFilter, selectedCategoryName])

  // ---------- API helpers ----------

  // Build params object conditionally (only include if value exists)
  const buildParams = obj => {
    const params = {}
    Object.entries(obj).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") params[k] = v
    })
    return params
  }

  const fetchStatuses = async () => {
    try {
      const res = await axios.get("/api/v1/get-all-Job-status/")
      setJobStatusList(res.data.results || [])
    } catch (err) {
      console.error("Failed to fetch statuses", err)
    }
  }
  const [jobSearchText, setJobSearchText] = useState("")
  const handleJobSearch = () => {
    setCurrentPage(1)
  }
    const getCategoryNameById = id => {
        const category = testTypeList.find(item => item.id == id)
        return category ? category.name : null;
    };
  const getUserPermissions = job => {
        const userId = userInfos?.user_details?.user_id
        const userPermission = job.permissions?.find(p => p.user_id === userId)
        return {
            canEditJob: userPermission?.can_edit_job || false,
            canDeleteJob: userPermission?.can_delete_job || false,
        };
    };

  const hasJobApplyLink = job =>
    Boolean(
      job?.website_url ||
      job?.apply_link ||
      job?.application_link ||
      job?.job_apply_link ||
      job?.post_to_website ||
      job?.posted_to_website
    );

  const getJobCompanyName = job =>
    job?.company_name ||
    job?.company_domain ||
    job?.client_name ||
    job?.company?.company_name ||
    job?.company?.company_domain ||
    job?.company ||
    "-";

  const getReportingManagerName = job => {
    const reportingManager = job?.reporting_manager;
    const nestedName = reportingManager && typeof reportingManager === "object"
      ? reportingManager.name || reportingManager.full_name || reportingManager.display_name
      : "";

    return job?.reporting_manager_name || nestedName || "Not assigned";
  };


  const parseValidDate = value => {
    if (!value) return null
    const parsedDate = new Date(value)
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate
  }

  const getJobOpenDays = row => {
    const createdDate = parseValidDate(row?.created_at)
    if (!createdDate) return null

    const endDate = parseValidDate(row?.close_date) || new Date()
    const diffInMs = endDate.getTime() - createdDate.getTime()
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))

    return diffInDays >= 0 ? diffInDays : 0
  }
  const jobOrderRequestRef = useRef(0)
  const jobOrderAbortRef = useRef(null)
  const getJobOrders = async (companyIdParam, page = 1, size = perPage, search, throwOnError = false) => {
    const requestId = ++jobOrderRequestRef.current
    jobOrderAbortRef.current?.abort()
    const controller = new AbortController()
    jobOrderAbortRef.current = controller
    setLoadingJobs(true)
    const searchValue = search !== undefined ? search : jobSearchText || ""
    try {
      const params = buildParams({
        company_id: companyIdParam,
        page,
        size,
        status_id: selectedStatusIdFilter,
        category_name: getCategoryNameById(selectedCategoryName),
        search: searchValue,
        ...(archivedOnly ? { archived_only: true } : {}),
      })

      let response
      let data = []

      if (isMyJobsView) {
        const myJobsResponse = await axios.get(`/api/v1/my-jobs/`, { params, signal: controller.signal })
        response = myJobsResponse
        const myJobsData = myJobsResponse?.data?.results?.data ?? myJobsResponse?.data?.results ?? []
        data = Array.isArray(myJobsData) ? myJobsData : myJobsData ? [myJobsData] : []
      } else {
        response = await axios.get(`/api/v1/create-job-order/`, { params, signal: controller.signal })
        data = response?.data?.results ?? []
      }

      if (requestId !== jobOrderRequestRef.current) return

      if (!Array.isArray(data) && data) data = [data]

      data = data.map((j, idx) => ({
        id: j.id ?? j.job_id ?? j.job_order_id ?? idx + 1,
        job_id: j.job_id ?? j.id ?? j.job_order_id ?? idx + 1,
        job_order_id: j.job_order_id ?? j.job_number ?? j.job_id ?? j.id ?? idx + 1,
        job_title: j.job_title,
        ...j,
      }))

      setJobOrdersData(data)
      setTotalRows(response?.data?.count ?? data.length)
    } catch (err) {
      if (controller.signal.aborted || axios.isCancel(err)) return
      if (requestId !== jobOrderRequestRef.current) return
      console.error(`Error fetching ${isMyJobsView ? "my " : ""}job orders:`, err)
      setJobOrdersData([])
      setTotalRows(0)
      if (throwOnError) throw err
    } finally {
      if (requestId === jobOrderRequestRef.current) {
        setLoadingJobs(false)
      }
    }
  }

  const getCandidateDetails = async (
    jobId,
    page = 1,
    size = 10,
    search = "",
    from_date = "",
    to_date = "",
    consent_status = "",
    email_sent = "",
    send_test = "",
    pipeline_stage = "",
    throwOnError = false,
    hrms_status,
    recruiter_id
  ) => {
    if (!candidateDetailRequestRef.current[jobId]) candidateDetailRequestRef.current[jobId] = 0
    const requestId = ++candidateDetailRequestRef.current[jobId]
    try {
       if (
      from_date &&
      to_date &&
      new Date(to_date) < new Date(from_date)
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Date Range",
        text: "End date should not be less than start date.",
        confirmButtonColor: "#1a5fa8",
      })

      return
    }
      setLoadingCandidatesMap(p => ({ ...p, [jobId]: true }))
      const activeHrmsStatus = hrms_status ?? hrmsStatusFilterMap[jobId] ?? ""
      const activeRecruiterIds = recruiter_id ?? recruiterFilterMap[jobId] ?? []

      const params = buildParams({
        job_id: jobId,
        page,
        size,
        company_id: companyId,
        search: search,
        from_date,
        to_date,
        pipeline_stage: serializePipelineStages(pipeline_stage),
        ...(consent_status ? { consent_status } : {}),
        ...(email_sent === true ? { email_sent: true } : {}),
        ...(send_test === true ? { send_test: true } : {}),
        ...(activeHrmsStatus ? { hrms_status: activeHrmsStatus } : {}),
        ...(activeRecruiterIds.length ? { recruiter_id: activeRecruiterIds } : {}),
      })

      const queryParams = new URLSearchParams()
      Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach(item => queryParams.append(key, String(item)))
        } else {
          queryParams.set(key, String(value))
        }
      })

      const response = await axios.get(
        `/api/v1/candidates/candidates-by-job/`,
        { params: queryParams }
      )
      if (requestId !== candidateDetailRequestRef.current[jobId]) return

      const candidates = Array.isArray(response?.data?.results?.candidates)
        ? response.data.results.candidates
        : []
      const responseMessage = response?.data?.message || response?.data?.detail || ""
      setCandidateResponseMessageMap(prev => ({ ...prev, [jobId]: responseMessage }))

      const hrmsSentCount = response?.data?.hrms_sent_count
      if (hrmsSentCount !== undefined && hrmsSentCount !== null) {
        setHrmsSentCountMap(prev => ({ ...prev, [jobId]: hrmsSentCount }))
      }
      const total = response?.data?.count ?? candidates.length

      const normalized = candidates.map((c, idx) => ({
        ...c,
        bulk_application_id: applicationId(c.job_candidate_id),
        job_candidate_id:
          c.job_candidate_id ??
          c.candidate_job_id ??
          c.candidate_id ??
          c.id ??
          idx + 1,
        candidate_id: c.candidate_id ?? c.id ?? idx + 1,
        job_id: c.job_id ?? c.job?.job_id ?? c.job?.id ?? jobId,
        talent_scan_id:
          c.talent_scan_candidate_id ?? c.talent_scan_id ?? c.talent_scan_candidate?.id ?? null,
      }))

      setCandidateDataMap(prev => ({ ...prev, [jobId]: normalized }))
      setTotalRowsMap(prev => ({ ...prev, [jobId]: total }))
      setPerPageMap(prev => ({ ...prev, [jobId]: size }))
      setCurrentPageMap(prev => ({ ...prev, [jobId]: page }))
      setSearchMap(prev => ({ ...prev, [jobId]: search }))
    } catch (err) {
      if (requestId !== candidateDetailRequestRef.current[jobId]) return
      console.error("Failed to fetch candidates for job", jobId, err)
      setCandidateDataMap(prev => ({ ...prev, [jobId]: [] }))
      setTotalRowsMap(prev => ({ ...prev, [jobId]: 0 }))
      setCandidateResponseMessageMap(prev => ({ ...prev, [jobId]: "" }))
      if (throwOnError) throw err
    } finally {
      if (requestId === candidateDetailRequestRef.current[jobId]) {
        setLoadingCandidatesMap(p => ({ ...p, [jobId]: false }))
      }
    }
  }

  const exportCandidatesForJob = async job => {
    const jobId = job?.id ?? job?.job_id ?? job?.job_order_id
    if (!jobId) return

    const safeJobTitle = sanitizeExportFileName(
      job?.job_title || job?.position || job?.job_order_id || jobId
    )

    const search = searchMap[jobId] ?? ""
    const fromDate = fromDateMap?.[jobId] || "";
    const toDate = toDateMap?.[jobId] || "";
    const consentStatus = consentStatusFilterMap[jobId] || ""
    const emailSent = emailSentFilterMap[jobId] || false
    const sendTest = sendTestFilterMap[jobId] || false
    const recruiterIds = recruiterFilterMap[jobId] || []

    try {
      Swal.fire({
        title: "Preparing export...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      })

      const params = buildParams({
        job_id: jobId,
        page: 1,
        size: 1000,
        company_id: companyId,
        search,
        from_date: fromDate,
        to_date: toDate,
        pipeline_stage: serializePipelineStages(getSelectedPipelineStages(jobId)),
        ...(consentStatus ? { consent_status: consentStatus } : {}),
        ...(emailSent === true ? { email_sent: true } : {}),
        ...(sendTest === true ? { send_test: true } : {}),
        ...(recruiterIds.length ? { recruiter_id: recruiterIds } : {}),
      })

      const response = await axios.get(`/api/v1/candidates/candidate-export-by-job/`, {
        params,
      })

      const candidates = Array.isArray(response?.data?.results?.candidates)
        ? response.data.results.candidates
        : []
      const reportSummary = response?.data?.summary || {}
      const summaryCount = (keys, fallback) => {
        const value = keys.find(key => reportSummary[key] !== undefined && reportSummary[key] !== null)
        const count = value === undefined ? Number.NaN : Number(reportSummary[value])
        return Number.isFinite(count) ? count : fallback
      }

      const normalized = candidates.map((candidate, index) => ({
        ...candidate,
        job_candidate_id:
          candidate.job_candidate_id ??
          candidate.candidate_job_id ??
          candidate.candidate_id ??
          candidate.id ??
          index + 1,
        candidate_id: candidate.candidate_id ?? candidate.id ?? index + 1,
        job_id: candidate.job_id ?? candidate.job?.job_id ?? candidate.job?.id ?? jobId,
        talent_scan_id:
          candidate.talent_scan_candidate_id ??
          candidate.talent_scan_id ??
          candidate.talent_scan_candidate?.id ??
          null,
      }))

      const getAddedAt = candidate =>
        candidate.added_at ||
        candidate.applied_at ||
        candidate.created_at ||
        candidate.applied_date ||
        candidate.timestamp

      const getMonthKey = value => {
        const parsed = new Date(value)
        if (Number.isNaN(parsed.getTime())) return "unknown"
        return `${parsed.getUTCFullYear()}-${String(parsed.getUTCMonth() + 1).padStart(2, "0")}`
      }

      const getMonthLabel = monthKey => {
        if (monthKey === "unknown") return "Unknown Month"
        const [year, month] = monthKey.split("-").map(Number)
        return new Date(Date.UTC(year, month - 1, 1)).toLocaleDateString("en-US", {
          month: "long",
          year: "numeric",
          timeZone: "UTC",
        })
      }

      const exportRows = normalized.map(candidate => ({
        "Job Title": candidate.job_title || job?.job_title || "--",
        "Candidate Name": candidate.candidate_name || getCandidateFullName(candidate) || "--",
        "Candidate Email":
          candidate.candidate_email ||
          candidate.email ||
          candidate.job_candidate__candidate_email ||
          "--",
        "Candidate Phone":
          candidate.candidate_phone ||
          candidate.mobile_phone ||
          candidate.job_candidate__candidate_phone ||
          "--",
        "Added By":
          candidate.applied_by ||
          candidate.added_by_name ||
          candidate.added_by ||
          candidate.created_by ||
          "--",
        "Added At": formatExportDateTime(getAddedAt(candidate)),
        Month: getMonthLabel(getMonthKey(candidate.added_at)),
        addedAtValue: candidate.added_at,
        "Candidate Pipeline Stage": getCandidatePipelineStatus(candidate),
        "Pipeline Logs": getCandidatePipelineLogs(candidate),
        emailsSent: Number(candidate.emails_sent_count || 0),
        interviewsScheduled: Number(candidate.interviews_scheduled_count || 0),
        clickToCallCalls: Number(candidate.click_to_call_count || 0),
      }))

      const ExcelJS = (await import("exceljs")).default
      const workbook = new ExcelJS.Workbook()
      workbook.creator = "Bharat ATS"
      workbook.created = new Date()
      workbook.modified = new Date()

      const columns = [
        "S. No",
        "Job Title",
        "Candidate Name",
        "Candidate Email",
        "Candidate Phone",
        "Added By",
        "Added At",
        "Candidate Pipeline Stage",
        "Pipeline Logs",
      ]
      const columnWidths = [8, 28, 28, 34, 20, 28, 23, 28, 48]
      const colors = {
        navy: "FF123B63",
        blue: "FF1A5FA8",
        paleBlue: "FFEAF4FC",
        border: "FFD4E2EF",
        text: "FF17324D",
        muted: "FF60758A",
        white: "FFFFFFFF",
        stripe: "FFF7FBFF",
      }

      const styleTitle = (sheet, title, subtitle = "") => {
        sheet.mergeCells(1, 1, 1, columns.length)
        const titleCell = sheet.getCell(1, 1)
        titleCell.value = title
        titleCell.font = { bold: true, size: 16, color: { argb: colors.white } }
        titleCell.alignment = { horizontal: "left", vertical: "middle" }
        titleCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: colors.navy } }
        sheet.getRow(1).height = 30

        if (subtitle) {
          sheet.mergeCells(2, 1, 2, columns.length)
          const subtitleCell = sheet.getCell(2, 1)
          subtitleCell.value = subtitle
          subtitleCell.font = { size: 10, color: { argb: colors.muted }, italic: true }
          subtitleCell.alignment = { horizontal: "left", vertical: "middle" }
          sheet.getRow(2).height = 22
        }
      }

      const addHeader = (sheet, rowNumber) => {
        const row = sheet.getRow(rowNumber)
        columns.forEach((column, index) => {
          const cell = row.getCell(index + 1)
          cell.value = column
          cell.font = { bold: true, size: 10, color: { argb: colors.white } }
          cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true }
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: colors.blue } }
          cell.border = {
            top: { style: "thin", color: { argb: colors.border } },
            left: { style: "thin", color: { argb: colors.border } },
            bottom: { style: "thin", color: { argb: colors.border } },
            right: { style: "thin", color: { argb: colors.border } },
          }
        })
        row.height = 28
        sheet.autoFilter = { from: { row: rowNumber, column: 1 }, to: { row: rowNumber, column: columns.length } }
      }

      const addRows = (sheet, rows, startRow) => {
        rows.forEach((data, index) => {
          const row = sheet.getRow(startRow + index)
          const values = [
            index + 1,
            data["Job Title"],
            data["Candidate Name"],
            data["Candidate Email"],
            data["Candidate Phone"],
            data["Added By"],
            data["Added At"],
            data["Candidate Pipeline Stage"],
            data["Pipeline Logs"],
          ]
          values.forEach((value, columnIndex) => {
            const cell = row.getCell(columnIndex + 1)
            cell.value = value
            cell.font = { size: 10, color: { argb: colors.text } }
            cell.alignment = { vertical: "middle", wrapText: true }
            if (index % 2 === 1) {
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: colors.stripe } }
            }
            cell.border = {
              top: { style: "thin", color: { argb: colors.border } },
              left: { style: "thin", color: { argb: colors.border } },
              bottom: { style: "thin", color: { argb: colors.border } },
              right: { style: "thin", color: { argb: colors.border } },
            }
          })
          row.height = Math.max(
            24,
            ...values.map(value => String(value).split("\n").length * 18 + 8)
          )
        })
      }

      const prepareSheet = (sheet, title, subtitle, rows) => {
        styleTitle(sheet, title, subtitle)
        const headerRow = 4
        addHeader(sheet, headerRow)
        addRows(sheet, rows, headerRow + 1)
        columns.forEach((_, index) => { sheet.getColumn(index + 1).width = columnWidths[index] })
        sheet.views = [{ state: "frozen", ySplit: headerRow }]
        sheet.pageSetup = { orientation: "landscape", fitToPage: true, fitToWidth: 1, fitToHeight: 0 }
      }

      const filterLabel = [
        fromDate ? `From: ${fromDate}` : "From: All dates",
        toDate ? `To: ${toDate}` : "To: All dates",
      ].join("  |  ")
      const monthOrder = value => {
        if (value === "Unknown Month") return Number.MAX_SAFE_INTEGER
        const timestamp = Date.parse(value)
        return Number.isNaN(timestamp) ? Number.MAX_SAFE_INTEGER : timestamp
      }
      const groupedRows = new Map()
      exportRows.forEach(row => {
        if (!groupedRows.has(row.Month)) groupedRows.set(row.Month, [])
        groupedRows.get(row.Month).push(row)
      })
      const backendMonthSummary = Array.isArray(reportSummary.month_summary)
        ? reportSummary.month_summary
        : []
      const backendMonthMap = new Map(backendMonthSummary.map(month => [month.month, month]))
      const sortedMonths = [...new Set([
        ...groupedRows.keys(),
        ...backendMonthSummary.map(month => month.month),
      ])].sort((a, b) => monthOrder(b) - monthOrder(a))
      const monthSummary = sortedMonths.map(month => {
        const rows = groupedRows.get(month) || []
        const backendMonth = backendMonthMap.get(month) || {}
        return {
          month,
          candidates: Number(backendMonth.candidates ?? rows.length),
          recruiters_count: Number(backendMonth.recruiters_count || 0),
          recruiters: Array.isArray(backendMonth.recruiters) ? backendMonth.recruiters : [],
          emails_sent: rows.reduce((total, row) => total + Number(row.emailsSent || 0), 0),
          interviews_scheduled: rows.reduce((total, row) => total + Number(row.interviewsScheduled || 0), 0),
          click_to_call_calls: rows.reduce((total, row) => total + Number(row.clickToCallCalls || 0), 0),
        }
      })

      if (sortedMonths.length) {
        const sheet = workbook.addWorksheet("Candidates")
        styleTitle(sheet, `${job?.job_title || "Job"} - Candidate Report`, filterLabel)
        columns.forEach((_, index) => { sheet.getColumn(index + 1).width = columnWidths[index] })
        let nextRow = 4

        sortedMonths.forEach(month => {
          const monthRows = (groupedRows.get(month) || []).sort((a, b) =>
            new Date(b.addedAtValue || 0) - new Date(a.addedAtValue || 0)
          )

          sheet.mergeCells(nextRow, 1, nextRow, columns.length)
          const monthCell = sheet.getCell(nextRow, 1)
          monthCell.value = month
          monthCell.font = { bold: true, size: 12, color: { argb: colors.text } }
          monthCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: colors.paleBlue } }
          monthCell.alignment = { horizontal: "left", vertical: "middle" }
          sheet.getRow(nextRow).height = 24
          nextRow += 1

          addHeader(sheet, nextRow)
          addRows(sheet, monthRows, nextRow + 1)
          nextRow += monthRows.length + 3
        })

        sheet.mergeCells(nextRow, 1, nextRow, columns.length)
        const summaryTitle = sheet.getCell(nextRow, 1)
        summaryTitle.value = "Month-wise Summary"
        summaryTitle.font = { bold: true, size: 12, color: { argb: colors.text } }
        summaryTitle.fill = { type: "pattern", pattern: "solid", fgColor: { argb: colors.paleBlue } }
        summaryTitle.alignment = { horizontal: "left", vertical: "middle" }
        sheet.getRow(nextRow).height = 24
        nextRow += 1

        const summaryHeaders = [
          "Month",
          "Candidates",
          "Recruiters",
          "Emails Sent",
          "Interviews Scheduled",
          "Click-to-Call Calls",
        ]
        summaryHeaders.forEach((header, index) => {
          const cell = sheet.getCell(nextRow, index + 1)
          cell.value = header
          cell.font = { bold: true, size: 10, color: { argb: colors.white } }
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: colors.blue } }
          cell.alignment = { horizontal: "center", vertical: "middle" }
          cell.border = {
            top: { style: "thin", color: { argb: colors.border } },
            left: { style: "thin", color: { argb: colors.border } },
            bottom: { style: "thin", color: { argb: colors.border } },
            right: { style: "thin", color: { argb: colors.border } },
          }
        })
        nextRow += 1

        monthSummary.forEach((summary, index) => {
          const summaryRow = sheet.getRow(nextRow)
          summaryRow.getCell(1).value = summary.month
          summaryRow.getCell(2).value = summary.candidates
          summaryRow.getCell(3).value = summary.recruiters_count
          summaryRow.getCell(4).value = summary.emails_sent
          summaryRow.getCell(5).value = summary.interviews_scheduled
          summaryRow.getCell(6).value = summary.click_to_call_calls
          summaryRow.eachCell({ includeEmpty: true }, cell => {
            cell.font = { size: 10, color: { argb: colors.text } }
            cell.alignment = { vertical: "middle" }
            if (index % 2 === 1) {
              cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: colors.stripe } }
            }
            cell.border = {
              top: { style: "thin", color: { argb: colors.border } },
              left: { style: "thin", color: { argb: colors.border } },
              bottom: { style: "thin", color: { argb: colors.border } },
              right: { style: "thin", color: { argb: colors.border } },
            }
          })
          nextRow += 1

          sheet.mergeCells(nextRow, 1, nextRow, summaryHeaders.length)
          const recruiterBreakdown = summary.recruiters.length
            ? summary.recruiters.map(recruiter => {
              const count = Number(recruiter.candidates || 0)
              return `${recruiter.recruiter_name || "Unknown recruiter"}: ${count} ${count === 1 ? "candidate" : "candidates"}`
            }).join(" | ")
            : "No recruiter breakdown"
          const breakdownCell = sheet.getCell(nextRow, 1)
          breakdownCell.value = recruiterBreakdown
          breakdownCell.font = { size: 10, italic: true, color: { argb: colors.muted } }
          breakdownCell.alignment = { vertical: "middle", wrapText: true }
          breakdownCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: colors.paleBlue } }
          sheet.getRow(nextRow).height = 24
          nextRow += 1
        })

        const totalSummaryRow = sheet.getRow(nextRow)
        totalSummaryRow.getCell(1).value = "Total"
        const monthTotals = monthSummary.reduce(
          (totals, summary) => ({
            candidates: totals.candidates + summary.candidates,
            recruiters_count: totals.recruiters_count + summary.recruiters_count,
            emails_sent: totals.emails_sent + summary.emails_sent,
            interviews_scheduled: totals.interviews_scheduled + summary.interviews_scheduled,
            click_to_call_calls: totals.click_to_call_calls + summary.click_to_call_calls,
          }),
          { candidates: 0, recruiters_count: 0, emails_sent: 0, interviews_scheduled: 0, click_to_call_calls: 0 }
        )
        totalSummaryRow.getCell(2).value = monthSummary.length
          ? monthTotals.candidates
          : summaryCount(["total_candidates"], 0)
        totalSummaryRow.getCell(3).value = monthTotals.recruiters_count
        totalSummaryRow.getCell(4).value = monthSummary.length
          ? monthTotals.emails_sent
          : summaryCount(["emails_sent", "emails_sent_count"], 0)
        totalSummaryRow.getCell(5).value = monthSummary.length
          ? monthTotals.interviews_scheduled
          : summaryCount(["interviews_scheduled", "interviews_scheduled_count"], 0)
        totalSummaryRow.getCell(6).value = summaryCount(["click_to_call_calls"], 0)
        totalSummaryRow.eachCell({ includeEmpty: true }, cell => {
          cell.font = { bold: true, size: 10, color: { argb: colors.text } }
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: colors.paleBlue } }
          cell.alignment = { vertical: "middle" }
        })
        sheet.getColumn(1).width = Math.max(sheet.getColumn(1).width || 0, 24)
        sheet.getColumn(2).width = Math.max(sheet.getColumn(2).width || 0, 28)
        sheet.getColumn(3).width = Math.max(sheet.getColumn(3).width || 0, 16)
        sheet.getColumn(4).width = Math.max(sheet.getColumn(4).width || 0, 18)
        sheet.getColumn(5).width = Math.max(sheet.getColumn(5).width || 0, 24)
        sheet.getColumn(6).width = Math.max(sheet.getColumn(6).width || 0, 22)
        sheet.views = [{ state: "frozen", ySplit: 4 }]
        sheet.pageSetup = { orientation: "landscape", fitToPage: true, fitToWidth: 1, fitToHeight: 0 }
      } else {
        prepareSheet(
          workbook.addWorksheet("Candidates"),
          `${job?.job_title || "Job"} - Candidate Report`,
          filterLabel,
          []
        )
      }

      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
      const url = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.download = `${safeJobTitle}_Candidates_Monthly.xlsx`
      document.body.appendChild(link)
      link.click()
      link.remove()
      URL.revokeObjectURL(url)
    } catch (error) {
      console.error("Failed to export candidates:", error)
      Swal.fire({
        icon: "error",
        title: "Export failed",
        text: "Unable to download candidate data right now.",
      })
    } finally {
      Swal.close()
    }
  }

  // ---------- candidate pagination & search handlers (per-job) ----------
  const candidateSearchFocusJobRef = useRef(null)
  const handleCandidateSearch = async (jobId, searchValue) => {
    candidateSearchFocusJobRef.current = jobId
    const page = 1
    const size = perPageMap[jobId] ?? 10
    const fromDate = fromDateMap?.[jobId] || ""
    const toDate = toDateMap?.[jobId] || ""
    setSearchMap(p => ({ ...p, [jobId]: searchValue }))
    await getCandidateDetails(
    jobId, page, size, searchValue, fromDate, toDate,
    consentStatusFilterMap[jobId] || "",
    emailSentFilterMap[jobId] || false,
    sendTestFilterMap[jobId] || false,
    getSelectedPipelineStages(jobId)
  )
  }

  const handlePageChangeForJob = async (jobId, page) => {
    const size = perPageMap[jobId] ?? 10
    const search = searchMap[jobId] ?? ""
    const fromDate = fromDateMap?.[jobId] || ""
    const toDate = toDateMap?.[jobId] || ""
  const consentStatus = consentStatusFilterMap[jobId] || ""
  const emailSent = emailSentFilterMap[jobId] || false
  const sendTest = sendTestFilterMap[jobId] || false
  setCurrentPageMap(p => ({ ...p, [jobId]: page }))
  await getCandidateDetails(jobId, page, size, search, fromDate, toDate, consentStatus, emailSent, sendTest, getSelectedPipelineStages(jobId))
}

  const handlePerRowsChangeForJob = async (jobId, newPerPage, page) => {
    const search = searchMap[jobId] ?? ""
    const fromDate = fromDateMap?.[jobId] || "";
    const toDate = toDateMap?.[jobId] || "";
  const consentStatus = consentStatusFilterMap[jobId] || ""
  const emailSent = emailSentFilterMap[jobId] || false
  const sendTest = sendTestFilterMap[jobId] || false
    if ((perPageMap[jobId] ?? 10) !== newPerPage) {
      setCurrentPageMap(p => ({ ...p, [jobId]: 1 }))
      page = 1
    }
    setPerPageMap(p => ({
      ...p,
      [jobId]: newPerPage === -1 ? totalRowsMap[jobId] ?? 0 : newPerPage,
    }))
    await getCandidateDetails(
      jobId,
      page,
      newPerPage === -1 ? totalRowsMap[jobId] ?? 0 : newPerPage,
      search,
      fromDate,
      toDate,
    consentStatus,
    emailSent,
    sendTest,
    getSelectedPipelineStages(jobId)
    )
  }

  // ---------- file upload helpers (for Add Candidate modal) ----------
  const addValidFiles = files => {
    if (!files.length) return
    const validFiles = files.filter(file =>
      [".pdf", ".doc", ".docx"].some(ext =>
        file.name.toLowerCase().endsWith(ext)
      )
    )
    const queuedAt = new Date().toISOString()
    setSelectedFiles(prev => [
      ...prev,
      ...validFiles
        .filter(f => !prev.some(p => (p.file?.name || p.name) === f.name))
        .map(file => ({ file, queuedAt })),
    ])
  }

  const resumeparsinguploadfiles = e => {
    e.preventDefault()
    let files = []
    if (e.dataTransfer?.items) {
      // Handle drag & drop — supports folders via webkitGetAsEntry
      const items = Array.from(e.dataTransfer.items)
      const entries = items
        .map(item => item.webkitGetAsEntry?.())
        .filter(Boolean)
      const hasDirectory = entries.some(entry => entry.isDirectory)

      if (hasDirectory) {
        const allFiles = []
        let pending = 0
        const readEntry = entry => {
          if (entry.isFile) {
            pending++
            entry.file(file => {
              allFiles.push(file)
              pending--
              if (pending === 0) addValidFiles(allFiles)
            })
          } else if (entry.isDirectory) {
            pending++
            const reader = entry.createReader()
            reader.readEntries(entries => {
              entries.forEach(readEntry)
              pending--
              if (pending === 0) addValidFiles(allFiles)
            })
          }
        }
        entries.forEach(readEntry)
        return
      }
      // No directories — fall through to normal file handling
      files = Array.from(e.dataTransfer.files)
    } else if (e.target?.files) {
      files = Array.from(e.target.files)
    }
    addValidFiles(files)
  }
  // ✅ ADD THIS AT THE TOP WITH OTHER STATES
  const [activeTab, setActiveTab] = useState("upload")
  // const handleSelect = (selectedList) => {
  //     console.log(selectedList)
  //     const ids = selectedList.map((item) => item?.candidate_id);
  //     console.log(ids)
  //     setusersdrop(ids);
  //     setInternalEmpSelectedValues1(selectedList);
  //     if (selectedList.length !== 0) {
  //         let temp = [];
  //         selectedList.map((itme, i) => {
  //             temp.push(itme.candidate_id);
  //         });
  //     } else {
  //     }
  // };
  const getEmpTitleText1 = () => {
    return internalEmpSelectedValues1.map(item => item.name).join(", ")
  }

  const getEmpDisplayText1 = () => {
    if (internalEmpSelectedValues1.length > 0) {
      var temp
      temp = internalEmpSelectedValues1.length
      return `${temp} items selected`
    } else if (internalEmpSelectedValues1.length === 1) {
      return internalEmpSelectedValues1[0].name
    } else {
      return "Select items"
    }
  }
  const getCandidates = async (companyId, page = 1, size = 10) => {
    try {
      if (!companyId || companyId === "all") return; 
      const response = await axios.get(
        `/api/v1/get-all-candidates/?company_id=${companyId}`
      )
      const response_data = response.data.results

      if (response_data) {
        const formatted = response_data.map(item => ({
          ...item,
          display_name: `${item.first_name} ${item.last_name || "-"}`,
          unique_key: `${item.candidate_id}-${item.first_name}`,
        }))

        setcandidateListingData(formatted)
      }
    } catch (error) {
      console.error("Error fetching candidates:", error)
    }
  }
  const handleSelect = selectedList => {
    const uniqueSelected = selectedList.filter(
      (v, i, a) => a.findIndex(t => t.candidate_id === v.candidate_id) === i
    )
    const ids = uniqueSelected.map(item => item.candidate_id)
    setusersdrop(ids)
    setInternalEmpSelectedValues1(uniqueSelected)
  }
  useEffect(() => {
    getCandidates(companyId)
  }, [companyId])
  const AddCandidateForJobCall = () => {
    if (isSubmitting) return
    setAddCandidateModal(false)
    setInternalEmpSelectedValues1([])
    setusersdrop([])
    setActiveTab("upload")
    setSelectedFiles([])
    setAddCandidateProgress({ percent: 0 })
  }

  const handleDeleteFile = index =>
    setSelectedFiles(prev => prev.filter((_, i) => i !== index))

  // const handleUpload = async () => {
  //   if (!selectedJobForUpload) return alert("No job selected!")
  //   setIsSubmitting(true)

  //   try {
  //     let payload = {
  //       job_id: selectedJobForUpload.job_id,
  //       company_id: companyId
  //     }

  //     // ✅ CASE 1: Upload resumes
  //     if (activeTab === "upload") {
  //       if (!selectedFiles.length) {
  //         setIsSubmitting(false)
  //         return alert("Please select at least one resume file!")
  //       }

  //       const attachments = await Promise.all(
  //         selectedFiles.map(
  //           file =>
  //             new Promise((resolve, reject) => {
  //               const reader = new FileReader()
  //               reader.onload = () => {
  //                 resolve({
  //                   file_name: file.name,
  //                   file_data: reader.result.split(",")[1],
  //                 })
  //               }
  //               reader.onerror = reject
  //               reader.readAsDataURL(file)
  //             })
  //         )
  //       )

  //       payload.attachments = attachments
  //     }

  //     // ✅ CASE 2: Select existing candidates
  //     else if (activeTab === "existing") {
  //       if (!internalEmpSelectedValues1.length) {
  //         setIsSubmitting(false)
  //         return alert("Select at least one candidate!")
  //       }

  //       payload.candidate_ids = userDrop
  //     }

  //     // ✅ API CALL
  //     const res = await axios.post(
  //       `/api/v1/candidates/upload-resumes/`,
  //       payload,
  //       {
  //         headers: { "Content-Type": "application/json" },
  //       }
  //     )

  //     if (res.status === 200 || res.data?.status_code === 200) {
  //       // alert("Success!");
  //       setSelectedFiles([])
  //       AddCandidateForJobCall()
  //       getJobOrders(companyId, 1)
  //       setErrorMessage("Candidate Added Successfully")
  //       setErrorAlert(true)
  //       setIsSuccess(true)
  //       getCandidateDetails(selectedJobForUpload.job_id)
  //     } else {
  //       // alert("Failed to process request.");
  //     }
  //   } catch (err) {
  //     console.error("Upload error:", err)
  //     // alert("Error processing request.");
  //   } finally {
  //     setIsSubmitting(false)
  //   }
  // }

  // ---------- delete job ----------
  const [uploadedResumeData, setUploadedResumeData] = useState(null);
  const [showUploadedResumeModal, setShowUploadedResumeModal] = useState(false);
  const getUploadTaskId = data =>
    data?.task_ids?.attachments_task || data?.task_ids?.candidate_ids_task ||
    data?.task_ids?.task_id ||
    data?.attachments_task ||
    data?.task_id ||
    "";

  const getAlreadyLinkedResponse = data => {
    const sources = [
      data,
      data?.result,
      data?.results,
      data?.data,
      data?.data?.result,
      data?.data?.results,
    ].filter(Boolean);
    const nestedItems = sources.flatMap(source => [
      ...(Array.isArray(source?.failed) ? source.failed : []),
      ...(Array.isArray(source?.failed_files) ? source.failed_files : []),
      ...(Array.isArray(source?.failed_resumes) ? source.failed_resumes : []),
    ]);
    return [...sources, ...nestedItems].find(item => item?.already_linked === true) || null;
  };

  const getUploadResult = data =>
    data?.result ||
    data?.results ||
    data?.data?.result ||
    data?.data?.results ||
    data?.data ||
    data ||
    {};

  const uploadResult = getUploadResult(uploadedResumeData);
  const shouldShowNotificationWarning =
    uploadResult?.automation_enabled === true &&
    Array.isArray(uploadResult?.disabled_notification_channels) &&
    uploadResult.disabled_notification_channels.length > 0;

  const getUploadStatus = data =>
    data?.status ?? data?.data?.status ?? "";

  const isUploadSuccessStatus = data => {
    const status = String(getUploadStatus(data) || "").trim().toUpperCase();
    return !status || status === "SUCCESS";
  };

const getUploadFailedFiles = data => {
  const result = getUploadResult(data);
  const files = Array.isArray(result?.failed)
    ? result.failed
    : Array.isArray(result?.failed_files)
      ? result.failed_files
      : Array.isArray(result?.failed_resumes)
        ? result.failed_resumes
        : [];
  const duplicate = getAlreadyLinkedResponse(data);
  return duplicate && !files.some(item => item === duplicate || item?.email === duplicate.email)
    ? [...files, duplicate]
    : files;
};

//   const getUploadSuccessCount = data =>
//   Array.isArray(data?.result?.created)
//     ? data.result.created.length
//     : Number(data?.created_count ?? data?.success_count ?? 0);
const getUploadFailedCount = data => {
  const result = getUploadResult(data);
  const files = getUploadFailedFiles(data);
  return files.length || Number(result?.failed_count ?? 0);
};
const getUploadSuccessCount = data => {
  const result = getUploadResult(data);
  return Array.isArray(result?.created) 
    ? result.created.length 
    : Number(result?.created_count ?? result?.success_count ?? 0);
};
const notificationChannelLabel = channel => ({
  email: "Email OFF",
  sms: "SMS OFF",
  whatsapp: "WhatsApp OFF",
}[String(channel).toLowerCase()] || `${channel} OFF`);
const cancelResumeParsing = async () => {
  const taskId = activeParsingTaskIdRef.current;
  if (!taskId) return;
  try {
    await axios.post(`/api/v1/resume-parsing/${taskId}/cancel/`, {});
    parsingCancelledRef.current = true;
    activeParsingTaskIdRef.current = "";
    Swal.close();
    setIsSubmitting(false);
    setSelectedFiles([]);
    await Swal.fire("Resume parsing cancelled.", "You can upload another batch.", "success");
  } catch (error) {
    const status = error?.response?.status;
    Swal.fire("Error", status === 409 ? "This parsing task has already completed." : status === 404 ? "Parsing task was not found." : "Unable to cancel parsing. Please try again.", "error");
  }
};
const showResumeUploadProcessingToast = (progress = 0) => {
  Swal.fire({
    toast: true,
    customClass: { popup: "resume-processing-toast" },
    position: "top-end",
    icon: "info",
    title: "Resume upload is being processed in the background.",
    text: "Please wait while we fetch the result.",
    showConfirmButton: false,
    // confirmButtonText: "Cancel Parsing",
    // confirmButtonColor: "#dc3545",
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      Swal.showLoading();

      const popup = Swal.getPopup();

      if (popup && !document.getElementById("resume-progress-wrapper")) {
        const wrapper = document.createElement("div");

        wrapper.id = "resume-progress-wrapper";
        wrapper.style.width = "100%";
        wrapper.style.marginTop = "12px";

        wrapper.innerHTML = `
          <div style="
            width:100%;
            height:8px;
            background:#e2e8f0;
            border-radius:999px;
            overflow:hidden;
          ">
            <div
              id="resume-upload-progress-bar"
              style="
                width:${progress}%;
                height:100%;
                background:#6366f1;
                transition:width .4s ease;
              "
            ></div>
          </div>

          <div
            id="resume-upload-progress-text"
            style="
              text-align:right;
              font-size:11px;
              color:#64748b;
              margin-top:4px;
            "
          >
            ${progress}%
          </div>
        `;

        popup.appendChild(wrapper);
      }
    },
  }).then(result => {
    if (result.isConfirmed) cancelResumeParsing();
  });
};
const waitForUploadTask = (taskId) => {
  activeParsingTaskIdRef.current = taskId;
  parsingCancelledRef.current = false;
  return new Promise((resolve, reject) => {
    let progress = 10;

    const updateProgressUI = value => {
      const progressBar = document.getElementById(
        "resume-upload-progress-bar"
      );

      const progressText = document.getElementById(
        "resume-upload-progress-text"
      );

      if (progressBar) {
        progressBar.style.width = `${value}%`;
      }

      if (progressText) {
        progressText.innerText = `${value}%`;
      }
    };

    const check = async () => {
      if (parsingCancelledRef.current) {
        reject(new Error("Resume parsing cancelled."));
        return;
      }
      try {
        // Increase by 20% on each GET API call
        progress = Math.min(progress + 20, 90);

        updateProgressUI(progress);

        setAddCandidateProgress(prev => ({
          percent: Math.max(
            prev.percent || 0,
            Math.min(95, progress)
          ),
        }));

        const response = await axios.get(
          `/api/v1/task-status/${taskId}/`
        );

        const taskData = response?.data || {};
        const status = String(taskData?.status || "").toUpperCase();

        if (status === "SUCCESS") {
          updateProgressUI(100);

          setAddCandidateProgress({
            percent: 100,
          });

          setTimeout(() => {
            Swal.close();
          }, 500);

          resolve(taskData);

        } else if (
          status === "FAILURE" ||
          status === "FAILED"
        ) {
          Swal.close();

          reject(
            new Error(
              taskData?.error || "Task failed."
            )
          );

        } else {
          setTimeout(check, 1000);
        }

      } catch (err) {
        Swal.close();
        reject(err);
      }
    };

    check();
  });
};

//   const handleUpload = async () => {
//   if (!selectedJobForUpload) {
//     return Swal.fire({
//       icon: "warning",
//       title: "No job selected",
//       text: "Please select a job before continuing.",
//     });
//   }

//   setIsSubmitting(true);
//   setAddCandidateProgress({ percent: 5 });

//   try {
//     let payload = {
//       job_id: selectedJobForUpload.job_id,
//       company_id: companyId,
//     };

//     // ✅ CASE 1: Upload resumes
//     if (activeTab === "upload") {
//         if (!selectedFiles.length) {
//           setIsSubmitting(false);
//           setAddCandidateProgress({ percent: 0 });
//           return Swal.fire({
//             icon: "warning",
//             title: "No resumes selected",
//           text: "Please select at least one resume file.",
//         });
//       }
//       setAddCandidateProgress({ percent: 15 });

//       const attachments = await Promise.all(
//         selectedFiles.map(
//           item =>
//             new Promise((resolve, reject) => {
//               const reader = new FileReader();
//               reader.onload = () => {
//                 resolve({
//                   file_name: item.file.name,
//                   file_data: reader.result.split(",")[1],
//                 });
//               };
//               reader.onerror = reject;
//               reader.readAsDataURL(item.file);
//             })
//         )
//       );

//       payload.attachments = attachments;
//     }

//     // ✅ CASE 2: Select existing candidates
//     else if (activeTab === "existing") {
//         if (!internalEmpSelectedValues1.length) {
//           setIsSubmitting(false);
//           setAddCandidateProgress({ percent: 0 });
//           return Swal.fire({
//             icon: "warning",
//             title: "No candidates selected",
//           text: "Please select at least one candidate.",
//         });
//       }

//       payload.candidate_ids = userDrop;
//       setAddCandidateProgress({ percent: 35 });
//     }

//     // ✅ API CALL
//     const res = await axios.post(
//       `/api/v1/candidates/upload-resumes/`,
//       payload,
//       {
//         headers: { "Content-Type": "application/json" },
//         onUploadProgress: progressEvent => {
//           if (!progressEvent?.total) return;

//           const uploadPercent = Math.min(
//             80,
//             35 + Math.round((progressEvent.loaded / progressEvent.total) * 45)
//           );

//           setAddCandidateProgress(prev => ({
//             percent: Math.max(prev.percent, uploadPercent),
//           }));
//         },
//       }
//     );

//   if (res.status === 200 || res.data?.status_code === 200) {
//       setAddCandidateProgress({ percent: 100 });
//       setSelectedFiles([]);
//       await new Promise(resolve => setTimeout(resolve, 350));
//       await getJobOrders(companyId, 1);
//       await getCandidateDetails(selectedJobForUpload.job_id);

//       if (res.data.failed_count > 0) {
//         setUploadedResumeData(res.data);
//         setShowUploadedResumeModal(true);
//       } else {
//         Swal.fire({
//           icon: "success",
//           title: "Success",
//           text: "Candidates added successfully.",
//           timer: 1500,
//           showConfirmButton: false,
//         });
//       }
//       AddCandidateForJobCall();
//     } else {
//       setAddCandidateProgress({ percent: 100 });
//       Swal.fire({
//         icon: "error",
//         title: "Failed",
//         text: "Unable to process the request.",
//       });
//     }
//   } catch (err) {
//     console.error("Upload error:", err);
//     setAddCandidateProgress({ percent: 100 });

//     Swal.fire({
//       icon: "error",
//       title: "Upload failed",
//       text: err?.message || "Something went wrong while processing your request.",
//     });
//   } finally {
//     setIsSubmitting(false);
//   }
// };
 const handleUpload = async () => {
  if (!selectedJobForUpload) {
    return Swal.fire({
      icon: "warning",
      title: "No job selected",
      text: "Please select a job before continuing.",
    });
  }
    if (selectedFiles.length > 20) {
      setIsSubmitting(false);
      setAddCandidateProgress({ percent: 0 });
      return Swal.fire({
        icon: "warning",
        title: "Limit exceeded",
        text: "You can upload a maximum of 20 resumes at a time.",
      });
    }

  setIsSubmitting(true);
  setAddCandidateProgress({ percent: 5 });
  let isBackgroundProcessing = false;

  try {
    const jobId = selectedJobForUpload.job_id;
    let payload = {
      job_id: jobId,
      company_id: companyId,
    };

    // ✅ CASE 1: Upload resumes
   if (activeTab === "upload") {
  if (!selectedFiles.length) {
    setIsSubmitting(false);
    setAddCandidateProgress({ percent: 0 });
    return Swal.fire({
      icon: "warning",
      title: "No resumes selected",
      text: "Please select at least one resume file.",
      });
  }

  if (await hasLegacyWordDocument(selectedFiles.map(item => item.file || item))) {
    setIsSubmitting(false);
    setAddCandidateProgress({ percent: 0 });
    return Swal.fire({
      icon: "warning",
      title: "Microsoft Word 97-2003 Document",
      text: "This .doc file cannot be parsed. Please upload the resume in PDF or DOCX format.",
      confirmButtonText: "OK",
    });
  }

      setAddCandidateProgress({ percent: 15 });

  const attachments = await Promise.all(
    selectedFiles.map(
      item =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
              reader.onload = () => {
                resolve({
                  file_name: item.file.name,
                  file_data: reader.result.split(",")[1],
                });
              };
          reader.onerror = reject;
          reader.readAsDataURL(item.file);
        })
    )
  );

      payload.attachments = attachments;
}

    // ✅ CASE 2: Select existing candidates
    else if (activeTab === "existing") {
        if (!internalEmpSelectedValues1.length) {
          setIsSubmitting(false);
          setAddCandidateProgress({ percent: 0 });
          return Swal.fire({
            icon: "warning",
            title: "No candidates selected",
          text: "Please select at least one candidate.",
        });
      }

      payload.candidate_ids = userDrop;
      setAddCandidateProgress({ percent: 35 });
    }

    // ✅ API CALL
    const res = await axios.post(
      `/api/v1/candidates/upload-resumes/`,
      payload,
      {
        headers: { "Content-Type": "application/json" },
        onUploadProgress: progressEvent => {
          if (!progressEvent?.total) return;

          const uploadPercent = Math.min(
            80,
            35 + Math.round((progressEvent.loaded / progressEvent.total) * 45)
          );

          setAddCandidateProgress(prev => ({
            percent: Math.max(prev.percent, uploadPercent),
          }));
        },
      }
    );

    if ((res.status >= 200 && res.status < 300) || res.data?.status_code === 200) {
      let uploadResult = res.data;
      const taskId = getUploadTaskId(res.data)

      isBackgroundProcessing = true;
      setIsSubmitting(false);
      setAddCandidateModal(false);
      showResumeUploadProcessingToast(10);
            if (taskId) {
        setAddCandidateProgress({ percent: 85 });
        uploadResult = await waitForUploadTask(taskId);
      } else if (!isUploadSuccessStatus(uploadResult)) {
        throw new Error(uploadResult?.error || uploadResult?.message || "Resume upload task failed.");
      }

      // setAddCandidateProgress({ percent: 100 });
      // setSelectedFiles([]);
      // await new Promise(resolve => setTimeout(resolve, 350));
      // await Promise.all([
      //   // getJobOrders(companyId, 1),
      //   getCandidateDetails(jobId),
      //   getCandidates(companyId),
      // ]);
      // Swal.close();
      // if (taskId || getUploadFailedCount(uploadResult) > 0) {
      //   setUploadedResumeData(uploadResult);
      //   setShowUploadedResumeModal(true);
      // } else {
      //   Swal.fire({
      //     icon: "success",
      //     title: "Success",
      //     text: "Candidates added successfully.",
      //     timer: 1500,
      //     showConfirmButton: false,
      //   });
      // }
      setAddCandidateProgress({ percent: 100 });
    setSelectedFiles([]);

    Swal.close();

    const uploadResultForWarnings = getUploadResult(uploadResult);
    const smsWarnings = (Array.isArray(uploadResultForWarnings?.invited)
      ? uploadResultForWarnings.invited
      : [])
      .filter(candidate => candidate?.notification_warning)
      .map(candidate => {
        const name = candidate?.candidate_name || candidate?.name || `Candidate ${candidate?.candidate_id}`;
        return `${name}: ${candidate.notification_warning}`;
      });

    if (smsWarnings.length > 0) {
      await Swal.fire({
        icon: "warning",
        title: "Some SMS Notifications Were Not Sent",
        text: smsWarnings.join("\n"),
        confirmButtonText: "OK",
      });
    }

    // ✅ OPEN MODAL IMMEDIATELY
    if (taskId || getUploadFailedCount(uploadResult) > 0) {
      setUploadedResumeData(uploadResult);
      setShowUploadedResumeModal(true);
    } else {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Candidates added successfully.",
        timer: 1500,
        showConfirmButton: false,
      });
    }

    // ✅ FETCH DATA IN BACKGROUND
    Promise.all([
      getCandidateDetails(jobId),
      getCandidates(companyId),
    ]);

AddCandidateForJobCall();
      AddCandidateForJobCall();
    } else {
      setAddCandidateProgress({ percent: 100 });
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Unable to process the request.",
      });
    }
  } catch (err) {
    console.error("Upload error:", err);
    if (parsingCancelledRef.current) return;
    setAddCandidateProgress({ percent: 100 });
    if (isBackgroundProcessing) {
      Swal.close();
    }

    Swal.fire({
      icon: "error",
      title: "Upload failed",
      text: err?.message || "Something went wrong while processing your request.",
    });
  } finally {
    if (!isBackgroundProcessing) {
      setIsSubmitting(false);
    }
  }
};
  const openDeleteJobModal = job => {
    if (!ensureValidCompanySelected()) return
    setJobToDelete(job)
    setShowDeleteJobModal(true)
  }
    // const handleSendForApproval = async () => {
    //     if (!selectedCandidateForApproval || !approvalReason.trim()) {
    //         Swal.fire({
    //             icon: "error",
    //             title: "Error",
    //             text: "Please provide a reason for approval",
    //         });
    //         return;
    //     }

    //     setIsSendingForApproval(true);
    //     try {
    //         const jobCandidateId = selectedCandidateForApproval.job_candidate_id;
    //         const url = `/api/v1/send-for-approval/send/?job_candidate_id=${jobCandidateId}`;

    //         const response = await axios.patch(url, { reason: approvalReason })

    //         if (response.data) {
    //             Swal.fire({
    //                 icon: "success",
    //                 title: "Success!",
    //                 text: "Candidate sent for approval successfully!",
    //             });
    //               setSendForApprovalModal(false);
    // setApprovalReason("");
    // setSelectedCandidateForApproval(null);
    // setTimeout(() => {
    //   Swal.fire({
    //     icon: "success",
    //     title: "Success!",
    //     text: "Candidate sent for approval successfully!",
    //   });
    // }, 150);

    //             // Update local state to reflect the change
    //             const jobId = selectedCandidateForApproval.job_id
    //             setCandidateDataMap(prev => {
    //                 const updatedCandidates =
    //                     prev[jobId]?.map(candidate =>
    //                         candidate.candidate_id ===
    //                             selectedCandidateForApproval.candidate_id
    //                             ? { ...candidate, send_for_approval: true, is_approved: true }
    //                             : candidate
    //                     ) || []
    //                 return { ...prev, [jobId]: updatedCandidates }
    //             })

    //             // Fetch updated candidate data
    //             await getCandidateDetails(jobId);
    //             // Reset modal state
    //            }
    //     } catch (error) {
    //         console.error("Approval Error:", error);
    //         Swal.fire({
    //             icon: "error",
    //             title: "Error!",
    //             text:
    //                 error.response?.data?.error ||
    //                 "Failed to send candidate for approval. Please try again.",
    //         })
    //     } finally {
    //         // setSendForApprovalModal(false);
    //         // setApprovalReason("");
    //         // setSelectedCandidateForApproval(null);
    //         setIsSendingForApproval(false);
    //     }
    // };

const handleSendForApproval = async () => {
 if (!approvalReason || !approvalReason.trim()) {
  Swal.fire("Error", "Please provide a reason", "error");
  return;
}


  setIsSendingForApproval(true);

  try {
    const jobCandidateId = selectedCandidateForApproval.job_candidate_id;

    await axios.patch(
      `/api/v1/send-for-approval/send/?job_candidate_id=${jobCandidateId}`,
      { reason: approvalReason }
    );

    // ✅ Close modal FIRST
    setSendForApprovalModal(false);
    setApprovalReason("");
    setSelectedCandidateForApproval(null);

    // Small delay ensures modal unmounts fully
    setTimeout(() => {
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Candidate sent for approval successfully!",
      });
    }, 150);

    // Update list AFTER modal close
    const jobId = selectedCandidateForApproval.job_id;
    setCandidateDataMap(prev => ({
      ...prev,
      [jobId]: prev[jobId].map(c =>
        c.candidate_id === selectedCandidateForApproval.candidate_id
          ? { ...c, send_for_approval: true, is_approved: true }
          : c
      ),
    }));

    await getCandidateDetails(jobId);

  } catch (error) {
    Swal.fire(
      "Error",
      error?.response?.data?.error || "Failed to send candidate for approval",
      "error"
    );
  } finally {
    setIsSendingForApproval(false);
  }
};


  const confirmDeleteJob = async () => {
    setDeleteLoader(true)
    try {
      await axios.delete(
        `/api/v1/create-job-order/delete/?job_id=${jobToDelete.id}`
      )
      setShowDeleteJobModal(false)
      setDeleteLoader(false)
      await getJobOrders(companyId, 1)
      setErrorMessage("Job deleted successfully")
      setErrorAlert(true)
      setIsSuccess(true)
    } catch (err) {
      console.error("Delete job failed", err)
      setShowDeleteJobModal(false)
      setDeleteLoader(false)
      setErrorMessage(
        err.response?.data?.detail ||
        err.response?.data?.message ||
        err.response?.data?.error ||
        "Failed to delete job"
      )
      setErrorAlert(true)
      setIsSuccess(false)
    }
  }

    const confirmDeleteCandidate = async () => {
        setCandidateDeleteLoader(true)
        try {
            await axios.delete(`/api/v1/candidate-job-links/${candidateDeleteId}/`)
            // console.log("hello")
            getCandidateDetails(SelectedJobIdFromCandidate, 1)
            setShowDeleteCandidateModal(false)
            setCandidateDeleteLoader(false)
            setErrorMessage("Candidate deleted successfully")
            setErrorAlert(true)
            setIsSuccess(true)
        } catch (err) {
            console.error("Delete job failed", err)
            setShowDeleteCandidateModal(false)
            setCandidateDeleteLoader(false)
            setErrorMessage(err?.response?.data?.error || "Failed to delete candidate")
            setErrorAlert(true)
            setIsSuccess(false)
        }
    };


    const openIntegratedPopup = (candidate, job) => {
        setShowUpgradePopup(true)

    };
  // ---------- send test ----------
  const openSendTestModal = (candidate, job) => {
      if (!job.questions_reviewed) {
    Swal.fire({
      icon: "warning",
      title: "Questions Not Reviewed",
      html: `The screening questions for <strong>${job.job_title}</strong> have not been reviewed yet.<br/><br/>Please send the Questions for review before sending a test.`,
      confirmButtonText: "Send for Review",
       denyButtonText: "Send Test",
      showCancelButton: true,
      showDenyButton: true,
      cancelButtonText: "Cancel",

    })
  .then(result => {
  if (result.isConfirmed) {
    handleOpenSendForReviewModal(job);
    return;
  }

  if (result.isDenied) {
    const missingFields = [];

    if (!candidate?.email && !candidate?.candidate_email)
      missingFields.push("Email");

    if (!candidate?.mobile_phone && !candidate?.candidate_phone)
      missingFields.push("Phone Number");

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Missing Contact Details",
        html: `Cannot send test — missing <b>${missingFields.join(", ")}</b>`,
      });
      return;
    }

    // Open confirmation modal
    setConfirmSendTestCandidate(candidate);
    setConfirmSendTestJob(job);
    setShowConfirmSendTestModal(true);

    setSendTestJobId(job.job_id ?? job.id);
    setSendTestCandidateId(candidate.candidate_id ?? candidate.id);

    return;
  }
});
    return;
  }
  const nonTechnicalCategories = ["non technical", "nontechnical", "non-technical"];
  const categoryName = String(job.category_name || "").toLowerCase().trim();
  if (nonTechnicalCategories.includes(categoryName)) {
  Swal.fire({
    icon: "info",
    title: "Non-Technical Job",
    html: `Talent Scan Test is only available for <strong>Technical</strong> job categories.<br/><br/>
           This job (<strong>${job.job_title}</strong>) is categorized as
           <strong>${job.category_name}</strong>.<br/><br/>
           Do you want to send the  test ?`,
    showDenyButton: true,
    showCancelButton: true,
    denyButtonText: "Send Test",
    confirmButtonText: "OK",
    cancelButtonText: "Cancel",
  }).then(result => {
    if (result.isDenied) {
      const missingFields = [];

      if (!candidate?.email && !candidate?.candidate_email)
        missingFields.push("Email");

      if (!candidate?.mobile_phone && !candidate?.candidate_phone)
        missingFields.push("Phone Number");

      if (missingFields.length > 0) {
        Swal.fire({
          icon: "warning",
          title: "Missing Contact Details",
          html: `Cannot send test — missing <b>${missingFields.join(", ")}</b>`,
        });
        return;
      }

      setConfirmSendTestCandidate(candidate);
      setConfirmSendTestJob(job);
      setShowConfirmSendTestModal(true);

      setSendTestJobId(job.job_id ?? job.id);
      setSendTestCandidateId(candidate.candidate_id ?? candidate.id);

      // OR directly:
      // handleSendTest(job.job_id ?? job.id, candidate.candidate_id ?? candidate.id);
    }
  });

  return;
}
    const missingFields = [];
  if (!candidate?.email && !candidate?.candidate_email) missingFields.push("Email");
  if (!candidate?.mobile_phone && !candidate?.candidate_phone) missingFields.push("Phone Number");

  if (missingFields.length > 0) {
    Swal.fire({
      icon: "warning",
      title: "Missing Contact Details",
      html: `Cannot send test — the following field${missingFields.length > 1 ? "s are" : " is"} missing for <strong>${candidate?.first_name || ""} ${candidate?.middle_name || ""} ${candidate?.last_name || ""}</strong> :<br/><br/><b>${missingFields.join(", ")}</b><br/><br/>Please update the candidate's details before sending the test.`,
      confirmButtonText: "OK",
    });
    return;
  }
    setConfirmSendTestCandidate(candidate);
    setConfirmSendTestJob(job);
    setShowConfirmSendTestModal(true);
    // setLoadingSendTest(true)
    setSendTestJobId(job.job_id ?? job.id)
    setSendTestCandidateId(candidate.candidate_id ?? candidate.id)
    // handleSendTest(job.job_id ?? job.id, candidate.candidate_id ?? candidate.id)
  }

  const handleSendTest = async (jobId, candId) => {
    setLoadingSendTest(true)
    setLoadingSendTestCandidateId(candId)
    try {
      const payload = { job_id: jobId, job_candidate_id: candId }
      const response = await axios.post(`/api/v1/screen/`, payload)
      const successMessage = response?.data?.detail || response?.data?.msg || response?.data?.message || "Test sent successfully"
      await Swal.fire({ icon: "success", title: "Test sent", text: successMessage, confirmButtonText: "OK" })
      await getCandidateDetails(jobId)
    } catch (err) {
      console.error("Send test failed", err)
      setShowSendTestModal(false)
      const detail = err?.response?.data?.detail || err?.response?.data?.error || "Failed to send test."
      await Swal.fire({ icon: "warning", title: "Unable to send test", text: detail, confirmButtonText: "OK" })
    } finally {
      setLoadingSendTest(false)
      setLoadingSendTestCandidateId(null)
    }
  }
    const hasUnsavedCandidateDetails = () => {
      if (!isCandidateStatusDetailsEdit || !selectedCandidateForStatus) {
        return false
      }

      const savedDetails = getCandidateStatusDraft(selectedCandidateForStatus)
      const draft = candidateStatusDetailsDraft || {}

      return Object.keys(savedDetails).some(field => {
        if (field === "relocation") {
          return Boolean(savedDetails[field]) !== Boolean(draft[field])
        }
        return String(savedDetails[field] ?? "").trim() !== String(draft[field] ?? "").trim()
      })
    }

    const handleCandidateStatusUpdate = async () => {
        if (hasUnsavedCandidateDetails()) {
            Swal.fire({
                icon: "warning",
                title: "Save Candidate Details",
                text: "Please click Save Details to save the candidate details and then proceed with the pipeline status update.",
                confirmButtonText: "OK",
            })
            return;
        }

        if (isCandidatePlaced(selectedCandidateForStatus)) {
            return;
        }

        setIsSubmitted(true);
        setCandidateStatusLoader(true);

        if (!selectedCandidateStatusId) {
            setCandidateStatusLoader(false);
            return setCandidateStatusError("Select a status");
        }

         if (!reason?.trim()) {
              setCandidateStatusLoader(false);
              setCandidateStatusError("Reason is mandatory");
              return;
          }


        const selectedStage = stagesList.find(
            stage => stage.id == selectedCandidateStatusId
        )
        if (!selectedStage) {
            setCandidateStatusLoader(false)
            return setCandidateStatusError("Invalid stage selected")
        }
        const isRejectedStage =
          String(selectedStage.name || "").toLowerCase().trim() === "rejected"
        if (isRejectedStage && !candidateRejectedRound) {
            setCandidateStatusLoader(false)
            return setCandidateStatusError("Select rejected round")
        }

        try {
           const { data } = await axios.put(
                `/api/v1/change-stage/${selectedCandidateForStatus.job_candidate_id}/?company_id=${companyId}`,
                {
                    stage: selectedStage.name,
                    reason: reason,
                    ...(isRejectedStage
                      ? {
                          rejected_round: candidateRejectedRound,
                        }
                      : {}),
                }
            )
            // setErrorMessage("Candidate stage updated successfully")
            setErrorMessage("Stage updated successfully · Notifications queued");
            setIsSuccess(true);
            setErrorAlert(true);
            setCandidateStatusModal(false);
            setCandidateStatusLoader(false);
            setCandidateStatusError("");
            setReason("");
            setCandidateRejectedRound("");
            setIsSubmitted(false);
            const jobId = selectedCandidateForStatus.job_id;
            const page = currentPageMap[jobId] ?? 1;
            const size = perPageMap[jobId] ?? 10;
            const search = searchMap[jobId] ?? "";
            const fromDate = fromDateMap?.[jobId] || "";
            const toDate = toDateMap?.[jobId] || "";
            const consentStatus = consentStatusFilterMap[jobId] || "";
            const emailSent = emailSentFilterMap[jobId] || false;
            const sendTest = sendTestFilterMap[jobId] || false;

            await getCandidateDetails(
              jobId,
              page,
              size,
              search,
              fromDate,
              toDate,
              consentStatus,
              emailSent,
              sendTest,
              getSelectedPipelineStages(jobId)
            );
            // await getCandidateDetails(
            //   jobId,
            //   1,
            //   perPageMap[jobId] ?? 10,
            //   "",
            //   "",
            //   "",
            //   "",
            //   false,
            //   false
            // );
        } catch (err) {
            console.error(err);
            setCandidateStatusLoader(false);
            setCandidateStatusModal(false)
            setCandidateStatusError("");
            const errorData = err?.response?.data || {};
            const errorMessage =
              errorData.error ||
              errorData.detail ||
              errorData.message ||
              errorData.msg ||
              (err?.message && err.message !== "Network Error" ? err.message : "Failed to update candidate stage");
            setErrorMessage(errorMessage)
            setIsSuccess(false);
            setErrorAlert(true);
        }
        finally {
    setCandidateStatusLoader(false) 
  }
    };

  const doSendTest = async () => {
    setShowSendTestModal(false)
  }

  // ---------- telephonic ----------
  const openTelephonicModal = job => {
    setTelephonicJob(job)
    setShowTelephonicModal(true)
  }

  const doTelephonicCall = async () => {
    try {
      // placeholder: call telephonic API if exists
      setShowTelephonicModal(false)
      setErrorMessage("Telephonic call logged")
      setErrorAlert(true)
      setIsSuccess(true)
    } catch (err) {
      console.error("telephonic error", err)
      setShowTelephonicModal(false)
      setErrorMessage("Telephonic call failed")
      setErrorAlert(true)
      setIsSuccess(false)
    }
  }

  // ---------- send to HRMS ----------
  const openHrmsModal = candidate => {
    setHrmsPayload(candidate)
    const selectedHrmsCompanyId = candidate?.hrms_company_id ?? candidate?.company_id ?? companyId
    setHrmsCompanyId(selectedHrmsCompanyId)
    const selectedDomain = getCompanyDomainById(selectedHrmsCompanyId)
    if (selectedDomain) setSubdomain(selectedDomain)
    setShowHrmsModal(true)
  }

  const intialcompanydomain =
      getCompanyDomainById(intialcompanyId) ??
      userInfos?.user_details?.companies_data?.[0]?.company_domain ??
      null

  const [subdomain, setSubdomain] = useState(intialcompanydomain)
  useEffect(() => {
    const domain = getCompanyDomainById(companyId)
    if (domain) setSubdomain(domain)
  }, [companyId])

  const formatDate = date => {
    if (!date) return null
    const day = String(date.getDate()).padStart(2, "0")
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const year = date.getFullYear()
    return `${day}-${month}-${year}`
  }

  const doSendToHrms = async () => {
    if (!hrmsCompanyId) {
      await Swal.fire({
        icon: "warning",
        title: "Company required",
        text: "Select the company where this candidate should be sent.",
        confirmButtonText: "OK",
      })
      return
    }

      setLoadingSendToHRMS(true);
    try {
      // console.log(hrmsPayload, "hrmsPayload")
      // Create a fresh axios instance — no global headers/interceptors will apply
      const hrmsAxios = axios.create()
      delete hrmsAxios.defaults.headers.common["Authorization"]

      const payload = {
        company:1,
        job_candidate_id: hrmsPayload.job_candidate_id,
        candidate_id: hrmsPayload.candidate_id,
        first_name: hrmsPayload.first_name,
        last_name: hrmsPayload.last_name,
        middle_name:hrmsPayload.middle_name,
        personal_email: hrmsPayload.email,
        phone: hrmsPayload.mobile_phone,
        X_ATS_TOKEN: "ATS@123",
        date_of_join: joiningDate ? formatDate(joiningDate) : null,
        // date_of_join: "",
        // gender: ""
      }

      await hrmsAxios.post(
        `https://${subdomain}.bharatpayroll.com/qxbox/api/directory/add/new/employee/`,
        payload,
        // {
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        // }
      )
      await getHrmsstatus(hrmsPayload.candidate_id, hrmsPayload.job_id);
      const jobId = hrmsPayload.job_id
      const page = currentPageMap[jobId] ?? 1
      const size = perPageMap[jobId] ?? 10
      const search = searchMap[jobId] ?? ""
      await getCandidateDetails(jobId, page, size, search, fromDateMap?.[jobId] || "", toDateMap?.[jobId] || "")
      setShowHrmsModal(false)
      setErrorMessage("Sent to HRMS")
      setErrorAlert(true)
      setIsSuccess(true)
    } catch (err) {
        console.error("send to hrms failed", err);
      setShowHrmsModal(false);
      const responseData = err?.response?.data
      const errorDetails = responseData?.error || responseData?.details || responseData?.message || responseData
      const formattedError = errorDetails && typeof errorDetails === "object"
        ? Object.entries(errorDetails)
            .map(([field, messages]) => `${field}: ${Array.isArray(messages) ? messages.join(", ") : messages}`)
            .join("\n")
        : String(errorDetails || err?.message || "Unable to send employee details to HRMS.")
      await Swal.fire({
        icon: "error",
        title: "HRMS request failed",
        text: formattedError,
        confirmButtonText: "OK",
      })
        setIsSuccess(false);
    } finally {
      setLoadingSendToHRMS(false)
    }
  }
  const [loadingSendTest, setLoadingSendTest] = useState(false)
  const [loadingSendTestCandidateId, setLoadingSendTestCandidateId] =
    useState(null)

  const [loadingSendToHRMS, setLoadingSendToHRMS] = useState(false)
  const [loadingSendToHRMSCandidateId, setLoadingSendToHRMSCandidateId] =
    useState(null)

  const [loadingDeleteCandidate, setLoadingDeleteCandidate] = useState(false)
  const [loadingDeleteCandidateId, setLoadingDeleteCandidateId] = useState(null)
  const [loadingCandidateTimelineId, setLoadingCandidateTimelineId] = useState(null)
  const [loadingJobTimelineId, setLoadingJobTimelineId] = useState(null)

  const getHrmsstatus = async (candidate_id, job_id) => {
    console.log("candidate_idDeptObjData", candidate_id)

    try {
      const response = await axios.patch(
        `/api/v1/change-hrms-status/?page=1&size=10`,
        { candidate_id: candidate_id,job_id: job_id }
      )
      const response_data = response.data.results
      if (response_data) {
        console.log(response_data)
      } else {
      }
    } catch (error) { }
  }
    const getCandidateTalentScanJobId = candidate => {
    return (
      candidate?.job_id ??
      candidate?.job?.job_id ??
      candidate?.job?.id ??
      candidate?.job_candidate?.job_id ??
      candidate?.job_candidate_job_id ??
      SelectedJob
    )
  }

  const getCandidateTalentScanId = candidate => {
    return (
      candidate?.talent_scan_id ??
      candidate?.candidate_talent_scan_id ??
      candidate?.talent_scan?.id ??
      candidate?.candidate_id ??
      candidate?.id
    )
  }

  const getTalentScanResultKey = candidate => {
    const jobId = getCandidateTalentScanJobId(candidate)
    const talentScanId = getCandidateTalentScanId(candidate)
    return jobId && talentScanId ? `${jobId}-${talentScanId}` : ""
  }

  const fetchCandidateTalentScanResult = async candidate => {
    const resultKey = getTalentScanResultKey(candidate)
    if (!resultKey || candidateTalentScanResultMap[resultKey] || loadingTalentScanResultMap[resultKey]) {
      return
    }

    const jobId = getCandidateTalentScanJobId(candidate)
    const talentScanId = getCandidateTalentScanId(candidate)

    if (!jobId || !talentScanId) return

    try {
      setLoadingTalentScanResultMap(prev => ({ ...prev, [resultKey]: true }))
      const response = await axios.post(
        `/api/v1/candidate-talent-scan-result/`,
        {
          talent_scan_id: talentScanId,
          job_id: jobId,
        },
        {
          params: buildParams({
            page: 1,
            size: 10,
            company_id: companyId,
          }),
        }
      )

      setCandidateTalentScanResultMap(prev => ({
        ...prev,
        [resultKey]: response?.data?.talent_scan_result ?? { results: [] },
      }))
    } catch (error) {
      console.error("Failed to fetch candidate talent scan result", error)
      setCandidateTalentScanResultMap(prev => ({
        ...prev,
        [resultKey]: { results: [] },
      }))
    } finally {
      setLoadingTalentScanResultMap(prev => ({ ...prev, [resultKey]: false }))
    }
  }

  // ---------- expandable components ----------
  const getCandidateStatusText = candidate =>
    String(
      candidate?.stage_name ??
        candidate?.candidate_status ??
        candidate?.pipeline_status ??
        candidate?.application_status ??
        ""
    ).trim()

  const isCandidatePlaced = candidate =>
    getCandidateStatusText(candidate).toLowerCase() === "placed"

  const isSelectedCandidatePlaced = isCandidatePlaced(selectedCandidateForStatus)
  const selectedCandidateStatusName = selectedCandidateForStatus
    ? getCandidateStatusText(selectedCandidateForStatus) || "--"
    : "--"
  const selectedCandidateStageForUpdate = stagesList.find(
    stage => String(stage.id) === String(selectedCandidateStatusId)
  )
  const isSelectedStatusRejected =
    String(selectedCandidateStageForUpdate?.name || "").toLowerCase().trim() ===
    "rejected"
  const candidateRejectedRoundOptions = [
    { label: "L1 Round", value: "L1 Round" },
    { label: "L2 Round", value: "L2 Round" },
    { label: "By HR", value: "By HR" },
    { label: "By Panel", value: "By Panel" },
  ]
  const selectedCandidateDisplayName = selectedCandidateForStatus
    ? [
        selectedCandidateForStatus?.first_name ||
          selectedCandidateForStatus?.candidate_name ||
          selectedCandidateForStatus?.firstName,
        selectedCandidateForStatus?.middle_name,
        selectedCandidateForStatus?.last_name ||
          selectedCandidateForStatus?.lastName,
      ]
        .filter(Boolean)
        .join(" ") || "--"
    : "--"

  const getCandidateDetailValue = (candidate, keys, fallback = "--") => {
    for (const key of keys) {
      const value = candidate?.[key]
      if (value !== undefined && value !== null && String(value).trim() !== "") {
        return value
      }
    }
    return fallback
  }

  const formatCandidateDetailValue = value => {
    if (value === undefined || value === null || String(value).trim() === "") {
      return "--"
    }
    if (typeof value === "boolean") return value ? "Yes" : "No"
    return String(value)
  }

  const formatCandidateExperience = value => {
    if (value === undefined || value === null || String(value).trim() === "") {
      return value
    }
    const numericValue = Number(value)
    return Number.isFinite(numericValue) ? String(numericValue) : value
  }

  const formatCandidateRelocation = value => {
    if (value === undefined || value === null || value === "") return "--"
    if (typeof value === "boolean") return value ? "Yes" : "No"
    const normalized = String(value).toLowerCase()
    if (["true", "yes", "1"].includes(normalized)) return "Yes"
    if (["false", "no", "0"].includes(normalized)) return "No"
    return String(value)
  }

  const getCandidateEditId = candidate =>
    candidate?.candidate_id ??
    candidate?.candidate ??
    candidate?.candidate_details?.id ??
    candidate?.id ??
    ""

  const getBooleanDraftValue = value => {
    if (typeof value === "boolean") return value
    if (value === undefined || value === null || value === "") return false
    return ["true", "yes", "1"].includes(String(value).toLowerCase())
  }

  const getCandidateLocationKey = candidate =>
    getCandidateDetailValue(candidate, ["city", "current_location", "location"], "")

  const getCandidateLocationDisplay = candidate => {
    const directLocationName = getCandidateDetailValue(candidate, [
      "current_location_name",
      "location_name",
      "city_name",
      "city_display",
      "cityName",
    ], "")

    if (directLocationName) return directLocationName

    const cityObjectName =
      candidate?.city && typeof candidate.city === "object"
        ? candidate.city.name || candidate.city.city_name || candidate.city.label
        : ""

    if (cityObjectName) return cityObjectName

    const locationValue = getCandidateLocationKey(candidate)
    if (!locationValue) return ""

    const mappedLocation = candidateStatusLocationNameMap[String(locationValue)]
    if (mappedLocation) return mappedLocation

    const stringValue = String(locationValue)
    return /^\d+$/.test(stringValue) ? "" : stringValue
  }

  const getCandidateSourceValue = candidate =>
    getCandidateDetailValue(candidate, [
      "source",
      "source_id",
      "resume_source_id",
      "resume_source",
      "source_name",
    ], "")

  const getCandidateSourceDisplay = candidate => {
    const sourceValue = getCandidateSourceValue(candidate)
    if (!sourceValue) return ""

    const matchedSource = candidateStatusSourceOptions.find(
      option =>
        String(option.value) === String(sourceValue) ||
        String(option.label).toLowerCase() === String(sourceValue).toLowerCase()
    )

    return matchedSource?.label || sourceValue
  }

  const getCandidateStatusDraft = candidate => ({
    email: getCandidateDetailValue(candidate, [
      "email",
      "candidate_email",
      "job_candidate__candidate_email",
    ], ""),
    mobile_phone: getCandidateDetailValue(candidate, [
      "mobile_phone",
      "candidate_phone",
      "work_phone",
      "job_candidate__candidate_phone",
    ], ""),
    current_company: getCandidateDetailValue(candidate, [
      "current_company",
      "company_name",
    ], ""),
    notice_period: getCandidateDetailValue(candidate, [
      "notice_period",
      "noticePeriod",
    ], ""),
    mode_of_work: getCandidateDetailValue(candidate, [
      "mode_of_work",
      "modeOfWork",
    ], ""),
    source: getCandidateSourceValue(candidate),
    current_location: getCandidateLocationDisplay(candidate),
    current_salary: getCandidateDetailValue(candidate, [
      "current_salary",
      "current_ctc",
    ], ""),
    expected_salary: getCandidateDetailValue(candidate, [
      "expected_salary",
      "expected_ctc",
    ], ""),
    total_experience: getCandidateDetailValue(candidate, [
      "total_experience",
      "experience",
      "exp",
    ], ""),
    relocation: getBooleanDraftValue(candidate?.relocation),
  })

  useEffect(() => {
    if (!candidateStatusModal || !selectedCandidateForStatus) return undefined

    const candidateId = getCandidateEditId(selectedCandidateForStatus)
    if (!candidateId) return undefined

    let isActive = true

    const fetchCandidateStatusDetails = async () => {
      try {
        setCandidateStatusDetailsLoader(true)
        const response = await axios.get(`/api/v1/candidates/${candidateId}/`)
        if (!isActive) return

        const details = response?.data || {}
        const mergedDetails = {
          ...selectedCandidateForStatus,
          ...details,
          candidate_id: selectedCandidateForStatus.candidate_id ?? details.candidate_id ?? details.id,
          job_candidate_id: selectedCandidateForStatus.job_candidate_id,
          job_id: selectedCandidateForStatus.job_id,
          pipeline_status: selectedCandidateForStatus.pipeline_status,
          stage_name: selectedCandidateForStatus.stage_name,
        }
        setSelectedCandidateForStatus(mergedDetails)
        if (isCandidateStatusDetailsEdit) {
          setCandidateStatusDetailsDraft(getCandidateStatusDraft(mergedDetails))
        }
      } catch (error) {
        console.error("Failed to fetch candidate details for status modal", error)
      } finally {
        if (isActive) setCandidateStatusDetailsLoader(false)
      }
    }

    fetchCandidateStatusDetails()

    return () => {
      isActive = false
    }
  }, [candidateStatusModal, selectedCandidateForStatus?.candidate_id])

  useEffect(() => {
    if (!candidateStatusModal || candidateStatusSourceOptions.length > 0) {
      return
    }

    let isActive = true

    const fetchCandidateStatusSources = async () => {
      try {
        setCandidateStatusSourcesLoading(true)
        const response = await axios.get(`/api/v1/resume-source/`)
        if (!isActive) return

        const transformedData = (response?.data?.results || []).map(source => ({
          label: source.resume_source,
          value: source.source_id,
        }))
        setCandidateStatusSourceOptions(transformedData)
      } catch (error) {
        console.error("Error fetching candidate status sources:", error)
        setCandidateStatusSourceOptions([])
      } finally {
        if (isActive) setCandidateStatusSourcesLoading(false)
      }
    }

    fetchCandidateStatusSources()

    return () => {
      isActive = false
    }
  }, [candidateStatusModal, candidateStatusSourceOptions.length])

  useEffect(() => {
    if (!candidateStatusModal || !selectedCandidateForStatus) return undefined

    const cityId = getCandidateLocationKey(selectedCandidateForStatus)
    const stateId = selectedCandidateForStatus?.state
    if (!cityId || !stateId || candidateStatusLocationNameMap[String(cityId)]) {
      return undefined
    }

    let isActive = true

    const fetchCandidateStatusCityName = async () => {
      try {
        const response = await axios.get(`/api/v1/get-all-cities/?state_id=${stateId}`)
        if (!isActive) return

        const cityOptions = Array.isArray(response?.data)
          ? response.data
          : response?.data?.results || []
        const city = cityOptions.find(item => String(item.id) === String(cityId))
        const cityName = city?.name || city?.city_name || city?.label

        if (cityName) {
          setCandidateStatusLocationNameMap(prev => ({
            ...prev,
            [String(cityId)]: cityName,
          }))
        }
      } catch (error) {
        console.error("Failed to fetch candidate city name", error)
      }
    }

    fetchCandidateStatusCityName()

    return () => {
      isActive = false
    }
  }, [
    candidateStatusModal,
    selectedCandidateForStatus?.city,
    selectedCandidateForStatus?.current_location,
    selectedCandidateForStatus?.location,
    selectedCandidateForStatus?.state,
    candidateStatusLocationNameMap,
  ])

  useEffect(() => {
    if (!candidateStatusModal || !selectedCandidateForStatus || isCandidateStatusDetailsEdit) {
      return
    }
    setCandidateStatusDetailsDraft(getCandidateStatusDraft(selectedCandidateForStatus))
  }, [candidateStatusModal, selectedCandidateForStatus, isCandidateStatusDetailsEdit])

  const handleCandidateStatusDraftChange = (field, value) => {
    setCandidateStatusDetailsDraft(prev => ({
      ...prev,
      [field]: value,
    }))
  }

  const handleEditCandidateDetailsFromStatus = () => {
    setCandidateStatusDetailsDraft(getCandidateStatusDraft(selectedCandidateForStatus))
    setIsCandidateStatusDetailsEdit(true)
  }

  const handleCancelCandidateDetailsEdit = () => {
    setCandidateStatusDetailsDraft(getCandidateStatusDraft(selectedCandidateForStatus))
    setIsCandidateStatusDetailsEdit(false)
  }

  const handleSaveCandidateDetailsFromStatus = async () => {
    const candidateId = getCandidateEditId(selectedCandidateForStatus)

    if (!candidateId) {
      Swal.fire({
        icon: "warning",
        title: "Candidate Not Found",
        text: "Unable to open candidate details for this record.",
        confirmButtonText: "OK",
      })
      return
    }

    const salaryValue = value =>
      value === null || value === undefined ? "" : String(value).trim()

    const payload = {
      email: candidateStatusDetailsDraft.email || "",
      mobile_phone: candidateStatusDetailsDraft.mobile_phone || "",
      current_company: candidateStatusDetailsDraft.current_company || "",
      current_location: candidateStatusDetailsDraft.current_location || "",
      current_salary: salaryValue(candidateStatusDetailsDraft.current_salary),
      expected_salary: salaryValue(candidateStatusDetailsDraft.expected_salary),
      total_experience: candidateStatusDetailsDraft.total_experience || null,
      notice_period: candidateStatusDetailsDraft.notice_period || "",
      mode_of_work: candidateStatusDetailsDraft.mode_of_work || "",
      source: candidateStatusDetailsDraft.source || "",
      relocation: !!candidateStatusDetailsDraft.relocation,
    }

    try {
      setCandidateStatusDetailsSaving(true)
      const response = await axios.patch(`/api/v1/candidates/${candidateId}/`, payload)

      if (response.status === 200) {
        void trackActivity({
          module: "Candidates",
          action: "Candidate Updated",
          recordType: "candidate",
          recordId: candidateId,
          companyId,
          metadata: {
            changes: Object.fromEntries(Object.entries(payload).map(([field, value]) => [field, {
              old: selectedCandidateForStatus?.[field] ?? null,
              new: value,
            }])),
            changedPayload: payload,
            source: "candidate-status-details",
          },
        })
        const updatedCandidate = response?.data || payload
        setSelectedCandidateForStatus(prev =>
          prev ? { ...prev, ...updatedCandidate, ...payload } : prev
        )
        setIsCandidateStatusDetailsEdit(false)
        Swal.fire({
          icon: "success",
          title: "Updated",
          text: "Candidate details updated successfully.",
          timer: 1500,
          showConfirmButton: false,
        })
      }
    } catch (error) {
      console.error("Failed to update candidate details from status modal", error)
      Swal.fire({
        icon: "error",
        title: "Update Failed",
        text: "Unable to update candidate details. Please try again.",
        confirmButtonText: "OK",
      })
    } finally {
      setCandidateStatusDetailsSaving(false)
    }
  }

  const selectedCandidateBasicDetails = selectedCandidateForStatus
    ? [
        {
          label: "Email",
          field: "email",
          value: getCandidateDetailValue(selectedCandidateForStatus, [
            "email",
            "candidate_email",
            "job_candidate__candidate_email",
          ]),
        },
        {
          label: "Phone",
          field: "mobile_phone",
          value: getCandidateDetailValue(selectedCandidateForStatus, [
            "mobile_phone",
            "candidate_phone",
            "work_phone",
            "job_candidate__candidate_phone",
          ]),
        },
        {
          label: "Source",
          field: "source",
          inputType: "source-select",
          value: getCandidateSourceDisplay(selectedCandidateForStatus),
        },
        {
          label: "Current Company",
          field: "current_company",
          value: getCandidateDetailValue(selectedCandidateForStatus, [
            "current_company",
            "company_name",
          ]),
        },
        {
          label: "Notice Period (Days/Months)",
          field: "notice_period",
          value: getCandidateDetailValue(selectedCandidateForStatus, [
            "notice_period",
            "noticePeriod",
          ]),
        },
        {
          label: "Mode of Work",
          field: "mode_of_work",
          inputType: "work-mode-select",
          value: getCandidateDetailValue(selectedCandidateForStatus, [
            "mode_of_work",
            "modeOfWork",
          ]),
        },
      ]
    : []

  const selectedCandidateSalaryDetails = selectedCandidateForStatus
    ? [
        {
          label: "Current Location",
          field: "current_location",
          value: getCandidateLocationDisplay(selectedCandidateForStatus),
        },
        {
          label: "Current CTC",
          field: "current_salary",
          inputType: "text",
          value: getCandidateDetailValue(selectedCandidateForStatus, [
            "current_salary",
            "current_ctc",
          ]),
        },
        {
          label: "Expected Salary",
          field: "expected_salary",
          inputType: "text",
          value: getCandidateDetailValue(selectedCandidateForStatus, [
            "expected_salary",
            "expected_ctc",
          ]),
        },
        {
          label: "Experience",
          field: "total_experience",
          inputType: "number",
          value: getCandidateDetailValue(selectedCandidateForStatus, [
            "total_experience",
            "experience",
            "exp",
          ]) !== ""
            ? formatCandidateExperience(
                getCandidateDetailValue(selectedCandidateForStatus, [
                  "total_experience",
                  "experience",
                  "exp",
                ])
              )
            : "",
        },
        {
          label: "Relocation",
          field: "relocation",
          inputType: "select",
          value: formatCandidateRelocation(
            getCandidateDetailValue(selectedCandidateForStatus, ["relocation"], "")
          ),
        },
      ]
    : []

  const getCandidateFullName = candidate =>
    [
      candidate?.first_name || candidate?.candidate_name || candidate?.firstName,
      candidate?.middle_name,
      candidate?.last_name || candidate?.lastName,
    ]
      .filter(Boolean)
      .join(" ")

  const getCandidateInitials = candidate => {
    const name = getCandidateFullName(candidate)
    return name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map(part => part.charAt(0).toUpperCase())
      .join("")
  }

  const getCandidateInitialColor = candidate => {
    const colors = [
      { background: "#e0f2fe", color: "#0369a1", border: "#7dd3fc" },
      { background: "#dcfce7", color: "#15803d", border: "#86efac" },
      { background: "#fef3c7", color: "#b45309", border: "#fcd34d" },
      { background: "#fce7f3", color: "#be185d", border: "#f9a8d4" },
      { background: "#ede9fe", color: "#6d28d9", border: "#c4b5fd" },
      { background: "#ccfbf1", color: "#0f766e", border: "#5eead4" },
    ]
    const name = getCandidateFullName(candidate) || "-"
    const index = name
      .split("")
      .reduce((total, char) => total + char.charCodeAt(0), 0) % colors.length
    return colors[index]
  }

  const TestAndCallsExpansion = ({ data: candidate }) => {
    const resultKey = getTalentScanResultKey(candidate)
    const hasCachedTalentScanResult = Object.prototype.hasOwnProperty.call(
      candidateTalentScanResultMap,
      resultKey
    )
    const hasInitialTalentScanResult = candidate?.talent_scan_result != null
    const talentScanResult =
      candidateTalentScanResultMap[resultKey] ?? candidate?.talent_scan_result
    const tests = talentScanResult?.results ?? []
    const isLoadingTalentScanResult = !!loadingTalentScanResultMap[resultKey]
    const shouldShowTalentScanShimmer =
      !tests.length &&
      !!resultKey &&
      (isLoadingTalentScanResult ||
        (!hasCachedTalentScanResult && !hasInitialTalentScanResult))

    useEffect(() => {
      fetchCandidateTalentScanResult(candidate)
    }, [resultKey])

    const sectionScoreColumns = useMemo(
      () => [
        { name: "Section", selector: r => r.section__name ?? "-" },
        { name: "Questions", selector: r => r.no_of_questions ?? "-" },
        { name: "Attempted", selector: r => r.no_of_questions_attempted ?? 0 },
        { name: "Total", selector: r => r.total_score ?? 0 },
        { name: "Cutoff", selector: r => r.cutoff_score ?? 0 },
        { name: "Secured", selector: r => r.score_secured ?? 0 },
        { name: "Percentage", selector: r => `${r.percentage ?? 0}%` },
        { name: "Behavioural", selector: r => `${r.behavioural_score ?? 0}%` },
      ],
      []
    )

    const SectionScoreExpansion = ({ data: result }) => (
      <div className="p-3 bg-light border-top">
        <Row className="mb-3">
          <Col md={4}>
            <strong>Total Score:</strong>{" "}
            {result?.ats_details?.total_score_secured ?? result?.total_candidate_score ?? 0} /{" "}
            {result?.ats_details?.actual_total_score ?? result?.total_test_score ?? 0}
          </Col>
          <Col md={4}>
            <strong>Percentage:</strong>{" "}
            {result?.ats_details?.percentage_score ?? result?.candidate_percentage_score ?? 0}%
          </Col>
          <Col md={4}>
            <strong>Qualified:</strong>{" "}
            <span className={result?.ats_details?.is_test_qualified ? "text-success" : "text-danger"}>
              {result?.ats_details?.is_test_qualified ? "Yes" : "No"}
            </span>
          </Col>
        </Row>

        {Array.isArray(result?.score_info) && result.score_info.length > 0 ? (
          <DataTable
            columns={sectionScoreColumns}
            data={result.score_info}
            dense
            highlightOnHover
            noHeader
          />
        ) : (
          <p className="text-muted mb-0">No section scores found.</p>
        )}
      </div>
    )

    const columns = useMemo(
      () => [
        { name: "Test Name", selector: r => r.test_info?.name ?? "-" },
        {
          name: "Designation",
          selector: r => r.test_info?.test_designation ?? "-",
        },
        {
          name: "Score",
          selector: r =>
            `${r.total_candidate_score ?? 0} / ${r.total_test_score ?? 0}`,
        },
        {
          name: "Percentage",
          selector: r => `${r.candidate_percentage_score ?? 0}%`,
        },
        {
          name: "Sent On",
          selector: r =>
            r.test_info?.created_at
              ? formatUTCDate(r.test_info.created_at) 
              : "-"
        },
        {
          name: "Is Attempted",
          selector: r => (r.is_attempted ? "Yes" : "No"),
        },
        {
          name: "Is Submitted",
          selector: r => (r.is_submitted ? "Yes" : "No"),
        },
        // {
        //     name: "Test Link",
        //     cell: r =>
        //         r.link ? (
        //             <a href={r.link} target="_blank" rel="noreferrer">
        //                 Open Test
        //             </a>
        //         ) : (
        //             "Not Available"
        //         ),

        // },
        {
          name: "View Result",
          cell: row => {
            const showButton = row?.id != null && row?.attempt_id != null
              const handleViewResult = async () => {
                  try {
                      const payload = {
                          assign_test_id: row.id,
                          attempt_id: row.attempt_id,
                      }
                      const response = await axios.post(
                          "/api/v1/ts-view-test/create-dashboard-link/",
                          payload
                      )
                      if (response.data?.url) {
                          window.open(response.data.url, "_blank")
                      } else {
                          Swal.fire("Error", "URL not found in response", "error")
                      }
                  } catch (err) {
                      console.error(err)
                      Swal.fire("Error", "Failed to generate link", "error")
                  }
              };

            if (!showButton) return "-"
            return (
              <button
                className="btn btn-primary btn-sm"
                onClick={handleViewResult}
              >
                View Result
              </button>
            )
          },
        },

        // {
        //     name: "Action",
        //     cell: r => (
        //         <RSButton outline size="sm">
        //             Resend
        //         </RSButton>
        //     ),
        // },
      ],
      []
    )

    return (
      <div className="p-3 bg-white rounded border mt-2">
        <h6 className="mb-3">
          Tests for{" "}
          <strong>
            {candidate.first_name ?? candidate.candidate_name ?? candidate.name}{candidate.middle_name ?? candidate.candidate_name ?? candidate.name} {candidate.last_name ?? candidate.candidate_name ?? candidate.name}
          </strong>
        </h6>

        {shouldShowTalentScanShimmer ? (
          <div className="border">
            <OrgTableShimmer columns={7} rows={4} titleWidth="180px" />
          </div>
        ) : Array.isArray(tests) && tests.length > 0 ? (
            <div id="CandidateTest_TableView" className="border">
                <DataTable
                    columns={columns}
                    data={tests}
                    dense
                    highlightOnHover
                    noHeader
                    expandableRows
                    expandableRowsComponent={SectionScoreExpansion}
                />
            </div>
        ) : (
         <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "48px 24px",
            gap: 16,
          }}>
            <div style={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              background: "#f1f5f9",
              border: "2px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 36,
            }}>
              📋
            </div>
            <div style={{ fontWeight: 700, fontSize: 18, color: "#1a202c" }}>
              No Tests Assigned
            </div>
            <div style={{ fontSize: 14, color: "#94a3b8", textAlign: "center", maxWidth: 280 }}>
              This candidate has not been assigned any tests yet.
            </div>
          </div>
        )}
      </div>
    )
  }
const TestResultsModal = () => {
    const candidate = testResultsCandidate
    useEffect(() => {
      if (testResultsModal && candidate) {
        fetchCandidateTalentScanResult(candidate)
      }
  }, [testResultsModal, candidate?.job_candidate_id ?? candidate?.candidate_id])
    if (!candidate) return null
    const resultKey = getTalentScanResultKey(candidate)
    const hasCachedTalentScanResult = Object.prototype.hasOwnProperty.call(
      candidateTalentScanResultMap,
      resultKey
    )
    const hasInitialTalentScanResult = candidate?.talent_scan_result != null
    const talentScanResult =
      candidateTalentScanResultMap[resultKey] ?? candidate?.talent_scan_result
    const tests = Array.isArray(talentScanResult?.results)
      ? talentScanResult.results
      : []
    const headerCandidateInfo = tests[0]?.candidate_info || {}
    const headerCandidateName =
      headerCandidateInfo.name || getCandidateFullName(candidate) || "Candidate"
    const headerCandidateEmail =
      headerCandidateInfo.email ||
      candidate?.email ||
      candidate?.candidate_email ||
      candidate?.job_candidate__candidate_email ||
      "-"
    const headerCandidatePhone =
      headerCandidateInfo.phone ||
      candidate?.mobile_phone ||
      candidate?.candidate_phone ||
      candidate?.job_candidate__candidate_phone ||
      "-"
    const isLoadingTalentScanResult = !!loadingTalentScanResultMap[resultKey]
    const shouldShowShimmer =
      !tests.length &&
      !!resultKey &&
      (isLoadingTalentScanResult ||
        (!hasCachedTalentScanResult && !hasInitialTalentScanResult))

    const levels = [
      {
        label: "Beginner",
        scoreKey: "score_secured_in_beginner",
        totalKey: "total_score_in_beginner",
        className: "beginner",
      },
      {
        label: "Intermediate",
        scoreKey: "score_secured_in_intermediate",
        totalKey: "total_score_in_intermediate",
        className: "intermediate",
      },
      {
        label: "Advanced",
        scoreKey: "score_secured_in_advanced",
        totalKey: "total_score_in_advanced",
        className: "advanced",
      },
    ]

    const asNumber = value => {
      const parsed = Number(value)
      return Number.isFinite(parsed) ? parsed : 0
    }

    const formatScore = value => {
      const num = asNumber(value)
      return Number.isInteger(num) ? `${num}` : num.toFixed(2)
    }

    const formatPct = value => {
      const num = asNumber(value)
      return Number.isInteger(num) ? `${num}%` : `${num.toFixed(2)}%`
    }

    const scoreTone = value => {
      const pct = asNumber(value)
      if (pct >= 50) return "good"
      if (pct >= 25) return "mid"
      return "low"
    }

    const textValue = value =>
      value !== null && value !== undefined && value !== "" ? value : "-"

    const formatSkills = skills =>
      Array.isArray(skills) ? textValue(skills.join(", ")) : textValue(skills)

    const getSectionScoreDict = test => {
      if (test?.score_info_dict && typeof test.score_info_dict === "object") {
        return Object.entries(test.score_info_dict)
      }

      return (Array.isArray(test?.score_info) ? test.score_info : []).map(
        section => [
          section.section__name || "Section",
          section.score_secured ?? 0,
        ]
      )
    }

    const boolBadge = value => (
      <span className={`ts-result-badge ${value ? "success" : "danger"}`}>
        {value ? "Yes" : "No"}
      </span>
    )

    const timelineLabels = new Set([
      "Created at",
      "Attempted at",
      "Submitted at",
      "Evaluated at",
    ])

    const renderKvRows = rows =>
      rows.map(([label, value]) => (
        <div className="ts-result-kv-row" key={label}>
          <span className="ts-result-kv-key">{label}</span>
          <span
            className={`ts-result-kv-val ${
              timelineLabels.has(label) ? "timeline" : ""
            }`}
          >
            {value}
          </span>
        </div>
      ))

    const handleViewResult = async (event, row) => {
      event?.preventDefault()
      event?.stopPropagation()
      if (row?.id == null || row?.attempt_id == null) return
      setTestResultsModal(false)
      setTestResultsCandidate(null)
      const resultRowKey = `${row.id}-${row.attempt_id}`
      setViewingTestResultMap(current => ({
        ...current,
        [resultRowKey]: true,
      }))
      try {
        const payload = { assign_test_id: row.id, attempt_id: row.attempt_id }
        const response = await axios.post(
          "/api/v1/ts-view-test/create-dashboard-link/",
          payload
        )
        if (response.data?.url) {
          window.open(response.data.url, "_blank")
        } else {
          Swal.fire("Error", "URL not found in response", "error")
        }
      } catch (err) {
        console.error(err)
        Swal.fire("Error", "Failed to generate link", "error")
      } finally {
        setViewingTestResultMap(current => ({
          ...current,
          [resultRowKey]: false,
        }))
      }
    }

    return (
      <Modal
        isOpen={testResultsModal}
        toggle={() => setTestResultsModal(false)}
        size="xl"
        centered
        scrollable
        className="test-result-modal"
      >
        <ModalHeader
          toggle={() => setTestResultsModal(false)}
          className="test-result-modal-header"
        >
          <div className="test-result-modal-heading">
            <div className="test-result-modal-title">
              Test Results - {headerCandidateName}
            </div>
            <div className="test-result-modal-candidate-contact">
              {headerCandidateEmail} <span aria-hidden="true">|</span>{" "}
              {headerCandidatePhone}
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="test-result-modal-body">
          {shouldShowShimmer ? (
            <div className="border rounded bg-white">
              <OrgTableShimmer columns={7} rows={4} titleWidth="180px" />
            </div>
          ) : tests.length > 0 ? (
            <div className="ts-result-list">
              {tests.map((test, index) => {
                const testInfo = test?.test_info || {}
                const candidateInfo = test?.candidate_info || {}
                const atsDetails = test?.ats_details || {}
                const sectionScores = Array.isArray(test?.score_info)
                  ? test.score_info
                  : []
                const totalSecured =
                atsDetails.total_score_secured ??
                  test.total_candidate_score ??
                  0
                const actualTotal =
                  atsDetails.actual_total_score ?? test.total_test_score ?? 0
                const overallPct =
                atsDetails.percentage_score ??
                  test.candidate_percentage_score ??
                  0
                const qualified = !!atsDetails.is_test_qualified
                const isCheated = !!testInfo.is_cheated
                const cheatedSection = testInfo.cheated_section || ""
                const scoreDict = getSectionScoreDict(test)
                const canViewResult =
                  test?.id != null && test?.attempt_id != null

                return (
                  <div className="ts-result-shell" key={test?.id ?? index}>
                    <div className="ts-result-header">
                      <div className="ts-result-header-main">
                        <div className="ts-result-title">
                          {textValue(testInfo.name)} -{" "}
                          {textValue(testInfo.test_designation)}
                        </div>
                      </div>
                      <div className="ts-result-header-badges">
                        <span
                          className={`ts-result-badge ${
                            qualified ? "success" : "danger"
                          }`}
                        >
                          {qualified ? "Qualified" : "Not qualified"}
                        </span>
                        {isCheated && (
                          <span className="ts-result-badge warning">
                            Cheated
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="ts-result-content">
                      <div className="ts-result-card ts-result-info-table">
                        <div className="ts-result-info-table-heading">
                          Candidate information
                        </div>
                        <div className="ts-result-grid-2">
                          {renderKvRows([
                            [
                              "Candidate ID",
                              textValue(candidateInfo.candidate_id),
                            ],
                            [
                              "Name",
                              textValue(
                                candidateInfo.name ||
                                  getCandidateFullName(candidate)
                              ),
                            ],
                            [
                              "Email",
                              textValue(
                                candidateInfo.email ||
                                  candidate?.email ||
                                  candidate?.candidate_email
                              ),
                            ],
                            [
                              "Phone",
                              textValue(
                                candidateInfo.phone ||
                                  candidate?.mobile_phone ||
                                  candidate?.candidate_phone
                              ),
                            ],
                            [
                              "Experience",
                              `${textValue(candidateInfo.experience)} yrs`,
                            ],
                            ["Test email", textValue(test.test_email)],
                          ])}
                        </div>

                        <div className="ts-result-info-table-heading">
                          Test information
                        </div>
                        <div className="ts-result-grid-2">
                          {renderKvRows([
                            ["Test ID", textValue(testInfo.id)],
                            ["Created at", formatTestDate(testInfo.created_at)],
                            ["Attempted at", formatTestDate(test.attempted_at)],
                            ["Submitted at", formatTestDate(test.submitted_at)],
                            ["Evaluated at", formatTestDate(test.evaluated_at)],
                            ["Attempt ID", textValue(test.attempt_id)],
                            ["Is sent", boolBadge(test.is_sent)],
                            ["Is attempted", boolBadge(test.is_attempted)],
                            ["Is submitted", boolBadge(test.is_submitted)],
                            ["Is active", boolBadge(test.is_active)],
                            [
                              "Link deactivated",
                              boolBadge(test.link_deactivated),
                            ],
                            ["Remarks", textValue(test.remarks)],
                          ])}
                        </div>
                      </div>

                      <div>
                        <div className="ts-result-section-label">
                          Overall score
                        </div>
                        <div className="ts-result-metrics">
                          {[
                            {
                              label: "Total secured / Actual Score",
                              value: `${formatScore(
                                totalSecured
                              )} / ${formatScore(actualTotal)}`,
                              tone: "info",
                            },
                            {
                              label: "Percentage",
                              value: formatPct(overallPct),
                              tone: scoreTone(overallPct),
                            },
                            // {
                            //   label: "Candidate score",
                            //   value: `${formatScore(
                            //     test.total_candidate_score
                            //   )} / ${formatScore(test.total_test_score)}`,
                            //   tone: "neutral",
                            // },
                            // {
                            //   label: "Behavioural",
                            //   value: formatPct(test.total_behavioural_score),
                            //   tone: "advanced",
                            // },
                            {
                              label: "Qualified",
                              value: qualified ? "Qualified" : "Not qualified",
                              tone: qualified ? "good" : "low",
                            },
                          ].map(metric => (
                            <div
                              className={`ts-result-metric ${metric.tone}`}
                              key={metric.label}
                            >
                              <div className="ts-result-metric-val">
                                {metric.value}
                              </div>
                              <div className="ts-result-metric-label">
                                {metric.label}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div>
                      </div>
                      <div>
                        <div className="ts-result-legend">
                          <span>Difficulty breakdown:</span>
                          {levels.map(level => (
                            <span
                              className={`ts-result-legend-item ${level.className}`}
                              key={level.label}
                            >
                              <span />
                              {level.label}
                            </span>
                          ))}
                        </div>
                        <div className="ts-result-section-label"  style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}>
                          <span>Section-wise detailed breakdown</span>
                            {/* <span>
                              Score Secured In Sections :{" "}
                              <span style={{fontSize:"12px"}}>{formatScore(atsDetails.total_score_secured)}</span>
                            </span> */}
                        </div>
                        <div className="ts-result-section-list">
                          {sectionScores.length > 0 ? (
                            sectionScores.map((section, sectionIndex) => {
                              const total = asNumber(section.total_score)
                              const cutoff = asNumber(section.cutoff_score)
                              const secured = asNumber(section.score_secured)
                              const sectionPct = asNumber(section.percentage)
                              const barPct =
                                total > 0
                                  ? Math.min((secured / total) * 100, 100)
                                  : 0
                              const passed = cutoff > 0 && secured >= cutoff
                              const isCheatedRow =
                                isCheated &&
                                cheatedSection &&
                                String(section.section__name || "")
                                  .trim()
                                  .toLowerCase() ===
                                  String(cheatedSection).trim().toLowerCase()
                              const durationMin = section.duration
                                ? `${formatScore(
                                    asNumber(section.duration) / 60
                                  )} min`
                                : "-"

                              return (
                                <div
                                  className={`ts-result-section-card ${
                                    isCheatedRow ? "cheated" : ""
                                  }`}
                                  key={`${section.section__name}-${sectionIndex}`}
                                >
                                  <div className="ts-result-section-top">
                                    <div className="ts-result-section-name-col">
                                      <div className="ts-result-section-name">
                                        <span>
                                          {textValue(section.section__name)}
                                        </span>
                                        {isCheatedRow && (
                                          <span className="ts-result-cheated-badge">
                                            Cheated section
                                          </span>
                                        )}
                                      </div>
                                      <div className="ts-result-chip-row">
                                        <span>
                                          Type :{" "}
                                          {textValue(section.question_type)}
                                        </span>
                                        <span>
                                          Criticality : {textValue(section.criticality)}
                                        </span>
                                        <span>Duration : {durationMin}</span>
                                        <span>
                                          Questions Attempted : {" "}
                                          {textValue(
                                            section.no_of_questions_attempted
                                          )}{" "}
                                          / {textValue(section.no_of_questions)}
                                        </span>
                                      </div>
                                      <div className="ts-result-chip-row status">
                                        {/* <span
                                          className={`ts-result-badge ${
                                            passed ? "success" : "danger"
                                          }`}
                                        >
                                          {passed ? "Passed" : "Failed"}
                                        </span> */}
                                        <span
                                          className={`ts-result-badge ${
                                            section.is_qualified
                                              ? "success"
                                              : "neutral"
                                          }`}
                                        > Is Qualified : {" "}
                                          {section.is_qualified
                                            ? "Qualified"
                                            : "Not qualified"}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="ts-result-section-score-col">
                                      <div className="ts-result-big-score">
                                        <span>Score Secured</span>
                                        <strong>{formatScore(secured)}</strong>
                                        <small>
                                          of <b>{formatScore(total)}</b> pts / cutoff {''}
                                          <b>{formatScore(cutoff)}</b>
                                        </small>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="ts-result-levels">
                                    {levels.map(level => {
                                      const levelScore = asNumber(
                                        section[level.scoreKey]
                                      )
                                      const levelTotal = asNumber(
                                        section[level.totalKey]
                                      )
                                      const levelPct =
                                        levelTotal > 0
                                          ? Math.min(
                                              (levelScore / levelTotal) * 100,
                                              100
                                            )
                                          : 0

                                      return (
                                        <div
                                          className={`ts-result-level ${level.className}`}
                                          key={level.label}
                                        >
                                          <div className="ts-result-level-head">
                                            <span />
                                            {level.label}
                                          </div>
                                          {isCheatedRow ? (
                                            <div className="ts-result-level-empty">
                                              -
                                            </div>
                                          ) : (
                                            <>
                                              <div className="ts-result-level-score-label">
                                                Score secured
                                              </div>
                                              <div className="ts-result-level-score">
                                                <strong>
                                                  {formatScore(levelScore)}
                                                </strong>
                                              </div>
                                              {/* <small>
                                                {formatPct(levelPct)}
                                              </small> */}
                                            </>
                                          )}
                                        </div>
                                      )
                                    })}
                                  </div>
                                  {isCheatedRow && (
                                    <div className="ts-result-cheated-note">
                                      Malpractice detected in this section.
                                    </div>
                                  )}
                                </div>
                              )
                            })
                          ) : (
                            <p className="text-muted mb-0">
                              No section scores found.
                            </p>
                          )}
                        </div>
                      </div>

                      {canViewResult && (
                        <div className="ts-result-actions">
                          <Button
                            className="ts-result-detail-btn"
                            style={{cursor:"pointer"}}
                            size="sm"
                            onClick={event => handleViewResult(event, test)}
                          >
                            View detailed result
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          ) : (
            <div className="ts-result-empty">
              <div className="ts-result-empty-icon">i</div>
              <div className="ts-result-empty-title">No Tests Assigned</div>
              <div className="ts-result-empty-copy">
                This candidate has not been assigned any tests yet.
              </div>
            </div>
          )}
        </ModalBody>

        <ModalFooter className="justify-content-center">
          <Button
            className="btn btn-md blueBtn"
            onClick={() => setTestResultsModal(false)}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
  // 🔹 History Fetch Handler
  const [historyModalOpen, setHistoryModalOpen] = useState(false)
  const [loadingHistory, setloadingHistory] = useState(false)
  const [historyData, setHistoryData] = useState([])
  const [historyTestData, setHistoryTestData] = useState([])
  const handleViewHistory = async job => {
    // console.log("job", job);
    setHistoryTestData(job)

    setloadingHistory(true)
    try {
      const res = await axios.get(
        `/api/v1/candidate-screen-history/?job_id=${SelectedJob}&candidate_id=${job.candidate_id}`
      )
      setHistoryData(res.data?.data || [])
      // console.log("res.data?.data", res.data?.data);
      setHistoryModalOpen(true)
      setloadingHistory(false)
    } catch (err) {
      setloadingHistory(false)

      console.error("Error fetching history:", err)
      alert("Failed to load history")
    } finally {
      setloadingHistory(false)
    }
  }
  const [showSendHRMSHistoryModal, setShowSendHRMSHistoryModal] =
    useState(false)
  const [showSendHRMSHistoryData, setshowSendHRMSHistoryData] = useState(false)
  const handleOfferLetterSubjectChange = useCallback((e) => {
    setOfferLetterSubject(e.target.value)
  }, [])

  const handleOfferLetterCCChange = useCallback((e) => {
    setOfferLetterCC(e.target.value)
  }, [])

  const fetchCandidateCommunicationHistory = async row => {
    setCommunicationHistoryCandidate(row)
    setCommunicationHistoryTab("calls")
    setCommunicationHistoryModal(true)
    setCommunicationHistoryLoading(true)
    setCommunicationHistoryError("")
    setCandidateCommunicationHistory([])
    setInterviewEmailTemplates([])
    setInterviewEmailTemplateCount(0)
    setCandidateEmailHistory([])
    setCandidateCallHistory([])
    setCandidateWhatsappHistory([])
    setCandidateSmsHistory([])
    setCandidateSmsTotal(0)
    setCallRecordingComments({})
    setCallRecordingCommentDrafts({})
    setSelectedCallRecordingDetail(null)
    setCallRecordingDetailModal(false)

    try {
      const jobCandidateId = row?.job_candidate_id || row?.id
      if (!jobCandidateId) {
        throw new Error("Job candidate id is missing")
      }
      const historyRes = await axios.get(`/api/v1/candidate-communication-history/${jobCandidateId}/`)
      const responseData = historyRes?.data?.data || historyRes?.data || {}
      const { emails, whatsapp, sms, calls } = getCommunicationBuckets(historyRes)
      const emailTemplates = getNestedArray(responseData?.email_templates).filter(item => item?.type === "email")

      const historyRows = getNestedArray(responseData?.history)
      const calendarEvents = getFirstAvailableArray(
        responseData?.calendar_events,
        responseData?.interview_events,
        responseData?.events
      ).filter(item => item?.type === "calendar_event")
      const allHistoryRows = historyRows.length
        ? historyRows
        : [...emails, ...whatsapp, ...sms, ...calls, ...calendarEvents]
      const sortNewest = items => [...(items || [])].sort((a, b) =>
        new Date(b?.sent_at || b?.event_date || b?.created_at || b?.datetime || b?.timestamp || 0) -
        new Date(a?.sent_at || a?.event_date || a?.created_at || a?.datetime || a?.timestamp || 0)
      )
      setCandidateCommunicationHistory(sortNewest(allHistoryRows))
      setInterviewEmailTemplates(sortNewest(emailTemplates))
      setInterviewEmailTemplateCount(Number(responseData?.total_email_templates || 0))
      setCandidateEmailHistory(sortNewest(emails.filter(item => item?.type === "email")))
      setCandidateWhatsappHistory(sortNewest(whatsapp))
      setCandidateSmsHistory(sortNewest(sms))
      setCandidateCallHistory(sortNewest(calls))
      setCandidateSmsTotal(Number(responseData?.total_sms ?? sms.length ?? 0))
      setCandidateCallHistory(calls)
      const existingComments = {};
      calls.forEach(call => {
        const key = getCallRecordingKey(call, call, 0);
        if (call.comments) {
          existingComments[key] = call.comments;
        }
        (call.recordings || []).forEach((rec, idx) => {
          const recKey = getCallRecordingKey(call, rec, idx);
          if (rec.comments) {
            existingComments[recKey] = rec.comments;
          }
        });
      });
        setCallRecordingComments(existingComments);
        setCallRecordingCommentDrafts(existingComments);
    } catch (error) {
      console.error("Error fetching communication history from qxbox API:", error)
      setCommunicationHistoryError("Failed to load communication history.")
    } finally {
      setCommunicationHistoryLoading(false)
    }
  }

  const handleViewSendHRMSHistory = data => {
    // console.log("data", data);
    setshowSendHRMSHistoryData(data)
    setShowSendHRMSHistoryModal(true)
  }
  const isWebsiteApplicantRow = row => {
    const sourceValues = [row?.applied_from, row?.added_from, row?.source]
      .filter(Boolean)
      .map(value => String(value).trim().toLowerCase())

    return sourceValues.some(value =>
      value === "website" ||
      value === "website applicant" ||
      value.includes("website applicant")
    )
  }

  const conditionalRowStyles = [
    {
      when: row => isWebsiteApplicantRow(row),
      style: {
        backgroundColor: "#fff4b8",
        fontWeight: "600",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "#ffef9a",
        },
      },
    },
  ]

  const getJobRowId = job => job?.job_id ?? job?.id
  const getCandidateRowId = candidate =>
    candidate?.job_candidate_id ??
    candidate?.candidate_job_id ??
    candidate?.candidate_id ??
    candidate?.id

  const CandidateExpansion = ({ data: job }) => {
    const jobId = getJobRowId(job)
    const jobName = job.job_title;
    const candidates = candidateDataMap[jobId] ?? []
    const candidateTab = candidateTabMap[jobId] || "Latest Resumes"
    const setCandidateTab = tab =>
      setCandidateTabMap(prev => ({ ...prev, [jobId]: tab }))
    const handleCandidateRowExpandToggled = (expanded, row) => {
      const rowId = getCandidateRowId(row)
      setExpandedCandidateRowMap(prev => ({
        ...prev,
        [jobId]: expanded ? rowId : null,
      }))
    }
    const expandedCandidateRowId = expandedCandidateRowMap[jobId] ?? null

    const filteredCandidates = candidates.filter(c => {
      const source = c.added_from || c.applied_from || ""
      const candidateStatus = String(
        c.stage_name ?? c.candidate_status ?? c.pipeline_status ?? c.application_status ?? ""
      ).toLowerCase()
      const selectedStages = getSelectedPipelineStages(jobId)
      const candidateStage = String(
        c.stage_name ?? c.candidate_status ?? c.pipeline_status ?? c.application_status ?? ""
      ).trim()

      if (selectedStages.length && !selectedStages.includes(candidateStage)) {
        return false
      }

      if (candidateTab === "Database Resumes") return source === "database"
      if (candidateTab === "Shortlisted Resumes") {
        return candidateStatus === "potential" || candidateStatus === "shortlisted"
      }
      return source !== "database"
    })
    const candidateTotalCount = hrmsStatusFilterMap[jobId] === "sent"
      ? hrmsSentCountMap[jobId] ?? getJobTotalRows(jobId) ?? filteredCandidates.length ?? 0
      : getJobTotalRows(jobId) || filteredCandidates.length || 0

    // local search state to avoid losing focus while typing
    const [localSearchMap, setLocalSearchMap] = useState({})
    const localSearch = localSearchMap[jobId] ?? searchMap[jobId] ?? ""
    const setLocalSearch = (val) => setLocalSearchMap(prev => ({ ...prev, [jobId]: val }))
    const candidateSearchInputRef = useRef(null)
    const candidateColumnsDropdownRef = useRef(null)

    useEffect(() => {
      if (candidateSearchFocusJobRef.current !== jobId) return
      const input = candidateSearchInputRef.current
      if (!input) return
      input.focus({ preventScroll: true })
      input.setSelectionRange(input.value.length, input.value.length)
      if (!loadingCandidatesMap[jobId]) candidateSearchFocusJobRef.current = null
    }, [jobId, loadingCandidatesMap[jobId]])

//   useEffect(() => {
//   if (showEditModal || candidateStatusModal || sendForApprovalModal || communicationHistoryModal) return undefined

//   const focusTimer = setTimeout(() => {
//     candidateSearchInputRef.current?.focus()
//   }, 0)

//   return () => clearTimeout(focusTimer)
// }, [jobId, showEditModal, candidateStatusModal, sendForApprovalModal, communicationHistoryModal])

    useEffect(() => {
      if (!candidateColumnsDropdownOpen[jobId]) return undefined

      const handleOutsideClick = event => {
        if (
          candidateColumnsDropdownRef.current &&
          !candidateColumnsDropdownRef.current.contains(event.target)
        ) {
          setCandidateColumnsDropdownOpen(prev => ({
            ...prev,
            [jobId]: false,
          }))
        }
      }

      document.addEventListener("mousedown", handleOutsideClick)

      return () => {
        document.removeEventListener("mousedown", handleOutsideClick)
      }
    }, [candidateColumnsDropdownOpen, jobId])
    useEffect(() => {
        if (!pipelineStageDropdownOpen[jobId]) return undefined

        const handleOutsideClick = event => {
          if (
            pipelineStageDropdownRefs.current[jobId] &&
            !pipelineStageDropdownRefs.current[jobId].contains(event.target)
          ) {
            setPipelineStageDropdownOpen(prev => ({
              ...prev,
              [jobId]: false,
            }))
          }
        }

        document.addEventListener("mousedown", handleOutsideClick)

        return () => {
          document.removeEventListener("mousedown", handleOutsideClick)
        }
      }, [pipelineStageDropdownOpen, jobId])

// const generateOfferLetterTemplate = ({
//   candidateName, jobTitle, designation, companyName, today, row, job,
// }) => {
//   const location = Array.isArray(job?.location)
//     ? job.location.join(", ")
//     : job?.location || "[Location]";
//   const shiftTimings = job?.shift || "[Shift Timings]";
//   const ctc = job?.salary_max || "[CTC]";
//   const recruiterFirstName = userInfos?.user_details?.user_name || "";
//   const recruiterLastName = userInfos?.user_details?.last_name || "";
//   const recruiterName = `${recruiterFirstName} ${recruiterLastName}`.trim() || "[Recruiter Name]";
//   const companyLogo = job?.company_logo || job?.logo || job?.company?.logo || "";
//   const companyAddress = job?.company_address || job?.address || "";

//   return `
// <div style="font-family:Arial,sans-serif;font-size:14px;line-height:1.6;color:#222;max-width:780px;margin:0 auto;padding:30px;">

//  ${companyLogo ? `
// <div style="text-align:center;margin-bottom:20px;">
//   <img
//     src="${companyLogo}"
//     alt="${companyName} Logo"
//     style="max-height:80px;max-width:220px;object-fit:contain;display:inline-block;border:none !important;outline:none !important;box-shadow:none !important;background:none !important;"
//     onerror="this.style.display='none'"
//   />
// </div>
// ` : `
// <div style="text-align:center;margin-bottom:20px;">
//   <div style="font-size:22px;font-weight:700;color:#12395c;">${companyName || "[Company Name]"}</div>
// </div>
// `}

//   ${companyAddress ? `<div style="text-align:center;font-size:13px;color:#555;margin-bottom:16px;">${companyAddress}</div>` : ""}

//   <div style="text-align:center;margin-bottom:24px;">
//     <strong style="font-size:15px;text-decoration:underline;">CONDITIONAL OFFER LETTER</strong>
//   </div>

//   <p style="text-align:right;margin-bottom:20px;">Date: ${today}</p>

//   <p>Dear <strong>${candidateName}</strong>,</p>

//   <p>We are pleased to issue this Conditional Offer of Employment for the role of <strong>${jobTitle}</strong> with <strong>${companyName || "[Company Name]"}</strong>, based on your application, interview performance, and the discussions held with you. The details of your employment are as follows:</p>

//   <p>
//     <strong>Designation:</strong> ${jobTitle}<br/>
//     <strong>Location:</strong> ${location}<br/>
//     <strong>Shift Timing:</strong> ${shiftTimings}<br/>
//     <strong>Total Cost to Company (CTC):</strong> ${ctc} per annum<br/>
//     (subject to applicable statutory deductions and company policies)<br/>
//     <strong>Date of Joining (DOJ):</strong> [Date of Joining]
//   </p>

//   <p><strong>Documents Required at the Time of Joining</strong></p>
//   <p>You shall submit self-attested copies for verification of the following documents:</p>
//     <ol style="margin:0 0 12px 0;padding-left:20px;list-style-type:decimal;list-style-position:outside;">
//     <li style="margin-bottom:4px;">Educational certificates and mark sheets (10th standard onwards)</li>
//     <li style="margin-bottom:4px;">Valid government-issued identity and address proof (Aadhaar / Passport / Voter ID / Driving License)</li>
//     <li style="margin-bottom:4px;">PAN Card and UAN details (if applicable)</li>
//     <li style="margin-bottom:4px;">Previous employment documents including offer letters, relieving and experience letters, and last three (3) months' salary slips (if applicable)</li>
//     <li style="margin-bottom:4px;">Two (2) recent passport-size photographs</li>
//     <li style="margin-bottom:4px;">Bank account details (cancelled cheque or passbook copy)</li>
//   </ol>
//   <p><strong>Nature and Conditions of Offer</strong></p>
//   <p>This offer is conditional upon your:</p>
//     <ol style="margin:0 0 12px 0;padding-left:20px;list-style-type:disc;">
//       <li style="margin-bottom:4px;">Submission and successful verification of all documents and information provided by you.</li>
//       <li style="margin-bottom:4px;">Satisfactory completion of background and/or reference verification, where applicable.</li>
//       <li style="margin-bottom:4px;">Acceptance of and compliance with all company policies, rules, codes of conduct, and execution of the Non-Disclosure Agreement (NDA), employment agreement, and any other documents as required by the Company.</li>
//     </ol>
//   <p>The Company reserves the right, at its sole discretion, to <strong>modify, defer, or withdraw</strong> this offer at any time if any information furnished by you is found to be inaccurate, incomplete, misleading, or inconsistent with verification findings.</p>

//   <p><strong>Acceptance</strong></p>
//   <p>Please sign and return a copy of this letter as your acceptance on or before <strong>[Acceptance Date]</strong>, failing which this offer may be treated as lapsed at the discretion of the Company.</p>

//   <p>We look forward to your association with <strong>${companyName || "[Company Name]"}</strong>, subject to fulfillment of the above conditions.</p>

//   <br/>
//   <p>Warm Regards,</p>
//   <br/>
//   <p>
//     For <strong>${companyName || "[Company Name]"}</strong>,<br/>
//     <strong>${recruiterName}</strong>,<br/>
//     Senior HR Manager.
//   </p>
// </div>
// `;
// };
const generateOfferLetterTemplate = ({
  candidateName,
  jobTitle,
  designation,
  companyName,
  today,
  row,
  job,
}) => {
  const location = Array.isArray(job?.location)
    ? job.location.join(", ")
    : job?.location || "[Location]";

  const shiftTimings = job?.shift || "[Shift Timings]";
  const ctc = job?.salary_max || "[CTC]";

  const recruiterFirstName = userInfos?.user_details?.user_name || "";
  const recruiterLastName = userInfos?.user_details?.last_name || "";
  const recruiterName =
    `${recruiterFirstName} ${recruiterLastName}`.trim() || "[Recruiter Name]";

  const companyLogo = job?.company_logo || job?.logo || job?.company?.logo || "";
  const companyAddress = job?.company_address || job?.address || "";

const numberedRow = (text, index) => `
  <div style="margin:0 0 7px;padding-left:22px;position:relative;font-size:14px;line-height:1.6;">
    <span style="position:absolute;left:0;top:0;">${index + 1}.</span>${text}
  </div>
`;

const numberedList = items => `
  <div style="margin:6px 0 16px;">
    ${items.map((text, index) => numberedRow(text, index)).join("")}
  </div>
`;

  return `
<div style="font-family:Arial,sans-serif;font-size:14px;line-height:1.6;color:#222;max-width:780px;margin:0 auto;padding:30px;direction:ltr;text-align:left;">

  ${
    companyLogo
      ? `<div style="text-align:center;margin-bottom:20px;">
          <img src="${companyLogo}" alt="${companyName} Logo" style="max-height:80px;max-width:220px;object-fit:contain;" onerror="this.style.display='none'" />
        </div>`
      : `<div style="text-align:center;margin-bottom:20px;">
          <div style="font-size:22px;font-weight:700;color:#12395c;">${companyName || "[Company Name]"}</div>
        </div>`
  }

  ${companyAddress ? `<div style="text-align:center;font-size:13px;color:#555;margin-bottom:16px;">${companyAddress}</div>` : ""}

  <div style="text-align:center;margin-bottom:24px;">
    <strong style="font-size:15px;text-decoration:underline;">CONDITIONAL OFFER LETTER</strong>
  </div>

  <p style="text-align:right;margin-bottom:20px;">Date: ${today}</p>

  <p>Dear <strong>${candidateName}</strong>,</p>

  <p>
    We are pleased to issue this Conditional Offer of Employment for the role of
    <strong>${jobTitle}</strong> with <strong>${companyName || "[Company Name]"}</strong>,
    based on your application, interview performance, and the discussions held with you.
    The details of your employment are as follows:
  </p>

  <p>
    <strong>Designation:</strong> ${jobTitle}<br/>
    <strong>Location:</strong> ${location}<br/>
    <strong>Shift Timing:</strong> ${shiftTimings}<br/>
    <strong>Total Cost to Company (CTC):</strong> ${ctc} per annum<br/>
    (subject to applicable statutory deductions and company policies)<br/>
    <strong>Date of Joining (DOJ):</strong> [Date of Joining]
  </p>

  <p><strong>Documents Required at the Time of Joining</strong></p>
  <p>You shall submit self-attested copies for verification of the following documents:</p>
  ${numberedList([
    "Educational certificates and mark sheets (10th standard onwards)",
    "Valid government-issued identity and address proof (Aadhaar / Passport / Voter ID / Driving License)",
    "PAN Card and UAN details (if applicable)",
    "Previous employment documents including offer letters, relieving and experience letters, and last three (3) months' salary slips (if applicable)",
    "Two (2) recent passport-size photographs",
    "Bank account details (cancelled cheque or passbook copy)",
  ])}

  <p><strong>Nature and Conditions of Offer</strong></p>
  <p>This offer is conditional upon your:</p>
  ${numberedList([
    "Submission and successful verification of all documents and information provided by you.",
    "Satisfactory completion of background and/or reference verification, where applicable.",
    "Acceptance of and compliance with all company policies, rules, codes of conduct, and execution of the Non-Disclosure Agreement (NDA), employment agreement, and any other documents as required by the Company.",
  ])}

  <p>
    The Company reserves the right, at its sole discretion, to <strong>modify, defer, or withdraw</strong>
    this offer at any time if any information furnished by you is found to be inaccurate,
    incomplete, misleading, or inconsistent with verification findings.
  </p>

  <p><strong>Acceptance</strong></p>
  <p>
    Please sign and return a copy of this letter as your acceptance on or before
    <strong>[Acceptance Date]</strong>, failing which this offer may be treated as lapsed
    at the discretion of the Company.
  </p>

  <p>
    We look forward to your association with <strong>${companyName || "[Company Name]"}</strong>,
    subject to fulfillment of the above conditions.
  </p>

  <br/>
  <p>Warm Regards,</p>
  <br/>
  <p>
    For <strong>${companyName || "[Company Name]"}</strong>,<br/>
    <strong>${recruiterName}</strong>,<br/>
    Senior HR Manager.
  </p>

</div>
`;
};
const filterResetKey = candidateFilterResetKeyMap[jobId] ?? 0
    useEffect(() => {
      setLocalSearch(searchMap[jobId] ?? "")
    }, [filterResetKey, jobId])
    const handleRowClick = (row, event) => {
      const isExpanderClick = event?.target?.closest?.(
        "[data-tag='allowRowEvents'], button, svg"
      )
      if (isExpanderClick) return

      if (isWebsiteApplicantRow(row)) {
        setClearedWebsiteRows(prev => {
          const updated = new Set(prev)
          updated.add(row.candidate_id)
          return updated
        })
      }
    }

    const rowStyles = row => {
      console.log(
        "selectedRowId === row.candidate_id ",
        selectedRowId === row.candidate_id
      )
      let style = {}
      if (isWebsiteApplicantRow(row)) {
        style = {
          backgroundColor: selectedRowId === row.candidate_id ? "" : "#ffff99",
          fontWeight: "bold",
          "&:hover": {
            cursor: "pointer",
          },
        }
      }
      if (selectedRowId === row.candidate_id) {
        style = {
          ...style,
          backgroundColor: "",
        }
      }
      return style
    }

    // init per-job values + fetch candidates once on mount
    useEffect(() => {
      setSelectedJob(jobId)

      if (currentPageMap[jobId] === undefined)
        setCurrentPageMap(p => ({ ...p, [jobId]: 1 }))
      if (perPageMap[jobId] === undefined)
        setPerPageMap(p => ({ ...p, [jobId]: 10 }))
      if (totalRowsMap[jobId] === undefined)
        setTotalRowsMap(p => ({ ...p, [jobId]: 0 }))

      initFiltersForJob(job)
      setLocalSearch(searchMap[jobId] ?? "")

      // use parent-level ref so remounts don't reset the guard
      if (!candidatesFetchedRef.current[jobId] && !candidateDataMap[jobId] && !loadingCandidatesMap[jobId]) {
        candidatesFetchedRef.current[jobId] = true
        const page = currentPageMap[jobId] ?? 1
        const size = perPageMap[jobId] ?? 10
        const search = searchMap[jobId] ?? ""
        getCandidateDetails(jobId, page, size, search)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [jobId])

    const loadingCandidates = !!loadingCandidatesMap[jobId]

    // const fetchCandidateTimeline = async (candidateId) => {
    //     try {
    //     const response = await axios.get(
    //         `/api/v1/action-logs/?page=1&size=10&candidate_id=${candidateId}`,

    //     );
    //     const data = response.data;
    //     navigate('/candidate-time-line', { state: { timelineData: data.data } });
    //     } catch (error) {
    //     console.error('Error fetching candidate timeline:', error);
    //     }
    // };
    const currentpath = location.pathname
    // returns true if navigation happened (i.e. timeline loaded), false otherwise
    const fetchCandidateTimeline = async candidateId => {
      setLoadingCandidateTimelineId(candidateId)
      void trackActivity({
        module: "Candidates",
        action: "Candidate Action Logs Viewed",
        recordType: "candidate",
        recordId: candidateId,
        companyId,
        metadata: { job_id: jobId, source: "candidate-action-logs" },
      })
      try {
        const response = await axios.get(
          `/api/v1/action-logs/?page=1&size=10&candidate_id=${candidateId}&job_id=${jobId}`,
          { validateStatus: () => true } // do not throw on 4xx/5xx
        )

        // console.info('Response:', response);
        if (response.status !== 200) {
          const serverMsg =
            response?.data?.msg || "Failed to fetch candidate timeline."
          Swal.fire({
            icon: "error",
            title: "Error",
            text: serverMsg,
            confirmButtonText: "OK",
          })
          return false
        }
        setActionTimelineModal({
          open: true,
          kind: "candidate",
          title: "Candidate Action Logs",
          records: response.data?.data || [],
        })
        return true
      } catch (error) {
        console.error("Error fetching candidate timeline:", error)

        const serverMsg =
          error?.response?.data?.msg ||
          "Failed to fetch candidate timeline. Please try again."
        Swal.fire({
          icon: "error",
          title: "Error",
          text: serverMsg,
          confirmButtonText: "OK",
        })
        return false
      }
      finally {
        setLoadingCandidateTimelineId(null) 
      }
    }

    const availableCandidateColumnOptions = candidateColumnOptions

    const baseColumns = useMemo(
      () => [
        {
          name: (
            <input
              type="checkbox"
              onChange={e => {
                if (e.target.checked) {
                  const currentPageRows = filteredCandidates.filter(c => getCandidateRowId(c))
                  setSelectedCandidateRows(prev => ({
                    ...prev,
                    [jobId]: Array.from(
                      new Set([
                        ...(prev[jobId] || []),
                        ...currentPageRows.map(c => getCandidateRowId(c)),
                      ])
                    ),
                  }));
                  setSelectedCandidateRowData(prev => ({
                    ...prev,
                    [jobId]: {
                      ...(prev[jobId] || {}),
                      ...Object.fromEntries(
                        currentPageRows.map(c => [getCandidateRowId(c), c])
                      ),
                    },
                  }));
                } else {
                  setSelectedCandidateRows(prev => ({
                    ...prev,
                    [jobId]: (prev[jobId] || []).filter(
                      id => !filteredCandidates.some(c => String(getCandidateRowId(c)) === String(id))
                    ),
                  }));
                  setSelectedCandidateRowData(prev => ({
                    ...prev,
                    [jobId]: Object.fromEntries(
                      Object.entries(prev[jobId] || {}).filter(
                        ([id]) => !filteredCandidates.some(c => String(getCandidateRowId(c)) === String(id))
                      )
                    ),
                  }));
                }
              }}
              checked={
                filteredCandidates.length > 0 &&
                filteredCandidates.every(c =>
                  (selectedCandidateRows[jobId] || []).some(
                    id => String(id) === String(getCandidateRowId(c))
                  )
                )
              }
            />
          ),
          width: "50px",
          cell: row => (
            <input
              type="checkbox"
              checked={(selectedCandidateRows[jobId] || []).some(
                id => String(id) === String(getCandidateRowId(row))
              )}
              onChange={e => {
                const id = getCandidateRowId(row);
                if (e.target.checked) {
                  setSelectedCandidateRows(prev => ({
                    ...prev,
                    [jobId]: Array.from(new Set([...(prev[jobId] || []), id])),
                  }));
                  setSelectedCandidateRowData(prev => ({
                    ...prev,
                    [jobId]: {
                      ...(prev[jobId] || {}),
                      [id]: row,
                    },
                  }));
                } else {
                  setSelectedCandidateRows(prev => ({
                    ...prev,
                    [jobId]: (prev[jobId] || []).filter(r => r !== id),
                  }));
                  setSelectedCandidateRowData(prev => {
                    const nextJobRows = { ...(prev[jobId] || {}) };
                    delete nextJobRows[id];
                    return {
                      ...prev,
                      [jobId]: nextJobRows,
                    };
                  });
                }
              }}
            />
          ),
        },
      //   {
      //     name: <span className="font_15 ColumnTitle fw-bold">First Name</span>,
      //     selector: r => r.first_name ?? r.candidate_name ?? r.firstName,
      //     sortable: true,
      //     cell: row => {
      //       const displayName =
      //         row.first_name || row.candidate_name || row.firstName || "--"
      //       return <span title={displayName}>{displayName}</span>
      //     },
      //   },
      //  {
      //   name: <span className="font_15 ColumnTitle fw-bold">Last Name</span>,
      //   sortable: true,
      //   selector: r =>
      //     [r.middle_name, r.last_name ?? r.lastName]
      //       .filter(Boolean)
      //       .join(" "),
      //   cell: row => {
      //     const lastName = [
      //       row.middle_name,
      //       row.last_name ?? row.lastName,
      //     ]
      //       .filter(Boolean)
      //       .join(" ")

      //     return (
      //       <span title={lastName}>
      //         {lastName || "—"}
      //       </span>)}
        
      //   },
  {
        columnKey: "candidate_name",
        name: (
          <span className="font_15 ColumnTitle fw-bold">Candidate Name</span>
        ),
        sortable: true,
        selector: r => getCandidateFullName(r),
        cell: row => {
          const fullName = getCandidateFullName(row)
          const initials = getCandidateInitials(row)
          const initialsColor = getCandidateInitialColor(row)
          const hasLogs = Array.isArray(row.pipeline_logs) && row.pipeline_logs.length > 0

         return (
            <div
              title={fullName}
              style={{
                display: "grid",
                gridTemplateColumns: "28px 1fr 20px",
                alignItems: "center",
                columnGap: 8,
                width: "100%",
                minWidth: 0,
              }}
            >
              {/* Initials */}
              <span
                className="d-inline-flex align-items-center justify-content-center rounded-circle fw-bold"
                style={{
                  backgroundColor: initialsColor.background,
                  border: `1px solid ${initialsColor.border}`,
                  color: initialsColor.color,
                  width: 28,
                  height: 28,
                  minWidth: 28,
                  fontSize: 12,
                  lineHeight: 1,
                  flexShrink: 0,
                }}
              >
                {initials || "-"}
              </span>

              <span
                onClick={() => ViewCandidateInfo(row,jobId)}
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  wordBreak: "normal",
                  minWidth: 0,
                  display: "block",
                  color: "#1a5fa8",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
              >
                {fullName || "--"}
              </span>
              {hasLogs ? (
                <span
                  title="View pipeline history"
                  style={{
                    cursor: "pointer",
                    color: "#6366f1",
                    fontSize: 13,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 20,
                    flexShrink: 0,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setPipelineLogsCandidate(row);
                    setPipelineLogsModal(true);
                  }}
                >
                  <FaHistory />
                </span>
              ) : (
                <span />
              )}
            </div>
          );
        },
        minWidth: "180px",
        grow: 1,
      },
        {
          columnKey: "job_orders",
          name: <span className="font_15 ColumnTitle fw-bold">Job Orders</span>,
          minWidth: "220px",
          wrap: true,
          cell: candidate => (
            <div style={{ padding: "8px 0", whiteSpace: "normal", overflowWrap: "anywhere" }}>
              {Array.isArray(candidate.job_orders) && candidate.job_orders.length
                ? candidate.job_orders.map((jobOrder, index) => (
                    <div key={`${jobOrder.job_id ?? jobOrder.id ?? "job"}-${index}`}>
                      {jobOrder.job_title || "-"}
                    </div>
                  ))
                : "-"}
            </div>
          ),
        },
        {
          columnKey: "email",
          name: <span className="font_15 ColumnTitle fw-bold">Email</span>,
          selector: r => r.email || r.candidate_email || "--",
          cell: row => (
            <div
              className="d-flex align-items-center"
            >
              <span
                className="MobilePhoneContaier"
                title={row.email || row.candidate_email || "--"}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setEditField("email");
                  setEditValue(row.email ?? row.candidate_email ?? "");
                  setCandidateToEdit(row);
                  setShowEditModal(true);
                }}
              >
                {row.email || row.candidate_email || "--"}
              </span>
               <FaPencilAlt
                  style={{ cursor: "pointer" }}
                  title="Edit Email"
                  onClick={() => {
                    setEditField("email");
                    setEditValue(row.email ?? row.candidate_email ?? "");
                    setCandidateToEdit(row);
                    setShowEditModal(true);
                  }}
                />
            </div>
          ),
          sortable: true,
          minWidth:'100px',
          // grow: 1,
        },
        {
          columnKey: "phone",
          name: <span className="font_15 ColumnTitle fw-bold">Phone</span>,
          selector: r => r.mobile_phone ?? r.candidate_phone ?? "-",
          cell: row => (
            <div
              className="d-flex align-items-center gap-2"
            >
              <span
                className="MobilePhoneContaier"
                title={row.mobile_phone ?? row.candidate_phone ?? "-"}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setEditField("mobile_phone");
                  setEditValue(row.mobile_phone ?? row.candidate_phone ?? "");
                  setCandidateToEdit(row);
                  setShowEditModal(true);
                }}
              >
                {row.mobile_phone ?? row.candidate_phone ?? "-"}
              </span>
              <FaPencilAlt
                style={{ cursor: "pointer" }}
                title="Edit Phone Number"
                onClick={() => {
                  setEditField("mobile_phone");
                  setEditValue(row.mobile_phone ?? row.candidate_phone ?? "");
                  setCandidateToEdit(row);
                  setShowEditModal(true);
                }}
              />
              <button
                type="button"
                className="btn btn-sm text-success p-0"
                title="Click to Call Candidate"
                onClick={() => handlePhoneCallOpen(row)}
              >
                <FaPhoneAlt />
              </button>
            </div>
            
          ),
          sortable: true,
          width: "150px"
        },
        // {
        //     name: "Designation",
        //     selector: (r) => r.designation ?? r.current_designation ?? "",
        // },
        // { name: "Company", selector: (r) => r.current_company ?? r.currentCompany ?? "" },
        {
          columnKey: "experience",
          name: (
            <span className="font_15 ColumnTitle fw-bold" style={{ whiteSpace: "nowrap" }}>
              Exp. (Yrs)
            </span>
          ),
          width: '120px',
          minWidth: '120px',
          selector: r => r.total_experience ?? r.experience ?? "-",
          cell: row => (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ position: "relative", width: "100%", minHeight: 24, paddingRight: 22 }}
            >
              <span
                title={row.total_experience ?? row.experience ?? "-"}
                style={{ cursor: "pointer", textAlign: "center", width: "100%" }}
                onClick={() => {
                  setEditField("total_experience");
                  setEditValue(String(row.total_experience ?? row.experience ?? ""));
                  setCandidateToEdit(row);
                  setShowEditModal(true);
                }}
              >
                {row.total_experience ?? row.experience ?? "-"} Yrs
              </span>
              <FaPencilAlt
                style={{ cursor: "pointer", position: "absolute", right: 2, top: "50%", transform: "translateY(-50%)" }}
                title="Edit Experience"
                onClick={() => {
                  setEditField("total_experience");
                  setEditValue(String(row.total_experience ?? row.experience ?? ""));
                  setCandidateToEdit(row);
                  setShowEditModal(true);
                }}
              />
            </div>
          ),
          sortable: true,
        },
        {
          columnKey: "status",
          name: <span className="font_15 ColumnTitle fw-bold">Status</span>,
          width: "115px",
          selector: r =>
            r.stage_name ??
            r.candidate_status ??
            r.pipeline_status ??
            r.application_status ??
            "-",
          sortable: true,
          cell: row => {
            const status =
              row.stage_name ??
              row.candidate_status ??
              row.pipeline_status ??
              row.application_status ??
              "-"
            const isPlaced = isCandidatePlaced(row)

            return (
              <div className="d-flex align-items-center gap-2">
                <button
                  type="button"
                  className="btn btn-sm"
                  title={status}
                  onClick={() => {
                      const missingFields = [];

                      if (!row?.email && !row?.candidate_email) missingFields.push("Email");
                      if (!row?.mobile_phone && !row?.candidate_phone) missingFields.push("Phone Number");

                      if (missingFields.length > 0) {
                        Swal.fire({
                          icon: "warning",
                          title: "Missing Contact Details",
                          html: `Cannot update pipeline status — the following field${
                            missingFields.length > 1 ? "s are" : " is"
                          } missing for <strong>${row?.first_name || ""}</strong> <strong>${row?.middle_name || ""}</strong> <strong>${row?.last_name || ""}</strong> :<br/><br/><b>${missingFields.join(", ")}</b><br/><br/>Please update the candidate's details before changing the stage.`,
                          confirmButtonText: "OK",
                        });
                        return;
                      }

                      setSelectedCandidateForStatus(row);

                      const selectedStage = stagesList.find(
                        stage => stage.name === row.pipeline_status
                      );

                      const statusId = selectedStage ? selectedStage.id : "";

                      setSelectedCandidateStatusId(statusId);
                      setCandidateRejectedRound(
                        row.rejection_round || row.rejected_round || row.reject_round || ""
                      );
                      setReason(
                        row.pipeline_logs?.[row.pipeline_logs.length - 1]?.reason ||
                          row.reason ||
                          ""
                      );
                      setCandidateStatusModal(true);
                    }}
                  style={{
                    background: "#eef6ff",
                    border: "1px solid #b8ddff",
                    color: "#075985",
                    borderRadius: 14,
                    padding: "2px 8px",
                    fontSize: 12,
                    fontWeight: 600,
                    lineHeight: 1.2,
                    whiteSpace: "nowrap",
                    maxWidth: 82,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {status}
                </button>
                {!isPlaced && (
                  <FaPencilAlt
                    style={{ cursor: "pointer" }}
  //                 onClick={() => {
  //                   setSelectedCandidateForStatus(row)
  //                    const statusId = row.stage_id ?? row.candidate_status_id ?? row.pipeline_status_id ?? row.application_status_id ?? "";
  //                    console.log("Selected Status ID:", statusId); // Debug log
  // console.log("Stages List:", stagesList); // D
  //                   setSelectedCandidateStatusId(
  //                     row.stage_id ??
  //                       row.candidate_status_id ??
  //                       row.pipeline_status_id ??
  //                       row.application_status_id ??
  //                       ""
  //                   )
  //                   setCandidateStatusModal(true)
  //                   setReason(row.is_approved_reason ?? row.is_rejected_reason ?? "");
  //                 }}
                      onClick={() => {
                         const missingFields = [];
                            if (!row?.email && !row?.candidate_email) missingFields.push("Email");
                            if (!row?.mobile_phone && !row?.candidate_phone) missingFields.push("Phone Number");

                            if (missingFields.length > 0) {
                              Swal.fire({
                                icon: "warning",
                                title: "Missing Contact Details",
                                html: `Cannot update pipeline status — the following field${missingFields.length > 1 ? "s are" : " is"} missing for <strong>${row?.first_name || ""} ${row?.middle_name || ""} ${row?.last_name || ""}</strong> :<br/><br/><b>${missingFields.join(", ")}</b><br/><br/>Please update the candidate's details before changing the stage.`,
                                confirmButtonText: "OK",
                              });
                              return;
                            }
                      setSelectedCandidateForStatus(row);
                      // Find the stage ID from stagesList that matches the pipeline_status
                      const selectedStage = stagesList.find(stage => stage.name === row.pipeline_status);
                      const statusId = selectedStage ? selectedStage.id : "";
                      setSelectedCandidateStatusId(statusId);
                      setCandidateRejectedRound(
                        row.rejection_round || row.rejected_round || row.reject_round || ""
                      );
                      setReason(
                        row.pipeline_logs?.[row.pipeline_logs.length - 1]?.reason ||
                          row.reason ||
                          ""
                      );
                      setCandidateStatusModal(true);
                    }}
                  />
                )}
              </div>
            )
          },
        },
        // {
        //   name: <span className="font_15 ColumnTitle fw-bold">Added By</span>,
        //   width: "110px",
        //   selector: r => r.applied_by ?? r.applied_by ?? r.created_at ?? "-",
        //   sortable: true,
        //   cell: row => {
        //     const appliedDate =
        //       row.applied_by ?? row.applied_by ?? row.applied_by
        //     return (
        //       <span title={appliedDate || "-"}>
        //         {appliedDate}
        //       </span>
        //     )
        //   },
        // },
        //  {
        //   name: <span className="font_15 ColumnTitle fw-bold">Added On</span>,
        //   width: "130px",
        //   selector: r => r.applied_on ?? r.applied_at ?? r.created_at ?? "-",
        //   sortable: true,
        //   cell: row => {
        //     const appliedDate =
        //       row.applied_on ?? row.applied_at ?? row.created_at

        //     if (!appliedDate) return <span>-</span>;

        //     const dateObj = new Date(appliedDate);

        //     const date = dateObj.toLocaleDateString("en-IN", {
        //       day: "2-digit",
        //       month: "short",
        //       year: "numeric",
        //     });

        //     const time = dateObj.toLocaleTimeString("en-IN", {
        //       hour: "2-digit",
        //       minute: "2-digit",
        //       hour12: true,
        //     });

        //     return (
        //       <span title={appliedDate}>
        //         <div>{date}</div>
        //         <div style={{ fontSize: "11px", color: "#6b7280" }}>
        //           {time}
        //         </div>
        //       </span>
        //     )
        //   },
        // },
        {
        columnKey: "added_by",
  name: <span className="font_15 ColumnTitle fw-bold">Added In Job</span>,
  width: "140px",
  selector: row =>
    `${row.applied_by ?? "-"} ${row.applied_on ?? row.applied_at ?? row.created_at ?? ""}`,
  sortable: true,
  cell: row => {
    const addedBy = formatDisplayName(row.applied_by ?? "-");
    const appliedDateRaw =
      row.applied_on ?? row.applied_at ?? row.created_at;

    if (!appliedDateRaw) {
      return (
        <span
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "block",
            width: "100%",
          }}
          title={addedBy}
        >
          {addedBy}
        </span>
      );
    }

   const dateObj = new Date(appliedDateRaw);

const formatted = appliedDateRaw
  ? `${String(dateObj.getUTCDate()).padStart(2, "0")}/${String(dateObj.getUTCMonth() + 1).padStart(2, "0")}/${dateObj.getUTCFullYear()}`
  : "-";
const formattedTitleDate = Number.isNaN(dateObj.getTime())
  ? "-"
  : formatUTCDate(appliedDateRaw);

    return (
      <div
        title={`${addedBy} | ${formattedTitleDate}`}
        style={{ overflow: "hidden", width: "100%", minWidth: 0 ,padding: "4px 0"}}
      >
        <div
          style={{
            fontWeight: 400,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {addedBy}
        </div>
        <div style={{ fontSize: "11px", color: "#6b7280", whiteSpace: "nowrap" }}>
          {formatted}
        </div>
      </div>
    );
  },
},
        {
          columnKey: "candidate_added_by",
          name: <span className="font_15 ColumnTitle fw-bold">Added In Database</span>,
          width: "145px",
          selector: row =>
            `${row.candidate_created_by ??
              row.candidate_added_by ??
              row.created_by_name ??
              row.created_by ??
              "-"} ${row.candidate_created_at ?? row.created_at ?? ""}`,
          sortable: true,
          omit: "",
          cell: row => {
            const candidateAddedBy = formatDisplayName(
              row.candidate_created_by ??
                row.candidate_added_by ??
                row.created_by_name ??
                row.created_by ??
                "-"
            );
            const candidateCreatedAt = row.candidate_created_at ?? row.created_at;
            const formattedCandidateCreatedAt = candidateCreatedAt
              ? (() => {
                const dateObj = new Date(candidateCreatedAt);
                if (Number.isNaN(dateObj.getTime())) return "-";
                return `${String(dateObj.getUTCDate()).padStart(2, "0")}-${String(dateObj.getUTCMonth() + 1).padStart(2, "0")}-${dateObj.getUTCFullYear()}`;
              })()
              : "-";
            const formattedCandidateCreatedAtTitle = candidateCreatedAt
              ? formatUTCDate(candidateCreatedAt)
              : "-";

            return (
              <div
                title={`${candidateAddedBy} | ${formattedCandidateCreatedAtTitle}`}
                style={{
                  width: "100%",
                  minWidth: 0,
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    fontWeight: 400,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {candidateAddedBy}
                </div>
                <div style={{ fontSize: "11px", color: "#6b7280", whiteSpace: "nowrap" }}>
                  {formattedCandidateCreatedAt}
                </div>
              </div>
            );
          },
        },
        // {
        //   name: (
        //     <span className="font_15 ColumnTitle fw-bold">Applied From</span>
        //   ),
        //   // width:"123px",
        //   selector: r =>
        //     r.applied_from ?? r.source ?? r.candidate_source ?? "-",
        //   cell: row => (
        //     <span title={row.applied_from ?? row.source ?? "-"}>
        //       {row.applied_from ?? row.source ?? "-"}
        //     </span>
        //   ),
        //   sortable: true,
        // },
        // {
        //   name: (
        //     <span className="font_15 ColumnTitle fw-bold">Added From</span>
        //   ),
        //   selector: r => r.added_from ?? "-",
        //   cell: row => (
        //     <span title={row.added_from ?? "-"}>
        //       {row.added_from ?? "-"}
        //     </span>
        //   ),
        //   sortable: true,
        // },
        // {
        //         name: "Added From",
        //         selector: r =>
        //             r.added_by_name ??
        //             r.created_by_name ??
        //             r.added_by ??
        //             r.created_by ??
        //             "-",
        //         sortable: true,
        //         cell: row => {
        //             const addedBy =
        //                 row.added_by_name ??
        //                 row.created_by_name ??
        //                 row.added_by ??
        //                 row.created_by ??
        //                 "-";

        //             return (
        //                 <span title={addedBy}>
        //                     {addedBy}
        //                 </span>
        //             );
        //         },
        //     },
        // { name: "City", selector: (r) => r.city ?? "" },
        // {
        //   name: (
        //     <span className="font_15 ColumnTitle fw-bold">
        //       Candidate Details
        //     </span>
        //   ),
        //   cell: row => (
        //     <div>
        //       <span
        //         style={{
        //           fontSize: "25px",
        //           fontWeight: "bold",
        //           cursor: "pointer",
        //         }}
        //         title="View Candidate Details"
        //         onClick={() => ViewCandidateInfo(row)}
        //       >
        //         <FaRegEye />
        //       </span>
        //     </div>
        //   ),
        // },
        // {
        //     name: "Assigned Test",
        //     cell: (row) => (
        //         <div>
        //             <RSButton size="sm" outline onClick={() => console.log("view assigned test", row)}>
        //                 View
        //             </RSButton>
        //         </div>
        //     ),
        // },
        // {
        //     name: "Candidate Pipeline Status",
        //     cell: row => {
        //         const qualified =
        //             row?.talent_scan_result?.results?.[0]?.ats_details
        //                 ?.is_test_qualified

        //         return (
        //             <span
        //                 className={`badge px-2 py-1 ${qualified ? "bg-success" : "bg-danger"
        //                     }`}
        //                 style={{ fontSize: "13px" }}
        //             >
        //                 {qualified ? "Yes" : "No"}
        //             </span>
        //         )
        //     },
        // },
        {
          columnKey: "is_selected",
          selector: row => row.pipeline_status === "Placed" ? 1 : 0,
          name: (
            <span className="font_15 ColumnTitle fw-bold">Is Selected</span>
          ),
          sortable: true,
          cell: row => {
            const qualified =
              row.pipeline_status === "Placed"

            return (
              <span
                className={`badge px-2 py-1 ${
                  qualified ? "bg-success" : "bg-danger"
                }`}
                style={{ fontSize: "13px" }}
              >
                {qualified ? "Yes" : "No"}
              </span>
            )
          },
          width:"120px"
        },

        {
          columnKey: "send_test",
          name: <span className="font_15 ColumnTitle fw-bold">Send Test</span>,
          width:"90px",
          cell: row => {
            const isLoading =
              loadingSendTest && loadingSendTestCandidateId === row.job_candidate_id  
            const isStandalone = userInfos.user_details?.companies_data?.some(
              c =>
                c.integration_type === "integrated-ts" ||
                c.integration_type === "standalone"
            )
            const isTestSent =
              row?.test_sent === true ||
              row?.test_sent === 1 ||
              String(row?.test_sent || "").toLowerCase() === "true"
            const candidateName =
              row.first_name || row.candidate_name || "Candidate"
            const jobTitle = job.job_title || "Job"
            const tooltipText = `Send Test to ${candidateName} for ${jobTitle}`
            const isPlaced = row.pipeline_status === "Placed" || row.stage_name === "Placed";
            if (isPlaced) {
              return <span>--</span>;
            }
            // return (
            //   <div className="d-block w-100 text-center">
            //     {isTestSent ? (
            //       <button
            //         className="btn btn-sm btn-outline-primary blueBtn"
            //         onClick={() => {
            //           if (isStandalone) {
            //             openSendTestModal(row, job)
            //           } else {
            //             openIntegratedPopup(row, job)
            //           }
            //         }}
            //         disabled={isLoading}
            //         title="Resend Test"
            //       >
            //         {isLoading ? (
            //           <span
            //             className="spinner-border spinner-border-sm"
            //             role="status"
            //             aria-hidden="true"
            //           ></span>
            //         ) : (
            //           "Resend"
            //         )}
            //       </button>
            //     ) : (
            //       <span
            //         style={{
            //           fontSize: "30px",
            //           fontWeight: "bold",
            //           cursor: "pointer",
            //         }}
            //         onClick={() => {
            //           if (isStandalone) {
            //             openSendTestModal(row, job)
            //           } else {
            //             openIntegratedPopup(row, job)
            //           }
            //         }}
            //         title={tooltipText}
            //       >
            //         {isLoading ? (
            //           <span
            //             className="spinner-border spinner-border-sm"
            //             role="status"
            //             aria-hidden="true"
            //           ></span>
            //         ) : (
            //           <IoIosSend />
            //         )}
            //       </span>
            //     )}
            //     {/* <Link
            //         className="btn btn-default"
            //         to="/candidate-time-line"
            //         style={{ fontSize: "24px" }}
            //         onClick={async (e) => {
            //             e.preventDefault();
            //             await fetchCandidateTimeline(row.candidate_id);
            //         }}
            //         title="Candidate Action Logs"
            //     >
            //         <FaBusinessTime />
            //     </Link> */}
            //     <FaRegEye
            //       style={{
            //         cursor: "pointer",
            //         color: "#0d6efd",
            //         fontSize: 18,
            //         marginLeft: 10,
            //         verticalAlign: "middle",
            //       }}
            //       title="View Test Results"
            //       onClick={(e) => {
            //         e.stopPropagation()
            //         openTestResultsModal(row)
            //       }}
            //     />
            //   </div>
            // )
            return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
                width: "100%",
                overflow: "visible",
              }}
            >
              {isTestSent ? (
                <button
                  className="btn btn-sm btn-outline-primary blueBtn"
                  style={{ whiteSpace: "nowrap", flexShrink: 0, padding: "4px 10px" }}
                  onClick={() => {
                    if (isStandalone) {
                      openSendTestModal(row, job)
                    } else {
                      openIntegratedPopup(row, job)
                    }
                  }}
                  disabled={isLoading}
                  title="Resend Test"
                >
                  {isLoading ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    "Resend"
                  )}
                </button>
              ) : (
                <span
                  style={{ fontSize: "26px", fontWeight: "bold", cursor: "pointer", display: "inline-flex", alignItems: "center", flexShrink: 0 }}
                  onClick={() => {
                    if (isStandalone) {
                      openSendTestModal(row, job)
                    } else {
                      openIntegratedPopup(row, job)
                    }
                  }}
                  title={tooltipText}
                >
                  {isLoading ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    <IoIosSend />
                  )}
                </span>
              )}

              
            </div>
          )
          },
        },
       {
          columnKey: "resume_score",
          name: <span className="font_15 ColumnTitle fw-bold">Resume Score</span>,
          width: "90px",
          sortable: true,
          selector: row => row.score ?? resumeScoreMap[row.job_candidate_id] ?? 0,
          sortFunction: (a, b) => {
            const scoreA = Number(a.score ?? resumeScoreMap[a.job_candidate_id] ?? 0);
            const scoreB = Number(b.score ?? resumeScoreMap[b.job_candidate_id] ?? 0);
            return scoreA - scoreB;
          },
          cell: row => {
            const score = row.score ?? resumeScoreMap[row.job_candidate_id] ?? null;
            if (score === null || score === undefined) {
              return <span>--</span>;
            }
            const numScore = Number(score);
            let color = "#dc3545";
            if (numScore >= 80) color = "#0d6efd";
            else if (numScore >= 60) color = "#198754";
            else if (numScore >= 40) color = "#121312";
            return (
              <div className="d-flex align-items-center gap-2">
                <span style={{ fontWeight: 600, fontSize: "13px" ,cursor: "pointer", color: color,textDecoration: "underline"}} title="View Resume Reason"
                onClick={() => {
                    setResumeReasonData(row);
                    setResumeReasonModal(true);
                  }}>{numScore}%</span>
                <FaRegEye
                  style={{ cursor: "pointer", color: "#0d6efd", fontSize: 14 }}
                  title="View Reason"
                  onClick={() => {
                    setResumeReasonData(row);
                    setResumeReasonModal(true);
                  }}
                />
              </div>
            );
          },
        },
        {
          columnKey: "agent_status",
          name: <span className="font_15 ColumnTitle fw-bold">Agent Status</span>,
          width: "110px",
          cell: row => {
            const status = getConsentStatus(row);
            const lower = status.toLowerCase();
            const bgColor =
              lower === "sent"
                ? "#198754"
                : lower === "rejected"
                  ? "#dc3545"
                  : lower === "pending"
                    ? "#f59e0b"
                    : "#94a3b8";
            const textColor = "#fff";
            const consentData = row?.consent_data ?? [];
            const hasRecords = Array.isArray(consentData)
              ? consentData.flat(Infinity).some(item => item && typeof item === "object")
              : false;
            return (
              <div className="d-flex align-items-center gap-2">
                <span
                  className="px-2 py-1"
                  title={hasRecords ? "View AI Screening Details" : "No AI Screening Details Available"}
                  style={{ fontSize: "12px", fontWeight: 600, borderRadius: 20, background: bgColor, color: textColor ,cursor: hasRecords ? "pointer" : "not-allowed",textDecoration: hasRecords ? "underline" : "none"}}
                   onClick={() => fetchConsentDetails(row)}
                >
                  {status}
                </span>
                 {hasRecords && (
                <FaRegEye
                  style={{ cursor: "pointer", fontSize: "16px", color: "#0d6efd" }}
                  title="View AI Screening Details"
                  onClick={() => fetchConsentDetails(row)}
                />
                )}
              </div>
            );
          },
        },

        // {
        //     name: "Send To Hrms",
        //     width:"100px",
        //     // cell: (row) => (
        //     //     <button className="btn blueBtn" onClick={() => openHrmsModal(row)}>
        //     //         Send
        //     //     </button >
        //     // ),
        //     cell: (row) => {
        //         const isSentToHRMS = row.hrms_status; // true/false
        //         const isLoading =
        //             loadingSendToHRMS && loadingSendToHRMSCandidateId === row.candidate_id;
        //         const isPlaced = row.stage_name === "Placed" || row.candidate_status === "Placed" || row.pipeline_status === "Placed";
        //         const candidateName = row.first_name || row.candidate_name || "Candidate";
        //         // const tooltipText = `Send ${candidateName} to HRMS`;
        //         const tooltipText = isPlaced
        //             ? `Send ${candidateName} to HRMS`
        //             : `Only candidates marked as Placed can be sent to HRMS.`;

        //         return (
        //             <div title={tooltipText} style={{ display: "inline-block" }}>
        //                 <button
        //                     className={`btn ${isSentToHRMS ? "btn-secondary" : "blueBtn"}`}
        //                      onClick={isSentToHRMS || !isPlaced ? null : () => openHrmsModal(row)}
        //                     disabled={isSentToHRMS ||!isPlaced|| isLoading}
        //                     title={tooltipText}
        //                     style={{
        //                         fontSize: "13px",
        //                         display: "flex",
        //                         alignItems: "center",
        //                         justifyContent: "center",
        //                         gap: "8px",
        //                     }}
        //                 >
        //                     {isLoading ? (
        //                         <span
        //                             className="spinner-border spinner-border-sm"
        //                             role="status"
        //                             aria-hidden="true"
        //                         ></span>
        //                     ) : isSentToHRMS ? (
        //                         <>
        //                             Sent

        //                         </>
        //                     ) : (
        //                         "Send"
        //                     )}
        //                 </button>
        //                 {isSentToHRMS && <span
        //                     onClick={(e) => {
        //                         e.stopPropagation(); // prevent triggering parent button
        //                         handleViewSendHRMSHistory(row);
        //                     }}
        //                     style={{
        //                         marginLeft: "5px",
        //                         fontSize: "18px",
        //                         cursor: "pointer",
        //                         color: "#333",
        //                     }}
        //                     title="View History"
        //                 >
        //                     <FaHistory />
        //                 </span>}
        //             </div>

        //         );
        //     },
        // },
        {
          columnKey: "send_to_hrms",
          name: <span className="font_15 ColumnTitle fw-bold">Send To Hrms</span>,
          width: "120px",
          cell: row => {
            const isSentToHRMS = row.hrms_status
            const isPlaced = row.pipeline_status === "Placed"
            const isApproved = row.is_approved
            const isRejected = row.is_rejected
            const isSentForApproval = row.send_for_approval
            const isLoading =
              loadingSendToHRMS &&
              loadingSendToHRMSCandidateId === row.candidate_id
            if (!isPlaced) {
              return <span>--</span>
            }
            if (isRejected) {
              const rejectedLabel = row.rejected_round
                ? `Rejected (${row.rejected_round})`
                : "Rejected (Not specified)"
              return (
                <div className="w-100 text-center">
                  <button
                    className="btn btn-sm btn-danger"
                    disabled
                    title={
                      row.rejected_at
                        ? `Rejected at ${new Date(row.rejected_at).toLocaleString()}`
                        : "Rejection date not specified"
                    }
                  >
                    {rejectedLabel}
                  </button>
                </div>
              )
            }
      //     if (hasVgus) {
      //   return (
      //     <div>
      //       <button
      //         className="btn btn-sm blueBtn"
      //         onClick={() => {  
      //           const candidateName =
      //             `${row.first_name || ""} ${row.middle_name || ""} ${row.last_name || ""}`.trim();
      //           const jobTitle = job?.job_title || "";
      //           const designation = job?.position_name || jobTitle;
      //           const companyName = job?.company_name || job?.client_name || "";
      //           const today = new Date().toLocaleDateString("en-IN", {
      //             day: "2-digit", month: "long", year: "numeric",
      //           });

      //           setOfferLetterCandidate(row);  
      //           setOfferLetterJob(job);   
      //           setOfferLetterSubject(`Offer of Employment - ${designation || "Position"}`);
      //           setOfferLetterCC(userInfos?.user_details?.email || "");
      //           setOfferLetterContent(
      //             generateOfferLetterTemplate({
      //               candidateName,
      //               jobTitle: designation || jobTitle,
      //               designation: designation || jobTitle,
      //               companyName,
      //               today,
      //               row,
      //               job,
      //             })
      //           );
      //           setOfferLetterModal(true);
      //         }}
      //       >
      //         Send Offer Letter
      //       </button>
      //     </div>
      //   );
      // }

            return (
              <div className="job-candidate-hrms-cell">
                {/* Show "Sent for Approval" if placed and sent_for_approval is true */}
                  {isPlaced && isSentForApproval && !isApproved && (
                    <button className="btn btn-sm btn-secondary" disabled id="SentForApprovalBtn">
                      Sent for Approval
                    </button>
                )}
                {/* Show "Send for Approval" button if placed and not approved */}
                {isPlaced &&  !isSentForApproval && !isApproved && (
                  <button
                    className="btn btn-sm blueBtn"
                    onClick={() => {
                      setSelectedCandidateForApproval(row)
                      setSelectedJobForUpload({ job_id: row.job_id }) // Set the job context
                      setSendForApprovalModal(true)
                    }}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <span
                        className="spinner-border spinner-border-sm me-1"
                        role="status"
                      ></span>
                    ) : (
                      <span id="SendForApprovalBtn">Send for Approval</span>
                    )}
                  </button>
                )}

                {/* Show "Send to HRMS" button if placed, approved, and not sent to HRMS */}
                {isPlaced && isApproved && !isSentToHRMS && (
                  <button
                    className="btn btn-sm blueBtn"
                    onClick={() => openHrmsModal(row)}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <span
                        className="spinner-border spinner-border-sm me-1"
                        role="status"
                      ></span>
                    ) : (
                      "Send to HRMS"
                    )}
                  </button>
                )}
{/* Chandu */}
                {/* Show "Sent" badge if sent to HRMS */}
                {isSentToHRMS && (
                  <div className="job-candidate-hrms-status">
                    {/* <span className="badge bg-success me-2">Sent</span> */}
                    <span title="Sent to HRMS">
                        <button className="btn btn-sm blueBtn job-candidate-hrms-sent" disabled>
                          Sent
                        </button>
                      </span>

                    <FaHistory
                      className="job-candidate-hrms-history"
                      style={{
                        cursor: "pointer",
                      }}
                      title="View HRMS History"
                      onClick={e => {
                        console.log(row)
                        e.stopPropagation()
                        handleViewSendHRMSHistory(row)
                      }}
                    />
                    {loggedInEmail === "anwar@pranathiss.com" && (
                      <button
                        type="button"
                        className="job-candidate-hrms-resend"
                        title="Resend to HRMS"
                        aria-label="Resend to HRMS"
                        onClick={e => {
                          e.stopPropagation()
                          openHrmsModal(row)
                        }}
                        disabled={isLoading}
                      >
                        <FaRedo aria-hidden="true" />
                      </button>
                    )}
                  </div>
                )}
              </div>
            )
          },
        },

        // {
        //   name: <span className="font_15 ColumnTitle fw-bold">Action</span>,
        //   width: "100px",
        //   // cell: (row) => (
        //   //     <div className="d-flex">
        //   //         {/* <Link to={`/create-job-orders-view/${job.id}`}>
        //   //             <RSButton color="light" size="sm">
        //   //                 <FaRegEdit />
        //   //             </RSButton>
        //   //         </Link> */}
        //   //         <button className="btn text-danger" size="sm" onClick={() => { handleCandidateDlink(row) }}>
        //   //             <FaRegTrashAlt />
        //   //         </button>
        //   //     </div>
        //   // ),
        //   cell: row => {
        //     const isSentToHRMS = row.hrms_status // hrms_status is true/false
        //     return (
        //       <div className="d-flex">
        //         <button
        //           className="btn text-danger"
        //           title="Delete Candidate"
        //           size="sm"
        //           onClick={
        //             isSentToHRMS ? null : () => handleCandidateDlink(row)
        //           }
        //           disabled={isSentToHRMS}
        //         >
        //           {loadingDeleteCandidate &&
        //           loadingDeleteCandidateId === row.candidate_id ? (
        //             <span
        //               className="spinner-border spinner-border-sm"
        //               role="status"
        //               aria-hidden="true"
        //             ></span>
        //           ) : (
        //             <FaRegTrashAlt />
        //           )}
        //         </button>
        //       </div>
        //     )
        //   },
        // },
        // {
        //   name: (
        //     <span className="font_15 ColumnTitle fw-bold">Action Logs</span>
        //   ),
        //   cell: row => (<>
        //         <Link
        //         className="btn btn-default"
        //         to="/candidate-time-line"
        //         style={{ fontSize: "24px" }}
        //         onClick={async e => {
        //             e.preventDefault()
        //             await fetchCandidateTimeline(row.candidate_id)
        //         }}
        //         title="Candidate Action Logs"
        //         >
        //         <FaBusinessTime />
        //         </Link>
        //         {/* <button type="button" className="btn btn-default ms-1" title="View Details"><FaNewspaper /></button> */}
        //          {(row.is_approved || row.is_rejected) && (
        //                 <button
        //                 type="button"
        //                 className="btn btn-default ms-1"
        //                 title="View Approval/Rejection Details"
        //                onClick={() => {
        //                     setSelectedCandidateForDetails({
        //                         ...row,
        //                         job_title: jobName, // Pass the job_name dynamically
        //                     });
        //                     setShowDetailsModal(true);
        //                     }}
        //                 >
        //                 <FaNewspaper />
        //             </button>
        //             )}
        //     </>
        //   ),
        // },
       {
        columnKey: "actions",
        name: <span className="font_15 ColumnTitle fw-bold">Actions</span>,
        cell: row => {
          const isSentToHRMS = row.hrms_status

          // Build all action icons into an array first
          const actionIcons = [
            <button
              key="history"
              type="button"
              className="btn btn-default text-primary job-candidate-action-btn"
              title="View Email & Call History"
              onClick={() => fetchCandidateCommunicationHistory(row)}
            >
              <FaHistory />
            </button>,

            <button
              key="talentscan"
              type="button"
              className="btn btn-default text-success job-candidate-action-btn"
              title="View Talent Scan Result"
              onClick={(e) => {
                e.stopPropagation()
                openTestResultsModal(row)
              }}
            >
              <FaChartBar style={{ cursor: "pointer", fontSize: 14, flexShrink: 0 }} />
            </button>,

            !isSentToHRMS && (
              <button
                key="delete"
                className="btn text-danger job-candidate-action-btn"
                title="Delete Candidate"
                size="sm"
                onClick={isSentToHRMS ? null : () => handleCandidateDlink(row)}
                disabled={isSentToHRMS}
              >
                {loadingDeleteCandidate && loadingDeleteCandidateId === row.candidate_id ? (
                  <span className="spinner-border spinner-border-sm"></span>
                ) : (
                  <FaRegTrashAlt />
                )}
              </button>
            ),

            <button
              key="timeline"
              className="btn btn-default job-candidate-action-btn"
              type="button"
              title="Candidate Action Logs"
              onClick={async e => {
                await fetchCandidateTimeline(row.candidate_id)
              }}
            >
              {loadingCandidateTimelineId === row.candidate_id ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                <FaBusinessTime />
              )}
            </button>,

            (row.is_approved || row.is_rejected) && (
              <button
                key="newspaper"
                type="button"
                className="btn btn-default job-candidate-action-btn"
                title="View Approval/Rejection Details"
                onClick={() => {
                  setSelectedCandidateForDetails({ ...row, job_title: jobName })
                  setShowDetailsModal(true)
                }}
              >
                <FaNewspaper />
              </button>
            ),

            (() => {
              const feedbacks = getCandidateFeedbacks(row)
              if (!feedbacks.length) return null

              return (
                <button
                  key="feedback"
                  type="button"
                  className="btn job-candidate-action-btn"
                  title={`View Panel Feedback (${feedbacks.length})`}
                  onClick={(e) => {
                    e.stopPropagation()
                    setSelectedFeedback({
                      candidate_name:
                        feedbacks[0]?.candidate_name ||
                        row.candidate_name ||
                        `${row.first_name || ""} ${row.middle_name || ""} ${row.last_name || ""}`.trim(),
                      feedbacks,
                    })
                    setShowFeedbackModal(true)
                  }}
                  style={{
                    // background: "#12395c",
                    // borderColor: "#12395c",
                    // color: "#fff",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <MdRateReview size={20} />
                </button>
              )
            })(),
          ].filter(Boolean) // remove any falsy/null entries from conditionals

          const firstRow = actionIcons.slice(0, 4)
          const secondRow = actionIcons.slice(4)

          return (
            <div
              className="job-candidate-actions-cell"
              style={{ display: "flex", flexDirection: "column", gap: 4, width: "100%", padding: "4px 0" }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                {firstRow}
              </div>
              {secondRow.length > 0 && (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
                  {secondRow}
                </div>
              )}
            </div>
          )
        },
        width: "185px",
      }
      ],
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [job.id,jobName,selectedCandidateRows, candidates]
    )

      const columns = useMemo(
      () => {
        const visibleColumns = baseColumns.filter(
          column => {
            const isOptionalColumn = candidateColumnOptions.some(
              option => option.key === column.columnKey
            )
            const isAvailableOptionalColumn = availableCandidateColumnOptions.some(
              option => option.key === column.columnKey
            )
            return (
              !isOptionalColumn ||
              (isAvailableOptionalColumn &&
                candidateColumnVisibility[column.columnKey] === true)
            )
          }
        )
        return visibleColumns.map(column => ({
          ...column,
          id: column.columnKey || `candidate-column-${baseColumns.indexOf(column)}`,
        }))
      },
      [baseColumns, availableCandidateColumnOptions, candidateColumnVisibility]
    )

    // return (
    //   <div className="bg-light rounded">
    //     <Row className="mb-2 mx-0">
    //       <Col xxl={12}>
    //         <h6 className="mb-3 pt-3">
    //           Candidates for <strong>{job.job_title}</strong>
    //         </h6>
    //       </Col>
    //     </Row>

    //     <Row className="mb-2 mx-0 align-items-center">
    //       <Col xxl={3} lg={6} md={12}>
    //         <div
    //           className="d-flex align-items-center"
    //           style={{ position: "relative", width: "100%" }}
    //         >
    //           <Input
    //             placeholder="Search with Name and Email"
    //             value={localSearch}
    //             onChange={e => {
    //               setLocalSearch(e.target.value)
    //             }}
    //             onKeyDown={e => {
    //               if (e.key === "Enter") {
    //                 setSearchMap(prev => ({ ...prev, [jobId]: localSearch }))
    //                 handleCandidateSearch(jobId, localSearch)
    //               }
    //             }}
    //             autoComplete="off"
    //             className="pe-4"
    //           />

    //           {localSearch && (
    //             <span
    //               style={{
    //                 position: "absolute",
    //                 right: "50px",
    //                 cursor: "pointer",
    //                 color: "#6c757d",
    //                 fontSize: "14px",
    //                 zIndex: 5,
    //               }}
    //               onClick={() => {
    //                 setLocalSearch("")
    //                 setSearchMap(prev => ({ ...prev, [jobId]: "" }))
    //                 handleCandidateSearch(jobId, "")
    //               }}
    //             >
    //               <FaTimes style={{ fontSize: "15px", color: "#6c757d" }} />
    //             </span>
    //           )}
    //           <Button
    //             className="btn searchIconBtn import-res-btn"
    //             onClick={() => {
    //               setSearchMap(prev => ({ ...prev, [jobId]: localSearch }))
    //               handleCandidateSearch(jobId, localSearch)
    //             }}
    //           >
    //             <i className="fa fa-search" />
    //           </Button>
    //         </div>
    //       </Col>
    //       <Col xxl={9} lg={6} md={12} className="d-flex justify-content-start align-items-center gap-2">
    //         <Button
    //           className="btn blueBtn d-flex align-items-center gap-1"
    //           onClick={() => {
    //             if ((selectedCandidateRows[jobId] || []).length === 0) {
    //               Swal.fire({
    //                 icon: "warning",
    //                 title: "No Candidates Selected",
    //                 text: "Please select at least one candidate to configure the call.",
    //                 confirmButtonText: "OK",
    //               });
    //               return;
    //             }
    //             handleConfigureCallOpen(job);
    //           }}
    //         >
    //           <FaCog /> Schedule Agent Call
    //         </Button>
    //         {candidateTab === "Database Resumes" && (
    //           <Button
    //             className="btn blueBtn d-flex align-items-center gap-1"
    //             onClick={() => {
    //               if ((selectedCandidateRows[jobId] || []).length === 0) {
    //                 Swal.fire({
    //                   icon: "warning",
    //                   title: "No Candidates Selected",
    //                   text: "Please select at least one candidate to configure bulk outreach.",
    //                   confirmButtonText: "OK",
    //                 });
    //                 return;
    //               }
    //               const companyName = job.company_name || job.client_name || "Pranathi Software Services Private Limited";
    //               const jobTitle = job.job_title || "";
    //               const location = Array.isArray(job.location) ? job.location.join(", ") : job.location || "";
    //               const minExp = job.min_exp ? `${job.min_exp}` : "—";
    //               const maxExp = job.max_exp ? `${job.max_exp}years` : "—";

    //               setConfigureCallJob(job);
    //               setOutreachSubject(`Opportunity: ${jobTitle} — Bharat ATS`);
    //               setOutreachBody(
    //                 `Hi {candidate_name},

    //       We reviewed your profile and it closely matches an exciting opportunity we have. Below are the details: 

    //       📋 Role: ${jobTitle}
    //       🏢 Company: ${companyName}
    //       📍 Location: ${location}
    //       🧑‍💼 Experience Required: ${minExp} - ${maxExp}

    //       We'd love to know if you're interested in this opportunity.

    //       👉 Please confirm your interest here:
    //      🔗 Consent Link {consent_url}`
    //               );
    //               setOutreachPayloadBody(`
    //             <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="width:100%; margin:0; padding:0; background-color:#f3f4f6; font-family:Arial, sans-serif; color:#222222;">
    //               <tr>
    //                 <td align="center" style="padding:24px 12px;">
    //                   <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="700" style="width:700px; max-width:700px; background-color:#ffffff; border:1px solid #d9e1ea;">
    //                     <tr>
    //                       <td align="center" style="background-color:#145b84; color:#ffffff; font-size:18px; line-height:24px; font-weight:700; padding:18px 20px;">
    //                         Your Profile Matches an Opportunity!
    //                       </td>
    //                     </tr>

    //                     <tr>
    //                       <td style="padding:18px 20px 10px 20px; font-size:14px; line-height:22px; color:#111111;">
    //                         Dear <strong>{candidate_name}</strong>,
    //                       </td>
    //                     </tr>

    //                     <tr>
    //                       <td style="padding:8px 20px 6px 20px; font-size:14px; line-height:22px; color:#111111; border-bottom:1px solid #edf2f7;">
    //                         We reviewed your profile and it closely matches an exciting opportunity we have. Below are the details:
    //                       </td>
    //                     </tr>

    //                     <tr>
    //                       <td style="padding:22px 34px 34px 34px; font-size:14px; line-height:24px; color:#111111;">
    //                         <ul style="margin:0; padding-left:18px;">
    //                           <li><strong>Company:</strong> ${companyName}</li>
    //                           <li><strong>Role:</strong> ${jobTitle}</li>
    //                           <li><strong>Location:</strong> ${location}</li>
    //                           <li><strong>Experience:</strong> ${minExp} - ${maxExp}</li>
    //                         </ul>
    //                       </td>
    //                     </tr>

    //                     <tr>
    //                       <td style="padding:10px 20px 16px 20px; font-size:16px; line-height:24px; font-weight:700; color:#111111;">
    //                         Are you interested in exploring this opportunity?
    //                       </td>
    //                     </tr>

    //                     <tr>
    //                       <td style="padding:16px 20px 22px 20px;">
    //                         <table role="presentation" cellpadding="0" cellspacing="0" border="0">
    //                           <tr>
    //                             <td align="center" style="background-color:#145b84;">
    //                              <a href="{consent_url}"
    //                                 target="_blank"
    //                                 rel="noopener noreferrer"
    //                                 style="
    //                                     display:inline-block;
    //                                     background-color:#145b84;
    //                                     color:#ffffff;
    //                                     text-decoration:none;
    //                                     font-size:14px;
    //                                     line-height:18px;
    //                                     font-weight:700;
    //                                     padding:10px 16px;
    //                                     border:1px solid #145b84;
    //                                     border-radius:6px;
    //                                 ">
    //                                 Click to give Consent
    //                               </a>
    //                             </td>
    //                             <td style="margin-left: 5px;">
    //                                 <a href="{unsubscribe_url}"
    //                                   target="_blank"
    //                                   rel="noopener noreferrer"
    //                                   style="
    //                                     display:inline-block;
    //                                     background-color:#ffffff;
    //                                     color:#6b7280;
    //                                     text-decoration:none;
    //                                     font-size:14px;
    //                                     line-height:18px;
    //                                     font-weight:700;
    //                                     padding:10px 16px;
    //                                     border:1px solid #6b7280;
    //                                     border-radius:6px;
    //                                 ">
    //                                   Unsubscribe
    //                                 </a>
    //                             </td>
    //                           </tr>
    //                         </table>
    //                       </td>
    //                     </tr>

    //                     <tr>
    //                       <td style="padding:34px 20px 20px 20px; font-size:14px; line-height:22px; color:#111111;">
    //                         <div>Thank you and best regards,</div>
    //                         <div style="font-weight:700;">${companyName},</div>
    //                       </td>
    //                     </tr>
    //                     <tr>
    //                       <td style="padding:0 20px 18px 20px; border-top:1px solid #edf2f7; font-size:12px; line-height:18px; color:#6b7280;">
    //                         <div style="padding-top:12px;">&copy; 2026 ${companyName}. All rights reserved.</div>
    //                         <div>This is an automated message — please do not reply to this email.</div>
    //                       </td>
    //                     </tr>
    //                   </table>
    //                 </td>
    //               </tr>
    //             </table>
    //           `);
    //               setOutreachTab("compose");
    //               setShowBulkOutreachModal(true);
    //             }}
    //           >
    //             <FaEnvelopeOpenText /> Schedule Bulk Email / WhatsApp
    //           </Button>
    //         )}
    //         {candidateTab === "Database Resumes" && (
    //           <Button
    //             className="btn blueBtn d-flex align-items-center gap-1 "
    //             onClick={() => {
    //               setConfigureCallJob(job);
    //               setShowOutreachResultsModal(true);
    //             }}
    //           >
    //             <FaRegEye /> View Outreach Result
    //           </Button>
    //         )}
    //         {/* Capture Resumes Button + Filter Dropdown */}
    //         <div style={{ position: "relative" }} className="d-flex align-items-center gap-1">
    //           <Button
    //             className="btn blueBtn d-flex align-items-center gap-1"
    //             onClick={() => {
    //               initFiltersForJob(job);
    //               toggleCaptureDropdown(jobId);
    //             }}
    //             disabled={captureResumeLoading[jobId]}
    //           >
    //             {captureResumeLoading[jobId] ? (
    //               <>
    //                 <Spinner size="sm" className="me-1" />
    //                 Capturing...
    //               </>
    //             ) : (
    //               <>
    //                 <i className="mdi mdi-file-document-outline"></i> Capture Resumes
    //               </>
    //             )}
    //           </Button>
    //           <span id={`captureInfoTip-${jobId}`} style={{ cursor: "pointer", color: "#0d6efd" }}>
    //             <FaInfoCircle size={16} />
    //           </span>
    //           <UncontrolledTooltip placement="top" target={`captureInfoTip-${jobId}`}>
    //            Click to capture a resume from the database. This will compare the resume with the job description (JD) and provide a score based on the matching qualifications.
    //           </UncontrolledTooltip>

    //           {captureResumeDropdown[jobId] && captureResumeFilters[jobId] && (
    //             <div
    //               style={{
    //                 position: "absolute",
    //                 top: "100%",
    //                 left: 0,
    //                 zIndex: 1050,
    //                 background: "#fff",
    //                 border: "1px solid #ddd",
    //                 borderRadius: 6,
    //                 padding: 16,
    //                 minWidth: 340,
    //                 boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    //                 marginTop: 4,
    //               }}
    //             >
    //               <h6 className="mb-2" style={{ fontWeight: 600 }}>Filter Criteria</h6>
    //               <p className="mb-3" style={{ fontSize: 13, color: "#6c757d", background: "#f0f4ff", padding: "6px 10px", borderRadius: 4, borderLeft: "3px solid #0d6efd" }}>
    //                 <FaInfoCircle size={11} className="me-1" />
    //                 Simply check the boxes for the relevant filters, and the system will display only the resumes that match your selected parameters.
    //                   This will help you find resumes that best align with your job description
    //               </p>

    //               {/* Experience Filter */}
    //               <div className="mb-3">
    //                 <div className="d-flex align-items-center gap-2 mb-1">
    //                   <Input
    //                     type="checkbox"
    //                     checked={captureResumeFilters[jobId].experience?.checked || false}
    //                     onChange={() => handleFilterCheckbox(jobId, "experience")}
    //                   />
    //                   <Label className="mb-0 fw-semibold">Experience (Years)</Label>
    //                 </div>
    //                 {captureResumeFilters[jobId].experience?.checked && (
    //                   <div className="d-flex align-items-center gap-2 ms-4">
    //                     <Input
    //                       type="number"
    //                       placeholder="Min"
    //                       key={`exp-min-${jobId}`}
    //                       defaultValue={captureResumeFilters[jobId].experience?.min || ""}
    //                       onBlur={(e) => handleFilterFieldChange(jobId, "experience", "min", e.target.value)}
    //                       style={{ width: 80 }}
    //                       bsSize="sm"
    //                     />
    //                     <span>-</span>
    //                     <Input
    //                       type="number"
    //                       placeholder="Max"
    //                       key={`exp-max-${jobId}`}
    //                       defaultValue={captureResumeFilters[jobId].experience?.max || ""}
    //                       onBlur={(e) => handleFilterFieldChange(jobId, "experience", "max", e.target.value)}
    //                       style={{ width: 80 }}
    //                       bsSize="sm"
    //                     />
    //                   </div>
    //                 )}
    //               </div>

    //               {/* Skills Filter */}
    //               <div className="mb-3">
    //                 <div className="d-flex align-items-center gap-2 mb-1">
    //                   <Input
    //                     type="checkbox"
    //                     checked={captureResumeFilters[jobId].skills?.checked || false}
    //                     onChange={() => handleFilterCheckbox(jobId, "skills")}
    //                   />
    //                   <Label className="mb-0 fw-semibold">Skills</Label>
    //                 </div>
    //                 {captureResumeFilters[jobId].skills?.checked && (
    //                   <div className="ms-4">
    //                     <Input
    //                       type="text"
    //                       placeholder="e.g. React, Node.js, Python"
    //                       key={`skills-${jobId}`}
    //                       defaultValue={captureResumeFilters[jobId].skills?.value || ""}
    //                       onBlur={(e) => handleFilterFieldChange(jobId, "skills", "value", e.target.value)}
    //                       bsSize="sm"
    //                     />
    //                   </div>
    //                 )}
    //               </div>

    //               {/* Location Filter */}
    //               <div className="mb-3">
    //                 <div className="d-flex align-items-center gap-2 mb-1">
    //                   <Input
    //                     type="checkbox"
    //                     checked={captureResumeFilters[jobId].location?.checked || false}
    //                     onChange={() => handleFilterCheckbox(jobId, "location")}
    //                   />
    //                   <Label className="mb-0 fw-semibold">Location</Label>
    //                 </div>
    //                 {captureResumeFilters[jobId].location?.checked && (
    //                   <div className="ms-4">
    //                     <div className="d-flex flex-wrap gap-1 mb-2">
    //                       {(captureResumeFilters[jobId].location?.values || []).map((loc, idx) => (
    //                         <span
    //                           key={idx}
    //                           className="badge bg-light text-dark border d-flex align-items-center gap-1"
    //                           style={{ fontSize: 12 }}
    //                         >
    //                           {loc}
    //                           <FaTimes
    //                             style={{ cursor: "pointer", fontSize: 10 }}
    //                             onClick={() => handleRemoveLocation(jobId, loc)}
    //                           />
    //                         </span>
    //                       ))}
    //                     </div>
    //                     <div className="d-flex gap-1">
    //                       <Input
    //                         type="text"
    //                         placeholder="Add location"
    //                         innerRef={(el) => { locInputRefs.current[jobId] = el; }}
    //                         bsSize="sm"
    //                         onKeyDown={(e) => { if (e.key === "Enter") handleAddLocation(jobId); }}
    //                       />
    //                       <Button size="sm" color="secondary" onClick={() => handleAddLocation(jobId)}>
    //                         <FaPlus />
    //                       </Button>
    //                     </div>
    //                   </div>
    //                 )}
    //               </div>

    //               {/* Action Buttons */}
    //               <div className="d-flex justify-content-center mt-1">
    //                 <Button size="sm" color="light" onClick={() => toggleCaptureDropdown(jobId)} className="btn btn-secondary blueBtn">
    //                   Cancel
    //                 </Button>
    //                 <Button
    //                   size="sm"
    //                   className="blueBtn"
    //                   onClick={() => {
    //                     toggleCaptureDropdown(jobId);
    //                     handleCaptureResumes(jobId);
    //                   }}
    //                   disabled={captureResumeLoading[jobId]}
    //                 >
    //                   Capture
    //                 </Button>
    //               </div>
    //             </div>
    //           )}
    //         </div>
    //       </Col>
    //     </Row>

    //     <Nav tabs className="mx-3 mb-2">
    //       <NavItem>
    //         <NavLink
    //           className={candidateTab === "Latest Resumes" ? "active fw-bold" : ""}
    //           onClick={() => setCandidateTab("Latest Resumes")}
    //           style={{ cursor: "pointer" }}
    //         >
    //           Latest Resumes
    //         </NavLink>
    //       </NavItem>
    //       <NavItem>
    //         <NavLink
    //           className={candidateTab === "Database Resumes" ? "active fw-bold" : ""}
    //           onClick={() => setCandidateTab("Database Resumes")}
    //           style={{ cursor: "pointer" }}
    //         >
    //           Database Resumes
    //         </NavLink>
    //       </NavItem>
    //     </Nav>

    //     <Row className="mx-0 w-100">
    //       <Col xxl={12}>
    //         {loadingCandidates ? (
    //           <div className="custom-loader mb-2">
    //             <CustomLoader />
    //           </div>
    //         ) : !Array.isArray(filteredCandidates) || filteredCandidates.length === 0 ? (
    //           <p className="text-muted mb-0 pb-3">No candidates found.</p>
    //         ) : (
    //           <div id="CandidateTest_DataTableView">
    //             <DataTable
    //               columns={columns}
    //               data={Array.isArray(filteredCandidates) ? filteredCandidates : []}
    //               expandableRows
    //               expandableRowsComponent={TestAndCallsExpansion}
    //               highlightOnHover
    //               pagination
    //               dense
    //               paginationServer
    //               paginationTotalRows={getJobTotalRows(jobId)}
    //               fixedHeader
    //               fixedHeaderScrollHeight="300px"
    //               paginationDefaultPage={getJobCurrentPage(jobId)}
    //               paginationPerPage={getJobPerPage(jobId)} // important to show selected per page
    //               paginationRowsPerPageOptions={[10, 15, 20, 50]}
    //               onChangePage={page => handlePageChangeForJob(jobId, page)}
    //               paginationComponentOptions={paginationComponentOptions}
    //               onChangeRowsPerPage={(newPerPage, page) =>
    //                 handlePerRowsChangeForJob(jobId, newPerPage, page)
    //               }
    //               onSelectedRowsChange={state => {
    //                 /* keep behavior - store selected if needed */
    //               }}
    //               onRowClicked={handleRowClick}
    //               conditionalRowStyles={conditionalRowStyles}
    //               progressComponent={<CustomLoader />}
    //             />
    //           </div>
    //         )}
    //       </Col>
    //     </Row>
    //   </div>
    // )
    return (
  <div style={{ background: "var(--bs-light, #f8f9fa)", borderRadius: 10, border: "1px solid #e2e8f0", overflow: "visible" }}>
    <style>{`
      .job-candidate-search-input:focus {
        border-color: #1a5fa8 !important;
        box-shadow: 0 0 0 3px rgba(26, 95, 168, 0.18) !important;
        outline: none !important;
        background: #fff !important;
      }
    `}</style>

    <div className="job-candidate-heading-row" style={{ padding: "14px 20px 12px", borderBottom: "1px solid #e2e8f0", background: "#fff" }}>
      <div>
      <h6 style={{ margin: 0, fontWeight: 600, fontSize: 15, color: "#1a202c" }}>
        Candidates for <strong>{job.job_title}</strong>
      </h6>
      <p style={{ margin: "2px 0 0", fontSize: 12, color: "#718096" }}>
        Select candidates below to take bulk actions
      </p>
      </div>
      {job.questions_reviewed && (
        <span className="job-screening-reviewed-note">
          <i className="pi pi-check-circle" aria-hidden="true" />
          Screening call questions are reviewed for this job.
          <button
            type="button"
            title="View question review history"
            aria-label="View question review history"
            className="btn btn-link p-0 ms-2"
            style={{ color: "#145b84", verticalAlign: "middle" }}
            disabled={questionReviewHistoryModal.loading && questionReviewHistoryModal.jobId === jobId}
            aria-busy={questionReviewHistoryModal.loading && questionReviewHistoryModal.jobId === jobId}
            onClick={event => {
              event.stopPropagation();
              fetchQuestionReviewHistory(jobId);
            }}
          >
            {questionReviewHistoryModal.loading && questionReviewHistoryModal.jobId === jobId ? (
              <Spinner size="sm" style={{ width: 14, height: 14 }} aria-label="Loading review history" />
            ) : (
              <FaHistory aria-hidden="true" />
            )}
          </button>
        </span>
      )}
    </div>
    <div
      className="job-candidate-toolbar"
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        justifyContent: "space-between",
        gap: 4,
        rowGap: 10,
        padding: "12px 20px",
        background: "#fff",
        borderBottom: "1px solid #e2e8f0",
      }}
    >
      <div className="job-candidate-filter-row" style={{ display: "contents" }}>
      <div style={{ position: "relative", display: "flex", alignItems: "center", flex: "0 0 285px" }}>
        <Input
          className="job-candidate-search-input"
          placeholder="Search by name, email or phone"
          innerRef={candidateSearchInputRef}
          value={localSearch}
          onChange={e => {
            const value = e.target.value
            setLocalSearch(value)
            if (value.trim() === "" && (searchMap[jobId] ?? "") !== "") {
              handleCandidateSearch(jobId, "")
            }
          }}
          onKeyDown={e => {
            if (e.key === "Enter") {
              e.preventDefault()
              setSearchMap(prev => ({ ...prev, [jobId]: localSearch }))
              handleCandidateSearch(jobId, localSearch)
              window.setTimeout(() => candidateSearchInputRef.current?.focus(), 0)
            }
          }}
          autoComplete="off"
          style={{
            paddingRight: localSearch ? 60 : 38,
            fontSize: 13,
            height: 34,
            borderRadius: 6,
            border: "1px solid #cbd5e0",
            background: "#f7fafc",
          }}
        />
        {localSearch && (
          <span
            style={{ position: "absolute", right: 36, cursor: "pointer", color: "#a0aec0", zIndex: 5 }}
            onMouseDown={e => e.preventDefault()}
            onClick={() => {
              setLocalSearch("")
              setSearchMap(prev => ({ ...prev, [jobId]: "" }))
              handleCandidateSearch(jobId, "")
              window.setTimeout(() => candidateSearchInputRef.current?.focus(), 0)
            }}
          >
            <FaTimes style={{ fontSize: 12 }} />
          </span>
        )}
        <Button
          style={{
            position: "absolute",
            right: 0,
            top: 0,
            bottom: 0,
            background: "#1a5fa8",
            border: "none",
            borderRadius: "0 6px 6px 0",
            padding: "0 11px",
            color: "#fff",
            fontSize: 13,
          }}
          onMouseDown={e => e.preventDefault()}
          onClick={() => {
            setSearchMap(prev => ({ ...prev, [jobId]: localSearch }))
            handleCandidateSearch(jobId, localSearch)
            window.setTimeout(() => candidateSearchInputRef.current?.focus(), 0)
          }}
        >
          <i className="fa fa-search" />
        </Button>
      </div>
      <div style={{ flex: "0 1 300px", minWidth: 260, maxWidth: 360 }}>
        <Select
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          isClearable
          isLoading={recruitersLoading}
          aria-label="Added By Recruiter"
          title="Filter candidates by the recruiter who added them"
          placeholder="All Recruiters"
          options={[{ value: "all", label: "All Recruiters" }, ...recruiterOptions]}
          value={recruiterOptions.filter(option => (recruiterFilterMap[jobId] || []).includes(option.value))}
          onChange={selectedOptions => {
            const selected = selectedOptions || []
            const recruiterIds = selected.some(option => option.value === "all")
              ? []
              : selected.map(option => option.value)
            setRecruiterFilterMap(prev => ({ ...prev, [jobId]: recruiterIds }))
          setCurrentPageMap(prev => ({ ...prev, [jobId]: 1 }))
          getCandidateDetails(
            jobId,
            1,
            perPageMap[jobId] ?? 10,
            searchMap[jobId] ?? "",
            fromDateMap[jobId] || "",
            toDateMap[jobId] || "",
            consentStatusFilterMap[jobId] || "",
            emailSentFilterMap[jobId] || false,
            sendTestFilterMap[jobId] || false,
            getSelectedPipelineStages(jobId),
            false,
            hrmsStatusFilterMap[jobId] || "",
            recruiterIds
          )
          }}
          styles={{
            control: (base, state) => ({
              ...base,
              minHeight: 34,
              borderRadius: 6,
              borderColor: state.isFocused ? "#1a5fa8" : "#1a5fa8",
              boxShadow: state.isFocused ? "0 0 0 2px rgba(26,95,168,0.16)" : "none",
              background: "#f8fbff",
              fontSize: 12,
              color: "#1a5fa8",
            }),
            valueContainer: base => ({ ...base, padding: "1px 8px", flexWrap: "wrap", maxHeight: 64, overflowY: "auto" }),
            multiValue: base => ({ ...base, background: "#e8f2fb", borderRadius: 4 }),
            multiValueLabel: base => ({ ...base, color: "#1a5fa8", fontSize: 11, whiteSpace: "nowrap" }),
            indicatorsContainer: base => ({ ...base, height: 32 }),
            menuPortal: base => ({ ...base, zIndex: 9999 }),
            menu: base => ({ ...base, fontSize: 12, zIndex: 9999 }),
          }}
          menuPortalTarget={typeof document !== "undefined" ? document.body : null}
          menuPosition="fixed"
        />
      </div>
      <div className="job-candidate-filter-controls" style={{ display: "contents" }}>
                <div style={{ position: "relative", width: 170 }}>
                <DatePicker
                className="form-control job-candidate-date-input"
                wrapperClassName="job-candidate-date-picker"
                dateFormat="dd-MM-yyyy"
                placeholderText="DD-MM-YYYY"
                selected={fromDateMap[jobId] ? new Date(`${fromDateMap[jobId]}T00:00:00`) : null}
                maxDate={new Date()}
                onChange={(date) => {
                  const newFromDate = date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}` : "";
                  setFromDateMap(prev => ({ ...prev, [jobId]: newFromDate }));

                  // Trigger refresh
                  const page = currentPageMap[jobId] ?? 1;
                  const size = perPageMap[jobId] ?? 10;
                  const search = searchMap[jobId] ?? "";

               getCandidateDetails(
                      jobId,
                      page,
                      size,
                      search,
                      newFromDate,
                      toDateMap[jobId] || "",
                      consentStatusFilterMap[jobId] || "",
                      emailSentFilterMap[jobId] || false,
                      sendTestFilterMap[jobId] || false,
                      getSelectedPipelineStages(jobId)
                    );
                }}
                style={{
                  width: "100%",
                  fontSize: 12,
                  height: 34,
                  color: "#1a5fa8",
                  border: "1px solid #1a5fa8",
                  background: "#f8fbff",
                }}
              />
              </div>
              <div style={{ position: "relative", width: 170 }}>
                        <DatePicker
                            className="form-control job-candidate-date-input"
                            wrapperClassName="job-candidate-date-picker"
                            dateFormat="dd-MM-yyyy"
                            placeholderText="DD-MM-YYYY"
                            minDate={fromDateMap[jobId] ? new Date(`${fromDateMap[jobId]}T00:00:00`) : undefined}
                            selected={toDateMap[jobId] ? new Date(`${toDateMap[jobId]}T00:00:00`) : null}
                          onChange={(date) => {
                  const newToDate = date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}` : "";
                  const startDate = fromDateMap[jobId];

                  if (startDate && newToDate && new Date(newToDate) < new Date(startDate)) {
                    Swal.fire({ /* validation */ });
                    return;
                  }

                  setToDateMap(prev => ({ ...prev, [jobId]: newToDate }));

                  // Trigger refresh
                  const page = currentPageMap[jobId] ?? 1;
                  const size = perPageMap[jobId] ?? 10;
                  const search = searchMap[jobId] ?? "";

                 getCandidateDetails(
                          jobId,
                          page,
                          size,
                          search,
                          startDate || "",
                          newToDate,
                           consentStatusFilterMap[jobId] || "",
                           emailSentFilterMap[jobId] || false,
                           sendTestFilterMap[jobId] || false,
                           getSelectedPipelineStages(jobId)
                         );
                }}
                            style={{
                              width: "100%",
                              fontSize: 12,
                              height: 34,
                              color: "#1a5fa8",
                              border: "1px solid #1a5fa8",
                              background: "#f8fbff",
                              paddingRight: 30,
                            }}
                          />
                          {(fromDateMap[jobId] || toDateMap[jobId]) && (
                    <FaTimesCircle
                      size={16}
                      title="Clear dates"
                      aria-label="Clear date filters"
                    onClick={async () => {
                  setFromDateMap(prev => ({
                    ...prev,
                    [jobId]: "",
                  }))

                  setToDateMap(prev => ({
                    ...prev,
                    [jobId]: "",
                  }))

              await getCandidateDetails(
                    jobId,
                    currentPageMap?.[jobId] || 1,
                    perPageMap?.[jobId] || 10,
                    searchMap?.[jobId] || "",
                    "",
                    "",
                    consentStatusFilterMap[jobId] || "",
                    emailSentFilterMap[jobId] || false,
                    sendTestFilterMap[jobId] || false,
                    getSelectedPipelineStages(jobId)
                  )
                }}
                      style={{
                        position: "absolute",
                        right: 9,
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#e53e3e",
                        flexShrink: 0,
                      }}
                    />
                  )}
              </div>
            
            <select
            className="form-select"
            value={consentStatusFilterMap[jobId] || ""}
            onChange={e => {
              const val = e.target.value
              setConsentStatusFilterMap(prev => ({ ...prev, [jobId]: val }))
              getCandidateDetails(
                jobId,
                1,
                perPageMap[jobId] ?? 10,
                searchMap[jobId] ?? "",
                fromDateMap[jobId] || "",
                toDateMap[jobId] || "",
                val,
                emailSentFilterMap[jobId] || false,
                sendTestFilterMap[jobId] || false,
                getSelectedPipelineStages(jobId)
              )
            }}
            style={{
               display: "inline-block",
               width: "190px",
              // alignItems: "center",
              height: 34,
              padding: "0 10px",
              border: "1px solid #1a5fa8",
              borderRadius: 6,
              fontSize: 13,
              // fontWeight: 500,
              color: "#1a5fa8",
              // background: consentStatusFilterMap[jobId] ? "#1a5fa8" : "#fff",
              cursor: "pointer",
              // whiteSpace: "nowrap",
              // outline: "none",
            }}
          >
            <option value="">AI Screening Status</option>
            <option value="not_sent">Not Sent</option>
            {/* <option value="pending">Pending</option> */}
            <option value="accepted">Sent</option>
            {/* <option value="rejected">Rejected</option> */}
          </select>
          

          {/* ── Email Sent filter ── */}
          <Input
            type="select"
            // className="form-select custom-select"
            value={
              emailSentFilterMap[jobId] && sendTestFilterMap[jobId]
                ? "email_and_tests_sent"
                : emailSentFilterMap[jobId]
                  ? "email_sent"
                  : sendTestFilterMap[jobId]
                    ? "tests_sent"
                    : hrmsStatusFilterMap[jobId] === "sent"
                      ? "hrms_sent"
                      : ""
            }
            style={{
              width: "190px",
              height: "34px",
              fontSize: "13px",
              border: "1px solid #1a5fa8",
              color:"#1a5fa8",
            //   borderRadius: 6,
              // color: emailSentFilterMap[jobId] || sendTestFilterMap[jobId] ? "#fff" : "#1a5fa8",
              // background: emailSentFilterMap[jobId] || sendTestFilterMap[jobId] ? "#1a5fa8" : "#fff",
              fontWeight: 600,
              cursor: "pointer",
              boxShadow: "0 1px 3px rgba(26, 95, 168, 0.18)",
            }}
            onChange={(e) => {
              const val = e.target.value
              const emailSent = val === "email_sent" || val === "email_and_tests_sent"
              const testsSent = val === "tests_sent" || val === "email_and_tests_sent"
              const hrmsStatus = val === "hrms_sent" ? "sent" : ""
              setEmailSentFilterMap(prev => ({ ...prev, [jobId]: emailSent }))
              setSendTestFilterMap(prev => ({ ...prev, [jobId]: testsSent }))
              setHrmsStatusFilterMap(prev => ({ ...prev, [jobId]: hrmsStatus }))
              setCurrentPageMap(prev => ({ ...prev, [jobId]: 1 }))
              getCandidateDetails(
                jobId,
                1,
                perPageMap[jobId] ?? 10,
                searchMap[jobId] ?? "",
                fromDateMap[jobId] || "",
                toDateMap[jobId] || "",
                consentStatusFilterMap[jobId] || "",
                emailSent,
                testsSent,
                getSelectedPipelineStages(jobId),
                false,
                hrmsStatus
              )
            }}
          >
            <option value="">Sent</option>
            <option value="email_sent">Emails Sent</option>
            <option value="tests_sent">Tests Sent</option>
            <option value="hrms_sent">Sent to HRMS</option>
            {/* <option value="email_and_tests_sent">Email + Tests Sent</option> */}
          </Input>
          <span ref={el => { pipelineStageDropdownRefs.current[jobId] = el }} style={{ position: "relative", display: "inline-block" }}>
            <Button
              type="button"
              onClick={() =>
                setPipelineStageDropdownOpen(prev => ({
                  ...prev,
                  [jobId]: !prev[jobId],
                }))
              }
              style={{
                width: "190px",
                height: "34px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 8,
                padding: "0 10px",
                fontSize: "12px",
                border: "1px solid #1a5fa8",
                borderRadius: 6,
                color:"#1a5fa8",
                background: "#fff",
                fontWeight: 600,
                cursor: "pointer",
                boxShadow: "0 1px 3px rgba(26, 95, 168, 0.18)",
              }}
            >
              <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}  title={
                    getSelectedPipelineStages(jobId).length === 0
                      ? "All Stages"
                      : getSelectedPipelineStages(jobId).join(", ")
                  }>
                {getSelectedPipelineStages(jobId).length === 0
                  ? "All Stages"
                  : getSelectedPipelineStages(jobId).length === 1
                    ? getSelectedPipelineStages(jobId)[0]
                    : `${getSelectedPipelineStages(jobId).length} Stages`}
              </span>
              {getSelectedPipelineStages(jobId).length > 0 && (
                <span
                  role="button"
                  title="Clear all selected stages"
                  onClick={event => {
                    event.preventDefault()
                    event.stopPropagation()
                    const nextStages = []
                    const listEl = pipelineStageListRefs.current[jobId]
                    const preservedListScrollTop = listEl ? listEl.scrollTop : 0
                    const preservedWindowScrollY = window.scrollY
                    const restoreScroll = () => {
                      const el = pipelineStageListRefs.current[jobId]
                      if (el) el.scrollTop = preservedListScrollTop
                      window.scrollTo({ top: preservedWindowScrollY, behavior: "auto" })
                    }

                    setSelectedPipelineStage(prev => ({
                      ...prev,
                      [jobId]: nextStages,
                    }))
                    setCurrentPageMap(prev => ({ ...prev, [jobId]: 1 }))
                    requestAnimationFrame(restoreScroll)
                    requestAnimationFrame(() => requestAnimationFrame(restoreScroll))
                    getCandidateDetails(
                      jobId,
                      1,
                      perPageMap[jobId] ?? 10,
                      searchMap[jobId] ?? "",
                      fromDateMap[jobId] || "",
                      toDateMap[jobId] || "",
                      consentStatusFilterMap[jobId] || "",
                      emailSentFilterMap[jobId] || false,
                      sendTestFilterMap[jobId] || false,
                      nextStages
                    ).finally(() => {
                      requestAnimationFrame(restoreScroll)
                      requestAnimationFrame(() => requestAnimationFrame(restoreScroll))
                    })
                  }}
                  style={{
                    width: 20,
                    height: 20,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                    background: "#e2e8f0",
                    color: "#64748b",
                    flexShrink: 0,
                  }}
                >
                  <FaTimes size={12} />
                </span>
              )}
              <FaChevronDown size={11} />
            </Button>

            {pipelineStageDropdownOpen[jobId] && (
              <div
                ref={el => { pipelineStageListRefs.current[jobId] = el }}
                style={{
                  position: "absolute",
                  top: "calc(100% + 6px)",
                  left: 0,
                  zIndex: 50,
                  width: 230,
                  maxHeight: 260,
                  overflowY: "auto",
                  background: "#fff",
                  border: "1px solid #dbe3ec",
                  borderRadius: 8,
                  boxShadow: "0 12px 24px rgba(15, 23, 42, 0.14)",
                  padding: 8,
                }}
              >
                {stagesList.map(stage => {
                  const selectedStages = getSelectedPipelineStages(jobId)
                  const checked = selectedStages.includes(stage.name)

                  return (
                    <label
                      key={stage.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        padding: "8px 10px",
                        margin: 0,
                        cursor: "pointer",
                        color: "#334155",
                        fontSize: 13,
                      }}
                    >
                      <Input
                        type="checkbox"
                        checked={checked}
                        onChange={() => {
                          const nextStages = checked
                            ? selectedStages.filter(item => item !== stage.name)
                            : [...selectedStages, stage.name]
                        const listEl = pipelineStageListRefs.current[jobId]
                        const preservedListScrollTop = listEl ? listEl.scrollTop : 0
                        const preservedWindowScrollY = window.scrollY
                        const restoreScroll = () => {
                          const el = pipelineStageListRefs.current[jobId]
                          if (el) el.scrollTop = preservedListScrollTop
                          window.scrollTo({ top: preservedWindowScrollY, behavior: "auto" })
                        }

                          setSelectedPipelineStage(prev => ({
                            ...prev,
                            [jobId]: nextStages,
                          }))
                          setCurrentPageMap(prev => ({ ...prev, [jobId]: 1 }))
                        requestAnimationFrame(restoreScroll)
                        requestAnimationFrame(() => requestAnimationFrame(restoreScroll))
                          getCandidateDetails(
                            jobId,
                            1,
                            perPageMap[jobId] ?? 10,
                            searchMap[jobId] ?? "",
                            fromDateMap[jobId] || "",
                            toDateMap[jobId] || "",
                            consentStatusFilterMap[jobId] || "",
                            emailSentFilterMap[jobId] || false,
                            sendTestFilterMap[jobId] || false,
                            nextStages
                          ).finally(() => {
                            requestAnimationFrame(restoreScroll)
                            requestAnimationFrame(() => requestAnimationFrame(restoreScroll))
                          })
                        }}
                        style={{ margin: 0 }}
                      />
                      <span>{stage.name}</span>
                    </label>
                  )
                })}
              </div>
            )}
          </span>

          {/* ── Send Test filter ── */}
        <span style={{ position: "relative", display: "inline-flex", alignItems: "center", gap: 8, order: 13 }}>
        <Button
          id={`filter-resumes-trigger-${jobId}`}
          style={{
            display: "inline-flex", alignItems: "center", gap: 6,
           background: "#fff", color: "#1a5fa8",
            border: "1px solid #1a5fa8",
            borderRadius: 6, padding: "6px 18px", fontSize: 13, fontWeight: 500,
            minWidth: 160,
            whiteSpace: "nowrap",
          }}
          title="Filter Resumes From Database"
          onClick={() => {
            initFiltersForJob(job)
            toggleCaptureDropdown(jobId)
          }}
          disabled={captureResumeLoading[jobId]}
        >
          {captureResumeLoading[jobId] ? (
            <><Spinner size="sm" className="me-1" /> Capturing...</>
          ) : (
            <><i className="mdi mdi-file-document-outline" style={{ fontSize: 13 }} /> Filter Resumes</>
          )}
        </Button>
        
        <span id={`captureInfoTip-${jobId}`} style={{ cursor: "pointer", color: "#3182ce", lineHeight: 1 }} className="ml-1">
          <FaInfoCircle size={15} />
        </span>
        <UncontrolledTooltip placement="top" target={`captureInfoTip-${jobId}`}>
          Click to capture a resume from the database. This will compare the resume with the job description (JD) and provide a score based on the matching qualifications.
        </UncontrolledTooltip>
        {captureResumeDropdown[jobId] && captureResumeFilters[jobId] && (
          <div
            style={{
              position: "fixed",
              top: captureResumeDropdownPosition[jobId]?.top ?? 80,
              left: captureResumeDropdownPosition[jobId]?.left ?? 16,
              width: captureResumeDropdownPosition[jobId]?.width ?? 360,
              zIndex: 1050,
              background: "#fff",
              border: "1px solid #e2e8f0",
              borderRadius: 8,
              minWidth: 0,
              maxWidth: "calc(100vw - 32px)",
              maxHeight: captureResumeDropdownPosition[jobId]?.maxHeight ?? "min(70vh, 520px)",
              overflow: "hidden",
              boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
            }}
          >
            <div style={{ padding: 16, overflowY: "auto", maxHeight: captureResumeDropdownPosition[jobId]?.maxHeight ? Math.max(100, captureResumeDropdownPosition[jobId].maxHeight - 58) : "calc(70vh - 58px)" }}>
            <h6 style={{ fontWeight: 600, fontSize: 13, marginBottom: 8, color: "#1a202c" }}>Filter criteria</h6>
            <p style={{
              fontSize: 12, color: "#4a5568",
              background: "#ebf8ff", padding: "6px 10px",
              borderRadius: 4, borderLeft: "3px solid #3182ce",
              marginBottom: 14, lineHeight: 1.5,
            }}>
              <FaInfoCircle size={11} className="me-1" />
               Simply check the boxes for the relevant filters, and the system will display only the resumes that match your selected parameters.
                This will help you find resumes that best align with your job description
            </p>

            <div style={{ marginBottom: 12 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                <Input type="checkbox"
                  checked={captureResumeFilters[jobId].experience?.checked || false}
                  onChange={() => handleFilterCheckbox(jobId, "experience")}
                  style={{ margin: 0 }}
                />
                <Label style={{ margin: 0, fontSize: 13, fontWeight: 500 }}>Experience (years)</Label>
              </div>
              {captureResumeFilters[jobId].experience?.checked && (
                <div style={{ display: "flex", alignItems: "center", gap: 8, paddingLeft: 22 }}>
                  <Input type="number" placeholder="Min"
                    key={`exp-min-${jobId}`}
                    defaultValue={captureResumeFilters[jobId].experience?.min || ""}
                    onBlur={e => handleFilterFieldChange(jobId, "experience", "min", e.target.value)}
                    style={{ width: 76, fontSize: 12, height: 30 }}
                    bsSize="sm"
                  />
                  <span style={{ color: "#a0aec0", fontSize: 13 }}>–</span>
                  <Input type="number" placeholder="Max"
                    key={`exp-max-${jobId}`}
                    defaultValue={captureResumeFilters[jobId].experience?.max || ""}
                    onBlur={e => handleFilterFieldChange(jobId, "experience", "max", e.target.value)}
                    style={{ width: 76, fontSize: 12, height: 30 }}
                    bsSize="sm"
                  />
                </div>
              )}
            </div>

            <div style={{ marginBottom: 12 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                <Input type="checkbox"
                  checked={captureResumeFilters[jobId].skills?.checked || false}
                  onChange={() => handleFilterCheckbox(jobId, "skills")}
                  style={{ margin: 0 }}
                />
                <Label style={{ margin: 0, fontSize: 13, fontWeight: 500 }}>Skills</Label>
              </div>
              {captureResumeFilters[jobId].skills?.checked && (
                <div style={{ paddingLeft: 22 }}>
                  <Input type="text" placeholder="e.g. React, Node.js, Python"
                    key={`skills-${jobId}`}
                    defaultValue={captureResumeFilters[jobId].skills?.value || ""}
                    onBlur={e => handleFilterFieldChange(jobId, "skills", "value", e.target.value)}
                    style={{ fontSize: 12, height: 30 }}
                    bsSize="sm"
                  />
                </div>
              )}
            </div>

            <div style={{ marginBottom: 14 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                <Input type="checkbox"
                  checked={captureResumeFilters[jobId].location?.checked || false}
                  onChange={() => handleFilterCheckbox(jobId, "location")}
                  style={{ margin: 0 }}
                />
                <Label style={{ margin: 0, fontSize: 13, fontWeight: 500 }}>Location</Label>
              </div>
              {captureResumeFilters[jobId].location?.checked && (
                <div style={{ paddingLeft: 22 }}>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 6, maxHeight: 96, overflowY: "auto", paddingRight: 4 }}>
                    {(captureResumeFilters[jobId].location?.values || []).map((loc, idx) => (
                      <span key={idx} style={{
                        display: "inline-flex", alignItems: "center", gap: 4,
                        background: "#ebf8ff", color: "#2b6cb0",
                        border: "1px solid #bee3f8",
                        borderRadius: 4, fontSize: 11, padding: "2px 7px",
                      }}>
                        {loc}
                        <FaTimes style={{ cursor: "pointer", fontSize: 9 }} onClick={() => handleRemoveLocation(jobId, loc)} />
                      </span>
                    ))}
                  </div>
                  <div style={{ display: "flex", gap: 6 }}>
                    <Input type="text" placeholder="Add location"
                      innerRef={el => { locInputRefs.current[jobId] = el }}
                      bsSize="sm"
                      style={{ fontSize: 12, height: 30 }}
                      onKeyDown={e => { if (e.key === "Enter") handleAddLocation(jobId) }}
                    />
                    <Button size="sm" color="secondary" onClick={() => handleAddLocation(jobId)}
                      style={{ height: 30, padding: "0 10px", flexShrink: 0 }}>
                      <FaPlus style={{ fontSize: 10 }} />
                    </Button>
                  </div>
                </div>
              )}
            </div>
            </div>

            <div style={{ display: "flex", gap: 8, justifyContent: "center", borderTop: "1px solid #e2e8f0", padding: 12, background: "#fff", position: "sticky", bottom: 0 }}>
              <Button size="sm" onClick={() => toggleCaptureDropdown(jobId)}
                style={{ fontSize: 12, padding: "5px 14px", background: "#fff", border: "1px solid #cbd5e0", color: "#4a5568", borderRadius: 5 }}>
                Cancel
              </Button>
              <Button size="sm"
                onClick={() => { toggleCaptureDropdown(jobId); handleCaptureResumes(jobId) }}
                disabled={captureResumeLoading[jobId]}
                style={{ fontSize: 12, padding: "5px 14px", background: "#1a5fa8", border: "none", color: "#fff", borderRadius: 5 }}>
                Capture
              </Button>
            </div>
          </div>
        )}
      </span>
      </div>
      <div className="job-candidate-action-row" style={{ display: "contents" }}>
        <span className="job-candidate-send-email" style={{ display: "inline-block", order: 4 }}>
            <EmailAC
              selectedData={candidates.filter(c =>
                (selectedCandidateRows[jobId] || []).includes(c.job_candidate_id)
              )}
              jobData={job}
              showDropdown={false}
              buttonLabel="Send Email "
              buttonTitle="Click to send email to selected candidates"
              buttonClassName="btn btn-outline-primary"
              buttonStyle={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                background: "#fff",
                color: "#1a5fa8",
                border: "1px solid #1a5fa8",
                borderRadius: 6,
            padding: "6px 10px",
            fontSize: 13,
                fontWeight: 400,
                whiteSpace: "nowrap",
                height:"32px"
              }}
             onBeforeOpen={async () => {
                if (!job?.jd_document) {
                  const continueWithoutJd = await Swal.fire({
                    icon: "warning",
                    title: "Job Description Document Missing",
                    text: "No job description document is attached to this job order. You can still proceed with sending the email.",
                    confirmButtonText: "Continue Email",
                    showCancelButton: true,
                    cancelButtonText: "Cancel",
                  });
                  if (!continueWithoutJd.isConfirmed) return false;
                }
                const selectedEmailCandidates = candidates.filter(candidate =>
                  (selectedCandidateRows[jobId] || []).includes(candidate.job_candidate_id)
                );
                return reviewCandidatesBeforeAction(job, selectedEmailCandidates, "email");
              }}
             onClose={(remainingJobCandidateIds) => {
                setSelectedCandidateRows(prev => ({
                  ...prev,
                  [jobId]: remainingJobCandidateIds ?? [],
                }));
                setSelectedCandidateRowData(prev => {
                  const remainingIds = new Set(
                    (remainingJobCandidateIds ?? []).map(id => String(id))
                  );
                  return {
                    ...prev,
                    [jobId]: Object.fromEntries(
                      Object.entries(prev[jobId] || {}).filter(([id]) =>
                        remainingIds.has(String(id))
                      )
                    ),
                  };
                });
              }}
            />
          </span>
        <Button
          type="button"
          // className="d-none"
          title="Schedule interview for selected candidates"
          onClick={() => openScheduleInterviewForJob(job, candidates)}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            height:"32",
            background: "#fff",
            color: "#1a5fa8",
            border: "1px solid #1a5fa8",
            borderRadius: 6,
            padding: "6px 10px",
            fontSize: 13,
            fontWeight: 500,
            lineHeight: 1.2,
            whiteSpace: "nowrap",
            order: 5,
          }}
        >
          <i className="pi pi-calendar" style={{ fontSize: 13 }} />
          Schedule Interview
          {(selectedCandidateRows[jobId] || []).length > 0 && (
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: 20,
                height: 20,
                padding: "0 6px",
                borderRadius: 999,
                background: "#1a5fa8",
                color: "#fff",
                fontSize: 11,
                fontWeight: 800,
              }}
            >
              {(selectedCandidateRows[jobId] || []).length}
            </span>
          )}
        </Button>
       {canViewScreeningResults && (
  <span
    title="View telephonic & talent scan screening results for this job"
    style={{ display: "inline-flex", alignItems: "center", height: 32, order: 8}}
  >
    <Button
      style={{
        display: "inline-flex", alignItems: "center", gap: 6,
        height: 32,
        background: "#fff",
        color: "#1a5fa8",
        border: "1px solid #1a5fa8",
        borderRadius: 6, padding: "0 14px", fontSize: 13, fontWeight: 500,
        whiteSpace: "nowrap",
      }}
      onClick={() => {
        setScreeningResultsJob(job);
        setScreeningResultsModal(true);
      }}
    >
      <FaPhoneAlt style={{ fontSize: 12 }} /> View Screening Results
    </Button>
  </span>
)}
      <span
            title={
              job.questions_reviewed
                ? "View Outreach Result"
                : "Questions not yet reviewed — cannot schedule agent call"
            }
            style={{ display: "inline-block" }}
          >
       {/* <Button
        style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          background: "#fff", color: "#1a5fa8",
          borderRadius: 6, padding: "6px 14px", fontSize: 13, fontWeight: 500,
          whiteSpace: "nowrap",
          border: "1px solid #1a5fa8",
        }}
        disabled={!job.questions_reviewed}
        title={!job.questions_reviewed
            ? "Questions not yet reviewed"
              : "Schedule Agent Call"}
        onClick={() => {
          if ((selectedCandidateRows[jobId] || []).length === 0) {
            Swal.fire({
              icon: "warning",
              title: "No Candidates Selected",
              text: "Please select at least one candidate to configure the call.",
              confirmButtonText: "OK",
                  });
                  return;
          }
                handleConfigureCallOpen(job);
        }}
      >
        <FaCog style={{ fontSize: 12 }} /> Schedule Agent Call
      </Button> */}
      </span>
      
       
        <>
        <span
            title={
              job.questions_reviewed
                ? "Schedule Bulk Email / WhatsApp"
                : "Questions not yet reviewed — cannot schedule bulk outreach"
            }
            style={{ display: "inline-block", order: 6 }}
          >
          <Button
            data-bulk-outreach-job={jobId}
            style={{
              display: "inline-flex", alignItems: "center", gap: 6,
              background: "#fff", color: "#1a5fa8",
              border: "1px solid #1a5fa8",
              borderRadius: 6, padding: "6px 14px", fontSize: 13, fontWeight: 500,
              minWidth: 205,
              justifyContent: "center",
              whiteSpace: "nowrap",
            }}
            onClick={async () => {
              if (!job.questions_reviewed) {
                Swal.fire({
                  icon: "warning",
                  title: "Questions Not Reviewed",
                  text: "Please send the screening questions for review before scheduling bulk email or WhatsApp outreach.",
                  confirmButtonText: "Send for Review",
                  cancelButtonText: "Cancel",
                  showCancelButton: true,
                }).then(result => {
                  if (result.isConfirmed) {
                    handleOpenSendForReviewModal(job);
                  }
                });
                return;
              }
              if ((selectedCandidateRows[jobId] || []).length === 0) {
                Swal.fire({
                  icon: "warning",
                  title: "No Candidates Selected",
                  text: "Please select at least one candidate to configure bulk outreach.",
                  confirmButtonText: "OK",
                    });
                    return;
              }
               const candidatesToReview = (candidateDataMap[jobId] || []).filter(c =>
                  (selectedCandidateRows[jobId] || []).includes(c.job_candidate_id)
                );
                const selectedCandidates = await reviewCandidatesBeforeAction(job, candidatesToReview, "outreach");
                if (selectedCandidates === false) return;

                const getMissingFieldsForCandidate = (c) => {
                      const email = (c?.email || c?.candidate_email || "").trim();
                      const phone = (c?.mobile_phone || c?.candidate_phone || "").trim();
                      const missing = [];

                      if (!email) {
                        missing.push("Email");
                      } else if (!email.includes("@")) {
                        missing.push("Invalid Email Format");
                      }

                      if (!phone) {
                        missing.push("Phone Number");
                      }

                      return missing;
                    };

                const invalidCandidates = selectedCandidates
                  .map(c => ({ candidate: c, missing: getMissingFieldsForCandidate(c) }))
                  .filter(item => item.missing.length > 0);

                if (invalidCandidates.length > 0) {
                  const rows = invalidCandidates
                    .map(
                      ({ candidate: c, missing }) => `
                        <tr>
                          <td style="padding:8px;border:1px solid #ddd;">
                            ${c.first_name || ""} ${c.last_name || ""}
                          </td>
                          <td style="padding:8px;border:1px solid #ddd;color:#dc3545;">
                            ${missing.join(", ")}
                          </td>
                        </tr>
                      `
                    )
                    .join("");

                  Swal.fire({
                    icon: "warning",
                    title: "Missing or Invalid Contact Details",
                    html: `
                      <p>Please check the details for the following candidates before sending:</p>
                      <table style="width:100%;border-collapse:collapse;">
                        <thead>
                          <tr>
                            <th style="padding:8px;border:1px solid #ddd;">Candidate</th>
                            <th style="padding:8px;border:1px solid #ddd;">Issue</th>
                          </tr>
                        </thead>
                        <tbody>
                          ${rows}
                        </tbody>
                      </table>
                    `,
                    width: 700,
                  });

                  return;
                }
                  const companyName = job.company_name || job.client_name || "-";
                  const companyDescription = job.company_description || "-";
                  const jobTitle = job.job_title || "";
                  const location = Array.isArray(job.location) ? job.location.join(", ") : job.location || "";
                  const minExp = job.min_exp ? `${job.min_exp}` : "—";
                  const maxExp = job.max_exp ? `${job.max_exp}years` : "—";
                  const companyLogo = job.company_logo || "";

                  setConfigureCallJob(job);
                  setOutreachSubject(`Opportunity: ${jobTitle} — Bharat ATS`);
              setOutreachBody(`Dear {candidate_name},
                Thank you for your interest in the ${jobTitle} position at ${companyName}.
                
                We have successfully received your application and resume.
                
                ${companyName} is a U.S.-based technology company delivering cloud communications, AI-powered business solutions, SaaS platforms, and enterprise technologies to organizations across multiple industries. As we continue to grow, we are seeking talented professionals who are passionate about innovation and helping build the next generation of business technology solutions.
                
                As the next step in our hiring process, we invite you to complete an initial screening interview with our AI Recruiter.
                
                Schedule Your Interview:
                📅 Book Your Screening Call
                🔗 {screening_link}
                
                The interview will take approximately 15–20 minutes and will help us better understand your experience, skills, and career goals.
                📎 Attached: Job Description for your review.

                Following the interview, our hiring team will evaluate your qualifications and contact selected candidates regarding the next stage of the recruitment process.

                Thank you again for your interest in ${companyName}. We look forward to speaking with you.
                
                Thank you and best regards,
                Talent Acquisition Team
                ${companyName}`);

              setOutreachPayloadBody(`
                <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="width:100%; margin:0; padding:0; background-color:#f3f4f6; font-family:Arial, sans-serif; color:#222222;">
                  <tr>
                    <td align="center" style="padding:24px 12px;">
                      <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="700" style="width:700px; max-width:700px; background-color:#ffffff; border:1px solid #d9e1ea;">
                        <tr>
                          <td align="center" style="background-color:#145b84; color:#ffffff; font-size:18px; line-height:24px; font-weight:700; padding:18px 20px;">
                            Your Profile Matches an Opportunity!
                          </td>
                        </tr>

                        <tr>
                          <td style="padding:18px 20px 10px 20px; font-size:14px; line-height:22px; color:#111111;">
                            Dear <strong>{candidate_name}</strong>,
                          </td>
                        </tr>

                        <tr>
                          <td style="padding:8px 20px 6px 20px; font-size:14px; line-height:22px; color:#111111; border-bottom:1px solid #edf2f7;">
                            We reviewed your profile and it closely matches an exciting opportunity we have. Below are the details:
                          </td>
                        </tr>

                        <tr>
                          <td style="padding:22px 34px 34px 34px; font-size:14px; line-height:24px; color:#111111;">
                            <ul style="margin:0; padding-left:18px;">
                              <li><strong>Company Name :</strong> ${companyName}</li>
                              <li><strong>Company Description :</strong> ${companyDescription}</li>
                              <li><strong>Role :</strong> ${jobTitle}</li>
                              <li><strong>Location :</strong> ${location}</li>
                              <li><strong>Experience :</strong> ${minExp} - ${maxExp}</li>
                              
                            </ul>
                          </td>
                        </tr>

                        <tr>
                          <td style="padding:10px 20px 16px 20px; font-size:16px; line-height:24px; font-weight:700; color:#111111;">
                            Are you interested in exploring this opportunity?
                          </td>
                        </tr>

                        <tr>
                          <td style="padding:16px 20px 22px 20px;">
                            <table role="presentation" cellpadding="0" cellspacing="0" border="0">
                              <tr>
                                <td align="center" style="background-color:#145b84;">
                                 <a href="{consent_url}"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style="
                                        display:inline-block;
                                        background-color:#145b84;
                                        color:#ffffff;
                                        text-decoration:none;
                                        font-size:14px;
                                        line-height:18px;
                                        font-weight:700;
                                        padding:10px 16px;
                                        border:1px solid #145b84;
                                        border-radius:6px;
                                    ">
                                    Click to give Consent
                                  </a>
                                </td>
                                <td style="margin-left: 5px;">
                                    <a href="{unsubscribe_url}"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style="
                                        display:inline-block;
                                        background-color:#ffffff;
                                        color:#6b7280;
                                        text-decoration:none;
                                        font-size:14px;
                                        line-height:18px;
                                        font-weight:700;
                                        padding:10px 16px;
                                        border:1px solid #6b7280;
                                        border-radius:6px;
                                    ">
                                    Unsubscribe
                                  </a>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                          <tr>
                            <td style="padding:0 20px 20px 20px; font-size:14px; line-height:22px; color:#111111;">

                                <div style="margin-top:10px">
                              <img src=${companyLogo} width="200"     ;                   
                              style="width:200px;" />

                              <div style="margin-top:8px;">Thanks and Regards,</div>

                              <div style="font-weight:700; margin:0;">
                                ${companyName},
                              </div>

                            </td>
                          </tr>
                        <tr>
                          <td style="padding:0 20px 18px 20px; border-top:1px solid #edf2f7; font-size:12px; line-height:18px; color:#6b7280;">
                            <div style="padding-top:12px;">&copy; 2026 ${companyName}. All rights reserved.</div>
                            <div>This is an automated message — please do not reply to this email.</div>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              `);
                  setOutreachTab("compose");
                  setShowBulkOutreachModal(true);
            }}
          >
            <FaEnvelopeOpenText style={{ fontSize: 12 }} /> Schedule Bulk Email / WhatsApp
          </Button>
          </span>
         
            <span
              ref={candidateColumnsDropdownRef}
              id={`candidate-columns-trigger-${jobId}`}
              title="Show or hide candidate table columns"
              style={{ display: "inline-flex", alignItems: "center", height: 32, position: "relative", order: 7 }}
            >
              <Button
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  background: "#fff",
                  color: "#1a5fa8",
                  border: "1px solid #1a5fa8",
                  borderRadius: 6,
                  padding: "6px 10px",
                  minWidth: 135,
                  justifyContent: "center",
                  fontSize: 12.5,
                  fontWeight: 500,
                  whiteSpace: "nowrap",
                }}
                type="button"
                onClick={() => toggleCandidateColumnsDropdown(jobId)}
              >
                <FaPlus style={{ fontSize: 12 }} /> Add Columns <FaChevronDown style={{ fontSize: 10 }} />
              </Button>
              <span
                id={`candidateAddColumnsInfo-${jobId}`}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: 6,
                  color: "#1a5fa8",
                  cursor: "pointer",
                  verticalAlign: "middle",
                }}
              >
                <FaInfoCircle size={14} />
              </span>
              <UncontrolledTooltip
                placement="top"
                target={`candidateAddColumnsInfo-${jobId}`}
              >
                Use Add Columns to show optional candidate columns: Job Orders, Is Selected, Added In Database, Resume Score, and Agent Status.
              </UncontrolledTooltip>
              {candidateColumnsDropdownOpen[jobId] && (
                <div
                  style={{
                    position: "fixed",
                    top: candidateColumnsDropdownPosition[jobId]?.top ?? 8,
                    left: candidateColumnsDropdownPosition[jobId]?.left ?? 8,
                    zIndex: 2000,
                    background: "#fff",
                    border: "1px solid #e2e8f0",
                    borderRadius: 8,
                    minWidth: 220,
                    maxHeight: "min(320px, calc(100vh - 16px))",
                    overflowY: "auto",
                    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    padding: "10px 12px",
                  }}
                >
                  {availableCandidateColumnOptions.map(column => (
                    <label
                      key={column.key}
                      htmlFor={`candidate-column-${jobId}-${column.key}`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        fontSize: 13,
                        color: "#1f2937",
                        padding: "5px 0",
                        cursor: "pointer",
                        margin: 0,
                      }}
                    >
                      <Input
                        id={`candidate-column-${jobId}-${column.key}`}
                        type="checkbox"
                        checked={candidateColumnVisibility[column.key] === true}
                        onChange={e =>
                          handleCandidateColumnVisibilityChange(
                            column.key,
                            e.target.checked
                          )
                        }
                        style={{ margin: 0 }}
                      />
                      <span>{column.label}</span>
                    </label>
                  ))}
                </div>
              )}
            </span>
          
            <>
              <span
                title={`${candidateTotalCount} candidates`}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 7,
                  background: "linear-gradient(135deg, #eff6ff, #f8fafc)",
                  color: "#0f5fa8",
                  border: "1px solid #bfdbfe",
                  borderRadius: 999,
                  padding: "5px 11px",
                  fontSize: 13,
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  boxShadow: "0 1px 4px rgba(15, 95, 168, 0.10)",
                  order: 9,
                }}
              >
                Count :
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: 24,
                    height: 24,
                    padding: "0 8px",
                    borderRadius: 999,
                    background: "#0f5fa8",
                    color: "#fff",
                    fontSize: 12,
                    fontWeight: 800,
                    boxShadow: "inset 0 -1px 0 rgba(255,255,255,0.25)",
                  }}
                >
                  {candidateTotalCount}
                </span>
              </span>
              <span className="d-inline-flex align-items-center gap-1" style={{ order: 10 }}>
                <Button
                  className="candidate-bulk-stage-trigger"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 32,
                    background: "#fff",
                    color: "#1a5fa8",
                    border: "1px solid #1a5fa8",
                    borderRadius: 6,
                    padding: "6px 14px",
                    fontSize: 13,
                    fontWeight: 500,
                    lineHeight: 1.2,
                    whiteSpace: "nowrap",
                    gap: 8,
                  }}
                  onClick={() => {
                  const count = (bulkStageSelection[jobId] || []).length
                  if (!count) return Swal.fire({ icon: "warning", title: "Select Candidates", text: "Please select at least one candidate to change stage." })
                  if (count > 100) return Swal.fire({ icon: "warning", title: "Selection Limit", text: "Select no more than 100 candidates per batch." })
                  setBulkStageJobId(jobId)
                  }}
                >
                  <span>Change stage ({(bulkStageSelection[jobId] || []).length})</span>
                  {(selectedCandidateRows[jobId] || []).length > 0 && <span
                    role="button"
                    tabIndex={0}
                    title="Clear candidate selection"
                    aria-label="Clear candidate selection"
                    onClick={(event) => {
                      event.stopPropagation()
                      setSelectedCandidateRows(previous => ({ ...previous, [jobId]: [] }))
                      setSelectedCandidateRowData(previous => ({ ...previous, [jobId]: {} }))
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault()
                        event.stopPropagation()
                        setSelectedCandidateRows(previous => ({ ...previous, [jobId]: [] }))
                        setSelectedCandidateRowData(previous => ({ ...previous, [jobId]: {} }))
                      }
                    }}
                    style={{ display: "inline-flex", alignItems: "center", cursor: "pointer", lineHeight: 1 }}
                  ><FaTimes aria-hidden="true" /></span>}
                </Button>
              </span>
              <span className="d-inline-flex align-items-center gap-1" style={{ order: 10 }}>
                <SmtpTestButton
                  companyId={job?.company_id ?? job?.company?.company_id ?? job?.company?.id}
                />
              </span>
            </>
          
       {/* <Button
            style={{
              display: "inline-flex", alignItems: "center", gap: 6,
              background: "#fff", color: "#1a5fa8",
              border: "1px solid #1a5fa8",
              borderRadius: 6, padding: "6px 14px", fontSize: 13, fontWeight: 500,
              whiteSpace: "nowrap",
            }}
            disabled={!job.questions_reviewed}
            onClick={() => {
                  setConfigureCallJob(job);
                  setShowOutreachResultsModal(true);
            }}
          >
            <FaRegEye style={{ fontSize: 12 }} /> View Outreach Result
          </Button> */}
          {/* <span
            title={
              job.questions_reviewed
                ? "View Outreach Result"
                : "Questions not yet reviewed — cannot view outreach result"
            }
            style={{ display: "inline-block" }}
          >
            <Button
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                background: "#fff",
                color: "#1a5fa8",
                border: "1px solid #1a5fa8",
                borderRadius: 6,
                padding: "6px 14px",
                fontSize: 13,
                fontWeight: 500,
                whiteSpace: "nowrap",
                pointerEvents: job.questions_reviewed ? "auto" : "none"
              }}
              disabled={!job.questions_reviewed}
              onClick={() => {
                setConfigureCallJob(job);
                setShowOutreachResultsModal(true);
              }}
            >
              <FaRegEye style={{ fontSize: 12 }} /> View Outreach Result
            </Button>
          </span> */}
          {/* {hasVgus && (
            <span title="View telephonic & talent scan screening results for this job" style={{ display: "inline-block" }}>
              <Button
                style={{
                  display: "inline-flex", alignItems: "center", gap: 6,
                  background: "linear-gradient(135deg,#0c447c,#145b84)",
                  color: "#fff",
                  border: "1px solid #0c447c",
                  borderRadius: 6, padding: "6px 14px", fontSize: 13, fontWeight: 600,
                  whiteSpace: "nowrap",
                  boxShadow: "0 2px 6px rgba(12,68,124,0.25)",
                }}
                onClick={() => {
                  setScreeningResultsJob(job);
                  setScreeningResultsModal(true);
                }}
              >
                <FaPhoneAlt style={{ fontSize: 12 }} /> View Screening Results
              </Button>
            </span>
          )} */}
        </>
      </div>
    </div>
    </div>
    <div style={{ display: "flex", alignItems: "center", background: "#fff", borderBottom: "1px solid #e2e8f0", padding: "0 20px", flexWrap: "wrap" }}>
      {["Latest Resumes", "Database Resumes"].map(tab => (
        <div
          key={tab}
          onClick={() => setCandidateTab(tab)}
          style={{
            padding: "10px 16px",
            fontSize: 13,
            cursor: "pointer",
            fontWeight: candidateTab === tab ? 600 : 400,
            color: candidateTab === tab ? "#1a5fa8" : "#718096",
            borderBottom: candidateTab === tab ? "2px solid #1a5fa8" : "2px solid transparent",
            marginBottom: -1,
            transition: "all 0.15s",
          }}
        >
          {tab}
        </div>
      ))}
      <Button
        type="button"
        title="Export candidate data"
        onClick={() => exportCandidatesForJob(job)}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 6,
          height: 32,
          marginLeft: "auto",
          padding: "6px 10px",
          fontSize: 12,
          fontWeight: 500,
          color: "#1a5fa8",
          background: "#fff",
          border: "1px solid #1a5fa8",
          borderRadius: 6,
          whiteSpace: "nowrap",
          flexShrink: 0,
        }}
      >
        <FaDownload style={{ fontSize: 12 }} /> Export Candidates
      </Button>
    </div>

    <div style={{ padding: "0 0 8px" }}>
      {loadingCandidates ? (
        <div style={{ padding: "24px 20px" }}>
          <CustomLoader />
        </div>
      ) : !Array.isArray(filteredCandidates) || filteredCandidates.length === 0 ? (
        <div
          style={{
            minHeight: 170,
            margin: "18px 20px 20px",
            padding: "32px 20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            border: "1px dashed #cbd9e8",
            borderRadius: 10,
            background: "linear-gradient(180deg, #fbfdff 0%, #f5f9fd 100%)",
          }}
        >
          <div style={{ width: 38, height: 38, display: "inline-flex", alignItems: "center", justifyContent: "center", borderRadius: "50%", background: "#e8f2fb", color: "#1a5fa8", fontSize: 18 }}>
            <FaInfoCircle />
          </div>
          <div style={{ marginTop: 10, color: "#334e68", fontSize: 15, fontWeight: 700 }}>
            {candidateResponseMessageMap[jobId] || ((recruiterFilterMap[jobId] || []).length > 0
              ? "This recruiter has not added candidates to this job order."
              : "No candidates found")}
          </div>
          <div style={{ marginTop: 4, color: "#829ab1", fontSize: 12 }}>
            {(recruiterFilterMap[jobId] || []).length > 0
              ? "Select All Recruiters or choose another recruiter to view more candidates."
              : "Try changing your search or add candidates to this job order."}
          </div>
        </div>
      ) : (
        <div id="CandidateTest_DataTableView">
          <DataTable
            columns={columns}
            data={Array.isArray(filteredCandidates) ? filteredCandidates : []}
            keyField="job_candidate_id"
            defaultSortFieldId={candidateSortByJobRef.current[jobId]?.columnId}
            defaultSortAsc={candidateSortByJobRef.current[jobId]?.direction !== "desc"}
            onSort={(column, direction) => {
              candidateSortByJobRef.current[jobId] = { columnId: column.id, direction };
            }}
            // expandableRows
            // expandableRowsComponent={TestAndCallsExpansion}
            // onRowExpandToggled={handleCandidateRowExpandToggled}
            // expandableRowExpanded={row =>
            //   getCandidateRowId(row) === expandedCandidateRowId
            // }
            highlightOnHover
            pagination
            dense
            paginationServer
            paginationTotalRows={getJobTotalRows(jobId)}
            paginationDefaultPage={getJobCurrentPage(jobId)}
                  paginationPerPage={getJobPerPage(jobId)} // important to show selected per page
            paginationRowsPerPageOptions={[10, 15, 20, 50]}
            onChangePage={page => handlePageChangeForJob(jobId, page)}
            paginationComponentOptions={paginationComponentOptions}
                  onChangeRowsPerPage={(newPerPage, page) =>
                    handlePerRowsChangeForJob(jobId, newPerPage, page)
                  }
                  onSelectedRowsChange={state => {
                    /* keep behavior - store selected if needed */
                  }}
            onRowClicked={handleRowClick}
            conditionalRowStyles={conditionalRowStyles}
            progressComponent={<CustomLoader />}
          />
        </div>
      )}
    </div>
  </div>
)
  }
  const fetchJobTimeline = async (jobId, page = 1) => {
    if (page === 1) {
      void trackActivity({
        module: "Job Orders",
        action: "Job Action Logs Viewed",
        recordType: "job",
        recordId: jobId,
        companyId,
        metadata: { job_id: jobId, source: "job-action-logs" },
      })
    }
    actionTimelineAbortRef.current?.abort()
    const controller = new AbortController()
    actionTimelineAbortRef.current = controller
    setLoadingJobTimelineId(jobId)
    try {
      const response = await axios.get(
        `/api/v1/action-logs/?page=${page}&size=10&job_id=${jobId}`,
        { signal: controller.signal }
      )
      const payload = response.data
      const records = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
          ? payload.data
          : []
      setActionTimelineModal({
        open: true,
        kind: "job",
        title: "Job Action Logs",
        records,
        jobId,
        page: payload?.page ?? response?.page ?? page,
        size: payload?.size ?? response?.size ?? 10,
        count: payload?.count ?? response?.count ?? records.length,
      })
    } catch (error) {
      if (controller.signal.aborted || axios.isCancel(error)) return
      console.error("Error fetching job timeline:", error)
    }
    finally {
      setLoadingJobTimelineId(null) 
    }
  }
  const fetchQuestionReviewHistory = async jobId => {
    setQuestionReviewHistoryModal({ open: true, jobId, records: [], loading: true, error: "" });
    try {
      const response = await axios.get(`/api/v1/jobs/${jobId}/question-review-history/`);
      const payload = response?.data || {};
      const records = Array.isArray(payload?.history) ? payload.history : [];
      setQuestionReviewHistoryModal({ open: true, jobId, records, loading: false, error: "" });
    } catch (error) {
      setQuestionReviewHistoryModal({
        open: true,
        jobId,
        records: [],
        loading: false,
        error: error?.response?.data?.message || error?.response?.data?.error || "Unable to load question review history.",
      });
    }
  }
  const getReviewQuestionText = (value, allowNumeric = false) => {
    if (typeof value === "string") {
      const text = value.trim();
      return text && (allowNumeric || !/^\d+$/.test(text)) ? text : "";
    }
    if (value && typeof value === "object") {
      return getReviewQuestionText(value.text || value.question || value.question_text || "", allowNumeric);
    }
    return "";
  };
  const getReviewQuestionSections = (record, type) => {
    const details = record?.details || {};
    const sections = [];
    const addSection = (name, values) => {
      const questions = (Array.isArray(values) ? values : [values])
        .map(value => getReviewQuestionText(value, true))
        .filter(Boolean);
      if (questions.length) sections.push({ name, questions });
    };

    if (type === "screening") {
      // The history API stores full snapshots separately. Only the explicit
      // added collection belongs in this modal.
      const screening = details.screening_questions_added;
      if (screening && typeof screening === "object" && !Array.isArray(screening)) {
        Object.entries(screening).forEach(([section, values]) => addSection(section.replace(/_/g, " "), values));
      } else if (Array.isArray(screening)) {
        addSection("Screening", screening);
      }
    } else {
      const talentScan = details.talentscan_questions_added;
      const grouped = new Map();
      const addTalentQuestions = (groupName, skill, level, values) => {
        const questions = Array.isArray(values) ? values : [values];
        questions.forEach(item => {
          const text = getReviewQuestionText(item);
          if (!text) return;
          const key = `${skill || ""}|${level || ""}|${text}`;
          if (!grouped.has(groupName)) grouped.set(groupName, { name: groupName, questions: [], keys: new Set() });
          const group = grouped.get(groupName);
          if (!group.keys.has(key)) {
            group.keys.add(key);
            group.questions.push({ text, skill: skill || "", level: level || "" });
          }
        });
      };

      const readSkillWise = value => {
        if (Array.isArray(value)) {
          value.forEach(item => {
            if (!item || typeof item !== "object") return;
            const skill = item.skill || item.name || "";
            ["beginner", "intermediate", "advanced"].forEach(level => {
              addTalentQuestions(`Skill: ${skill || "Unknown"}`, skill, level, item[level]);
            });
          });
          return;
        }
        Object.entries(value && typeof value === "object" ? value : {}).forEach(([skill, details]) => {
          const questions = details?.questions || details;
          ["beginner", "intermediate", "advanced"].forEach(level => {
            addTalentQuestions(`Skill: ${skill}`, skill, level, questions?.[level]);
          });
        });
      };

      const readSectionWise = value => {
        Object.entries(value && typeof value === "object" ? value : {}).forEach(([section, details]) => {
          const questions = details?.questions || details;
          ["beginner", "intermediate", "advanced"].forEach(level => {
            addTalentQuestions(`Section: ${section}`, details?.skill || "", level, questions?.[level]);
          });
        });
      };

      if (talentScan && typeof talentScan === "object") {
        readSkillWise(talentScan.skill_wise_questions);
        readSectionWise(talentScan.section_wise_questions);
        (Array.isArray(talentScan.time_settings) ? talentScan.time_settings : []).forEach(setting => {
          readSkillWise(setting?.skill_wise_questions);
          readSectionWise(setting?.section_wise_questions);
        });
      }

      sections.push(...Array.from(grouped.values()).map(({ keys, ...section }) => section));
    }
    return sections;
  };
  const jobsWithApplyLinkCount = useMemo(() => {
    return jobOrdersData.filter(job => hasJobApplyLink(job)).length
  }, [jobOrdersData])

  const postedWebsiteCompanyNames = useMemo(() => {
    const names = jobOrdersData
      .filter(job => hasJobApplyLink(job))
      .map(job => getJobCompanyName(job))
      .filter(name => name && name !== "-")

    return [...new Set(names)]
  }, [jobOrdersData])

  const postedWebsiteCompanyLabel = postedWebsiteCompanyNames.join(", ")

  // ---------- job table columns ----------
  const jobColumns = useMemo(
    () => {
      const columns = [
        {
          name: <span className="fs-6 fw-bold">Job ID</span>,
          selector: r => r.job_order_id ?? r.job_number ?? r.id,
          sortable: true,
          cell: row => (
            <span title={row.job_order_id ?? row.job_number ?? row.id}>
              {row.job_order_id ?? row.job_number ?? row.id}
            </span>
          ),
          width: "100px",
        },
        // {
        //   name: <span className="fs-6 fw-bold">Job Title</span>,
        //   selector: r => r.job_title ?? r.position ?? r.job_order_id,
        //   sortable: true,
        //   cell: row => (
        //     <Link
        //       to={`/create-job-orders-view/${row.id}`}
        //       title={row.job_title ?? row.position ?? row.job_order_id}
        //       style={{ color: "inherit", textDecoration: "none" }}
        //     >
        //       <span style={{ borderBottom: "1px solid currentColor" }}>
        //         {row.job_title ?? row.position ?? row.job_order_id}
        //       </span>
        //     </Link>
        //   ),
        //   width: "230px",
        // },
        {
              name: <span className="fs-6 fw-bold">Job Title</span>,
              selector: r => r.job_title ?? r.position ?? r.job_order_id,
              sortable: true,
              cell: row => {
                const userId = userInfos?.user_details?.user_id;
                const userPermission = row.permissions?.find(p => p.user_id === userId);
                const canEdit = userPermission?.can_edit_job ?? false;

                return (
                  <Link
                    to={`/create-job-orders-view/${row.id}`}
                    state={{ selectedCompanyId: companyId }}
                    className="job-order-title-link"
                    title={row.job_title ?? row.position ?? row.job_order_id}
                    style={{ color: "inherit", textDecoration: "none" }}
                    // onClick={e => {
                    //   if (!canEdit) e.preventDefault();  
                    // }}
                  >
                    <span
                      style={{
                        textDecoration: "underline",
                        textUnderlineOffset: "3px",
                        color: canEdit ? "inherit" : "#034e66",  
                        // cursor: canEdit ? "pointer" : "not-allowed",
                      }}
                      title={!canEdit ? "You don't have edit access for this job" : undefined}
                    >
                      {row.job_title ?? row.position ?? row.job_order_id}
                    </span>
                  </Link>
                );
              },
              width: "240px",
            },
        ...(!companyId
          ? [
              {
                name: <span className="fs-6 fw-bold">Company</span>,
                selector: r => getJobCompanyName(r),
                sortable: true,
                cell: row => (
                  <span title={getJobCompanyName(row)}>
                    {getJobCompanyName(row)}
                  </span>
                ),
                width: "170px",
              },
            ]
          : []),
        {
          name: <span className="fs-6 fw-bold">Category</span>,
          selector: r => (r.category_name ? r.category_name : "-"),
          sortable: true,
          cell: row => (
            <span className="" title={row.category_name ?? "-"}>
              {row.category_name ?? "-"}
            </span>
          ),
          width: "105px",
        },
      ]
     

      columns.push({
        name: <span className="fs-6 fw-bold">Openings</span>,
        selector: r => (r.openings ? r.openings : "-"),
        sortable: true,
        cell: row => (
          <span title={row.openings ?? "-"}>
            {row.openings ?? "-"}
          </span>
        ),
        width: "90px",
      })
      columns.push({
        name: <span className="fs-6 fw-bold">Location</span>,
        selector: r => (r.location ? r.location : "-"),
        sortable: true,
        cell: row => (
          <span title={row.location ?? "-"}>
            {row.location ?? "-"}
          </span>
        ),
        width: "95px",
      })
      // {
      //   name: <span className="fs-6 fw-bold">Handled By</span>,
      //   cell: row => (
      //     <span title={row.recruiters_names?.join(", ") || "-"}>
      //       {row.recruiters_names?.join(", ") || "-"}
      //     </span>
      //   ),
      //   sortable: true,
      //   width: "180px",
      // },
    //  {
    //         name: <span className="fs-6 fw-bold">Created At</span>,
    //         selector: r =>
    //           r.created_at ? new Date(r.created_at).toLocaleString() : "-",
    //         sortable: true,
    //         cell: row => {
    //           if (!row.created_at) return "-";
    //           const d = new Date(row.created_at);
    //           const date = d.toLocaleDateString();   
    //           const time = d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true });   

    //           return (
    //             <div style={{ display: "flex", flexDirection: "column", lineHeight: "16px" }}>
    //               <span className="mb-1" title={date}>
    //                 {date}
    //               </span>
    //               <span title={time}>
    //                 {time}
    //               </span>
    //             </div>
    //           );
    //         },
    //         width: "140px", 
    //       },
          // {
          //   name: <span className="fs-6 fw-bold">Updated At</span>,
          //   selector: r =>
          //     r.updated_at ? new Date(r.updated_at).toLocaleString() : "-",
          //   sortable: true,
          //   cell: row => {
          //     if (!row.updated_at) return "-";
          //     const d = new Date(row.updated_at);
          //     const date = d.toLocaleDateString();
          //     const time = d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true });

          //     return (
          //       <div style={{ display: "flex", flexDirection: "column", lineHeight: "16px" }}>
          //         <span className="mb-1" title={date}>
          //           {date}
          //         </span>
          //         <span title={time}>
          //           {time}
          //         </span>
          //       </div>
          //     );
          //   },
          //   width: "135px",
          // },
       columns.push({
        name: <span className="fs-6 fw-bold">Created By</span>,
        selector: r => {
          if (!r.created_at) return r.created_by_name || "-";
          const d = new Date(r.created_at);
          const dd = String(d.getDate()).padStart(2, "0");
          const mm = String(d.getMonth() + 1).padStart(2, "0");
          const yyyy = d.getFullYear();
          let hours = d.getHours();
          let minutes = String(d.getMinutes()).padStart(2, "0");
          const ampm = hours >= 12 ? "pm" : "am";
          hours = hours % 12 || 12;
          return `${dd}/${mm}/${yyyy} ${r.created_by_name || ""}`;
        },
        sortable: true,
        width: "165px",
        cell: row => {
  const byName = formatDisplayName(row.created_by_name || "-");
  if (!row.created_at) return <span title={byName} style={{ textAlign: "center", display: "block", width: "100%" }}>{byName}</span>;

  const d = new Date(row.created_at);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  let hours = d.getHours();
  let minutes = String(d.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12 || 12;
  const date = `${dd}/${mm}/${yyyy}`;
  const time = `${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;

  return (
    <div
      title={`${byName} | ${date} ${time}`}
      style={{ overflow: "hidden", width: "100%", minWidth: 0, padding: "4px 6px", textAlign: "center" }}
    >
      <div
        style={{
          fontWeight: 400,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          textAlign: "center",
        }}
      >
        {byName}
      </div>
      <div style={{ fontSize: "11px", color: "#6b7280", whiteSpace: "nowrap", textAlign: "center" }}>
        {date} 
      </div>
    </div>
  );
},
      })
      columns.push({
        name: <span className="fs-6 fw-bold">Reporting Manager</span>,
        selector: r => getReportingManagerName(r),
        sortable: true,
        cell: row => (
          <span title={getReportingManagerName(row)}>
            {getReportingManagerName(row)}
          </span>
        ),
        width: "155px",
      })
      columns.push({
        name: <span className="fs-6 fw-bold">End Date</span>,
        selector: r => {
          if (!r.close_date) return "-";

          const d = new Date(r.close_date);

          const dd = String(d.getDate()).padStart(2, "0");
          const mm = String(d.getMonth() + 1).padStart(2, "0");
          const yyyy = d.getFullYear();

          let hours = d.getHours();
          let minutes = String(d.getMinutes()).padStart(2, "0");
          const ampm = hours >= 12 ? "pm" : "am";
          hours = hours % 12 || 12;

          const date = `${dd}/${mm}/${yyyy}`;
          const time = `${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;

          return `${date}\n${time}`;
        },
        sortable: true,
        cell: row => {
          if (!row.close_date) return "-";

          const d = new Date(row.close_date);

          const dd = String(d.getDate()).padStart(2, "0");
          const mm = String(d.getMonth() + 1).padStart(2, "0");
          const yyyy = d.getFullYear();

          let hours = d.getHours();
          let minutes = String(d.getMinutes()).padStart(2, "0");
          const ampm = hours >= 12 ? "pm" : "am";
          hours = hours % 12 || 12;

          const date = `${dd}/${mm}/${yyyy}`;
          const time = `${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
          const result = `${date} ${time}`;

          return (
            <span title={result} className="d-flex flex-column">
              <span>{date}</span>
              <span>{time}</span>
            </span>
          );
        },
        width: "115px",
      })
      columns.push({
        name: <span className="fs-6 fw-bold">Days Open</span>,
        selector: r => {
          const daysOpen = getJobOpenDays(r)
          return daysOpen ?? -1
        },
        sortable: true,
        cell: row => {
          const daysOpen = getJobOpenDays(row)
          return <span title={daysOpen !== null ? `${daysOpen} days` : "-"}>{daysOpen !== null ? daysOpen : "-"}</span>
        },
        width: "80px",
      })
       if (!isMyJobsView) {
        columns.push(
        //   {
        //   name: <span className="fs-6 fw-bold">Created By</span>,
        //   selector: r => (r.created_by_name ? r.created_by_name : "-"),
        //   sortable: true,
        //   cell: row => (
        //     <span title={row.created_by_name ?? "-"}>
        //       {row.created_by_name ?? "-"}
        //     </span>
        //   ),
        //   width: "150px",
        // }
      )
      }

      columns.push({
              name: (
                <button
                  type="button"
                  className="MuiButtonBase-root MuiIconButton-root MuiIconButton-sizeMedium addCandidateHeaderBtn"
                >
                  <span className="fs-6 fw-bold ms-1">Add Candidate</span>
                </button>
              ),

              cell: row => (
                <button
                  className="addCandidateBtn btn btn-primary btn-sm"
                  title={`Add Candidate to ${
                    row.job_title ?? row.position ?? row.job_order_id
                  } Job`}
                  onClick={() => {
                    if (!ensureValidCompanySelected()) return
                    setSelectedJobForUpload(row)
                    setAddCandidateModal(true)
                  }}
                >
                  {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg> */}

                  <span>Add Candidate</span>
                </button>
              ),

              width: "120px",
            })
      columns.push({
        name: <span className="fs-6 fw-bold">View Candidates</span>,
        cell: row => (
        <div
          className="d-flex align-items-center justify-content-center gap-2"
          style={{ width: "100%", flexWrap: "nowrap", whiteSpace: "nowrap" }}
        >
          <span style={{ lineHeight: 1 }}>{Number(row.candidate_count || 0)}</span>

          <button
            className="btn btn-sm bg-light text-dark"
            style={{ flexShrink: 0, padding: "5px 9px" }}
            title={`View Candidates in ${
              row.job_title ?? row.position ?? row.job_order_id
            } Job`}
            onClick={() =>
              navigate("/candidate-details-view", {
                state: { job_id: row.job_id ?? row.id, companyId },
              })
            }
          >
            <FaRegEye />
          </button>
        </div>
      ),
        width: "125px",
      })
      columns.push({
         name: (
            <span className="fs-6 fw-bold d-inline-flex align-items-center gap-1">
              Job Info
              <span
                title={`${jobsWithApplyLinkCount} job${jobsWithApplyLinkCount === 1 ? "" : "s"} posted to website${postedWebsiteCompanyLabel ? ` - ${postedWebsiteCompanyLabel}` : ""}`}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: 20,
                  height: 30,
                  padding: "0 6px",
                  borderRadius: 999,
                  background: "#dcfce7",
                  color: "#16a34a",
                  fontSize: 13,
                  fontWeight: 900,
                  lineHeight: 1,
                }}
              >
                {jobsWithApplyLinkCount}
              </span>
            </span>
          ),
          cell: row => (  
            <RSButton
              color="light"
              size="sm"
              title={
                hasJobApplyLink(row)
                  ? `This job has been posted to ${getJobCompanyName(row)} website`
                  : "View Job Details"
              }
              onClick={() => {
                setSelectedJobDetails(row)
                setShowJobDetailsModal(true)
              }}
            >
              <FaRegEye
                style={{
                  color: hasJobApplyLink(row) ? "#16a34a" : undefined,
                  fontSize: 15,
                }}
                title={
                hasJobApplyLink(row)
                  ? `This job has been posted to ${getJobCompanyName(row)} website`
                  : "View Job Details"
              }
              />
            </RSButton>
          ),
          width: "90px",
        })
      // {
      //     name: <span className="fs-6 fw-bold">Action</span>,
      //     cell: row => (
      //         <div className="d-flex gap-2">
      //             <Link to={`/create-job-orders-view/${row.id}`}>
      //                 <RSButton color="light" size="sm" title="Edit Job order">
      //                     <FaRegEdit />
      //                 </RSButton>
      //             </Link>
      //             <RSButton
      //                 color="light"
      //                 size="sm"
      //                 title="Delete Job"
      //                 onClick={() => openDeleteJobModal(row)}
      //             >
      //                 <FaRegTrashAlt />
      //             </RSButton>
      //             <Link to="/job-time-line" onClick={() => fetchJobTimeline(row.id)}>
      //             <RSButton color="light" size="sm" title="Job Action Logs">
      //                 <FaBusinessTime />
      //             </RSButton>
      //             </Link>
      //         </div>
      //     ),
      // },
      
      columns.push({
        name: <span className="fs-6 fw-bold">Actions</span>,
        cell: row => {
          const { canEditJob, canDeleteJob } = getUserPermissions(row)
          return (
            <div className="job-order-actions-cell">
              {/* {canEditJob && (
                <Link to={`/create-job-orders-view/${row.id}`}>
                  <RSButton color="light" size="sm" title="Edit Job order">
                    <FaRegEdit />
                  </RSButton>
                </Link>
              )} */}

              <RSButton
                color="light"
                size="sm"
                title="Delete Job"
                onClick={() => openDeleteJobModal(row)}
              >
                <FaRegTrashAlt className="text-danger" title="Delete Job"/>
              </RSButton>
             <button
                type="button"
                className="btn btn-light"
                onClick={async e => {
                  await fetchJobTimeline(row.id)
                }}
              >
                <RSButton color="light" size="sm" title="Job Action Logs">
                  {loadingJobTimelineId === row.id ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    <FaBusinessTime title="Job Action Logs" />
                  )}
                </RSButton>
              </button>
              {/* <RSButton
                color="light"
                size="sm"
                title={
                  hasJobApplyLink(row)
                    ? `This job has been posted to ${getJobCompanyName(row)} website`
                    : "View Job Details"
                }
                onClick={() => {
                  setSelectedJobDetails(row)
                  setShowJobDetailsModal(true)
                }}
              >
                <FaRegEye
                  style={{
                    color: hasJobApplyLink(row) ? "#16a34a" : undefined,
                    fontSize: 15,
                  }}
                />
              </RSButton> */}
              <RSButton
                color="light"
                size="sm"
                title="Send for Review"
                // title={row.questions_reviewed
                //   ? "Send for Review"
                //   : "Questions not yet reviewed — cannot send for review"}
                // // disabled={!row.questions_reviewed}
                onClick={() => handleOpenSendForReviewModal(row)}
              >
                <VscOpenPreview title="Send for Review"/>
              </RSButton>
            </div>
          )
        },
        minWidth: "140px",
        grow: 1,
      })
      

      return columns
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [companyId, isMyJobsView, jobStatusList, jobsWithApplyLinkCount, postedWebsiteCompanyLabel,loadingJobTimelineId]
  )

  const [expandedRowId, setExpandedRowId] = useState(null)
  const [expandedCandidateRowMap, setExpandedCandidateRowMap] = useState({})
  const [statusError, setstatusError] = useState("")
  const [statusLoader, setstatusLoader] = useState(false)
  const handleJobRowExpandToggled = (expanded, row) => {
    const rowId = getJobRowId(row)
    setExpandedRowId(expanded ? rowId : null)
  }

  useEffect(() => {
    const restoreState = location.state
    const restoreJobId = restoreState?.restoreJobId

    if (!restoreJobId || restoreCandidateViewRef.current) return

    restoreCandidateViewRef.current = true
    setExpandedRowId(restoreState.restoreExpandedRowId ?? restoreJobId)
    setCandidateTabMap(prev => ({
      ...prev,
      [restoreJobId]: restoreState.restoreCandidateTab || "Latest Resumes",
    }))
    setCurrentPageMap(prev => ({
      ...prev,
      [restoreJobId]: restoreState.restoreCandidatePage ?? 1,
    }))
    setPerPageMap(prev => ({
      ...prev,
      [restoreJobId]: restoreState.restoreCandidatePerPage ?? prev[restoreJobId] ?? 10,
    }))
    setSearchMap(prev => ({
      ...prev,
      [restoreJobId]: restoreState.restoreCandidateSearch ?? "",
    }))
  }, [location.state])

  const handleStatusUpdate = async () => {
    setstatusLoader(true)

    if (!selectedStatusId) {
      setstatusLoader(false)
      return setstatusError("Select a status")
    }

    try {
      await axios.patch(
        `/api/v1/jobs/${selectedJobForStatus.job_id}/change-status/`,
        {
          status: selectedStatusId,
        }
      )

      // ✅ Trigger UI alert BEFORE closing modal
      setErrorMessage("Status updated successfully")
      // console.log("hjgjhg")
      setIsSuccess(true)
      setErrorAlert(true)

      setStatusModal(false)
      setstatusLoader(false)
      setstatusError("")
      await getJobOrders(companyId, currentPage, perPage)
    } catch (err) {
      console.error(err)
      setstatusLoader(false)
      setstatusError("")

      setErrorMessage("Failed to update status")
      setIsSuccess(false)
      setErrorAlert(true)
    }
  }

  const handleCompanyChange = company => {
    if (company?.company_id) {
      setHrmsCompanyId(company.company_id)
      setSubdomain(company.company_domain)
    }
  }
  const [testTypeList, setTestTypeList] = useState([])
  useEffect(() => {
    const fetchTestTypes = async () => {
      try {
        const response = await axios.get("api/v1/test-types/")
        setTestTypeList(response.data)
      } catch (error) {
        console.error("Error fetching test types:", error)
      }
    }
    fetchTestTypes()
  }, [])
  const [resetLoading, setResetLoading] = useState(false)
  const isFirstRenderSearchRef = useRef(true)

  useEffect(() => {
    if (isFirstRenderSearchRef.current) {
      isFirstRenderSearchRef.current = false
      return
    }
    setCurrentPage(1)
    const timer = setTimeout(() => {
      getJobOrders(companyId, 1, perPage, jobSearchText).finally(() => {
        setResetLoading(false)
      })
    }, 400)

    return () => clearTimeout(timer)
  }, [jobSearchText])

  // ---------- render ----------
  const interviewCommunicationRows = interviewEmailTemplates
  const communicationDate = item => item?.sent_at || item?.event_date || item?.created_at || item?.datetime || item?.timestamp
  const communicationBody = item => item?.body || item?.message || item?.description || ""
  const communicationText = value => value || "--"
  const communicationEmpty = label => <p className="text-center text-muted py-4 mb-0">No {label} found for this candidate.</p>
  const renderCommunicationEmail = (item, index) => {
    const deliveryStatus = item.delivery_status || "Unknown"
    const deliveryStatusColor = deliveryStatus === "Sent"
      ? "#15803d"
      : deliveryStatus === "Not sent"
        ? "#dc2626"
        : "#64748b"

    return (
      <div key={`email-${item.id || index}`} style={{ background: "#fff", border: "1px solid #dbe4f0", borderRadius: 14, padding: 14, boxShadow: "0 8px 22px rgba(15, 23, 42, 0.05)" }}>
      <div className="d-flex justify-content-between align-items-start gap-3 mb-2">
        <div>
          <div className="fw-semibold" style={{ color: "#0f172a", fontSize: 14 }}>{communicationText(item.subject || item.title || "No Subject")}</div>
          <div style={{ fontSize: 12, color: "#64748b" }}>From: {communicationText(item.from || item.from_address || item.sender_email || item.sent_by)}</div>
        </div>
        <span style={{ fontSize: 12, color: "#64748b", whiteSpace: "nowrap" }}>{formatHistoryDateTime(communicationDate(item))}</span>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "6px 16px", padding: "10px 12px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, fontSize: 12, color: "#334155" }}>
        <div><strong>To:</strong> {communicationText(item.to || item.to_addresses || item.recipient_email)}</div>
        <div><strong>CC:</strong> {communicationText(item.cc || item.cc_addresses)}</div>
        <div><strong>Sender:</strong> {communicationText(item.sender || item.sender_name || item.sent_by || item.created_by_name)}</div>
        <div>
          <strong>Delivery status:</strong>{" "}
          <span style={{ color: deliveryStatusColor, fontWeight: 700 }}>{deliveryStatus}</span>
          {item.delivery_error ? (
            <div style={{ marginTop: 3, color: "#dc2626", fontSize: 11 }}>{item.delivery_error}</div>
          ) : null}
        </div>
      </div>
      {communicationBody(item) ? (
        <details style={{ marginTop: 10, border: "1px solid #dbe4f0", borderRadius: 10, overflow: "hidden", background: "#fff" }}>
          <summary style={{ cursor: "pointer", padding: "9px 12px", color: "#0b5fc1", fontSize: 12, fontWeight: 700, listStylePosition: "inside" }}>
            View full email
          </summary>
          <div style={{ padding: "0 10px 10px" }}>
            {looksLikeHtml(communicationBody(item)) ? (
              <iframe
                title={`communication-email-${index}`}
                srcDoc={getCommunicationHistoryEmailHtml(communicationBody(item))}
                sandbox=""
                scrolling="no"
                onLoad={event => {
                  const frame = event.currentTarget
                  const resizeFrame = () => {
                    const documentBody = frame.contentDocument?.body
                    const documentElement = frame.contentDocument?.documentElement
                    const documentHeight = Math.max(
                      documentBody?.scrollHeight || 0,
                      documentBody?.offsetHeight || 0,
                      documentElement?.scrollHeight || 0,
                      documentElement?.offsetHeight || 0,
                      220
                    )
                    frame.style.height = `${Math.max(documentHeight + 120, 520)}px`
                  }
                  frame.contentDocument?.querySelectorAll("img").forEach(image => {
                    image.addEventListener("load", resizeFrame)
                  })
                  resizeFrame()
                  window.requestAnimationFrame(resizeFrame)
                  window.setTimeout(resizeFrame, 150)
                  window.setTimeout(resizeFrame, 500)
                }}
                style={{ width: "100%", height: 520, border: "1px solid #e2e8f0", borderRadius: 8, background: "#fff", display: "block", overflow: "hidden" }}
              />
            ) : (
              <div style={{ padding: 10, border: "1px solid #e2e8f0", borderRadius: 8, color: "#334155", fontSize: 13, whiteSpace: "pre-wrap" }}>
                {communicationBody(item)}
              </div>
            )}
          </div>
        </details>
      ) : null}
      </div>
    )
  }
  const renderCommunicationEvent = (item, index) => {
    const members = item.panel_members || item.panel || item.panelists || item.contact_ids
    const panelText = Array.isArray(members) ? members.map(member => typeof member === "object" ? member.name || member.email : member).filter(Boolean).join(", ") : communicationText(members)
    return (
      <div key={`event-${item.id || index}`} style={{ background: "#fff", border: "1px solid #cfe0f2", borderRadius: 14, padding: 14, boxShadow: "0 8px 22px rgba(15, 23, 42, 0.05)" }}>
        <div className="d-flex justify-content-between align-items-start gap-3 mb-3"><strong style={{ color: "#0f172a", fontSize: 15 }}>{communicationText(item.subject || item.interview_subject || item.name)}</strong><span style={{ padding: "4px 9px", borderRadius: 999, background: "#eff6ff", color: "#1d4ed8", fontSize: 11, fontWeight: 700 }}>{communicationText(item.status || item.interview_status)}</span></div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "8px 16px", padding: "11px 12px", background: "#f8fbff", border: "1px solid #dbeafe", borderRadius: 10, fontSize: 12, color: "#334155" }}>
          <div><strong>Event type:</strong> {communicationText(item.event_type)}</div><div><strong>Subtype:</strong> {communicationText(item.event_subtype || item.event_sub_type)}</div>
          <div><strong>Candidate:</strong> {communicationText(item.candidate_name || item.candidate)}</div><div><strong>Job title:</strong> {communicationText(item.job_title || item.job_name || item.position)}</div>
          <div><strong>Interview date:</strong> {communicationText(item.interview_date || item.start_date || item.event_date)}</div><div><strong>Time:</strong> {communicationText(item.start_time)} - {communicationText(item.end_time)}</div>
          <div><strong>Time zone:</strong> {communicationText(item.time_zone || item.timezone)}</div><div><strong>Created by:</strong> {communicationText(item.created_by_name || item.created_by)}</div>
          <div><strong>Created-by email:</strong> {communicationText(item.created_by_email)}</div><div><strong>Panel members:</strong> {panelText}</div>
          <div><strong>Manager/contact:</strong> {communicationText(item.manager_name || item.manager || item.contact_name)}</div><div><strong>Meeting link:</strong> {item.meeting_link || item.google_calendar_link ? <a href={item.meeting_link || item.google_calendar_link} target="_blank" rel="noreferrer">Open meeting</a> : "--"}</div>
        </div>
      </div>
    )
  }
  const renderCommunicationRecord = (item, index) => item.type === "email" ? renderCommunicationEmail(item, index) : item.type === "calendar_event" ? renderCommunicationEvent(item, index) : (
    <div key={`record-${item.id || index}`} style={{ background: "#fff", border: "1px solid #dbe4f0", borderRadius: 12, padding: 14 }}><div className="d-flex justify-content-between gap-3"><strong>{communicationText(item.type || item.channel || "Communication")}</strong><span style={{ color: "#64748b", fontSize: 12 }}>{formatHistoryDateTime(communicationDate(item))}</span></div><div style={{ marginTop: 7, color: "#334155", fontSize: 13, whiteSpace: "pre-wrap" }}>{communicationBody(item) || communicationText(item.subject || item.description)}</div></div>
  )
  const renderCommunicationCards = (items, renderer, label) => items.length ? <div style={{ display: "grid", gap: 12 }}>{items.map(renderer)}</div> : communicationEmpty(label)
  return (
    <>
      <div className="container-fluid p-3">
        <div className="row mb-3 mx-0">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <h4 className="mb-0">{archivedOnly ? "Archived Job Orders" : isMyJobsView ? "My Job Orders" : "Job Orders"}</h4>
            <div />
              </div>
            </div>

        <div className="job-orders-filter-strip">
          {/* Status Filter Dropdown */}
                <div className="job-orders-filter-left">
                  <Input
                    type="select"
                    value={selectedStatusIdFilter}
                    onChange={e => setSelectedStatusIdFilter(e.target.value)}
              className="form-select job-orders-filter-select"
                  >
              <option value="">-- Select Status --</option>
                    {jobStatusList.map(item => (
                      <option key={item.id} value={item.id}>
                        {item.job_status}
                      </option>
                    ))}
                  </Input>
                </div>
          <div className="job-orders-filter-left">
                  <Input
                    type="select"
                    value={selectedCategoryName}
                    onChange={e => setSelectedCategoryName(e.target.value)}
              className="form-select job-orders-filter-select"
                  >
              <option value="">-- Select Category --</option>
                    {testTypeList.map(item => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Input>
                </div>

          <div className="job-orders-filter-actions">
            <div className="job-orders-company-inline">
              <div className="job-orders-company-control">
                <label>Select Company</label>
                <div className="job-orders-company-select">
                    <CompanySelector
                      onCompanyChange={c => {
                        const nextCompanyId = c?.company_id === "All" ? "all" : c?.company_id ?? null
                        setCompanyId(nextCompanyId)
                        if (nextCompanyId) {
                          sessionStorage.setItem("active-company-id", String(nextCompanyId))
                          const sessionToken = getSessionToken()
                          if (sessionToken) {
                            axios.defaults.headers.common.Authorization = sessionToken.toLowerCase().startsWith("bearer ")
                              ? sessionToken
                              : `Bearer ${sessionToken}`
                          }
                          try {
                            const activeUserInfo = JSON.parse(sessionStorage.getItem("user-info") || "{}")
                            activeUserInfo.active_company_id = nextCompanyId
                            sessionStorage.setItem("user-info", JSON.stringify(activeUserInfo))
                          } catch {
                            // Keep the selector usable if session storage contains invalid data.
                          }
                        } else {
                          sessionStorage.removeItem("active-company-id")
                        }
                      }}
                      selectedCompanyId={companyId ?? "All"}
                      showAllOption
                    />
                </div>
                  </div>
                </div>

            <div className="job-orders-search-inline">
              <InputGroup className="job-orders-search-group">
                    <Input
                      placeholder="Search with job title"
                      value={jobSearchText}
                      className="job-orders-search-input"
                      onChange={e => {
                        const value = e.target.value
                        setJobSearchText(value)
                    if (value === "") {
                      // getJobOrders(companyId, 1, perPage,);
                    }
                      }}
                      onKeyDown={e => {
                        if (e.key === "Enter") handleJobSearch(jobSearchText)
                      }}
                    />
                    {jobSearchText !== "" && (
                      <InputGroupText
                    className="job-orders-search-clear"
                    style={{
                      cursor: "pointer",
                      background: "transparent",
                      borderLeft: "none",
                    }}
                        onClick={() => {
                          setResetLoading(true)
                          setJobSearchText("")
                      //  getJobOrders(companyId, 1, perPage,);
                        }}
                      >
                        <FaTimes style={{ fontSize: "14px", color: "#6c757d" }} />
                      </InputGroupText>
                    )}
                    <Button
                      className="btn searchIconBtn import-res-btn job-orders-search-btn"
                      // onClick={handleJobSearch}
                      onClick={() => {
                          if (!jobSearchText.trim()) return; 
                          handleJobSearch(jobSearchText);
                        }}
                    >
                      <i className="fa fa-search" />
                    </Button>
                  </InputGroup>
            </div>

            <div>
              <button
                type="button"
                className="btn border-0 blueBtn job-orders-create-inline"
                onClick={() =>
                  navigate(`/create-job-orders-view`, {
                    state: { selectedCompanyId: companyId },
                  })
                }
              >
                Create Job Order
              </button>
            </div>
                </div>
              </div>

        <div className="p-1" id="JobOrderTableView"  style={{ position: "relative" }}>
             <div
                style={{
                  position: "absolute",
                  top: "27px",
                  left: "17px",
                  zIndex: 999,
                  fontSize: "16px",        
                  color: "#212529",
                  // cursor: "pointer",       
                }}
                title="View Candidate Details"
              >
                <FaPlus />
              </div>
                <DataTable
                  columns={jobColumns}
                  data={Array.isArray(jobOrdersData) ? jobOrdersData : []}
                  progressPending={loadingJobs}
                  expandableRows
                  expandableRowsComponent={CandidateExpansion}
                  highlightOnHover
                  pagination
                  persistTableHead
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
            paginationPerPage={perPage} // top-level table per page
                  paginationRowsPerPageOptions={[10, 15, 20, 50]}
                  onChangeRowsPerPage={async (newPerPage, page) => {
                    if (perPage !== newPerPage) {
                      setCurrentPage(1)
                      page = 1
                    }
                    setPerPage(newPerPage === -1 ? totalRows : newPerPage)
                    await getJobOrders(
                      companyId,
                      page,
                      newPerPage === -1 ? totalRows : newPerPage,
                      jobSearchText
                    )
                  }}
                  onChangePage={async page => {
                    setCurrentPage(page)
                    await getJobOrders(companyId, page, perPage, jobSearchText)
                  }}
                  onSelectedRowsChange={state =>
                    setSelectedJobs(state.selectedRows || [])
                  }
                  expandableIcon={{
                    collapsed: (
                      <span
                        style={{ fontSize: "18px", fontWeight: "bold" }}
                        className="expander-bubble"
                        title="Click to View Candidate Details"
                      >
                        &gt;
                      </span>
                    ),
                    expanded: (
                      <span
                        style={{ fontSize: "18px", fontWeight: "bold" }}
                        className="expander-bubble"
                      >
                        <FaMinus />
                      </span>
                    ),
                  }}
                  onRowExpandToggled={handleJobRowExpandToggled}
                  expandableRowExpanded={row => getJobRowId(row) === expandedRowId}
                  subHeader
                  paginationComponentOptions={paginationComponentOptions}
                  progressComponent={<OrgTableShimmer columns={6} rows={6} titleWidth="210px" />}
                  noDataComponent={
                    <div className="job-order-empty-state">
                      <i className="pi pi-briefcase" aria-hidden="true" />
                      <strong>No job orders available</strong>
                      <span>Try changing the filters or search criteria.</span>
                    </div>
                  }
                />
        </div>
      </div>

      {/* ---------- Add Candidate Modal ---------- */}
      <Modal
        isOpen={AddCandidateModal}
        toggle={isSubmitting ? undefined : AddCandidateForJobCall}
        centered
        backdrop={isSubmitting ? "static" : true}
        keyboard={!isSubmitting}
        className="job-order-add-candidate-modal"
        size="lg"
      >
        <ModalHeader
          toggle={isSubmitting ? undefined : AddCandidateForJobCall}
          className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header"
        >
          Add Candidate(s){selectedJobForUpload?.job_title ? ` — ${selectedJobForUpload.job_title}` : ""}
        </ModalHeader>

        <ModalBody className="job-order-add-candidate-body">
          {/* ✅ Tab Buttons */}
          <div className="job-order-upload-tabs">
            <button
              className={
                activeTab === "upload"
                  ? "btn border blueBtn"
                  : "btn light  mt-2 mb-2"
              }
              onClick={() => !isSubmitting && setActiveTab("upload")}
              disabled={isSubmitting && activeTab !== "upload"}
            >
              Upload Resume
            </button>

            <button
              className={
                activeTab === "existing"
                  ? "btn border blueBtn"
                  : "btn  light mt-2 mb-2"
              }
              onClick={() => !isSubmitting && setActiveTab("existing")}
              disabled={isSubmitting && activeTab !== "existing"}
            >
              Select Existing Candidates
            </button>
          </div>

          {/* ✅ TAB 1 - Upload Resumes */}
          {activeTab === "upload" && (
            <div
              className={`uploadFileClass ${isSubmitting ? "disabled" : ""}`}
              onDragOver={e => e.preventDefault()}
              onDrop={!isSubmitting ? resumeparsinguploadfiles : undefined}
              style={{
                border: "2px dashed #ccc",
                borderRadius: "10px",
                padding: "30px",
                textAlign: "center",
                cursor: isSubmitting ? "not-allowed" : "pointer",
                background: isSubmitting ? "#f8f9fa" : "white",
              }}
            >
              <input
                type="file"
                id="uploadPdfFiles"
                multiple
                accept=".doc,.docx,.pdf"
                style={{ display: "none" }}
                disabled={isSubmitting}
                onChange={resumeparsinguploadfiles}
              />
              <input
                type="file"
                id="uploadPdfFolder"
                webkitdirectory=""
                directory=""
                multiple
                style={{ display: "none" }}
                disabled={isSubmitting}
                onChange={resumeparsinguploadfiles}
              />

              <div className="job-order-upload-icon"><i className="pi pi-cloud-upload" /></div>
              <h5 className="job-order-upload-title">Upload resumes</h5>
              <p className="chooseFileSpan">Drag and drop resumes here, or choose from your device</p>
              <div className="job-order-upload-choices">
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                  disabled={isSubmitting}
                  onClick={e => {
                    e.stopPropagation()
                    document.getElementById("uploadPdfFiles").click()
                  }}
                >
                  <i className="pi pi-file me-1"></i>Choose Files
                </button>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                  disabled={isSubmitting}
                  onClick={e => {
                    e.stopPropagation()
                    document.getElementById("uploadPdfFolder").click()
                  }}
                >
                  <i className="pi pi-folder-open me-1"></i>Choose Folder
                </button>
              </div>
              <p className="hintText"><i className="pi pi-info-circle me-1" />PDF, DOC, and DOCX files up to 5 MB each</p>
            </div>
          )}

          {/* ✅ FILE LIST */}
          {activeTab === "upload" && selectedFiles.length > 0 && (
            <div className="job-order-selected-files">
              <div className="job-order-selected-files-header">
                <div>
                  <h6>Selected resumes</h6>
                  <span>{selectedFiles.length} {selectedFiles.length === 1 ? "file" : "files"} ready to upload</span>
                </div>
                <i className="pi pi-check-circle" aria-hidden="true" />
              </div>
              <div className="job-order-selected-files-list">
              {selectedFiles.map((item, index) => (
                <div
                  key={index}
                  className="resume-upload-file-card"
                >
                  <div className="resume-upload-file-icon">
                    {item.file.name.toLowerCase().endsWith(".pdf") ? (
                      <FaFilePdf className="resume-native-file-icon resume-file-pdf-icon" aria-label="PDF file" />
                    ) : item.file.name.toLowerCase().endsWith(".doc") || item.file.name.toLowerCase().endsWith(".docx") ? (
                      <FaFileWord className="resume-native-file-icon resume-file-word-icon" aria-label="Word file" />
                    ) : (
                      <img src={documentIcon} alt="document" height="30" width="30" />
                    )}
                  </div>
                  <div className="resume-upload-file-details">
                    <strong title={item.file.name}>{item.file.name}</strong>
                    <div className="resume-upload-file-properties">
                      <span><b>Format</b>{item.file.name.split(".").pop()?.toUpperCase()}</span>
                      <span><b>Size</b>{(item.file.size / 1024).toFixed(1)} KB</span>
                      <span><b>Type</b>{item.file.type || "Unavailable"}</span>
                      <span><b>Modified</b>{item.file.lastModified ? new Date(item.file.lastModified).toLocaleString() : "Unavailable"}</span>
                    </div>
                  </div>
                  <span className="resume-upload-file-ready">Ready to parse</span>
                  <img
                    src={deleteIcon}
                    alt="delete"
                    height="20"
                    width="20"
                    className="resume-upload-delete-icon"
                    title="Remove resume"
                    onClick={e => {
                      e.stopPropagation()
                      handleDeleteFile(index)
                    }}
                  />
                </div>
              ))}
              </div>
            </div>
          )}

          {/* ✅ TAB 2 - Select Existing Candidates */}
          {activeTab === "existing" && (
            <div className="job-order-existing-candidates" id="ExistingCandidate_MultiSel">
              <label
                style={{ fontWeight: 500, marginBottom: 5, display: "block" }}
              >
                Choose Candidates
              </label>

              <Multiselect
                showArrow
                options={candidateListingData}
                selectedValues={internalEmpSelectedValues1}
                onSelect={handleSelect}
                onRemove={handleSelect}
                displayValue="display_name"
                optionValue="candidate_id"
                placeholder="Select Candidates"
                hidePlaceholder
                showCheckbox
                avoidHighlightFirstOption
                selectedValueDecorator={() => (
                  <span title={getEmpTitleText1()}>{getEmpDisplayText1()}</span>
                )}
                style={{
                  inputField: {
                    textAlign:
                      internalEmpSelectedValues1 == 0 ? "left" : "right",
                    width: "90%",
                  },
                }}
              />
            </div>
          )}
        </ModalBody>

        <ModalFooter className="job-order-add-candidate-footer justify-content-center">
          <button
            className="btn border blueBtn"
            onClick={AddCandidateForJobCall}
            disabled={isSubmitting}
          >
            Cancel
          </button>

          <button
            className="btn border addBtn"
            onClick={handleUpload}
            disabled={isSubmitting}
          >
            {/* {isSubmitting
              ? (
                <div style={{ minWidth: 180 }}>
                  <div
                    style={{
                      height: 6,
                      borderRadius: 999,
                      background: "rgba(255,255,255,0.35)",
                      overflow: "hidden",
                      marginBottom: 4,
                    }}
                  >
                    <div
                      style={{
                        width: `${addCandidateProgress.percent || 0}%`,
                        height: "100%",
                        background: "#fff",
                        transition: "width 0.3s ease",
                      }}
                    />
                  </div>
                  <div style={{ fontSize: 12, fontWeight: 600 }}>
                    {addCandidateProgress.percent || 0}%
                  </div>
                </div>
              )
              : "Submit"} */}
              {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </ModalFooter>
      </Modal>

      {/* ---------- Delete Job Confirmation Modal ---------- */}
      <Modal
        isOpen={showDeleteJobModal}
        toggle={() => setShowDeleteJobModal(!showDeleteJobModal)}
        centered
      >
        <ModalHeader
          toggle={() => setShowDeleteJobModal(!showDeleteJobModal)}
          className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header"
        >
          Confirm Delete
        </ModalHeader>
        <ModalBody>
          Are you sure you want to delete job{" "}
          <strong>{jobToDelete?.job_title}</strong>?
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <RSButton
            color="secondary"
            onClick={() => setShowDeleteJobModal(false)}
          >
            Cancel
          </RSButton>
          <RSButton
            color="danger"
            onClick={confirmDeleteJob}
            disabled={deleteLoader}
          >
            {deleteLoader ? "Deleting.." : "Delete"}
          </RSButton>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={showDeleteCandidateModal}
        toggle={() => setShowDeleteCandidateModal(!showDeleteCandidateModal)}
        centered
      >
        <ModalHeader
          toggle={() => setShowDeleteCandidateModal(!showDeleteCandidateModal)}
          className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header"
        >
          Confirm Delete
        </ModalHeader>
        <ModalBody>
          <span className="justify-content-center">
            Are you sure you want to delete candidate <strong>{candidateNameToDelete}</strong>?
          </span>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <RSButton
            color="secondary"
            onClick={() => setShowDeleteCandidateModal(false)}
          >
            Cancel
          </RSButton>
          <RSButton
            color="danger"
            onClick={confirmDeleteCandidate}
            disabled={CandidateDeleteLoader}
          >
            {CandidateDeleteLoader ? "Deleting.." : "Delete"}
          </RSButton>
        </ModalFooter>
      </Modal>

      {/* ---------- Send Test Modal ---------- */}
      <Modal
        isOpen={showSendTestModal}
        toggle={() => setShowSendTestModal(false)}
      >
        <ModalHeader
          toggle={() => setShowSendTestModal(false)}
          className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header"
        >
          Send Test
        </ModalHeader>
        <ModalBody>
          <p>Test sent successfully</p>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <RSButton
            color="secondary"
            onClick={() => setShowSendTestModal(false)}
          >
            Ok
          </RSButton>
        </ModalFooter>
      </Modal>

      {/* ---------- Upgrade Modal ---------- */}
      <Modal
        isOpen={showSendTestModal}
        toggle={() => setShowSendTestModal(false)}
      >
        <ModalHeader
          toggle={() => setShowSendTestModal(false)}
          className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header"
        >
          Send Test
        </ModalHeader>
        <ModalBody>
          <p>
            Telephonic call logged for{" "}
            <strong>{telephonicJob?.job_title}</strong>
          </p>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <RSButton
            color="secondary"
            onClick={() => setShowSendTestModal(false)}
          >
            Ok
          </RSButton>
        </ModalFooter>
      </Modal>
      {/* ---------- Telephonic Call Modal ---------- */}

      {/* ---------- Send to HRMS Modal ---------- */}
      <Modal
        isOpen={showHrmsModal}
        toggle={() => setShowHrmsModal(!showHrmsModal)}
        centered
      >
        <ModalHeader
          toggle={() => setShowHrmsModal(false)}
          className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header"
        >
          Send to HRMS
        </ModalHeader>
        <ModalBody>
          <p>
            Send{" "}
            <strong>
              {hrmsPayload?.first_name ?? hrmsPayload?.candidate_name} {hrmsPayload?.middle_name ?? hrmsPayload?.candidate_name} {hrmsPayload?.last_name ?? hrmsPayload?.candidate_name}
            </strong>{" "}
            to HRMS?
          </p>
          <Label for="DesignationInput" className="d-block">
            Company <span className="text-danger">*</span>
          </Label>
          <CompanySelector
            onCompanyChange={handleCompanyChange}
            selectedCompanyId={hrmsCompanyId}
          />

          <Col>
            <div>
              <Label for="dateOfJoin" className="d-block">
                Date of Join <span className="text-danger">*</span>
              </Label>
              <DatePicker
                id="dateOfJoin"
                className="form-control"
                selected={joiningDate}
                onChange={date => setJoiningDate(date)}
                minDate={new Date()} // only current & future dates
                dateFormat="dd-MM-yyyy"
                placeholderText="Select Date of Join"
              />
            </div>
          </Col>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <RSButton color="secondary" onClick={() => setShowHrmsModal(false)}>
            Cancel
          </RSButton>
          {/* <RSButton color="primary" onClick={doSendToHrms}>Send</RSButton> */}
          <RSButton
            color="primary"
            onClick={doSendToHrms}
            disabled={loadingSendToHRMS}
          >
            {loadingSendToHRMS ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Sending...
              </>
            ) : (
              "Send"
            )}
          </RSButton>
        </ModalFooter>
      </Modal>

      {/* ---------- Status Modal ---------- */}
      <Modal isOpen={statusModal} 
      // toggle={() => setStatusModal(false)}
        toggle={() => {
    if (statusLoader) return;
    setStatusModal(false);
    setstatusError("");
  }}
          backdrop={statusLoader ? "static" : true}
  keyboard={!statusLoader}
        >
        <ModalHeader
          toggle={() => {
            setStatusModal(false)
            setstatusError("")
          }}
          className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header"
        >
          Update Status
        </ModalHeader>
        <ModalBody>
          <label className="fw-bold mt-4">Select Status</label>
          <Input
            type="select"
            value={selectedStatusId}
            onChange={e => {
              setSelectedStatusId(e.target.value)
              setstatusError("")
            }}
            className="mb-4"
          >
            <option value="">-- Select --</option>
            {jobStatusList.map(item => (
              <option key={item.id} value={item.id}>
                {item.job_status}
              </option>
            ))}
          </Input>
          <small className="text-danger">{statusError}</small>
        </ModalBody>

        <ModalFooter className="justify-content-center">
          <button
            className="btn blueBtn"
            disabled={candidateStatusLoader}
            onClick={() => {
              // setCandidateStatusModal(false)
              setStatusModal(false);
              setCandidateStatusError("")
              setReason("")
            }}
          >
            Cancel
          </button>
          <button
            className="btn addBtn"
            onClick={handleStatusUpdate}
            disabled={candidateStatusLoader}
          >
            {candidateStatusLoader ? "Updating..." : "Update"}
          </button>
          <button
            type="button"
            className="btn"
            disabled={candidateStatusLoader}
            onClick={() => {
              setCandidateStatusModal(false)
              setCandidateStatusError("")
              setReason("")
              setCandidateRejectedRound("")
              setIsSubmitted(false)
              setIsCandidateStatusDetailsEdit(false)
            }}
            style={{
              border: "1px solid #cbd5e1",
              background: "#eef2f7",
              color: "#334155",
              fontWeight: 600,
              minWidth: 84,
              padding: "7px 14px",
              fontSize: 13,
              borderRadius: 8,
            }}
          >
            Close
          </button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={communicationHistoryModal}
        toggle={() => setCommunicationHistoryModal(false)}
        size="xl"
        centered
        scrollable
        className="communication-history-modal"
      >
        <ModalHeader
          toggle={() => setCommunicationHistoryModal(false)}
          style={{
            padding: "16px 20px",
            border: "none",
            background: "linear-gradient(135deg, #eef6ff 0%, #f8fbff 100%)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span
              style={{
                width: 38,
                height: 38,
                borderRadius: 10,
                background: "#dbeafe",
                color: "#1d4ed8",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <FaHistory />
            </span>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div>
                <div style={{ fontWeight: 800, fontSize: 17, color: "#0f172a", lineHeight: 1.2 }}>
                  Communication History
                </div>
                <div style={{ display: "flex", alignItems: "baseline", gap: 6, marginTop: 5, color: "#475569" }}>
                  <span style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".04em" }}>
                    Candidate Name:
                  </span>
                  <strong style={{ fontSize: 14, color: "#0b5f95", fontWeight: 800 }}>
                    {communicationHistoryCandidate
                      ? `${communicationHistoryCandidate.first_name || ""} ${communicationHistoryCandidate.middle_name || ""} ${communicationHistoryCandidate.last_name || ""}`.trim() || communicationHistoryCandidate.candidate_name || "Candidate"
                      : "Candidate"}
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </ModalHeader>

        <ModalBody
          style={{
            maxHeight: "78vh",
            overflowY: "auto",
            overflowX: "hidden",
            scrollbarGutter: "stable",
            background: "#f6f9fc",
            padding: "14px 18px 18px",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
              gap: 10,
              background: "#f6f9fc",
              paddingBottom: 12,
            }}
          >
            {[
              { id: "whatsapp", label: "WhatsApp", count: candidateWhatsappHistory.length },
              { id: "sms", label: "SMS", count: candidateSmsTotal || candidateSmsHistory.length },
              { id: "calls", label: "Calls", count: candidateCallHistory.length },
              { id: "interview-emails", label: "Interview Emails", count: interviewEmailTemplateCount },
            ].map(tab => (
              <button
                type="button"
                key={tab.id}
                onClick={() => setCommunicationHistoryTab(tab.id)}
                style={{
                  minWidth: 0,
                  padding: "9px 12px",
                  fontSize: 12,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6,
                  whiteSpace: "nowrap",
                  borderRadius: 10,
                  border: communicationHistoryTab === tab.id ? "1px solid #93c5fd" : "1px solid #dbe4f0",
                  background: communicationHistoryTab === tab.id ? "#eff6ff" : "#ffffff",
                  color: communicationHistoryTab === tab.id ? "#0b5fc1" : "#475569",
                  fontWeight: 700,
                  boxShadow: communicationHistoryTab === tab.id ? "0 6px 14px rgba(37, 99, 235, 0.09)" : "none",
                }}
              >
                <span>{tab.label}</span>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: 20,
                    height: 20,
                    padding: "0 6px",
                    borderRadius: 999,
                    background: communicationHistoryTab === tab.id ? "#fff" : "#eef2ff",
                    color: "#334155",
                    fontSize: 11,
                    fontWeight: 700,
                    lineHeight: 1,
                  }}
                >
                  {tab.count}
                </span>
              </button>
            ))}
          </div>

          <div style={{ overflow: "visible" }}>
            {communicationHistoryError && !communicationHistoryLoading && (
              <div className="bo-alert mb-3" style={{ background: "#fef2f2", color: "#b91c1c" }}>
                {communicationHistoryError}
              </div>
            )}

            {communicationHistoryLoading ? (
              <div className="text-center py-4">
                <Spinner />
              </div>
            ) : communicationHistoryTab === "interview-emails" ? (
              interviewCommunicationRows.length > 0 ? (
                renderCommunicationCards(interviewCommunicationRows, renderCommunicationEmail, "interview email templates")
              ) : (
                <p className="text-center text-muted py-4 mb-0">No interview email templates found.</p>
              )
            ) : communicationHistoryTab === "emails" ? (
              candidateEmailHistory.length > 0 ? (
                <div style={{ display: "grid", gap: 12 }}>
                  {candidateEmailHistory.map((item, index) => (
                    <div
                      key={`${item.subject || "email"}-${index}`}
                      style={{
                        background: "#fff",
                        border: "1px solid #dbe4f0",
                        borderRadius: 14,
                        padding: 14,
                        boxShadow: "0 8px 22px rgba(15, 23, 42, 0.05)",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-start gap-3 mb-2">
                        <div>
                          <div className="fw-semibold" style={{ color: "#0f172a", fontSize: 14 }}>
                            {item.subject || item.title || "No Subject"}
                          </div>
                          <div style={{ fontSize: 12, color: "#64748b" }}>
                            From {item.sent_by || item.from_address || item.created_by_name || item.user_id || item.email || "--"}
                          </div>
                        </div>
                        <span style={{ fontSize: 12, color: "#64748b", whiteSpace: "nowrap" }}>
                          {formatHistoryDateTime(item.datetime || item.created_at || item.sent_at || item.timestamp)}
                        </span>
                      </div>
                      {item.to_addresses ? (
                        <div style={{ fontSize: 13, color: "#334155", marginBottom: 4 }}>
                          To: {item.to_addresses}
                        </div>
                      ) : null}
                      <div style={{ fontSize: 13, color: "#334155", marginBottom: 8 }}>
                        Type: {item.type || item.channel || "Email"}
                      </div>
                      {item.body || item.message || item.description ? (
                        looksLikeHtml(item.body || item.message || item.description) ? (
                          <div
                            style={{
                              marginTop: 6,
                              paddingTop: 8,
                              borderTop: "1px solid #e2e8f0",
                              overflow: "hidden",
                            }}
                          >
                            <div
                              style={{
                                overflow: "hidden",
                                padding: 0,
                                background: "#fff",
                                borderRadius: 10,
                                border: "1px solid #e2e8f0",
                                fontSize: 12,
                              }}
                            >
                              <iframe
                                title={`email-preview-${index}`}
                                srcDoc={getCommunicationHistoryEmailHtml(
                                  item.body || item.message || item.description
                                )}
                                sandbox=""
                                style={{
                                  width: "100%",
                                  height: 420,
                                  border: 0,
                                  display: "block",
                                  background: "#fff",
                                }}
                              />
                            </div>
                          </div>
                        ) : (
                          <div style={{ fontSize: 13, color: "#334155", whiteSpace: "pre-wrap", marginTop: 8 }}>
                            {item.body || item.message || item.description}
                          </div>
                        )
                      ) : null}
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-center text-muted py-4 mb-0">No sent email history found for this candidate.</p>
              )
            ) : communicationHistoryTab === "sms" ? (
              candidateSmsHistory.length > 0 ? (
                <div style={{ display: "grid", gap: 12 }}>
                  {candidateSmsHistory.map((item, index) => (
                    <div key={`${item?.sent_at || "sms"}-${index}`} className="border rounded-3 p-3" style={{ background: "#fff", borderColor: "#dbe4f0" }}>
                      <div className="d-flex justify-content-between align-items-start gap-3 mb-2">
                        <div className="fw-semibold" style={{ color: "#0f172a" }}>SMS notification</div>
                        <span style={{ fontSize: 12, color: "#64748b", whiteSpace: "nowrap" }}>{formatHistoryDateTime(item?.sent_at || item?.created_at || item?.timestamp)}</span>
                      </div>
                      <div style={{ fontSize: 13, color: "#334155", whiteSpace: "pre-wrap", marginBottom: 7 }}>{item?.message || item?.body || item?.text || "--"}</div>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 12, fontSize: 12, color: "#64748b" }}>
                        <span><strong>To:</strong> {item?.to_number || "--"}</span>
                        <span><strong>Status:</strong> {item?.status || "--"}</span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : <p className="text-center text-muted py-4 mb-0">No SMS history found for this candidate.</p>
            ) : communicationHistoryTab === "whatsapp" ? (
              candidateWhatsappHistory.length > 0 ? (
                <div style={{ display: "grid", gap: 12 }}>
                  {candidateWhatsappHistory.map((item, index) => (
                    <div
                      key={`${item?.sent_at || "whatsapp"}-${index}`}
                      className="border rounded-3 p-3"
                      style={{ background: "#fff", borderColor: "#e2e8f0" }}
                    >
                      <div className="d-flex justify-content-between align-items-start gap-3 mb-2">
                        <div>
                          <div className="fw-semibold d-flex align-items-center gap-2" style={{ color: "#0f172a" }}>
                            <FaWhatsapp style={{ color: "#16a34a" }} />
                            <span>{item?.job_title || item.title || "WhatsApp Outreach"}</span>
                          </div>
                          <div style={{ fontSize: 12, color: "#64748b" }}>
                            Candidate Added By : {item?.sent_by || item?.user || "--"}
                          </div>
                        </div>
                        <span style={{ fontSize: 12, color: "#64748b", whiteSpace: "nowrap" }}>
                          {formatHistoryDateTime(item?.sent_at || item?.created_at || item?.timestamp)}
                        </span>
                      </div>
                      {item?.subject ? (
                        <div style={{ fontSize: 13, color: "#334155", marginBottom: 6 }}>
                          Subject: {item?.subject}
                        </div>
                      ) : null}
                      <div style={{ fontSize: 13, color: "#334155", whiteSpace: "pre-wrap" }}>
                        {item?.body_template || item?.body || item?.message || "--"}
                      </div>
                      {item?.error ? (
                        <div style={{ fontSize: 12, color: "#b91c1c", marginTop: 8 }}>
                          Error: {item?.error}
                        </div>
                      ) : null}
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-center text-muted py-4 mb-0">No WhatsApp history found for this candidate.</p>
              )
            ) : candidateCallHistory.length > 0 ? (
              <div style={{ display: "grid", gap: 12 }}>
                {candidateCallHistory.map((item, index) => (
                  <div
                    key={`${item.id || item.calldate || "call"}-${index}`}
                    className="border rounded-3 p-3"
                    style={{ background: "#fff", borderColor: "#e2e8f0" }}
                  >
                    {(() => {
                      const firstRecording = Array.isArray(item.recordings) && item.recordings.length > 0 ? item.recordings[0] : null
                      const callType = item?.type || firstRecording?.callstatus || "Unknown"
                      const callStatus = item?.disposition || item?.status || firstRecording?.disposition || "Completed"
                      const callExtension = item?.extension || firstRecording?.extension || "--"
                      const candidateName =
                        item?.candidate_name ||
                        item?.name ||
                        `${communicationHistoryCandidate?.first_name || ""} ${communicationHistoryCandidate?.last_name || ""}`.trim() ||
                        communicationHistoryCandidate?.candidate_name ||
                        "Unknown"

                      return (
                        <>
                    <div className="d-flex justify-content-between align-items-start gap-3 mb-2">
                      <div>
                        <div className="d-flex flex-wrap gap-2 mt-2" style={{ fontSize: 12, color: "#334155" }}>
                          <span style={{ color: "#64748b", fontWeight: 600 }}>Candidate:</span>
                          <span
                            style={{
                              minWidth: 0,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: 260,
                            }}
                            title={candidateName}
                          >
                            {candidateName}
                          </span>
                        </div>
                      </div>
                      <span style={{ fontSize: 12, color: "#64748b", whiteSpace: "nowrap" }}>
                        {formatHistoryDateTime(item?.calldate || item?.created_at || item?.timestamp)}
                      </span>
                    </div>
                    <div
                      className="mb-3"
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                        gap: "8px 14px",
                        fontSize: 12,
                        color: "#334155",
                        background: "#f8fafc",
                        border: "1px solid #e2e8f0",
                        borderRadius: 10,
                        padding: "10px 12px",
                      }}
                    >
                      <div><strong>Call Type :</strong> {callType}</div>
                      <div><strong>Status :</strong> {callStatus}</div>
                      <div><strong>Extension :</strong> {callExtension}</div>
                      <div><strong>Date :</strong> {formatHistoryDateTime(item.calldate || item.created_at || item.timestamp)}</div>
                    </div>
                    </>
                      )
                    })()}
                    {Array.isArray(item.recordings) && item.recordings.length > 0 ? (
                      <div className="mt-3" style={{ display: "grid", gap: 10 }}>
                        {item.recordings.map((recording, recIndex) => {
                          const recordingUrl = recording?.recording_url || recording?.url || ""
                          const playUrl = getRecordingPlayUrl(recordingUrl)
                          const recordingKey = getCallRecordingKey(item, recording, recIndex)
                          const recordingComment = callRecordingComments[recordingKey] || item.comments || ""
                          const recordingCommentDraft = callRecordingCommentDrafts[recordingKey] ?? item.comments ?? ""
                          return (
                            <div
                              key={`${item.call_id || item.calldate || "call"}-${recording?.id || recordingUrl || recIndex}`}
                              className="rounded-3 p-3"
                              style={{
                                background: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
                                border: "1px solid #fde68a",
                              }}
                            >
                              <div className="d-flex justify-content-between align-items-start gap-3 mb-3">
                                <div>
                                  <div className="fw-semibold" style={{ color: "#92400e", fontSize: 13 }}>
                                    Recording {recIndex + 1}
                                  </div>
                                  <div style={{ fontSize: 12, color: "#b45309" }}>
                                    Extension: {recording?.extension || item.extension || "--"} • Recruiter : {recording?.extname || item.extname || "--"}
                                  </div>
                                </div>
                                <span style={{ fontSize: 12, color: "#92400e", whiteSpace: "nowrap" }}>
                                  {formatHistoryDateTime(recording?.calldate || recording?.created_at || item.calldate || item.created_at)}
                                </span>
                              </div>
                              <div
                                className="mb-3"
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                                  gap: "8px 16px",
                                  fontSize: 12,
                                  color: "#92400e",
                                }}
                              >
                                <div><strong>Call Status:</strong> {recording?.callstatus || item.callstatus || "--"}</div>
                                <div><strong>Disposition:</strong> {recording?.disposition || item.disposition || "--"}</div>
                                <div><strong>From:</strong> {recording?.src || item.src || "--"}</div>
                                <div><strong>To:</strong> {recording?.dst || item.dst || "--"}</div>
                                <div><strong>Call Date:</strong> {formatHistoryDateTime(recording?.calldate || item.calldate || item.created_at)}</div>
                                <div><strong>Duration:</strong> {recording?.billsec || item.billsec || "--"} sec</div>
                              </div>
                              {playUrl ? (
                                <CommunicationRecordingPlayer
                                  src={playUrl}
                                  currentPlayingRef={communicationCurrentPlayingRef}
                                />
                              ) : (
                                <div style={{ fontSize: 12, color: "#b91c1c" }}>
                                  Recording unavailable
                                </div>
                              )}
                              <div
                                className="mt-2"
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "max-content minmax(220px, 1fr) 140px 160px",
                                  alignItems: "center",
                                  gap: 10,
                                  width: "100%",
                                }}
                              >
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    padding: "4px 10px",
                                    borderRadius: 999,
                                    background: "#dcfce7",
                                    color: "#15803d",
                                    border: "1px solid #86efac",
                                    fontSize: 12,
                                    fontWeight: 700,
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Status: Contacted
                                </span>
                                <Input
                                  type="text"
                                  value={recordingCommentDraft}
                                  placeholder="Comment"
                                  title={recordingComment || recordingCommentDraft || "Comment"}
                                  onChange={e => updateCallRecordingCommentDraft(recordingKey, e.target.value)}
                                  style={{ fontSize: 13, height: 31, minWidth: 0, width: "100%" }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-sm blueBtn"
                                  onClick={() => writeCallRecordingComment(recordingKey, item.call_id || item.id)}
                                  style={{ whiteSpace: "nowrap", padding: "4px 8px", width: "100%", marginLeft: 8 }}
                                >
                                  Write Comment
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={() =>
                                    openCallRecordingDetail({
                                      call: item,
                                      recording,
                                      recordingKey,
                                      recordingIndex: recIndex,
                                      playUrl,
                                    })
                                  }
                                  style={{ whiteSpace: "nowrap", padding: "4px 8px", width: "100%" }}
                                >
                                  View All Comments
                                </button>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    ) : item.recording_url ? (
                      (() => {
                        const recording = { ...item, recording_url: item.recording_url }
                        const playUrl = getRecordingPlayUrl(item.recording_url)
                        const recordingKey = getCallRecordingKey(item, recording, 0)
                       const recordingComment = callRecordingComments[recordingKey] || item.comments || ""
                      const recordingCommentDraft = callRecordingCommentDrafts[recordingKey] ?? item.comments ?? ""

                        return (
                          <div className="mt-3 rounded-3 p-3" style={{ background: "#fffbeb", border: "1px solid #fde68a" }}>
                            <CommunicationRecordingPlayer
                              src={playUrl}
                              currentPlayingRef={communicationCurrentPlayingRef}
                            />
                            <div
                              className="mt-2"
                              style={{
                                display: "grid",
                                gridTemplateColumns: "max-content minmax(220px, 1fr) 140px 160px",
                                alignItems: "center",
                                gap: 10,
                                width: "100%",
                              }}
                            >
                              <span
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  padding: "4px 10px",
                                  borderRadius: 999,
                                  background: "#dcfce7",
                                  color: "#15803d",
                                  border: "1px solid #86efac",
                                  fontSize: 12,
                                  fontWeight: 700,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Status: Contacted
                              </span>
                              <Input
                                type="text"
                                value={recordingCommentDraft}
                                placeholder="Comment"
                                title={recordingComment || recordingCommentDraft || "Comment"}
                                onChange={e => updateCallRecordingCommentDraft(recordingKey, e.target.value)}
                                style={{ fontSize: 13, height: 31, minWidth: 0, width: "100%" }}
                              />
                              <button
                                type="button"
                                className="btn btn-sm blueBtn"
                                onClick={() => writeCallRecordingComment(recordingKey, item.call_id || item.id)}
                                style={{ whiteSpace: "nowrap", padding: "4px 8px", width: "100%", marginLeft: 8 }}
                              >
                                Write Comment
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                onClick={() =>
                                  openCallRecordingDetail({
                                    call: item,
                                    recording,
                                    recordingKey,
                                    recordingIndex: 0,
                                    playUrl,
                                  })
                                }
                                style={{ whiteSpace: "nowrap", padding: "4px 8px", width: "100%" }}
                              >
                                View All Comments
                              </button>
                            </div>
                          </div>
                        )
                      })()
                    ) : null}
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-center text-muted py-4 mb-0">No extension call logs found for this candidate.</p>
            )}
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={callRecordingDetailModal}
        toggle={() => setCallRecordingDetailModal(false)}
        centered
        size="lg"
      >
        <ModalHeader toggle={() => setCallRecordingDetailModal(false)}>
          Audio Log Details
        </ModalHeader>
        <ModalBody>
          {selectedCallRecordingDetail ? (
            (() => {
              const { call, recording, recordingKey, recordingIndex, playUrl } = selectedCallRecordingDetail
              const comment = callRecordingComments[recordingKey] || ""
              const commentDraft = getCallRecordingCommentDraft(recordingKey)
              const candidateName =
                call?.candidate_name ||
                call?.name ||
                `${communicationHistoryCandidate?.first_name || ""} ${communicationHistoryCandidate?.last_name || ""}`.trim() ||
                communicationHistoryCandidate?.candidate_name ||
                "Unknown"

              return (
                <div style={{ display: "grid", gap: 14 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 12,
                      flexWrap: "wrap",
                    }}
                  >
                    <div>
                      <div className="fw-semibold" style={{ color: "#0f172a", fontSize: 16 }}>
                        Recording {(recordingIndex ?? 0) + 1}
                      </div>
                      <div style={{ fontSize: 13, color: "#64748b" }}>{candidateName}</div>
                    </div>

                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        padding: "4px 12px",
                        borderRadius: 999,
                        background: "#dcfce7",
                        color: "#15803d",
                        border: "1px solid #86efac",
                        fontSize: 12,
                        fontWeight: 700,
                      }}
                    >
                      Status: Contacted
                    </span>
                  </div>

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                      gap: "10px 16px",
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                      borderRadius: 10,
                      padding: "12px 14px",
                      fontSize: 13,
                      color: "#334155",
                    }}
                  >
                    <div><strong>Call Status:</strong> {recording?.callstatus || call?.callstatus || "--"}</div>
                    <div><strong>Disposition:</strong> {recording?.disposition || call?.disposition || call?.status || "--"}</div>
                    <div><strong>Extension:</strong> {recording?.extension || call?.extension || "--"}</div>
                    <div><strong>Recruiter:</strong> {recording?.extname || call?.extname || "--"}</div>
                    <div><strong>From:</strong> {recording?.src || call?.src || "--"}</div>
                    <div><strong>To:</strong> {recording?.dst || call?.dst || "--"}</div>
                    <div><strong>Call Date:</strong> {formatHistoryDateTime(recording?.calldate || call?.calldate || call?.created_at || call?.timestamp)}</div>
                    <div><strong>Duration:</strong> {recording?.billsec || call?.billsec || "--"} sec</div>
                  </div>

                  {playUrl ? (
                    <CommunicationRecordingPlayer
                      src={playUrl}
                      currentPlayingRef={communicationCurrentPlayingRef}
                    />
                  ) : (
                    <div style={{ fontSize: 12, color: "#b91c1c" }}>
                      Recording unavailable
                    </div>
                  )}

                  <div>
                    <label className="fw-semibold mb-1" style={{ display: "block", fontSize: 13 }}>
                      Comment
                    </label>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "minmax(220px, 1fr) minmax(150px, 0.35fr)",
                        gap: 10,
                        width: "100%",
                      }}
                    >
                      <Input
                        type="text"
                        value={commentDraft}
                        placeholder="Write comment"
                        onChange={e => updateCallRecordingCommentDraft(recordingKey, e.target.value)}
                        style={{ fontSize: 12, minWidth: 0, width: "100%" }}
                      />
                      <button
                        type="button"
                        className="btn btn-sm blueBtn"
                        onClick={() => writeCallRecordingComment(recordingKey, call.call_id || call.id)}
                        style={{ whiteSpace: "nowrap", width: "100%" }}
                      >
                        Add Comment
                      </button>
                    </div>
                    {comment ? (
                      <div className="mt-2" style={{ fontSize: 13, color: "#334155" }}>
                        <strong>Comment:</strong> {comment}
                      </div>
                    ) : null}
                  </div>
                </div>
              )
            })()
          ) : (
            <p className="text-muted mb-0">No audio log selected.</p>
          )}
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <Button className="btn blueBtn" onClick={() => setCallRecordingDetailModal(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={historyModalOpen}
        toggle={() => setHistoryModalOpen(!historyModalOpen)}
        size="lg"
      >
        <ModalHeader
          toggle={() => setHistoryModalOpen(false)}
          className="modal-header_box blueBtn p-3 d-flex justify-content-between modal-header m-0"
        >
          Candidate Test History{" "}
          {historyTestData && (
            <>
              – {historyTestData.first_name} {historyTestData.last_name}
            </>
          )}
        </ModalHeader>

        <ModalBody
          style={{
            maxHeight: "70vh",
            overflowY: "auto",
            scrollbarWidth: "thin",
            scrollbarColor: "#0d6efd33 transparent",
          }}
        >
          {loadingHistory ? (
            <div className="text-center py-4">
              <Spinner />
            </div>
          ) : historyData && historyData.length > 0 ? (
            <div
              style={{
                position: "relative",
                marginLeft: "30px",
                paddingLeft: "20px",
              }}
            >
              {/* Vertical line */}
              <div
                style={{
                  content: '""',
                  position: "absolute",
                  left: "8px",
                  top: 0,
                  bottom: 0,
                  width: "2px",
                  background: "#0d6efd33",
                }}
              ></div>

              {historyData.map((item, index) => (
                <div
                  key={index}
                  style={{ position: "relative", marginBottom: "25px" }}
                >
                  {/* Timeline dot */}
                  <div
                    style={{
                      position: "absolute",
                      left: "-2px",
                      top: "12px",
                      width: "12px",
                      height: "12px",
                      background: "#0d6efd",
                      borderRadius: "50%",
                      border: "2px solid white",
                      boxShadow: "0 0 0 2px #0d6efd33",
                    }}
                  ></div>

                  {/* Card */}
                  <div
                    className="card shadow-sm border-0 p-3"
                    style={{
                      marginLeft: "25px",
                      borderRadius: "10px",
                      background: "#fff",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.transform = "translateY(-2px)"
                      e.currentTarget.style.boxShadow =
                        "0 4px 10px rgba(0, 0, 0, 0.08)"
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.transform = "none"
                      e.currentTarget.style.boxShadow =
                        "0 2px 6px rgba(0,0,0,0.04)"
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <h6 className="fw-bold mb-0 text-primary">
                        {item.job_name || "Untitled Job"}
                      </h6>
                      <small className="text-muted">
                        {item.sent_at || "—"}
                      </small>
                    </div>

                    <hr className="my-2" />

                    <p className="mb-1">
                      <strong>Candidate:</strong> {item.candidate_name || "—"}
                    </p>
                    <p className="mb-1">
                      <strong>Job ID:</strong> {item.job_id || "—"}
                    </p>
                    <p className="mb-1">
                      <strong>Sent By:</strong> {item.sent_by_name || "—"}
                    </p>
                    <p className="mb-0">
                      <strong>Email:</strong>{" "}
                      <a
                        href={`mailto:${item.sent_by_email}`}
                        className="text-decoration-none"
                      >
                        {item.sent_by_email}
                      </a>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-center text-muted py-4">
              No history found for this candidate.
            </p>
          )}
        </ModalBody>
        {actionTimelineModal.kind === "job" && actionTimelineModal.count > actionTimelineModal.page * actionTimelineModal.size && (
          <ModalFooter className="justify-content-between">
            <small className="text-muted">
              {((actionTimelineModal.page - 1) * actionTimelineModal.size) + 1}-{Math.min(actionTimelineModal.page * actionTimelineModal.size, actionTimelineModal.count)} of {actionTimelineModal.count}
            </small>
            <Button
              color="primary"
              size="sm"
              onClick={() => fetchJobTimeline(actionTimelineModal.jobId, actionTimelineModal.page + 1)}
            >
              Next
            </Button>
          </ModalFooter>
        )}
      </Modal>
      {reviewedEmailRequest && (
        <EmailAC
          key={reviewedEmailRequest.requestId}
          selectedData={reviewedEmailRequest.candidates}
          jobData={reviewedEmailRequest.job}
          showDropdown={false}
          buttonStyle={{ display: "none" }}
          openRequest={reviewedEmailRequest}
          onClose={() => setReviewedEmailRequest(null)}
        />
      )}
      <Modal
        isOpen={scheduleReviewModal}
        toggle={closeScheduleCandidateReview}
        centered
        size="xl"
        className="schedule-review-modal"
        backdrop={scheduleReviewSaving ? "static" : true}
        keyboard={!scheduleReviewSaving}
      >
        <ModalHeader
          toggle={scheduleReviewSaving ? undefined : closeScheduleCandidateReview}
          className="schedule-review-header"
        >
          <div className="schedule-review-title-wrap">
            <div className="schedule-review-title-icon">
              <FiBriefcase />
            </div>
            <div>
              <div className="schedule-review-title">Review Candidate Details</div>
              <div className="schedule-review-subtitle">Review candidate details before {candidateReviewAction === "email" ? "sending email" : candidateReviewAction === "outreach" ? "bulk outreach" : "scheduling the interview"}</div>
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="schedule-review-body">
          <div className="schedule-review-summary">
            <div>
              <span className="schedule-review-summary-label">Selected candidates</span>
              <strong>{scheduleReviewRows.length}</strong>
            </div>
            <div>
              <span className="schedule-review-summary-label">Job</span>
              <strong title={scheduleReviewJob?.job_title || ""}>
                {scheduleReviewJob?.job_title || "Interview"}
              </strong>
            </div>
            <div>
              <span className="schedule-review-summary-label">Required fields</span>
              <strong>Name, email, salary, notice</strong>
            </div>
          </div>

          {scheduleReviewError && (
            <div className="schedule-review-error">
              <FaInfoCircle />
              {scheduleReviewError}
            </div>
          )}

          <div className="schedule-review-list">
            {scheduleReviewRows.map((row, index) => (
              <div
                key={`${row.candidate_id || row.row_id || index}-${index}`}
                className="schedule-review-card"
              >
                <div className="schedule-review-card-header">
                  <div className="schedule-review-candidate-meta">
                    <div className="schedule-review-avatar">
                      {String(row.first_name || row.email || "C").slice(0, 1).toUpperCase()}
                    </div>
                    <div>
                      <div className="schedule-review-candidate-title">
                        {[row.first_name, row.middle_name, row.last_name].filter(value => String(value || "").trim()).join(" ").trim() || "Candidate name required"}
                      </div>
                      <div className="schedule-review-candidate-email">
                        <FiMail />
                        <span title={row.email || ""}>{row.email || "Email required"}</span>
                      </div>
                    </div>
                  </div>
                  <div className="schedule-review-job-pill" title={row.job_title || scheduleReviewJob?.job_title || ""}>
                    {row.job_title || scheduleReviewJob?.job_title || ""}
                  </div>
                </div>

                <Row className="g-3 schedule-review-fields">
                  <Col md={3}>
                    <Label className="schedule-review-label">First Name <span>*</span></Label>
                    <Input
                      className="schedule-review-input"
                      value={row.first_name || ""}
                      disabled={scheduleReviewSaving}
                      onChange={e => handleScheduleReviewChange(index, "first_name", e.target.value)}
                    />
                  </Col>
                  <Col md={3}>
                    <Label className="schedule-review-label">Middle Name</Label>
                    <Input
                      className="schedule-review-input"
                      value={row.middle_name || ""}
                      disabled={scheduleReviewSaving}
                      onChange={e => handleScheduleReviewChange(index, "middle_name", e.target.value)}
                    />
                  </Col>
                  <Col md={3}>
                    <Label className="schedule-review-label">Last Name</Label>
                    <Input
                      className="schedule-review-input"
                      value={row.last_name || ""}
                      disabled={scheduleReviewSaving}
                      onChange={e => handleScheduleReviewChange(index, "last_name", e.target.value)}
                    />
                  </Col>
                  <Col md={3}>
                    <Label className="schedule-review-label">Email <span>*</span></Label>
                    <Input
                      className="schedule-review-input"
                      type="email"
                      value={row.email || ""}
                      disabled={scheduleReviewSaving}
                      onChange={e => handleScheduleReviewChange(index, "email", e.target.value)}
                    />
                  </Col>
                  <Col md={4}>
                    <Label className="schedule-review-label">Current Salary <span>*</span></Label>
                    <Input
                      className="schedule-review-input"
                      value={row.current_salary || ""}
                      disabled={scheduleReviewSaving}
                      onChange={e => handleScheduleReviewChange(index, "current_salary", e.target.value)}
                    />
                  </Col>
                  <Col md={4}>
                    <Label className="schedule-review-label">Expected Salary <span>*</span></Label>
                    <Input
                      className="schedule-review-input"
                      value={row.expected_salary || ""}
                      disabled={scheduleReviewSaving}
                      onChange={e => handleScheduleReviewChange(index, "expected_salary", e.target.value)}
                    />
                  </Col>
                  <Col md={4}>
                    <Label className="schedule-review-label">Notice Period <span>*</span></Label>
                    <Input
                      className="schedule-review-input"
                      value={row.notice_period || ""}
                      disabled={scheduleReviewSaving}
                      onChange={e => handleScheduleReviewChange(index, "notice_period", e.target.value)}
                    />
                  </Col>
                </Row>
              </div>
            ))}
          </div>
        </ModalBody>
        <ModalFooter className="schedule-review-footer">
          <Button className="schedule-review-cancel" outline onClick={closeScheduleCandidateReview} disabled={scheduleReviewSaving}>
            Cancel
          </Button>
          <Button className="schedule-review-primary" onClick={saveScheduleReviewAndOpenInterview} disabled={scheduleReviewSaving}>
            {scheduleReviewSaving ? (
              <>
                <Spinner size="sm" className="me-2" /> Saving...
              </>
            ) : (
              `Save & ${candidateReviewActionLabel}`
            )}
          </Button>
        </ModalFooter>
      </Modal>

      {/* 🔹 HRMS Send History Modal */}
      <ScheduleInterviewDialog
        candidateReviewHandled
        visible={scheduleInterviewModalOpen}
        onHide={() => {
          setScheduleInterviewModalOpen(false)
          setScheduleInterviewCandidate(null)
          setScheduleInterviewCandidates([])
          setScheduleInterviewJob(null)
        }}
        companyId={
          scheduleInterviewCandidate?.company ||
          scheduleInterviewCandidate?.company_id ||
          scheduleInterviewJob?.company_id ||
          companyId
        }
        candidate={scheduleInterviewCandidate}
        candidates={scheduleInterviewCandidates}
        currentJobId={scheduleInterviewJob?.job_id || scheduleInterviewJob?.id}
        jobTitle={scheduleInterviewJob?.job_title || ""}
        disableCompany
        onScheduled={() => {
          getJobOrders(companyId, currentPage, perPage, jobSearchText)
          const scheduledJobId = scheduleInterviewJob?.job_id || scheduleInterviewJob?.id
          if (scheduledJobId) {
            setSelectedCandidateRows(prev => {
              const updated = { ...prev }
              delete updated[scheduledJobId]
              return updated
            })
            setSelectedCandidateRowData(prev => {
              const updated = { ...prev }
              delete updated[scheduledJobId]
              return updated
            })
          }
          setScheduleInterviewModalOpen(false)
          setScheduleInterviewCandidate(null)
          setScheduleInterviewCandidates([])
          setScheduleInterviewJob(null)
        }}
      />

      <Modal
        isOpen={showSendHRMSHistoryModal}
        toggle={() => setShowSendHRMSHistoryModal(false)}
        centered
      >
        <ModalHeader
          toggle={() => setShowSendHRMSHistoryModal(false)}
          className="modal-header_box blueBtn p-3 d-flex justify-content-between align-items-center m-0"
        >
          <h6 className="m-0 text-white fw-semibold">
            HRMS Send History
            {showSendHRMSHistoryData && (
              <>
                {" "}
                – {showSendHRMSHistoryData.first_name}{" "}
                {showSendHRMSHistoryData.middle_name}{" "}
                {showSendHRMSHistoryData.last_name}
              </>
            )}
          </h6>
        </ModalHeader>

        <ModalBody className="p-4">
          {showSendHRMSHistoryData ? (
            <div
              className="border rounded-3 p-3 shadow-sm"
              style={{ background: "#f8f9fa" }}
            >
              <p className="mb-2">
                <strong>📅 Sent On:</strong>{" "}
                {showSendHRMSHistoryData.sent_to_hrms_timeline || "N/A"}
              </p>
              <p className="mb-2">
                <strong>👤 Sent By:</strong>{" "}
                {showSendHRMSHistoryData.sent_by_name || "N/A"}
              </p>
              <p className="mb-0">
                <strong>📧 Email:</strong>{" "}
                {showSendHRMSHistoryData.sent_by_email || "N/A"}
              </p>
            </div>
          ) : (
            <p className="text-center m-0">No history available.</p>
          )}
        </ModalBody>
      </Modal>

      <SuccessErrorPopup
        show={errorAlert}
        handleClose={handleCloseErrorModal}
        errorMessage={errorMessage}
        isSuccess={isSuccess}
      />
      <JobInformationModal
        isOpen={showJobDetailsModal}
        onClose={() => setShowJobDetailsModal(false)}
        job={selectedJobDetails}
        onCopy={handleCopyContent}
      />
      <Modal
        isOpen={actionTimelineModal.open}
        toggle={() => setActionTimelineModal(previous => ({ ...previous, open: false }))}
        centered
        size="lg"
        className="action-timeline-modal"
      >
        <ModalHeader
          toggle={() => setActionTimelineModal(previous => ({ ...previous, open: false }))}
          className="action-timeline-header"
        >
          <div className="action-timeline-heading">
            <span className="action-timeline-heading-icon"><i className="pi pi-history" /></span>
            <span>
              <span className="action-timeline-title">{actionTimelineModal.title}</span>
              <span className="action-timeline-subtitle">Recent activity for this job</span>
            </span>
            <span className="action-timeline-count">{actionTimelineModal.count || 0} total</span>
          </div>
        </ModalHeader>
        <ModalBody className="action-timeline-body">
          {!actionTimelineModal.records?.length ? (
            <div className="action-timeline-empty">
              <span className="action-timeline-empty-icon"><i className="pi pi-inbox" /></span>
              <strong>No activity yet</strong>
              <span>No action logs were found for this job.</span>
            </div>
          ) : (
            <div className="action-timeline-list">
              {actionTimelineModal.records.map((record, index) => (
                <article className="action-timeline-item" key={record?.id || record?.action_id || index}>
                  <div className="action-timeline-rail">
                    <span className="action-timeline-dot"><i className="pi pi-bolt" /></span>
                  </div>
                  <div className="action-timeline-card">
                    <div className="action-timeline-card-top">
                      <span className="action-timeline-badge">{getTimelineAction(record)}</span>
                      <time><i className="pi pi-clock" /> {getTimelineDate(record)}</time>
                    </div>
                    <p className="action-timeline-description">
                      {getActivityDescription(record)}
                    </p>
                    <div className="action-timeline-meta">
                      <span><i className="pi pi-user" /> {getTimelineActor(record)}</span>
                      {record?.module_name && <span><i className="pi pi-folder" /> {record.module_name}</span>}
                    </div>
                    {isQuestionGenerationRecord(record) ? (
                      <div className="question-activity-preview">
                        <div><i className="pi pi-sparkles" /><span>{record?.change_details?.heading || "Question generation details"}</span></div>
                        <Button color="primary" size="sm" onClick={() => setQuestionActivityRecord(record)}>
                          View questions <i className="pi pi-arrow-up-right" />
                        </Button>
                      </div>
                    ) : (
                      (
                        (record?.change_details && Object.keys(record.change_details).length > 0) ||
                        (record?.metadata?.fields && Object.keys(record.metadata.fields).length > 0) ||
                        (record?.metadata?.changes && Object.keys(record.metadata.changes).length > 0)
                      ) && (
                        <div className="action-timeline-change-box">
                          <div className="action-timeline-change-title"><i className="pi pi-pencil" /> Change details</div>
                          <TimelineChanges record={record} />
                        </div>
                      )
                    )}
                    <TimelineMetadata record={record} />
                  </div>
                </article>
              ))}
            </div>
          )}
        </ModalBody>
        {actionTimelineModal.kind === "job" && actionTimelineModal.count > actionTimelineModal.page * actionTimelineModal.size && (
          <ModalFooter className="action-timeline-footer">
            <span>
              Showing {((actionTimelineModal.page - 1) * actionTimelineModal.size) + 1}
              –{Math.min(actionTimelineModal.page * actionTimelineModal.size, actionTimelineModal.count)} of {actionTimelineModal.count}
            </span>
            <Button
              color="primary"
              className="action-timeline-next"
              disabled={loadingJobTimelineId === actionTimelineModal.jobId}
              onClick={() => fetchJobTimeline(actionTimelineModal.jobId, actionTimelineModal.page + 1)}
            >
              {loadingJobTimelineId === actionTimelineModal.jobId ? "Loading..." : <>Next <i className="pi pi-arrow-right" /></>}
            </Button>
          </ModalFooter>
        )}
      </Modal>
      <Modal
        isOpen={Boolean(questionActivityRecord)}
        toggle={() => setQuestionActivityRecord(null)}
        centered
        size="xl"
        className="question-activity-modal"
      >
        <ModalHeader toggle={() => setQuestionActivityRecord(null)} className="question-activity-modal-header">
          <div className="question-activity-modal-heading">
            <span className="question-activity-modal-icon"><i className="pi pi-sparkles" /></span>
            <div>
              <strong>{questionActivityRecord?.change_details?.heading || "Question Activity"}</strong>
              <span>{questionActivityRecord?.action_date || "Generation details"}</span>
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="question-activity-modal-body">
          {questionActivityRecord && <QuestionGenerationDetails record={questionActivityRecord} />}
        </ModalBody>
      </Modal>
      <BulkCandidateStageModal
        jobId={bulkStageJobId}
        selectedCompanyId={companyId}
        authToken={getSessionToken()}
        ids={bulkStageSelection[bulkStageJobId] || []}
        candidates={Object.values(selectedCandidateRowData[bulkStageJobId] || {}).filter(row =>
          (bulkStageSelection[bulkStageJobId] || []).includes(row.bulk_application_id)
        ).map(row => ({
          id: row.bulk_application_id,
          name: getCandidateFullName(row),
          stage: getCandidateStatusText(row),
          reason: row.pipeline_logs?.[row.pipeline_logs.length - 1]?.reason || row.reason || "--",
        }))}
        stages={stagesList}
        onClose={() => setBulkStageJobId(null)}
        onProcessed={(jobId, successful) => {
          const succeeded = id => successful.includes(applicationId(selectedCandidateRowData[jobId]?.[id]?.bulk_application_id))
          setSelectedCandidateRows(previous => ({ ...previous, [jobId]: (previous[jobId] || []).filter(id => !succeeded(id)) }))
          setSelectedCandidateRowData(previous => ({ ...previous, [jobId]: Object.fromEntries(
            Object.entries(previous[jobId] || {}).filter(([id]) => !succeeded(id))
          ) }))
        }}
        onRefresh={async jobId => {
          await Promise.all([getCandidateDetails(jobId, currentPageMap[jobId] ?? 1, perPageMap[jobId] ?? 10,
            searchMap[jobId] ?? "", fromDateMap[jobId] || "", toDateMap[jobId] || "",
            consentStatusFilterMap[jobId] || "", emailSentFilterMap[jobId] || false,
            sendTestFilterMap[jobId] || false, getSelectedPipelineStages(jobId), true),
            getJobOrders(companyId, currentPage, perPage, jobSearchText, true)])
        }}
      />
      <Modal
        isOpen={candidateStatusModal}
        // toggle={() => setCandidateStatusModal(false)}
        centered
        size="lg"
        style={{ maxWidth: 975, width: "calc(100% - 32px)" }}
        backdrop={candidateStatusLoader ? "static" : true}
        keyboard={!candidateStatusLoader}
         toggle={
            !candidateStatusLoader
              ? () => {
                  setCandidateStatusModal(false);
                  setCandidateStatusError("");
                  setReason("");
                  setCandidateRejectedRound("");
                  setIsSubmitted(false);
                  setIsCandidateStatusDetailsEdit(false);
                }
              : undefined 
          }
      >
        <ModalHeader
          // toggle={() => {
          //             setCandidateStatusModal(false);
          //   setCandidateStatusError("");
          //             setReason("");
          // }}
           toggle={
              !candidateStatusLoader
                ? () => {
                    setCandidateStatusModal(false);
                    setCandidateStatusError("");
                    setReason("");
                    setCandidateRejectedRound("");
                    setIsSubmitted(false);
                    setIsCandidateStatusDetailsEdit(false);
                  }
                : undefined
            }
          className="modal-header_box blueBtn candidate-status-modal-header d-flex justify-content-between m-0 modal-header"
          style={{
            borderBottom: "0",
            padding: "14px 18px",
            background: "linear-gradient(135deg, #334155 0%, #4f46e5 100%)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
              style={{
                width: 34,
                height: 34,
                borderRadius: 9,
                background: "rgba(255,255,255,0.16)",
                border: "1px solid rgba(255,255,255,0.22)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <FaInfoCircle size={16} />
            </div>
            <div>
              <div style={{ fontSize: 18, fontWeight: 800, lineHeight: 1.15 }}>
                Update Candidate Status
              </div>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 500,
                  opacity: 0.88,
                  marginTop: 3,
                }}
              >
                Review candidate details and update the pipeline stage
              </div>
            </div>
          </div>
        </ModalHeader>
        <ModalBody style={{ padding: "16px 18px 8px", background: "#f7f8fc" }}>
          <div
            style={{
              background: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: 10,
              padding: "12px 14px",
              marginBottom: 12,
              boxShadow: "0 8px 18px rgba(51, 65, 85, 0.07)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 12,
              }}
            >
              <div style={{ minWidth: 0, display: "flex", alignItems: "center", gap: 10 }}>
                <div
                  style={{
                    width: 38,
                    height: 38,
                    borderRadius: "50%",
                    background: "#eef2ff",
                    border: "1px solid #c7d2fe",
                    color: "#4338ca",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 15,
                    fontWeight: 800,
                    flexShrink: 0,
                  }}
                >
                  {String(selectedCandidateDisplayName || "C")
                    .split(" ")
                    .filter(Boolean)
                    .slice(0, 2)
                    .map(part => part[0])
                    .join("")
                    .toUpperCase() || "C"}
                </div>
                <div style={{ minWidth: 0 }}>
                  <div
                    style={{
                      fontSize: 11,
                      color: "#64748b",
                      fontWeight: 800,
                      textTransform: "uppercase",
                      marginBottom: 4,
                      letterSpacing: 0.2,
                    }}
                  >
                    Candidate
                  </div>
                  <div
                    title={selectedCandidateDisplayName}
                    style={{
                      color: "#0f172a",
                      fontSize: 15,
                      fontWeight: 800,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {selectedCandidateDisplayName}
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  flexShrink: 0,
                }}
              >
                <button
                  type="button"
                  className="btn"
                  onClick={
                    isCandidateStatusDetailsEdit
                      ? handleSaveCandidateDetailsFromStatus
                      : handleEditCandidateDetailsFromStatus
                  }
                  disabled={
                    candidateStatusLoader ||
                    candidateStatusDetailsLoader ||
                    candidateStatusDetailsSaving
                  }
                  style={{
                    background: isCandidateStatusDetailsEdit ? "#4f46e5" : "#fff",
                    border: "1px solid #c7d2fe",
                    color: isCandidateStatusDetailsEdit ? "#fff" : "#4338ca",
                    borderRadius: 6,
                    padding: "5px 10px",
                    fontSize: 12,
                    fontWeight: 700,
                    whiteSpace: "nowrap",
                  }}
                >
                  {candidateStatusDetailsSaving
                    ? "Saving..."
                    : isCandidateStatusDetailsEdit
                      ? "Save Details"
                      : "Edit Candidate Details"}
                </button>
                {isCandidateStatusDetailsEdit && (
                  <button
                    type="button"
                    className="btn"
                    onClick={handleCancelCandidateDetailsEdit}
                    disabled={candidateStatusDetailsSaving}
                    style={{
                      background: "#fff",
                      border: "1px solid #cbd5e1",
                      color: "#334155",
                      borderRadius: 6,
                      padding: "5px 10px",
                      fontSize: 12,
                      fontWeight: 700,
                      whiteSpace: "nowrap",
                    }}
                  >
                    Cancel Edit
                  </button>
                )}
                <span
                  title={selectedCandidateStatusName}
                  style={{
                    background: isSelectedCandidatePlaced ? "#dcfce7" : "#e0f2fe",
                    border: `1px solid ${isSelectedCandidatePlaced ? "#86efac" : "#bae6fd"}`,
                    color: isSelectedCandidatePlaced ? "#166534" : "#075985",
                    borderRadius: 999,
                    padding: "5px 10px",
                    fontSize: 12,
                    fontWeight: 700,
                    whiteSpace: "nowrap",
                  }}
                >
                  {selectedCandidateStatusName}
                </span>
              </div>
            </div>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
              gap: 12,
              marginBottom: 12,
            }}
          >
            <div
              style={{
                border: "1px solid #e2e8f0",
                borderTop: "3px solid #4f46e5",
                borderRadius: 10,
                background: "#ffffff",
                padding: "13px 14px",
                minHeight: 190,
                boxShadow: "0 8px 18px rgba(51, 65, 85, 0.06)",
              }}
            >
              <div
                style={{
                  color: "#4338ca",
                  fontSize: 13,
                  fontWeight: 800,
                  marginBottom: 10,
                }}
              >
                Candidate Basic Details
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  gap: "10px 14px",
                }}
              >
               {selectedCandidateBasicDetails.map(detail => {
                    const isCenteredLastItem = false
                    return (
                    <div
                      key={detail.label}
                      style={{
                        minWidth: 0,
                        gridColumn:
                          detail.fullWidth || isCenteredLastItem ? "1 / -1" : "auto",
                        justifySelf: isCenteredLastItem ? "center" : "stretch",
                        width: isCenteredLastItem ? "88%" : "100%",
                      }}
                    >
                      <div
                        title={detail.label}
                        style={{
                          color: "#64748b",
                          fontSize: 11,
                          fontWeight: 700,
                          textTransform: "uppercase",
                          marginBottom: 3,
                          minHeight: 28,
                          lineHeight: "14px",
                          display: "flex",
                          alignItems: "flex-end",
                        }}
                      >
                        {detail.label}
                      </div>
                      {isCandidateStatusDetailsEdit ? (
                        detail.inputType === "source-select" ? (
                          <Input
                            type="select"
                            value={candidateStatusDetailsDraft?.[detail.field] ?? ""}
                            onChange={e =>
                              handleCandidateStatusDraftChange(detail.field, e.target.value)
                            }
                            disabled={
                              candidateStatusDetailsSaving ||
                              candidateStatusSourcesLoading
                            }
                            title={candidateStatusDetailsDraft?.[detail.field] ?? ""}
                            style={{
                          height: 34,
                              fontSize: 12,
                              padding: "6px 9px",
                            }}
                          >
                            <option value="">
                              {candidateStatusSourcesLoading
                                ? "Loading sources..."
                                : "Select Source"}
                            </option>
                            {candidateStatusSourceOptions.map(option => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </Input>
                        ) : detail.inputType === "work-mode-select" ? (
                          <Input
                            type="select"
                            value={candidateStatusDetailsDraft?.[detail.field] ?? ""}
                            onChange={e =>
                              handleCandidateStatusDraftChange(detail.field, e.target.value)
                            }
                            disabled={candidateStatusDetailsSaving}
                            title={candidateStatusDetailsDraft?.[detail.field] ?? ""}
                            style={{
                              height: 34,
                              fontSize: 12,
                              padding: "6px 9px",
                            }}
                          >
                            <option value="">Select mode of work</option>
                            <option value="Work from Home">Work from Home</option>
                            <option value="Work From Office">Work From Office</option>
                            <option value="Hybrid">Hybrid</option>
                            <option value="Onsite">Onsite</option>
                          </Input>
                        ) : (
                        <Input
                          type={detail.inputType || "text"}
                          value={candidateStatusDetailsDraft?.[detail.field] ?? ""}
                          onChange={e =>
                            handleCandidateStatusDraftChange(detail.field, e.target.value)
                          }
                          disabled={candidateStatusDetailsSaving}
                          title={candidateStatusDetailsDraft?.[detail.field] ?? ""}
                          placeholder={detail.field === "mode_of_work" ? "Enter mode of work" : undefined}
                          style={{
                          height: 34,
                            fontSize: 12,
                            padding: "6px 9px",
                          }}
                        />
                        )
                      ) : (
                        <div
                          title={formatCandidateDetailValue(detail.value)}
                          style={{
                            color: "#0f172a",
                            fontSize: 12,
                            fontWeight: 600,
                            minHeight: 34,
                            border: "1px solid #d7dde8",
                            borderRadius: 6,
                            background: "#ffffff",
                            padding: "6px 9px",
                            display: "flex",
                            alignItems: "center",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {candidateStatusDetailsLoader
                            ? "Loading..."
                            : formatCandidateDetailValue(detail.value)}
                        </div>
                      )}
                    </div>
                    )
                })}
              </div>
            </div>

            <div
              style={{
                border: "1px solid #e2e8f0",
                borderTop: "3px solid #14b8a6",
                borderRadius: 10,
                background: "#ffffff",
                padding: "13px 14px",
                minHeight: 190,
                boxShadow: "0 8px 18px rgba(51, 65, 85, 0.06)",
              }}
            >
              <div
                style={{
                  color: "#0f766e",
                  fontSize: 13,
                  fontWeight: 800,
                  marginBottom: 10,
                }}
              >
                Salary & Preference Details
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  gap: "10px 14px",
                }}
              >
                {selectedCandidateSalaryDetails.map((detail, index) => {
                  const isCenteredLastItem = index === 4
                  return (
                  <div
                    key={detail.label}
                    style={{
                      minWidth: 0,
                      gridColumn: isCenteredLastItem ? "1 / -1" : "auto",
                      justifySelf: isCenteredLastItem ? "center" : "stretch",
                      width: isCenteredLastItem ? "88%" : "100%",
                    }}
                  >
                    <div
                      style={{
                        color: "#64748b",
                        fontSize: 11,
                        fontWeight: 700,
                        textTransform: "uppercase",
                        marginBottom: 3,
                        minHeight: 28,
                        lineHeight: "14px",
                        display: "flex",
                        alignItems: "flex-end",
                      }}
                    >
                      {detail.label}
                    </div>
                    {isCandidateStatusDetailsEdit ? (
                      detail.inputType === "select" ? (
                        <Input
                          type="select"
                          value={candidateStatusDetailsDraft?.[detail.field] ? "true" : "false"}
                          onChange={e =>
                            handleCandidateStatusDraftChange(
                              detail.field,
                              e.target.value === "true"
                            )
                          }
                          disabled={candidateStatusDetailsSaving}
                          style={{
                            height: 34,
                            fontSize: 12,
                            padding: "6px 9px",
                          }}
                        >
                          <option value="false">No</option>
                          <option value="true">Yes</option>
                        </Input>
                      ) : (
                        <Input
                          type={detail.inputType || "text"}
                          value={candidateStatusDetailsDraft?.[detail.field] ?? ""}
                          onChange={e =>
                            handleCandidateStatusDraftChange(detail.field, e.target.value)
                          }
                          disabled={candidateStatusDetailsSaving}
                          style={{
                            height: 34,
                            fontSize: 12,
                            padding: "6px 9px",
                          }}
                        />
                      )
                    ) : (
                      <div
                        title={formatCandidateDetailValue(detail.value)}
                        style={{
                          color: "#0f172a",
                          fontSize: 12,
                          fontWeight: 600,
                          minHeight: 34,
                          border: "1px solid #d7dde8",
                          borderRadius: 6,
                          background: "#ffffff",
                          padding: "6px 9px",
                          display: "flex",
                          alignItems: "center",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {candidateStatusDetailsLoader
                          ? "Loading..."
                          : formatCandidateDetailValue(detail.value)}
                      </div>
                    )}
                  </div>
                  )
                })}
              </div>
            </div>
          </div>

          <div
            style={{
              background: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: 10,
              padding: "13px 14px",
              boxShadow: "0 8px 18px rgba(51, 65, 85, 0.06)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 12,
                marginBottom: 10,
              }}
            >
              <div>
                <div style={{ color: "#4338ca", fontSize: 13, fontWeight: 800 }}>
                  Pipeline Update
                </div>
                <div style={{ color: "#64748b", fontSize: 12, marginTop: 2 }}>
                  Select the next status and add the reason for this change.
                </div>
              </div>
            </div>

            <div
              className="mb-3"
              style={{
                display: "grid",
                gridTemplateColumns: isSelectedStatusRejected
                  ? "repeat(2, minmax(0, 1fr))"
                  : "1fr",
                gap: 12,
                alignItems: "start",
              }}
            >
              <div>
                <label className="fw-bold mb-2" style={{ fontSize: 13 }}>
                  Select Status
                </label>
                <Input
                  type="select"
                  value={selectedCandidateStatusId}
                  onChange={e => {
                    const nextStatusId = e.target.value
                    setSelectedCandidateStatusId(nextStatusId)
                    const nextStage = stagesList.find(
                      stage => String(stage.id) === String(nextStatusId)
                    )
                    if (
                      String(nextStage?.name || "").toLowerCase().trim() !==
                      "rejected"
                    ) {
                      setCandidateRejectedRound("")
                    }
                    setCandidateStatusError("");
                  }}
                >
                  <option value="">-- Select --</option>
                  {stagesList.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Input>
              </div>
              {isSelectedStatusRejected && (
                <div>
                  <label className="fw-bold mb-2" style={{ fontSize: 13 }}>
                    Rejected At <span className="text-danger">*</span>
                  </label>
                  <Input
                    type="select"
                    value={candidateRejectedRound}
                    onChange={e => {
                      setCandidateRejectedRound(e.target.value)
                      setCandidateStatusError("")
                    }}
                    invalid={
                      isSubmitted &&
                      isSelectedStatusRejected &&
                      !candidateRejectedRound
                    }
                  >
                    <option value="">-- Select Rejected At --</option>
                    {candidateRejectedRoundOptions.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Input>
                  {isSubmitted && isSelectedStatusRejected && !candidateRejectedRound && (
                    <small className="text-danger">Rejected At is mandatory</small>
                  )}
                </div>
              )}
            </div>
            {/* <small className="text-danger">{candidateStatusError}</small> */}
            <div className="mb-0">
              <label className="fw-bold mb-2" style={{ fontSize: 13 }}>
                Reason <span className="text-danger">*</span>
              </label>
              <Input
                type="textarea"
                value={reason || ""}
                onChange={e => setReason(e.target.value)}
                invalid={isSubmitted && !reason?.trim()}
                placeholder="Enter reason for status change"
                rows={3}
                style={{ resize: "vertical", minHeight: 82, fontSize: 13 }}
              />

              {isSubmitted && !reason?.trim() && (
                <small className="text-danger">Reason is mandatory</small>
              )}
            </div>
          </div>

          {isSelectedCandidatePlaced && (
            <div
              style={{
                background: "#fff7ed",
                border: "1px solid #fed7aa",
                color: "#9a3412",
                borderRadius: 6,
                padding: "9px 11px",
                fontSize: 12,
                fontWeight: 600,
                marginTop: 14,
              }}
            >
              Placed candidates cannot be updated.
            </div>
          )}

        </ModalBody>

        <ModalFooter
          className="justify-content-center"
          style={{
            borderTop: "0",
            padding: "14px 24px 22px",
            gap: 10,
            background: "#f7f8fc",
          }}
        >
          <button
            className="btn"
            disabled={candidateStatusLoader}
            onClick={() => {
                setCandidateStatusModal(false);
                setCandidateStatusError("");
              setReason("");
              setCandidateRejectedRound("");
              setIsSubmitted(false);
              setIsCandidateStatusDetailsEdit(false);
            }}
            style={{
              border: "1px solid #cbd5e1",
              background: "#fff",
              color: "#334155",
              fontWeight: 600,
              minWidth: 84,
              padding: "7px 14px",
              fontSize: 13,
              borderRadius: 8,
            }}
          >
            Cancel
          </button>
          <button
            className="btn"
            onClick={handleCandidateStatusUpdate}
            disabled={candidateStatusLoader || isSelectedCandidatePlaced}
            title={
              isSelectedCandidatePlaced
                ? "Placed candidates cannot be updated"
                : "Update candidate status"
            }
            style={{
              background:
                candidateStatusLoader || isSelectedCandidatePlaced
                  ? "#94a3b8"
                  : "#4f46e5",
              border: "1px solid transparent",
              color: "#fff",
              fontWeight: 700,
              minWidth: 96,
              padding: "7px 14px",
              fontSize: 13,
              borderRadius: 8,
              cursor:
                candidateStatusLoader || isSelectedCandidatePlaced
                  ? "not-allowed"
                  : "pointer",
            }}
          >
            {candidateStatusLoader ? "Updating..." : "Update"}
          </button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={sendForApprovalModal}
         backdrop={isSendingForApproval ? "static" : true}
         fade={false}
         keyboard={!isSendingForApproval}
        // toggle={() => {
        //     setSendForApprovalModal(false);
        //   setApprovalReason("");
        //     setSelectedCandidateForApproval(null);
        //   setIsSendingForApproval(false);
        // }}
        centered
      >
        <ModalHeader  toggle={
              !isSendingForApproval
                ? () => {
                    setSendForApprovalModal(false);
                    setApprovalReason("");
                    setSelectedCandidateForApproval(null);
                  }
                : undefined
            }>
            <div style={{ fontSize: "16px"}}>Send {selectedCandidateForApproval?.first_name} {selectedCandidateForApproval?.last_name} for Approval</div>
        </ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <Label for="approvalReason" className="form-label">
              Reason for Approval <span className="text-danger">*</span>
            </Label>
            <Input
              type="text"
              id="approvalReason"
              value={approvalReason}
              onChange={e => setApprovalReason(e.target.value)}
              placeholder="Enter reason..."
            //   rows={3}
              required
            />
          </div>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <Button
            color="secondary"
            disabled={isSendingForApproval}
            onClick={() => {
                setSendForApprovalModal(false);
                setApprovalReason("");
                setSelectedCandidateForApproval(null);
            }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={handleSendForApproval}
            disabled={!approvalReason.trim() || isSendingForApproval}
          >
            {isSendingForApproval ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                ></span>
                Sending...
              </>
            ) : (
              "Send for Approval"
            )}
          </Button>
        </ModalFooter>
      </Modal>
<Modal
  isOpen={showDetailsModal}
  toggle={() => {
    setShowDetailsModal(false);
    setSelectedCandidateForDetails(null);
  }}
  centered
  size="xl"
>
  <ModalHeader
    toggle={() => setShowDetailsModal(false)}
    className="candidate-status-modal-header"
    style={{
      border: 0,
      background: "linear-gradient(135deg, #334155 0%, #4f46e5 100%)",
      color: "#fff",
      padding: "14px 18px",
    }}
  >
    <div>
      <div style={{ fontSize: 18, fontWeight: 800, lineHeight: 1.2 }}>
        Approval/Rejection Details
      </div>
      <div style={{ fontSize: 12, opacity: 0.86, marginTop: 3 }}>
        Review the latest approval decision for this candidate
      </div>
    </div>
  </ModalHeader>
  <ModalBody style={{ background: "#f7f8fc", padding: 18 }}>
    {selectedCandidateForDetails && (() => {
      const approvalCandidateName = [
        selectedCandidateForDetails?.first_name,
        selectedCandidateForDetails?.middle_name,
        selectedCandidateForDetails?.last_name,
      ].filter(Boolean).join(" ") || "--"
      const approvalJobName = selectedCandidateForDetails.job_title || "N/A"
      const approvalStatus = selectedCandidateForDetails.is_approved
        ? "Approved"
        : selectedCandidateForDetails.rejected_round
          ? `Rejected (${selectedCandidateForDetails.rejected_round})`
          : "Rejected (Not specified)"
      const approvalReason = selectedCandidateForDetails.is_approved
        ? selectedCandidateForDetails.is_approved_reason
        : selectedCandidateForDetails.is_rejected_reason || "--"
      const approvalBy = selectedCandidateForDetails.is_approved
        ? selectedCandidateForDetails.approved_by
        : selectedCandidateForDetails.rejected_by || "--"
      const approvalDate = selectedCandidateForDetails.is_approved
        ? selectedCandidateForDetails.approved_at
          ? new Date(selectedCandidateForDetails.approved_at).toLocaleString()
          : "N/A"
        : selectedCandidateForDetails.rejected_at
          ? new Date(selectedCandidateForDetails.rejected_at).toLocaleString()
          : "N/A"
      const approvalCellStyle = {
        fontSize: 12,
        padding: "12px 14px",
        verticalAlign: "middle",
        color: "#0f172a",
        lineHeight: 1.45,
        textAlign: "center",
      }
      const approvalHeaderStyle = {
        fontSize: 12,
        fontWeight: 800,
        padding: "12px 14px",
        verticalAlign: "middle",
        color: "#334155",
        background: "#eef2ff",
        whiteSpace: "nowrap",
        textAlign: "center",
      }

      return (
      <div>
        <div
          title={`Candidate Name : ${approvalCandidateName}`}
          style={{
            background: "#ffffff",
            border: "1px solid #e2e8f0",
            borderRadius: 10,
            padding: "12px 14px",
            marginBottom: 14,
            boxShadow: "0 8px 18px rgba(51, 65, 85, 0.06)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
          }}
        >
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 11, color: "#64748b", fontWeight: 800, textTransform: "uppercase" }}>
              Candidate Name
            </div>
            <div
              style={{
                fontSize: 14,
                fontWeight: 800,
                color: "#0f172a",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {approvalCandidateName}
            </div>
          </div>
          <span
            title={approvalStatus}
            style={{
              background: selectedCandidateForDetails.is_approved ? "#dcfce7" : "#fee2e2",
              border: `1px solid ${selectedCandidateForDetails.is_approved ? "#86efac" : "#fecaca"}`,
              color: selectedCandidateForDetails.is_approved ? "#166534" : "#991b1b",
              borderRadius: 999,
              padding: "5px 10px",
              fontSize: 12,
              fontWeight: 800,
              flexShrink: 0,
            }}
          >
            {approvalStatus}
          </span>
        </div>
        <div
          id="CandidateApprovalTable"
          style={{
            background: "#fff",
            border: "1px solid #dbe4ef",
            borderRadius: 10,
            overflow: "hidden",
            boxShadow: "0 8px 18px rgba(51, 65, 85, 0.05)",
          }}
        >
          <div className="table-responsive">
            <table className="table table-bordered table-hover mb-0" style={{ tableLayout: "fixed" }}>
              <thead>
                <tr>
                  <th title="Job Name" style={{ ...approvalHeaderStyle, width: "28%" }}>Job Name</th>
                  <th title="Status" className="text-center" style={{ ...approvalHeaderStyle, width: 110 }}>Status</th>
                  <th title="Reason" style={{ ...approvalHeaderStyle, width: "25%" }}>Reason</th>
                  <th title="Approved/Rejected By" style={{ ...approvalHeaderStyle, width: "22%" }}>Approved/Rejected By</th>
                  <th title="Approval/Rejection Date" style={{ ...approvalHeaderStyle, width: "18%" }}>Approval/Rejection Date</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td title={approvalJobName} style={approvalCellStyle}>
                    <div style={{ width: "100%", textAlign: "center", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {approvalJobName}
                    </div>
                  </td>
                  <td title={approvalStatus} className="text-center" style={approvalCellStyle}>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minWidth: 74,
                        borderRadius: 999,
                        padding: "5px 10px",
                        fontSize: 11,
                        fontWeight: 800,
                        background: selectedCandidateForDetails.is_approved ? "#dcfce7" : "#fee2e2",
                        border: `1px solid ${selectedCandidateForDetails.is_approved ? "#86efac" : "#fecaca"}`,
                        color: selectedCandidateForDetails.is_approved ? "#166534" : "#991b1b",
                      }}
                    >
                      {approvalStatus}
                    </span>
                  </td>
                  <td title={approvalReason} style={approvalCellStyle}>
                    <div style={{ width: "100%", textAlign: "center", maxHeight: 48, overflow: "hidden" }}>
                      {approvalReason}
                    </div>
                  </td>
                  <td title={approvalBy} style={approvalCellStyle}>
                    <div style={{ width: "100%", textAlign: "center", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {approvalBy}
                    </div>
                  </td>
                  <td title={approvalDate} style={approvalCellStyle}>
                    <div style={{ width: "100%", textAlign: "center", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {approvalDate}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      )
    })()}
  </ModalBody>
  <ModalFooter className="justify-content-center" style={{ background: "#f7f8fc", borderTop: 0, padding: "12px 18px 18px" }}>
    <Button
      color="secondary"
      className="btn btn-primary blueBtn"
      onClick={() => {
        setShowDetailsModal(false);
        setSelectedCandidateForDetails(null);
      }}
    >
      Close
    </Button>
  </ModalFooter>
</Modal>
<Modal
  isOpen={showConfirmSendTestModal}
  toggle={() => setShowConfirmSendTestModal(false)}
  centered
>
  <ModalHeader toggle={() => setShowConfirmSendTestModal(false)}>
    Confirm Send Test
  </ModalHeader>
  <ModalBody>
    <p>
      Are you sure you want to send the test to{" "}
      <strong>
        {confirmSendTestCandidate?.first_name} {confirmSendTestCandidate?.middle_name} {confirmSendTestCandidate?.last_name}
      </strong>?
    </p>
    <p>
      <strong>Email :</strong> {confirmSendTestCandidate?.email || "N/A"}
    </p>
    <p>
      <strong>Phone :</strong> {confirmSendTestCandidate?.mobile_phone || "N/A"}
      <hr />
    </p>
       <p> <strong>Disclaimer :</strong> <span>Please Verify Candidate Email and Phone Number before sending the test</span></p>

  </ModalBody>
  
  <ModalFooter className="justify-content-center">
    <Button
      color="secondary"
      onClick={() => setShowConfirmSendTestModal(false)}
    >
      Cancel
    </Button>
    <Button
      color="primary"
      onClick={async () => {
        setShowConfirmSendTestModal(false);
        setLoadingSendTest(true);
        setLoadingSendTestCandidateId(confirmSendTestCandidate.candidate_id); // ←
        await handleSendTest(
          confirmSendTestJob.job_id ?? confirmSendTestJob.id,
          confirmSendTestCandidate.job_candidate_id
        );
      }}
    >
      Send
    </Button>
  </ModalFooter>
</Modal>
<Modal
  isOpen={showEditModal}
  toggle={isLoading ? undefined : () => setShowEditModal(false)}
  centered
  backdrop={isLoading ? "static" : true}
  keyboard={!isLoading}
>
  <ModalHeader toggle={isLoading ? undefined : () => {setShowEditModal(false);setValidationError("");}}>
    <span style={{ display: "block", fontSize: 16, lineHeight: 1.25, fontWeight: 600 }}>
      Update {editField === "mobile_phone" ? "Phone Number" : editField === "total_experience" ? "Experience" : "Email"}{" "}
        {candidateToEdit
          ? `— ${[candidateToEdit.first_name, candidateToEdit.middle_name, candidateToEdit.last_name].filter(Boolean).join(" ")}`
          : ""}
    </span>
  </ModalHeader>
  <ModalBody>
   <Input
      innerRef={editInputRef}
      type={editField === "mobile_phone" ? "text" : editField === "total_experience" ? "number" : "email"}
      inputMode={editField === "mobile_phone" || editField === "total_experience" ? "numeric" : undefined}
      step={editField === "total_experience" ? "0.01" : undefined}
      min={editField === "total_experience" ? "0" : undefined}
      value={editValue}
      maxLength={editField === "mobile_phone" && !hasVgus ? 10 : undefined}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          if ((!hasVgus ? !validationError : true) && editValue.trim()) {
            handleUpdateCandidateField(
              candidateToEdit.job_candidate_id,
              editField,
              editValue
            );
          }
        }}}
      onChange={(e) => {
        const value = e.target.value;
        if (editField === "mobile_phone") {
          if (!hasVgus) {
            const hasSpecialCharacters = /[+\-()]/.test(value);
            const onlyNumbers = value.replace(/\D/g, "").slice(0, 10);
            setEditValue(onlyNumbers);
            if (hasSpecialCharacters) {
              setValidationError("Special characters (+91, -,) are not allowed.");
              return;
            }
            if (onlyNumbers.length > 0 && onlyNumbers.length !== 10) {
              setValidationError("Phone number must be exactly 10 digits.");
              return;
            }
            if (/^(\d)\1{9}$/.test(onlyNumbers)) {
              setValidationError("Invalid phone number.");
              return;
            }
            if (onlyNumbers.length === 10 && onlyNumbers.startsWith("0")) {
              setValidationError("Phone number cannot start with 0.");
              return;
            }
            // ✅ ADD THIS — clears stale validation errors once the number is valid
            setValidationError("");
          } else {
            setEditValue(value);
            setValidationError("");
          }
        } else if (editField === "total_experience") {
          const experienceValue = value.replace(/[^\d.]/g, "").replace(/\.(?=.*\.)/g, "");
          setEditValue(experienceValue);
          const numericValue = Number(experienceValue);
          setValidationError(
            experienceValue && (!Number.isFinite(numericValue) || numericValue < 0)
              ? "Experience must be a valid non-negative number."
              : ""
          );
        } else {
          setEditValue(value);
          if (!hasVgus) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (value && !emailRegex.test(value)) {
              setValidationError("Please enter a valid email");
            } else {
              setValidationError("");
            }
          }
        }
      }}
      placeholder={`Enter new ${editField}`}
    />
     {editField === "mobile_phone" && !hasVgus && (
      <div className="mt-2" style={{ fontSize: "14px" }}>
        <strong>Note: </strong><span>(+91), (-) are not allowed. 
        Please enter Valid Phone Number.</span>
      </div>
    )}

    {validationError && (
      <div className="text-danger mt-1" style={{ fontSize: "13px" }}>
        {validationError}
      </div>
    )}
  </ModalBody>
  <ModalFooter className="justify-content-center">
    <Button color="secondary" onClick={() => {setShowEditModal(false);setValidationError("");}} disabled={isLoading}>
      Cancel
    </Button>
    <Button
      color="primary"
      onClick={() => {if (!hasVgus &&validationError) return;handleUpdateCandidateField(candidateToEdit.job_candidate_id, editField, editValue)}}
      disabled={!editValue.trim()}
    >
     {isLoading ? (
      <>
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        Updating...
      </>
    ) : (
      "Update"
    )}
    </Button>
  </ModalFooter>
</Modal>
<Modal
  isOpen={showUploadedResumeModal}
  toggle={() => setShowUploadedResumeModal(false)}
  size="xl"
  centered
  className="resume-upload-result-modal"
>
  <ModalHeader toggle={() => setShowUploadedResumeModal(false)} className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header">
    Resume Upload Result
  </ModalHeader>
 <ModalBody style={{ maxHeight: "500px", overflowY: "auto" }}>
  {shouldShowNotificationWarning && (
    <div className="alert alert-warning d-flex flex-wrap align-items-center justify-content-between gap-2">
      <div>
        <div className="fw-bold">Automatic processing completed, but some notification channels are disabled.</div>
        <div className="mt-2 d-flex flex-wrap gap-2">
          {uploadResult.disabled_notification_channels.map(channel => (
            <span key={channel} className="badge bg-warning text-dark">{notificationChannelLabel(channel)}</span>
          ))}
        </div>
      </div>
      <Button size="sm" color="warning" onClick={() => navigate("/calling-notification-settings")}>
        Open Notification Settings
      </Button>
    </div>
  )}
  <section className="resume-upload-summary-section mb-4">
      <h6 className="resume-upload-summary-title">Calling Notifications</h6>
      <div className="resume-upload-invite-summary">
      <div className="resume-upload-metric resume-upload-metric-success"><span>Invitations sent</span><strong>{Array.isArray(uploadResult.invited) ? uploadResult.invited.length : Number(uploadResult.invited || 0)}</strong></div>
      <div className="resume-upload-metric resume-upload-metric-warning"><span>Skipped</span><strong>{Array.isArray(uploadResult.skipped) ? uploadResult.skipped.length : Number(uploadResult.skipped || 0)}</strong></div>
      <div className="resume-upload-metric resume-upload-metric-danger"><span>Failed</span><strong>{Array.isArray(uploadResult.failed) ? uploadResult.failed.length : Number(uploadResult.failed || 0)}</strong></div>
      </div>
  </section>
  <section className="resume-upload-summary-section mb-4">
    <h6 className="resume-upload-summary-title">Resume Upload Summary</h6>
    <div className="resume-upload-total-summary">
    <div><span>Total uploaded</span><strong>{getUploadSuccessCount(uploadedResumeData) + getUploadFailedCount(uploadedResumeData)}</strong></div>
    <div className="text-success"><span>Success</span><strong>{getUploadSuccessCount(uploadedResumeData)}</strong></div>
    <div className="text-danger"><span>Failed</span><strong>{getUploadFailedCount(uploadedResumeData)}</strong></div>
    </div>
  </section>

  {/* SUCCESS SECTION */}
  {getUploadSuccessCount(uploadedResumeData) > 0 && (
    <>
      <div className="table-responsive">
        <table className="table table-bordered table-striped table-hover">
          <thead className="table-success">
            <tr>
              <th className="text-center">S.No</th>
              <th>Candidate Name</th>
              <th>Email</th>
              {/* <th className="text-center">Candidate ID</th> */}
              {/* <th className="text-center">Linked Job</th> */}
              <th className="text-center">Added On</th>
            </tr>
          </thead>
          <tbody>
            {getUploadSuccessFiles(uploadedResumeData).map((item, index) => (
              <tr key={index}>
                <td className="text-center">{index + 1}</td>
                <td>{item.name || "N/A"}</td>
                <td>{item.email || "N/A"}</td>
                {/* <td className="text-center">{item.candidate_id || "N/A"}</td> */}
                {/* <td className="text-center">{item.linked_to_job || "N/A"}</td> */}
                <td className="text-center">{item.created_on ? convertISTtoEST(item.created_on) : "N/A"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  )}

  {/* FAILED SECTION (existing) */}
  {getUploadFailedFiles(uploadedResumeData).length > 0 && (
    <>
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead className="table-danger">
            <tr>
              <th className="text-center">S.No</th>
              <th className="text-center">File Name</th>
              <th>Candidate Name</th>
              <th className="text-center">Email</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            {getUploadFailedFiles(uploadedResumeData).map((item, index) => (
              <tr key={index}>
                <td className="text-center">{index + 1}</td>
                <td>{item.file_name || "N/A"}</td>
                <td>{item.name || "N/A"}</td>
                <td>{item.email || "N/A"}</td>
                <td className="text-danger fw-bold">
                  <div>{item.already_linked === true
                    ? (item.reason || "Candidate is already applied to this job")
                    : (item.reason || item.action || item.error || "Failed")}</div>
                  {item.already_linked === true && (
                    <>
                      <div className="fw-normal mt-1">
                        Added by: {item.added_by?.name || "Unknown user"}
                      </div>
                      <div className="fw-normal">
                        Email: {item.added_by?.email || "Email unavailable"}
                      </div>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  )}

  {getUploadSuccessCount(uploadedResumeData) === 0 && 
   getUploadFailedCount(uploadedResumeData) === 0 && (
    <p className="text-center text-muted py-4">No upload result data available.</p>
  )}
</ModalBody>
  <ModalFooter className="justify-content-center">
    <Button
      className="btn border blueBtn"
      onClick={() => setShowUploadedResumeModal(false)}
    >
      Close
    </Button>
  </ModalFooter>
</Modal>



            <Modal isOpen={showSendForReviewModal} toggle={handleCloseSendForReviewModal} centered size="lg">
        <ModalHeader toggle={handleCloseSendForReviewModal}>
          <span style={{ fontSize: 17, fontWeight: 600 }}>
            Send for Review - {reviewQuestionJob?.job_title || "Job"}
          </span>
        </ModalHeader>
        <ModalBody>
          <Row className="g-3">
            <Col md={6}>
              <Label className="fw-bold">Select Company</Label>
              <CompanySelector
                onCompanyChange={company => {
                  setReviewCompanyId(company?.company_id || "");
                  setReviewSelectedEmployee(null);
                }}
                selectedCompanyId={reviewCompanyId}
              />
            </Col>
            <Col md={6}>
              <Label className="fw-bold">Select Employee</Label>
              <Select
                placeholder={reviewEmployeesLoading ? "Loading employees..." : "Select Employee"}
                options={reviewEmployeeOptions}
                value={reviewSelectedEmployee}
                onChange={setReviewSelectedEmployee}
                closeMenuOnSelect
                hideSelectedOptions={false}
                isClearable
                isLoading={reviewEmployeesLoading}
                 styles={{
                option: (base, state) => ({
                  ...base,
                  backgroundColor: "white",
                  color: "black",
                  ":hover": {
                    backgroundColor: "#0d6efd", 
                    color: "white",
                  },
                  ...(state.isSelected && {
                    backgroundColor: "white",
                    color: "black",
                  })
                }),
                multiValue: (base) => ({
                  ...base,
                  backgroundColor: "white",
                }),

                multiValueLabel: (base) => ({
                  ...base,
                  color: "black",
                }),

                multiValueRemove: (base) => ({
                  ...base,
                  color: "black",
                  ":hover": {
                    backgroundColor: "white",
                    color: "black",
                  }
                })
              }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <Button color="light" className="blueBtn" onClick={handleCloseSendForReviewModal}>Cancel</Button>
          <Button className="blueBtn" onClick={handleSendForReview} disabled={reviewSending}>
            {reviewSending ? "Sending..." : "Send for Review"}
          </Button>
          {/* <Button
            color="secondary"
            onClick={() => {
              if (!reviewQuestionJob) return;
              window.open(
                buildReviewQuestionsLink(reviewQuestionJob, reviewCompanyId),
                "_blank",
                "noopener,noreferrer"
              );
            }}
            disabled={!reviewQuestionJob}
          >
            Preview  Page
          </Button> */}
        </ModalFooter>
      </Modal>
<Modal isOpen={configureCallModal} toggle={handleConfigureCallClose} centered size="xl" className="configure-call-modal">
        <ModalBody style={{  padding: 0 }}>

          <Nav tabs style={{ paddingLeft: 16, paddingTop: 8 }}>
            <NavItem>
              {/* <NavLink
                className={configureCallStep === "first" ? "active fw-bold" : ""}
                onClick={() => setConfigureCallStep("first")}
                style={{ cursor: "pointer" }}
              >
                First Screening
              </NavLink> */}
            </NavItem>
            <NavItem>
              <NavLink
                className={configureCallStep === "second" ? "active fw-bold" : ""}
                // onClick={() => {
                //   const jobId = configureCallJob?.id;
                //   const selectedIds = selectedCandidateRows[jobId] || [];
                //   const candidates = candidateDataMap[jobId] || [];
                //   const selectedCandidates = candidates.filter(c => selectedIds.includes(c.job_candidate_id));
                //   const notCompleted = selectedCandidates.filter(c => c.first_screening_completed !== true);
                //   if (notCompleted.length > 0) {
                //     const namesList = notCompleted.map(c => `${c.first_name || ""} ${c.last_name || ""}`.trim() || "Unknown").join(", ");
                //     Swal.fire({
                //       icon: "warning",
                //       title: "First Screening Not Completed",
                //       html: `The below candidate(s) have not completed the first screening.<br/><br/><b>Candidate Name:</b> ${namesList}<br/><br/>Do You Want to Proceed?`,
                //       confirmButtonText: "OK",
                //     });
                //   }
                //   setConfigureCallStep("second");
                // }}
                style={{ cursor: "pointer" }}
              >
                Screening Questions
              </NavLink>
            </NavItem>
            <div className="ms-auto me-3 d-flex align-items-center">
              <button type="button" className="btn-close" onClick={handleConfigureCallClose} />
            </div>
          </Nav>

          <div style={{ padding: 20 }}>
            <TabContent activeTab={configureCallStep}>
{/* 
              <TabPane tabId="first">
                <Row className="mb-1">
                  <Col md={6} sm={6} xs={12} className="mb-2">
                    <Label className="fw-bold mb-1">Select Agent <span className="text-danger">*</span></Label>
                    <Select
                      placeholder="Select Agent"
                      options={agentOptions}
                      value={configureCallData.agent}
                      onChange={val => setConfigureCallData(prev => ({ ...prev, agent: val }))}
                      getOptionLabel={o => o.label}
                      getOptionValue={o => o.value}
                      isClearable
                    />
                  </Col>
                  <Col md={6} sm={6} xs={12} className="mb-2">
                    <Label className="fw-bold mb-1">Select Source</Label>
                    <Select
                      placeholder="Select Source"
                      options={sourceOptions}
                      value={configureCallData.source}
                      onChange={val => setConfigureCallData(prev => ({ ...prev, source: val }))}
                      isClearable
                    />
                  </Col>
                </Row>

                <Label className="fw-bold mb-1">Screening Questions</Label>
                {configureCallData?.firstScreeningQuestions?.map((val, idx) => (
                  <div key={idx} className="d-flex align-items-center gap-2 mb-1">
                    <Input
                      type="text"
                      placeholder={`Enter question`}
                      value={val}
                      onChange={e => handleEditFirstSQ(idx, e.target.value)}
                      style={{ width: "90%"}}
                    />
                    {idx === 0 ? (
                      <Button className="btn blueBtn btn-primary" title="Add" onClick={handleAddFirstSQ} style={{ width: "70px", marginLeft: "10px", marginRight: "initial"}}>
                        Add
                      </Button>
                    ) : (
                      <Button className="btn btn-danger" title="Remove" onClick={() => handleRemoveFirstSQ(idx)} style={{ width: "70px", marginLeft: "10px"}}>
                        <FaRegTrashAlt />
                      </Button>
                      // <button
                      //   className="text-danger border-0 p-0 bg-white"
                      //   title="Remove"
                      //   onClick={() => handleRemoveFirstSQ(idx)}
                      // >
                      //   <FaRegTrashAlt />
                      // </button>
                    )}
                  </div>
                ))}
                <div className="d-flex justify-content-center gap-2 mt-1">
                  <Button color="secondary" className="btn btn-primary blueBtn" onClick={handleConfigureCallClose}>
                    Cancel
                  </Button>
                  <Button className="btn blueBtn" onClick={handleInitiateFirstScreening} disabled={loadingInitiateCall}>
                    {loadingInitiateCall ? (
                      <><Spinner size="sm" className="me-1" /> Initiating...</>
                    ) : (
                      "Initiate Call"
                    )}
                  </Button>
                </div>
              </TabPane> */}

              <TabPane tabId="second">
                <Row className="mb-3">
                  <Col md={4} sm={6} xs={12} className="mb-2">
                    <Label className="fw-bold mb-1">Select Test Type</Label>
                    <Select
                      placeholder="Select Test Type"
                      options={testTypeOptions}
                      value={configureCallData.testType}
                      onChange={val => setConfigureCallData(prev => ({ ...prev, testType: val }))}
                    />
                  </Col>
                  <Col md={4} sm={6} xs={12} className="mb-2">
                    <Label className="fw-bold mb-1">Select Agent <span className="text-danger">*</span></Label>
                    <Select
                      placeholder="Select Agent"
                      options={agentOptions}
                      value={configureCallData.agent}
                      onChange={val => setConfigureCallData(prev => ({ ...prev, agent: val }))}
                      getOptionLabel={o => o.label}
                      getOptionValue={o => o.value}
                      isClearable
                    />
                  </Col>
                  {/* <Col md={3} sm={6} xs={12} className="mb-2">
                    <Label className="fw-bold mb-1 ">Schedule Date & Time</Label>
                    <DatePicker
                      selected={configureCallData.scheduleDate}
                      onChange={date =>
                        setConfigureCallData(prev => ({ ...prev, scheduleDate: date }))
                      }
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      dateFormat="dd/MM/yyyy h:mm aa"
                      placeholderText="Select Date & Time"
                      className="form-control"
                      minDate={new Date()}
                      minTime={
                        configureCallData.scheduleDate &&
                        configureCallData.scheduleDate.toDateString() === new Date().toDateString()
                          ? currentTime
                          : new Date(0, 0, 0, 0, 0)
                      }
                      maxTime={new Date(0, 0, 0, 23, 59)}
                    />
                  </Col> */}
                  <Col md={4} sm={6} xs={12} className="mb-2">
                    <Label className="fw-bold mb-1">Select Source</Label>
                    <Select
                      placeholder="Select Source"
                      options={sourceOptions}
                      value={configureCallData.source}
                      onChange={val => setConfigureCallData(prev => ({ ...prev, source: val }))}
                      isClearable
                    />
                  </Col>
                </Row>
                <div className="" id="SecondScreeningContainer">
                  <Row>
                    <Col className="pe-4">
                {Object.entries(configureCallData.secondScreeningQuestions).map(([category, questions]) => (
                  <div className="mb-3" key={category}>
                    <Label className="fw-bold mb-1">{category.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())}</Label>
                    {questions.map((val, idx) => (
                      <div key={idx} className="d-flex align-items-center gap-2 mb-2">
                        <Input
                          type="text"
                          placeholder={`Enter ${category.replace(/_/g, " ").toLowerCase()} question`}
                          value={val}
                          title={val}
                          onChange={e => handleEditSecondSQ(category, idx, e.target.value)}
                          style={{ width: "90%"}}
                        />
                        {idx > 0 ? (
                          // <button
                          //   className="text-danger border-0 p-0 bg-white"
                          //   title="Remove"
                          //   onClick={() => handleRemoveSecondSQ(category, idx)}
                          // >
                          //   <FaRegTrashAlt />
                          // </button>
                          <Button title="Remove" className="btn btn-danger" onClick={() => handleRemoveSecondSQ(category, idx)} style={{ width: "70px", marginLeft: "10px"}}><FaRegTrashAlt /></Button>
                        ) : (
                          <Button className="btn blueBtn btn-primary" onClick={() => handleAddSecondSQ(category)} style={{ width: "70px", marginLeft: "10px", marginRight: "initial"}}>
                            Add
                          </Button>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
                    </Col>
                  </Row>
                </div>
                <div className="d-flex justify-content-center gap-1 mt-3">
                  <Button color="secondary" className="btn btn-secondary blueBtn" onClick={handleConfigureCallClose}>
                    Cancel
                  </Button>
                  <Button className="btn blueBtn" onClick={handleCreateCall} disabled={loadingCreateCall}>
                    {loadingCreateCall ? (
                      <><Spinner size="sm" className="me-2" /> Sending Consent Request...</>
                    ) : (
                      "Send Consent Request"
                    )}
                  </Button>
                </div>
              </TabPane>

            </TabContent>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={phoneCallModal} toggle={phoneCallLoading ? undefined : handlePhoneCallClose} centered>
        <ModalHeader toggle={phoneCallLoading ? undefined : handlePhoneCallClose}>
          Call Confirmation
        </ModalHeader>
        <ModalBody>
          <div className="text-center">
            <FaPhoneAlt style={{ fontSize: "40px", color: "#28a745" }} className="mb-3" />
            <h5 className="mb-3">Are you sure you want to make this call?</h5>
          </div>
          <div className="border rounded p-3">
            <Row className="mb-2">
              <Col xs={5}><strong>Candidate Name</strong></Col>
              <Col xs={7}>
                : {phoneCallCandidate
                  ? `${phoneCallCandidate.first_name || ""} ${phoneCallCandidate.last_name || ""}`.trim() || "--"
                  : "--"}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col xs={5}><strong>Phone Number</strong></Col>
              <Col xs={7}>
                : {phoneCallCandidate?.mobile_phone || phoneCallCandidate?.candidate_phone || "--"}
              </Col>
            </Row>
            <Row>
              <Col xs={5}><strong>Your Extension</strong></Col>
              <Col xs={7}>: {extension}</Col>
            </Row>
          </div>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <Button color="secondary" onClick={handlePhoneCallClose} disabled={phoneCallLoading}>
            Cancel
          </Button>
          <Button className="btn blueBtn" onClick={handlePhoneCallProceed} disabled={phoneCallLoading}>
            {phoneCallLoading ? (
              <><Spinner size="sm" className="me-2" /> Proceeding...</>
            ) : (
              "Proceed"
            )}
          </Button>
        </ModalFooter>
      </Modal>
      <UpgradePlanPopup
        show={showUpgradePopup}
        handleClose={() => setShowUpgradePopup(false)}

      />

      {/* ---------- Consent Detail Modal ---------- */}
      <Modal
        isOpen={consentDetailModal}
        toggle={() => setConsentDetailModal(false)}
        centered
        size="lg"
        style={{ maxHeight: "85vh" }}
      >
        <ModalHeader toggle={() => setConsentDetailModal(false)}>
          <i className="mdi mdi-shield-check me-2" style={{ color: "#0d6efd" }}></i>
          AI Screening  Details
        </ModalHeader>
        <ModalBody style={{ maxHeight: "65vh", overflowY: "auto" }}>
          {consentDetailLoading ? (
            <div className="text-center py-4">
              <Spinner color="primary" />
              <p className="mt-2 mb-0">Loading AI Screening...</p>
            </div>
          ) : consentDetailData?.error ? (
            <div className="text-center text-danger py-3">
              Failed to load AI Screening Details.
            </div>
          ) : consentDetailData ? (
            <>
              {(() => {
                const statusText = consentDetailData.status || "--";
                const statusKey = String(statusText).toLowerCase();
                const statusStyle =
                  statusKey === "sent" || statusKey === "accepted"
                    ? { bg: "#dcfce7", color: "#166534", border: "#86efac", label: statusText }
                    : statusKey === "rejected" || statusKey === "declined"
                      ? { bg: "#fee2e2", color: "#991b1b", border: "#fecaca", label: statusText }
                      : statusKey === "pending"
                        ? { bg: "#fef3c7", color: "#92400e", border: "#fde68a", label: statusText }
                        : { bg: "#e0f2fe", color: "#075985", border: "#bae6fd", label: statusText };
                const timeline = Array.isArray(consentDetailData.timeline) ? consentDetailData.timeline : [];
                const talentScanHistory = Array.isArray(consentDetailData.talent_scan_history) ? consentDetailData.talent_scan_history : [];
                const initials = String(consentDetailData.candidate_name || "C")
                  .split(" ")
                  .filter(Boolean)
                  .slice(0, 2)
                  .map(name => name[0])
                  .join("")
                  .toUpperCase() || "C";

                return (
                  <div style={{ padding: "18px 20px 4px" }}>
                    <div
                      style={{
                        background: "linear-gradient(135deg, #f8fbff, #eef6ff)",
                        border: "1px solid #dbeafe",
                        borderRadius: 12,
                        padding: 16,
                        marginBottom: 14,
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 14, flexWrap: "wrap" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
                          <div
                            style={{
                              width: 46,
                              height: 46,
                              borderRadius: "50%",
                              background: "#0d6efd",
                              color: "#fff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: 700,
                              flexShrink: 0,
                            }}
                          >
                            {initials}
                          </div>
                          <div style={{ minWidth: 0 }}>
                            <div style={{ fontSize: 16, fontWeight: 700, color: "#0f172a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                              {consentDetailData.candidate_name || "--"}
                            </div>
                            <div style={{ fontSize: 12, color: "#64748b", marginTop: 3 }}>
                              AI screening consent activity
                            </div>
                          </div>
                        </div>
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            borderRadius: 999,
                            padding: "6px 12px",
                            fontSize: 12,
                            fontWeight: 700,
                            background: statusStyle.bg,
                            color: statusStyle.color,
                            border: `1px solid ${statusStyle.border}`,
                          }}
                        >
                          {statusStyle.label}
                        </span>
                      </div>
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: 10, marginBottom: 16 }}>
                      {[
                        { label: "Email", value: consentDetailData.email || "--" },
                        { label: "Phone", value: consentDetailData.phone || "--" },
                        { label: "Times sent", value: consentDetailData.times_sent ?? 0 },
                        { label: "Last sent", value: consentDetailData.last_sent_date ? formatTestDate(consentDetailData.last_sent_date) : "--" },
                      ].map(item => (
                        <div key={item.label} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, padding: "10px 12px", minWidth: 0 }}>
                          <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700, textTransform: "uppercase", marginBottom: 4 }}>
                            {item.label}
                          </div>
                          <div title={String(item.value)} style={{ fontSize: 13, color: "#0f172a", fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {item.value}
                          </div>
                        </div>
                      ))}
                    </div>

                    <div style={{ display: "flex", gap: 8, borderBottom: "1px solid #e2e8f0", marginBottom: 14 }}>
                      {[
                        { key: "calling", label: "Calling History" },
                        { key: "talentScan", label: "TalentScan History" },
                      ].map(tab => (
                        <button
                          key={tab.key}
                          type="button"
                          onClick={() => setConsentDetailTab(tab.key)}
                          style={{
                            border: 0,
                            borderBottom: `2px solid ${consentDetailTab === tab.key ? "#0d6efd" : "transparent"}`,
                            background: "transparent",
                            color: consentDetailTab === tab.key ? "#0d6efd" : "#64748b",
                            fontWeight: 700,
                            fontSize: 13,
                            padding: "8px 10px",
                            cursor: "pointer",
                          }}
                        >
                          {tab.label}
                        </button>
                      ))}
                    </div>

                    {consentDetailTab === "calling" ? <div>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                        <h6 className="fw-bold mb-0" style={{ color: "#0f172a" }}>Consent History</h6>
                        <span style={{ fontSize: 12, color: "#64748b" }}>{timeline.length} events</span>
                      </div>

                      {timeline.length === 0 ? (
                        <div style={{ border: "1px dashed #cbd5e1", borderRadius: 10, padding: "22px", textAlign: "center", color: "#64748b", background: "#f8fafc" }}>
                          No AI screening activity is available yet.
                        </div>
                      ) : (
                        <div style={{ display: "grid", gap: 10 }}>
                          {timeline.map((t, idx) => {
                            const isAccepted = t.event === "consent_accepted";
                            const isDeclined = t.event === "consent_declined" || t.event === "consent_rejected";
                            const itemStyle = isAccepted
                              ? { bg: "#f0fdf4", color: "#166534", border: "#bbf7d0", label: "Consented" }
                              : isDeclined
                                ? { bg: "#fef2f2", color: "#991b1b", border: "#fecaca", label: "Declined" }
                                : { bg: "#fffbeb", color: "#92400e", border: "#fde68a", label: "Sent" };

                            return (
                              <div key={idx} style={{ display: "grid", gridTemplateColumns: "120px 1fr 120px", gap: 12, alignItems: "center", background: itemStyle.bg, border: `1px solid ${itemStyle.border}`, borderRadius: 10, padding: "11px 13px" }}>
                                <span style={{ justifySelf: "start", padding: "4px 10px", borderRadius: 999, background: "#fff", color: itemStyle.color, fontSize: 12, fontWeight: 700, border: `1px solid ${itemStyle.border}` }}>
                                  {itemStyle.label}
                                </span>
                                <div style={{ minWidth: 0 }}>
                                  <div style={{ fontSize: 13, color: "#0f172a", fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                    {t?.note || "--"}
                                  </div>
                                  {isDeclined && t?.reason_to_reject && (
                                    <div style={{ fontSize: 12, marginTop: 4, color: "#7f1d1d" }}>
                                      <strong>Reason:</strong> {t.reason_to_reject}
                                    </div>
                                  )}
                                  <div style={{ fontSize: 12, color: "#64748b", marginTop: 4 }}>
                                    Sent by {t?.created_by || "--"}
                                  </div>
                                </div>
                                <div style={{ textAlign: "right", fontSize: 12, color: "#475569", fontWeight: 600 }}>
                                  {t?.timestamp ? formatTestDate(t.timestamp) : "--"}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div> : (
                      <div>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                          <h6 className="fw-bold mb-0" style={{ color: "#0f172a" }}>TalentScan History</h6>
                          <span style={{ fontSize: 12, color: "#64748b" }}>{talentScanHistory.length} records</span>
                        </div>
                        {talentScanHistory.length === 0 ? (
                          <div style={{ border: "1px dashed #cbd5e1", borderRadius: 10, padding: "22px", textAlign: "center", color: "#64748b", background: "#f8fafc" }}>
                            No TalentScan history available
                          </div>
                        ) : (
                          <div style={{ display: "grid", gap: 10 }}>
                            {talentScanHistory.map((record, idx) => (
                              <div key={record.id || idx} style={{ border: "1px solid #dbeafe", borderRadius: 10, padding: "13px 15px", background: "#f8fbff" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, marginBottom: 10 }}>
                                  <span style={{ padding: "4px 10px", borderRadius: 999, background: "#e0f2fe", color: "#075985", fontSize: 12, fontWeight: 700 }}>
                                    {record.state || "--"}
                                  </span>
                                  <span style={{ fontSize: 12, color: "#64748b" }}>
                                    Created: {record.created_at ? formatTestDate(record.created_at) : "--"}
                                  </span>
                                </div>
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "8px 18px", fontSize: 12, color: "#475569" }}>
                                  <div><strong>Selected date:</strong> {record.selected_date || "--"}</div>
                                  <div><strong>Selected time:</strong> {record.selected_time || "--"}</div>
                                  <div><strong>Scheduled:</strong> {record.scheduled_at ? formatTestDate(record.scheduled_at) : "--"}</div>
                                  <div><strong>Timezone:</strong> {record.timezone_name || "--"}</div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })()}
              {false && (
            <div>
              {/* Candidate Info Card */}
              <div style={{ background: "#f8f9fa", borderRadius: "10px", padding: "16px 20px", marginBottom: "16px" }}>
                <Row>
                  <Col md={6}>
                    <div className="mb-2">
                      <small className="text-muted d-block">Candidate Name</small>
                      <strong style={{ fontSize: "15px" }}>{consentDetailData.candidate_name || "--"}</strong>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-2">
                      <small className="text-muted d-block">Current Status</small>
                      <span
                        style={{
                          display: "inline-block",
                          padding: "3px 12px",
                          borderRadius: "20px",
                          fontSize: "13px",
                          fontWeight: 600,
                          color: consentDetailData.status === "Pending" || consentDetailData.status === "Not Sent" ? "#000" : "#fff",
                          background:
                            consentDetailData.status === "accepted" ? "#198754"
                              : consentDetailData.status === "Rejected" ? "#dc3545"
                              : consentDetailData.status === "Pending" ? "#ffc107"
                              : "#0dcaf0",
                        }}
                      >
                        {consentDetailData.status || "--"}
                      </span>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <div className="mb-1">
                      <small className="text-muted d-block">Email</small>
                      <span style={{ fontSize: "14px" }}>{consentDetailData.email || "--"}</span>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-1">
                      <small className="text-muted d-block">Phone</small>
                      <span style={{ fontSize: "14px" }}>{consentDetailData.phone || "--"}</span>
                    </div>
                  </Col>
                </Row>
              </div>

              {/* Summary Cards */}

              {/* Consent History Timeline */}
              {/* {consentDetailData.history && consentDetailData.history.length > 0 && (
                <div>
                  <h6 className="fw-bold mb-3" style={{ borderBottom: "2px solid #0d6efd", paddingBottom: "6px", display: "inline-block" }}>
                    Consent History
                  </h6>
                  <div style={{ position: "relative", paddingLeft: "28px" }}>
                    {/* Vertical timeline line */}
                    {/* <div style={{
                      position: "absolute", left: "10px", top: "8px", bottom: "8px",
                      width: "2px", background: "#dee2e6"
                    }}></div> */}

                    {/* {consentDetailData.history.map((h, idx) => {
                      const cg = h.consent_given;
                      const isConsented = cg === true || cg === "true";
                      const isDeclined = cg === false || cg === "false";
                      const isPending = cg === null || cg === undefined;
                      const dotColor = isConsented ? "#198754" : isDeclined ? "#dc3545" : "#ffc107";
                      const bgColor = isConsented ? "#e8f5e9" : isDeclined ? "#fde8e8" : "#fff8e1";
                      const statusLabel = isConsented ? "Consented" : isDeclined ? "Declined" : "Pending";

                      return (
                        <div key={idx} style={{ position: "relative", marginBottom: idx < consentDetailData.history.length - 1 ? "12px" : "0" }}>
                          {/* Timeline dot */}
                          {/* <div style={{
                            position: "absolute", left: "-22px", top: "12px",
                            width: "12px", height: "12px", borderRadius: "50%",
                            background: dotColor, border: "2px solid #fff",
                            boxShadow: `0 0 0 2px ${dotColor}`
                          }}></div> */}

                          {/* <div style={{ background: bgColor, borderRadius: "8px", padding: "12px 16px" }}>
                            <Row className="align-items-center">
                              <Col md={3}>
                                <small className="text-muted">Sent</small>
                               <div style={{ fontSize: "13px", fontWeight: 500 }}>
                                    {h.created_at
                                      ? new Date(h.created_at).toLocaleString("en-IN", {
                                          timeZone: "Asia/Kolkata",
                                          day: "2-digit",
                                          month: "2-digit",
                                          year: "numeric",
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          hour12: false
                                        })
                                      : "--"}
                                  </div>
                              </Col>
                              <Col md={3}>
                                <small className="text-muted">Response</small>
                               <div style={{ fontSize: "13px", fontWeight: 500 }}>
                                  {h.consent_given_at
                                    ? (() => {
                                        const d = new Date(h.consent_given_at);
                                        const ist = new Date(d.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
                                        const day = String(ist.getDate()).padStart(2, "0");
                                        const month = String(ist.getMonth() + 1).padStart(2, "0");
                                        const year = ist.getFullYear();
                                        const hours = String(ist.getHours()).padStart(2, "0");
                                        const minutes = String(ist.getMinutes()).padStart(2, "0");
                                        return `${day}-${month}-${year} ${hours}:${minutes}`;
                                      })()
                                    : "No response yet"}
                                </div>
                              </Col>
                              <Col md={3}>
                                <small className="text-muted">Sent By</small>
                                <div style={{ fontSize: "13px", fontWeight: 500 }}>
                                  {h.created_by__name || consentDetailData.sent_by_name || "--"}
                                </div>
                              </Col>
                              <Col md={3} className="text-md-end">
                                <span
                                  style={{
                                    display: "inline-block",
                                    padding: "3px 14px",
                                    borderRadius: "20px",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    color: isPending ? "#000" : "#fff",
                                    background: dotColor,
                                  }}
                                >
                                  {statusLabel}
                                </span>
                              </Col>
                            </Row>
                          </div>
                        </div> */}
                      {/* ); */}
                    {/* })} */} 
                  {/* </div> */}
                {/* </div> */}
              {/* )}  */}
              {consentDetailData.timeline && consentDetailData.timeline.length > 0 && (
                  <div>
                    <h6 className="fw-bold mb-3" style={{ borderBottom: "2px solid #0d6efd", paddingBottom: "6px", display: "inline-block" }}>
                      Consent History
                    </h6>

                    <div style={{ position: "relative", paddingLeft: "28px" }}>
                      <div style={{
                        position: "absolute", left: "10px", top: "8px", bottom: "8px",
                        width: "2px", background: "#dee2e6"
                      }}></div>

                      {consentDetailData.timeline.map((t, idx) => {
                        const isSent = t.event === "consent_sent";
                        const isAccepted = t.event === "consent_accepted";
                        const isDeclined =
                          t.event === "consent_declined" ||
                          t.event === "consent_rejected";

                        const dotColor = isAccepted ? "#198754" : isDeclined ? "#dc3545" : "#ffc107";
                        const bgColor = isAccepted ? "#e8f5e9" : isDeclined ? "#fde8e8" : "#fff8e1";

                        const label = isAccepted
                          ? "Consented"
                          : isDeclined
                          ? "Declined"
                          : "Sent";

                        return (
                          <div key={idx} style={{ position: "relative", marginBottom: "12px" }}>
                            {/* Dot */}
                            <div style={{
                              position: "absolute", left: "-22px", top: "12px",
                              width: "12px", height: "12px", borderRadius: "50%",
                              background: dotColor, border: "2px solid #fff",
                              boxShadow: `0 0 0 2px ${dotColor}`
                            }}></div>

                            <div style={{ background: bgColor, borderRadius: "8px", padding: "12px 16px" }}>
                              <Row className="align-items-center">
                                 <Col md={3}>
                                  <small className="text-muted">Sent By</small>
                                  <div style={{ fontSize: "13px", fontWeight: 500 }}>
                                    {t?.created_by ||  "--"}
                                  </div>
                                </Col>
                                
                                {/* Time */}
                                <Col md={3}>
                                  <small className="text-muted">Sent on</small>
                                  <div style={{ fontSize: "13px", fontWeight: 500 }}>
                                    {t?.timestamp ? formatTestDate(t.timestamp) : "--"}
                                  </div>
                                </Col>

                                {/* Note */}
                                <Col md={3}>
                                  <small className="text-muted">Response</small>
                                  <div style={{ fontSize: "13px", fontWeight: 500 }}>
                                    {t?.note || "--"}
                                  </div>
                                  {isDeclined && t?.reason_to_reject && (
                                    <div style={{ fontSize: "13px", marginTop: "6px", color: "#7f1d1d" }}>
                                      <strong>Rejected Reason :</strong> {t.reason_to_reject}
                                    </div>
                                  )}
                                </Col>

                                {/* Status */}
                                <Col md={3} className="text-md-end">
                                  <span
                                    style={{
                                      display: "inline-block",
                                      padding: "3px 14px",
                                      borderRadius: "20px",
                                      fontSize: "12px",
                                      fontWeight: 600,
                                      color: label === "Sent" ? "#000" : "#fff",
                                      background: dotColor,
                                    }}
                                  >
                                    {label}
                                  </span>
                                </Col>

                              </Row>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
            </div>
              )}
            </>
          ) : null}
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <Button className="btn btn-primary addBtn" onClick={() => setConsentDetailModal(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      {/* Resume Score Reason Modal */}
      {/* Resume Score Reason Modal */}
{/* Resume Score Reason Modal */}
{/* Resume Score Reason Modal */}
<Modal isOpen={resumeReasonModal} toggle={() => setResumeReasonModal(false)} centered size="xl" className="resume-score-modal">
  <ModalHeader
    toggle={() => setResumeReasonModal(false)}
    style={{ background: "linear-gradient(135deg, #0f527d 0%, #176b91 100%)", color: "#fff", border: 0, padding: "16px 22px" }}
  >
    Resume Score Breakdown
  </ModalHeader>
  <ModalBody style={{ padding: 0, background: "#f4f8fc" }}>
    {resumeReasonData && (() => {
      const rawReason = resumeReasonData?.score_reason;
      const pick = (obj, ...keys) => {
        if (!obj) return undefined;
        for (const k of keys) {
          if (obj[k] !== undefined) return obj[k];
        }
        return undefined;
      };

      const normalizeSection = (sec) => {
        if (!sec) return sec;
        return {
          ...sec,
          summary: pick(sec, "summary", "reason", "explanation"),
          primary_match: pick(sec, "primary_match", "primary_matches"),
          secondary_match: pick(sec, "secondary_match", "secondary_matches"),
          other_match: pick(sec, "other_match", "other_matches"),
          total_jd_skills: pick(sec, "total_jd_skills", "total_skills", "total_required_skills"),
          candidate_exp: pick(sec, "candidate_exp", "candidate_experience"),
          required_min: pick(sec, "required_min", "min_exp"),
          required_max: pick(sec, "required_max", "max_exp"),
          degree_sub_score: pick(sec, "degree_sub_score", "degree_score"),
          cert_sub_score: pick(sec, "cert_sub_score", "certificate_score"),
          required_level: pick(sec, "required_level", "min_education_level"),
          jd_title: pick(sec, "jd_title"),
          roles_checked: pick(sec, "roles_checked"),
          matched_skills: pick(sec, "matched_skills", "matchedSkills", "matched", "skills_matched", "matched_skill_names"),
        };
      };

      const reason = rawReason ? {
        ...rawReason,
        skill: normalizeSection(rawReason.skill ?? rawReason.skills),
        experience: normalizeSection(rawReason.experience),
        education: normalizeSection(rawReason.education),
        location: normalizeSection(rawReason.location),
        title: normalizeSection(rawReason.title ?? rawReason.job_title),
        meta: rawReason.meta ? {
          ...rawReason.meta,
          effective_weights: (() => {
            const ew = rawReason.meta.effective_weights || rawReason.meta.weights || {};
            const { skills, ...rest } = ew;
            return { ...rest, skill: ew.skill ?? skills };
          })(),
        } : rawReason.meta,
      } : rawReason;

      const totalScore = resumeReasonData?.score ?? 0;

      const toValueList = value => {
        if (!value) return [];
        if (Array.isArray(value)) {
          return value
            .flat(Infinity)
            .map(item => String(item || "").trim())
            .filter(Boolean);
        }
        if (typeof value === "string") {
          return value
            .replace(/^matched skills\s*:\s*/i, "")
            .split(/,\s*/)
            .map(item => item.trim())
            .filter(Boolean);
        }
        return [];
      };

      const getMatchedSkills = sec => {
        const directSkills = toValueList(sec?.matched_skills);
        if (directSkills.length > 0) return directSkills;

        const summary = typeof sec?.summary === "string" ? sec.summary : "";
        const summaryMatch = summary.match(/matched skills\s*:\s*(.*)$/i);
        return toValueList(summaryMatch?.[1]);
      };

      const scoreColor = (n) => {
        if (n >= 70) return { bg: "#EAF3DE", c: "#27500A", bar: "#639922" };
        if (n >= 45) return { bg: "#FAEEDA", c: "#633806", bar: "#EF9F27" };
        return { bg: "#FCEBEB", c: "#791F1F", bar: "#E24B4A" };
      };

      const sections = [
        { key: "skill",      label: "Skills",     icon: "🧠", ib: "#E6F1FB", ic: "#185FA5" },
        { key: "experience", label: "Experience", icon: "💼", ib: "#EAF3DE", ic: "#3B6D11" },
        { key: "education",  label: "Education",  icon: "🎓", ib: "#EEEDFE", ic: "#534AB7" },
        { key: "location",   label: "Location",   icon: "📍", ib: "#FAEEDA", ic: "#854F0B" },
        { key: "title",      label: "Job Title",  icon: "🏷️", ib: "#F1EFE8", ic: "#5F5E5A" },
      ];

      const extraChips = (key, sec) => {
        if (key === "skill") return [
          { l: "Primary match",   v: sec.primary_match },
          { l: "Secondary match", v: sec.secondary_match },
          { l: "Other match",     v: sec.other_match },
          { l: "Total JD skills", v: sec.total_jd_skills },
        ];
        if (key === "experience") return [
          { l: "Candidate", v: sec.candidate_exp !== undefined ? `${sec.candidate_exp} yrs` : undefined },
          { l: "Required",  v: (sec.required_min !== undefined && sec.required_max !== undefined)
              ? `${sec.required_min}–${sec.required_max} yrs` : undefined },
        ];
        if (key === "education") return [
          { l: "Degree score",   v: sec.degree_sub_score !== undefined ? `${sec.degree_sub_score}/100` : undefined },
          { l: "Cert score",     v: sec.cert_sub_score !== undefined ? `${sec.cert_sub_score}/100` : undefined },
          { l: "Required level", v: sec.required_level },
        ];
        if (key === "title") return [
          { l: "JD title",      v: sec.jd_title },
          { l: "Roles checked", v: sec.roles_checked },
        ];
        return [];
      };

      return (
        <div>
          {/* ── Header ── */}
          <div style={{
            display: "grid", gridTemplateColumns: "1fr auto", gap: 16,
            alignItems: "center", padding: "18px 24px",
            borderBottom: "1px solid #e2e8f0", background: "#f8fafc",
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
              <div style={{
                width: 48, height: 48, borderRadius: "50%",
                background: "#E6F1FB", color: "#0C447C",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontWeight: 500, fontSize: 16, flexShrink: 0,
              }}>
                {(resumeReasonData.first_name?.[0] || "").toUpperCase()}
                {(resumeReasonData.last_name?.[0] || "").toUpperCase()}
              </div>
              <div>
                <div style={{ fontSize: 17, fontWeight: 600, color: "#0f172a", marginBottom: 4 }}>
                  {`${resumeReasonData.first_name || ""} ${resumeReasonData.last_name || ""}`.trim() || "—"}
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                  {[
                    { icon: "✉️", val: resumeReasonData.email },
                    { icon: "📞", val: resumeReasonData.mobile_phone },
                    { icon: "🗓️", val: `${resumeReasonData.total_experience ?? 0} yrs experience` },
                  ].filter(x => x.val).map(({ icon, val }) => (
                    <span key={val} style={{ fontSize: 13, color: "#64748b", display: "flex", alignItems: "center", gap: 4 }}>
                      <span style={{ fontSize: 12 }}>{icon}</span>{val}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div style={{
              textAlign: "center", background: "#E6F1FB",
              border: "1px solid #B5D4F4", borderRadius: 10,
              padding: "12px 24px", minWidth: 110,
            }}>
              <div style={{ fontSize: 30, fontWeight: 700, color: "#0C447C", lineHeight: 1 }}>{totalScore}%</div>
              <div style={{ fontSize: 12, color: "#185FA5", marginTop: 4 }}>Overall match</div>
            </div>
          </div>

          {/* ── Section Cards ── */}
          <div style={{
            display: "grid", gridTemplateColumns: "1fr 1fr 1fr",
            gap: 14, padding: "20px 24px 24px",
          }}>
           {sections.map(({ key, label, icon, ib }) => {
              const sec = reason?.[key];
              if (!sec) return null;
              const applied = sec.applied !== false;
              const n = Number(sec.score ?? 0);
              const sc = applied ? scoreColor(n) : { bg: "#f1f5f9", c: "#94a3b8", bar: "#cbd5e1" };
              const chips = applied ? extraChips(key, sec).filter(c => c.v !== undefined) : [];
              const matchedSkills = key === "skill" ? getMatchedSkills(sec) : [];
              const weight = sec.weight || reason?.meta?.effective_weights?.[key] || "—";

              // For skills, build the summary from the actual matched-primary count
              // instead of trusting sec.summary (which can disagree with the chips).
              const displaySummary =
                key === "skill" && (sec.primary_match !== undefined || sec.total_jd_skills !== undefined)
                  ? `${sec.primary_match ?? 0} primary${sec.other_match ? `, ${sec.other_match} other` : ""} matched out of ${sec.total_jd_skills ?? 0} JD skills`
                  : sec.summary;
              const cleanDisplaySummary =
                key === "skill" && matchedSkills.length > 0
                  ? String(displaySummary || "").replace(/matched skills\s*:\s*.*$/i, "").trim()
                  : displaySummary;

                return (
                  <div key={key} style={{
                  background: applied ? "#ffffff" : "#f8fafc",
                  border: `1px solid ${applied ? "#d6e4ef" : "#e2e8f0"}`,
                  borderRadius: 12, padding: "16px 17px",
                  minHeight: matchedSkills.length > 0 ? 0 : 150,
                  boxShadow: applied ? "0 4px 14px rgba(15, 82, 125, 0.06)" : "none",
                  opacity: applied ? 1 : 0.6,
                  gridColumn: matchedSkills.length > 0 ? "1 / -1" : undefined,
                }}>
                  {/* Card header */}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10, gap: 8 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, flex: 1, minWidth: 0 }}>
                      <div style={{
                        width: 30, height: 30, borderRadius: 7, background: ib,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: 16, flexShrink: 0,
                      }}>
                        {icon}
                      </div>
                      <span style={{ fontSize: 14, fontWeight: 600, color: "#1e293b" }}>{label}</span>
                      {!applied && (
                        <span style={{
                          fontSize: 11, padding: "2px 8px", borderRadius: 999,
                          background: "#e2e8f0", color: "#94a3b8", flexShrink: 0,
                        }}>not applied</span>
                      )}
                    </div>
                    <span style={{
                      fontSize: 14, fontWeight: 600, padding: "3px 12px",
                      borderRadius: 999, whiteSpace: "nowrap",
                      background: sc.bg, color: sc.c,
                    }}>
                      {n}<span style={{ fontSize: 11, opacity: 0.65 }}>/100</span>
                    </span>
                  </div>

                  {/* Progress bar */}
                  <div style={{ height: 6, borderRadius: 999, background: "#e2e8f0", overflow: "hidden", marginBottom: 10 }}>
                    <div style={{ width: `${Math.min(n, 100)}%`, height: "100%", borderRadius: 999, background: sc.bar }} />
                  </div>

                  {/* Summary */}
                  {cleanDisplaySummary && (
                    <div style={{ fontSize: 12, color: "#64748b", lineHeight: 1.6, marginBottom: chips.length ? 8 : 0 }}>
                      {cleanDisplaySummary}
                    </div>
                  )}

                  {matchedSkills.length > 0 && (
                    <div style={{
                      marginBottom: 10,
                      padding: "10px 12px",
                      borderRadius: 8,
                      background: "#fff",
                      border: "1px solid #dbeafe",
                    }}>
                      <div style={{
                        fontSize: 12,
                        fontWeight: 700,
                        color: "#185FA5",
                        marginBottom: 7,
                      }}>
                        Matched skills
                      </div>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                        {matchedSkills.map(skill => (
                          <span
                            key={skill}
                            title={skill}
                            style={{
                              fontSize: 12,
                              padding: "4px 9px",
                              borderRadius: 999,
                              background: "#E6F1FB",
                              border: "1px solid #B5D4F4",
                              color: "#0C447C",
                              fontWeight: 600,
                              whiteSpace: "normal",
                            }}
                          >
                            {skill}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Chips */}
                  {chips.length > 0 && (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
                      {chips.map(({ l, v }) => (
                        <span key={l} style={{
                          fontSize: 12, padding: "3px 10px", borderRadius: 999,
                          background: "#fff", border: "1px solid #e2e8f0", color: "#475569",
                        }}>
                          {l}: <strong style={{ color: "#0f172a" }}>{v}</strong>
                        </span>
                      ))}
                    </div>
                  )}

                  {/* Weight footer */}
                  <div style={{
                    marginTop: 10, paddingTop: 8,
                    borderTop: "1px solid #e2e8f0",
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                  }}>
                    <span style={{ fontSize: 12, color: "#94a3b8" }}>Percentage</span>
                    <span style={{ fontSize: 13, fontWeight: 600, color: "#475569" }}>{weight}</span>
                  </div>
                </div>
              );
            })}
          </div>

          {/* ── Effective Weights Footer ── */}
          {reason?.meta?.effective_weights && (
            <div style={{
              display: "flex", flexWrap: "wrap", gap: 7, alignItems: "center",
              padding: "16px 24px 18px",
              borderTop: "1px solid #dbe6f0", background: "#eef5fa",
            }}>
              <span style={{ fontSize: 14, color: "#284866", fontWeight: 700, marginRight: 2 }}>Score weighting</span>
              {
              Object.entries(reason.meta.effective_weights).map(([k, v]) => (
                <span key={k} style={{
                  fontSize: 12, padding: "4px 12px", borderRadius: 999,
                  background: "#fff", border: "1px solid #e2e8f0", color: "#64748b",
                }}>
                  {k.charAt(0).toUpperCase() + k.slice(1)}: <strong style={{ color: "#1e293b" }}>{v}</strong>
                </span>
              ))
              }
            </div>
          )}
        </div>
      );
    })()}
  </ModalBody>
  <ModalFooter className="justify-content-center">
    <Button className="btn btn-primary addBtn" onClick={() => setResumeReasonModal(false)}>Close</Button>
  </ModalFooter>
</Modal>
      <Modal
  isOpen={showBulkOutreachModal}
  toggle={() => { setShowBulkOutreachModal(false); setOutreachTab("compose"); }}
  size="lg"
  centered
  className="bo-modal"
>
  <ModalHeader
    className="bo-colored-header"
    toggle={() => { setShowBulkOutreachModal(false); setOutreachTab("compose"); }}
    style={{
      border: "none",
      background: "linear-gradient(135deg, #075985, #0f77b4)",
      borderRadius: "0.3rem 0.3rem 0 0",
    }}
  >
    <div style={{ display: "grid", gridTemplateColumns: "minmax(0, 1fr)", alignItems: "center", gap: 18, width: "100%", paddingRight: 38 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
        <div
          style={{
            width: 42,
            height: 42,
            borderRadius: "12px",
            background: "rgba(255, 255, 255, 0.16)",
            border: "1px solid rgba(255, 255, 255, 0.26)",
            color: "#fff",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 800,
            fontSize: 18,
            boxShadow: "0 8px 18px rgba(8, 47, 73, 0.24)",
            flex: "0 0 auto",
          }}
        >
          <FaEnvelopeOpenText />
        </div>
        <div
          style={{
            fontWeight: 800,
            color: "#fff",
            fontSize: 18,
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
          title={configureCallJob?.job_title || "Bulk Outreach"}
        >
          Bulk Outreach
          <div
            style={{
              color: "rgba(255, 255, 255, 0.84)",
              fontSize: 12,
              fontWeight: 600,
              marginTop: 2,
            }}
          >
            {configureCallJob?.job_title || "Job"} | {(selectedCandidateRows[configureCallJob?.job_id || configureCallJob?.id] || []).length} candidates
          </div>
        </div>
      </div>
    </div>
  </ModalHeader>

  <ModalBody onKeyDown={stopBulkOutreachEventPropagation}>
    {/* ── Tab Bar ── */}
    <div className="bo-tabs">
      {[
        { id: "compose",  label: "Compose" },
        { id: "followup", label: "Follow-up" },
        { id: "review",   label: "Review" },
      ].map((t) => {
        const isDone =
          (t.id === "compose"  && ["followup", "review"].includes(outreachTab)) ||
          (t.id === "followup" && outreachTab === "review");
        return (
          <div
            key={t.id}
            className={["bo-tab", outreachTab === t.id ? "active" : "", isDone ? "done" : ""].join(" ")}
            onClick={() => {
              setOutreachTab(t.id);
            }}
          >
            {isDone ? `✓ ${t.label}` : t.label}
          </div>
        );
      })}
    </div>

    {/* ════ TAB 1 — COMPOSE ════ */}
    {outreachTab === "compose" && (
      <div className="bo-panel">
        <div className="bo-section-head">
          <span className="bo-section-icon"><FaEnvelopeOpenText /></span>
          <div>
            <div className="bo-section-title">Compose Outreach</div>
            <div className="bo-section-subtitle">Choose channels and craft the message candidates will receive first.</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
          <button
            className={`bo-channel-btn ${outreachChannels.email ? "active" : ""}`}
            onClick={() => setOutreachChannels(p => ({ ...p, email: !p.email }))}
          >
            <input type="checkbox" checked={outreachChannels.email} readOnly style={{ accentColor: "#2563eb" }} />
            <FaRegEnvelope />
            📧 Email
          </button>
          <button
            className={`bo-channel-btn wp ${outreachChannels.whatsapp ? "active" : ""}`}
            onClick={() => setOutreachChannels(p => ({ ...p, whatsapp: !p.whatsapp }))}
          >
            <input type="checkbox" checked={outreachChannels.whatsapp} readOnly style={{ accentColor: "#16a34a" }} />
            <FaWhatsapp />
            💬 WhatsApp
          </button>
        </div>

        {outreachChannels.email && (
          <>
            <div className="bo-label">Email Subject</div>
        <input
          className="bo-input bo-input-subject"
          style={{ marginBottom: 16 }}
          placeholder="Opportunity : Full Stack Engineer — Bharat ATS"
          value={outreachSubject}
          onChange={e => setOutreachSubject(e.target.value)}
        />

          </>
        )}

        <div className="bo-label">Message Body (Email &amp; WhatsApp)</div>
        <textarea
          className="bo-input bo-textarea"
          value={outreachBody}
          onChange={(e) => setOutreachBody(e.target.value)}
        />

        {/* <div className="bo-vars">
          <span style={{ fontSize: 12, color: "#94a3b8", alignSelf: "center" }}>Variables:</span>
          {["{CandidateName}", "{JobTitle}", "{ConsentLink}", "{RecruiterName}"].map(v => (
            <span key={v} className="bo-var" title="Click to insert" onClick={() => setOutreachBody(b => b + v)}>
              {v}
            </span> 
          ))}
        </div> */}

        <div className="bo-hint">
          <span>⚠️</span>
          <span><strong>One-time blast:</strong> Initial message sent once per candidate. Follow-up reminders go to non-responders.</span>
        </div>
      </div>
    )}

    {/* ════ TAB 2 — FOLLOW-UP ════ */}
    {outreachTab === "followup" && (
      <div className="bo-panel">
        <div className="bo-section-head">
          <span className="bo-section-icon"><FaHistory /></span>
          <div>
            <div className="bo-section-title">Reminder Settings</div>
            <div className="bo-section-subtitle">Configure how often reminders go out and when they should stop.</div>
          </div>
        </div>
        <div className="bo-alert">
          🔔 Auto-reminders only go to non-responders until they Accept, Decline, or the max is reached.
        </div>

        <Row className="mb-3">
          <Col md={6}>
            <div className="bo-label">Reminder Frequency</div>
            <select className="bo-input" value={outreachFrequency} onChange={e => setOutreachFrequency(e.target.value)}>
              <option value="daily">Daily (every 24 hours)</option>
              <option value="12h">Every 12 hours</option>
              <option value="48h">Every 48 hours</option>
              <option value="weekly">Weekly</option>
            </select>
          </Col>
          <Col md={6}>
            <div className="bo-label">Number Of Days</div>
            <input
              type="number" className="bo-input" min={1} max={20}
              value={outreachMaxReminders}
              onChange={e => setOutreachMaxReminders(Number(e.target.value))}
            />
            <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>
              After {outreachMaxReminders} reminders → marked Unresponsive
            </div>
          </Col>
        </Row>

        <div className="bo-label" style={{ marginBottom: 10 }}>Reminder Channels</div>
        <div style={{ display: "flex", gap: 16, marginBottom: 20 }}>
          {[
            { key: "email",    label: "📧 Email" },
            { key: "whatsapp", label: "💬 WhatsApp" },
            // { key: "sms",      label: "📱 SMS" },
          ].map(ch => (
            <label key={ch.key} className="bo-check-row">
              <input type="checkbox" checked={outreachChannels[ch.key] || false}
                onChange={() => setOutreachChannels(p => ({ ...p, [ch.key]: !p[ch.key] }))} />
              {ch.label}
            </label>
          ))}
        </div>

        <div className="bo-label" style={{ marginBottom: 10 }}>Auto-stop Conditions</div>
        {[
          { key: "accept",  label: "Candidate clicks Accept" },
          { key: "decline", label: "Candidate clicks Decline" },
          { key: "max",     label: "Maximum reminders reached" },
        ].map(c => (
          <label key={c.key} className="bo-check-row">
            <input type="checkbox" checked={outreachAutoStop[c.key]}
              onChange={() => setOutreachAutoStop(p => ({ ...p, [c.key]: !p[c.key] }))} />
            {c.label}
          </label>
        ))}
      </div>
    )}

    {/* ════ TAB 3 — REVIEW ════ */}
    {outreachTab === "review" && (() => {
      const jobId = configureCallJob?.id;
      const selectedIds = selectedCandidateRows[jobId] || [];
      const allCandidates = candidateDataMap[jobId] || [];
      const selectedCandidates = allCandidates.filter(c => selectedIds.includes(c.job_candidate_id));
      const channels = [
        outreachChannels.email && "Email",
        outreachChannels.whatsapp && "WhatsApp",
        // outreachChannels.sms && "SMS",
      ].filter(Boolean).join(" + ");
      const freqLabel = { daily: "daily", "12h": "every 12 hours", "48h": "every 48 hours", weekly: "weekly" }[outreachFrequency];
      const avatarColors = ["#2563eb","#7c3aed","#db2777","#059669","#d97706"];

      return (
        <div className="bo-panel">
          <div className="bo-card-1" style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: 700, marginBottom: 12, display: "flex", alignItems: "center", gap: 8 }}>
              <FaRegEye style={{ color: "#2563eb" }} />
              <span>Review Summary</span>
            </div>
            {[
              { label: "Job",        value: configureCallJob?.job_title || "--" },
              { label: "Recipients", value: `${selectedCandidates.length} candidates` },
              { label: "Channels",   value: channels || "--" },
              { label: "Follow-up",  value: `${freqLabel} · max ${outreachMaxReminders} reminders` },
            ].map(r => (
              <div key={r.label} className="bo-info-row">
                <span className="bo-info-label">{r.label}</span>
                <span style={{ color: "#1e293b", fontWeight: 500 }}>{r.value}</span>
              </div>
            ))}
          </div>

          <div className="bo-card bo-review-list">
            <div style={{ fontWeight: 700, color: "#2563eb", marginBottom: 10, display: "flex", alignItems: "center", gap: 8 }}>
              <FaCopy />
              <span>Candidate List</span>
            </div>
            {selectedCandidates.length === 0 ? (
              <p className="text-muted mb-0" style={{ fontSize: 13 }}>No candidates selected.</p>
            ) : selectedCandidates.map((c, i) => {
              const name = `${c.first_name || ""} ${c.last_name || ""}`.trim() || "Unknown";
              return (
                <div key={c.job_candidate_id} className="bo-candidate-item ">
                  <div className="bo-avatar" style={{ background: avatarColors[i % avatarColors.length] }}>
                    {name.charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <div style={{ fontWeight: 600 }}>{name}</div>
                    <div style={{ color: "#94a3b8", fontSize: 12 }}>{c.email || "--"}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );
    })()}
  </ModalBody>

  <ModalFooter style={{ justifyContent: "center", gap: 10 }}>
    <div style={{ display: "flex", justifyContent: "center" }}>
      {outreachTab !== "compose" && (
        <button className="bo-btn-secondary" onClick={() => {
          if (outreachTab === "review")   setOutreachTab("followup");
          if (outreachTab === "followup") setOutreachTab("compose");
        }}>← Back</button>
      )}
    </div>
    <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
      <button className="bo-btn-secondary" onClick={() => {
        setShowBulkOutreachModal(false);
        setOutreachTab("compose");
      }}>Cancel</button>

      {outreachTab !== "review" ? (
        <button className="bo-btn-primary" 
       onClick={() => {
              if (outreachTab === "compose") setOutreachTab("followup");
              else setOutreachTab("review");
            }}
        >Next →</button>
      ) : (
        <button
          className="bo-btn-primary"
          disabled={isSendingOutreach}
          onClick={async () => {
              const jobId = configureCallJob?.id;
              const selectedIds = selectedCandidateRows[jobId] || [];

              if (!selectedIds.length) {
                Swal.fire("Warning", "No candidates selected.", "warning");
                return;
              }

              const selectedCompanyDomain = String(getCompanyDomainById(companyId) || "").toLowerCase();
              if (selectedCompanyDomain === "vgus") {
                const allCandidates = [
                  ...(candidateDataMap[jobId] || []),
                  ...Object.values(selectedCandidateRowData[jobId] || {}),
                ].filter((candidate, index, candidates) => {
                  const candidateId = getCandidateRowId(candidate) || candidate?.candidate_id || candidate?.job_candidate_id;
                  return candidates.findIndex(item => {
                    const itemId = getCandidateRowId(item) || item?.candidate_id || item?.job_candidate_id;
                    return String(itemId) === String(candidateId);
                  }) === index;
                });
                const selectedCandidates = allCandidates.filter(candidate =>
                  selectedIds.some(id =>
                    String(getCandidateRowId(candidate)) === String(id) ||
                    String(candidate?.candidate_id) === String(id) ||
                    String(candidate?.job_candidate_id) === String(id)
                  )
                );
                const indianNumberCandidates = selectedCandidates.filter(candidate => {
                  const phone = String(
                    candidate?.mobile_phone ||
                    candidate?.candidate_phone ||
                    candidate?.phone ||
                    ""
                  ).trim();
                  return phone && !phone.startsWith("+1");
                });

                if (indianNumberCandidates.length > 0) {
                  await Swal.fire({
                    icon: "warning",
                    title: "Cannot Schedule Outreach",
                    text: "Outreach cannot be scheduled for Indian numbers under VGUS. Please select candidates with +1 phone numbers.",
                    confirmButtonText: "OK",
                  });
                  return;
                }
              }

              const requiresSubject = outreachChannels.email;
              if ((requiresSubject && !outreachSubject.trim()) || !outreachBody.trim()) {
                Swal.fire("Warning", requiresSubject ? "Subject & Body required" : "Body required", "warning");
                return;
              }

              setIsSendingOutreach(true);

              try {
                let apiChannel = "email";
                if (outreachChannels.email && outreachChannels.whatsapp) apiChannel = "both";
                else if (outreachChannels.whatsapp) apiChannel = "whatsapp";

                const freqMap = {
                  daily: 24,
                  "12h": 12,
                  "48h": 48,
                  weekly: 168
                };

                const res=await axios.post(
                  "/api/v1/send-bulk-notifications/",
                  {
                    channel: apiChannel,
                    subject: outreachSubject,
                    body_template: outreachPayloadBody || outreachBody,
                    job_id: jobId,
                    job_candidate_ids: selectedIds,
                    consent_url: buildConsentScheduleUrl(configureCallJob),
                    unsubscribe_url: buildConsentUnsubscribeUrl(configureCallJob),
                    reminder_freq_hours: freqMap[outreachFrequency],
                    // reminder_freq_hours: 24,
                    max_reminders: outreachMaxReminders
                  },
                );

                const responseData = res?.data || {};
                let { sent = [], failed = [] } = responseData;

                // The send endpoint queues Celery work. Read the email records until
                // the queued rows have a terminal email_status so the summary matches
                // the backend rather than the initial queue response.
                if (apiChannel === "email" || apiChannel === "both") {
                  for (let attempt = 0; attempt < 40; attempt += 1) {
                    try {
                      const emailResponse = await axios.get("/api/v1/emails/", {
                        params: { page: 1, size: Math.max(selectedIds.length, 50), company_id: companyId, job_id: jobId },
                      });
                      const emailRows = Array.isArray(emailResponse?.data?.results)
                        ? emailResponse.data.results
                        : Array.isArray(emailResponse?.data?.data)
                          ? emailResponse.data.data
                          : [];
                      const selectedEmailRows = emailRows.filter(row => {
                        const rowJobId = row.job_id ?? row.job_order_id;
                        const rowCandidateId = row.candidate_id ?? row.job_candidate_id;
                        return String(rowJobId) === String(jobId) || selectedIds.some(id => String(id) === String(rowCandidateId));
                      });
                      if (!selectedEmailRows.length) {
                        await new Promise(resolve => setTimeout(resolve, 1500));
                        continue;
                      }
                      const inProgress = selectedEmailRows.some(row => {
                        const status = String(row.email_status || row.status || "").toLowerCase().replace(/[_-]+/g, " ");
                        return status === "pending" || status === "sending" || status === "in progress";
                      });
                      sent = selectedEmailRows.filter(row => String(row.email_status || row.status || "").toLowerCase() === "sent");
                      failed = selectedEmailRows
                        .filter(row => /smtp failed|smtp failure|smtp error|failed|error/.test(String(row.email_status || row.status || "").toLowerCase().replace(/[_-]+/g, " ")))
                        .map(row => ({
                          email: row.to_address || row.to_email || row.recipient_email || row.to_addresses,
                          error: row.email_error || row.error || row.failure_reason || "Email delivery failed",
                          candidate_id: row.candidate_id || row.job_candidate_id,
                        }));
                      if (!inProgress) break;
                      await new Promise(resolve => setTimeout(resolve, 1500));
                    } catch (pollError) {
                      // Activity/status polling must never block the existing outreach result.
                      break;
                    }
                  }
                }
                if (!isSuccessfulDelivery(res, [200, 201, 202]) || responseData.success === false || failed.length > 0) {
                  const disabledLabels = (responseData.disabled_channels || [])
                    .map(channel => ({
                      email: "Email is disabled",
                      whatsapp: "WhatsApp is disabled",
                      sms: "SMS is disabled",
                    }[String(channel).toLowerCase()] || channel))
                    .filter(Boolean);
                  const disabledText = disabledLabels.length
                    ? `\n\n${disabledLabels.join("\n")}`
                    : "";
                  const message = responseData.detail || responseData.reason || responseData.message || "Notifications could not be sent.";

                  const summaryText = deliverySummaryMessage({
                    ...responseData,
                    total_recipients: responseData.total_recipients ?? (sent.length + failed.length || selectedIds.length),
                    successful_count: sent.length,
                    failed_count: failed.length,
                    failed_recipients: failed.map(item => item.email || item.recipient || item),
                  });
                  const outreachAlert = await Swal.fire({
                    icon: "error",
                    title: responseData.disabled_channels?.length ? "Notifications Disabled" : "Outreach delivery failed",
                    text: `${deliveryErrorMessage({ ...responseData, message }, responseData.from_email || responseData.from_address)}\n${summaryText}`,
                    confirmButtonText: "OK",
                  });
                  if (
                    outreachAlert.isConfirmed &&
                    !responseData.disabled_channels?.length &&
                    /enable email or whatsapp in calling notification settings/i.test(message)
                  ) {
                    navigate("/calling-notification-settings");
                  }
                  return;
                }

                setSelectedCandidateRows(prev => {
                  const updated = { ...prev };
                  delete updated[jobId];
                  return updated;
                });
                setSelectedCandidateRowData(prev => {
                  const updated = { ...prev };
                  delete updated[jobId];
                  return updated;
                });
                setShowBulkOutreachModal(false);
                setOutreachTab("compose");

                if (failed.length > 0) {
                  const allCandidates = candidateDataMap[jobId] || [];
                  const failedRows = failed.map(f => {
                    const candidate = allCandidates.find(
                      c => c.candidate_id === f.candidate_id || c.job_candidate_id === f.candidate_id
                    );
                    const recipient = f.email || f.recipient || candidate?.candidate_email || candidate?.email || `Candidate #${f.candidate_id}`;
                    return `<tr><td style="padding:8px 12px;border:1px solid #e5e7eb;font-weight:500;">${recipient}</td><td style="padding:8px 12px;border:1px solid #e5e7eb;color:#dc2626;">${f.error || "Unknown error"}</td></tr>`;
                  }).join("");
                  await Swal.fire({
                    icon: sent.length > 0 ? "warning" : "error",
                    title: sent.length > 0 ? "Partially Sent" : "Failed to Send",
                    html: `<div style="margin-bottom:10px;font-size:13px;color:#374151;"><span style="color:#dc2626;font-weight:600;">${failed.length} failed</span></div><div style="max-height:260px;overflow:auto;"><table style="width:100%;border-collapse:collapse;font-size:13px;"><thead><tr><th style="padding:8px 12px;border:1px solid #e5e7eb;">Recipient</th><th style="padding:8px 12px;border:1px solid #e5e7eb;">Reason</th></tr></thead><tbody>${failedRows}</tbody></table></div>`,
                    width: 560,
                    confirmButtonText: "OK",
                  });
                } else {
                  Swal.fire({
                    icon: "success",
                    title: "Message Sent!",
                    text: "Message sent successfully.",
                    timer: 1800,
                    showConfirmButton: false,
                  });
                }

              } catch (err) {
                const errorData = err?.response?.data || {};
                const errorMessage = deliveryErrorMessage(errorData);
                const outreachErrorAlert = await Swal.fire({
                  icon: err?.response?.status === 400 ? "warning" : "error",
                  title: err?.response?.status === 400 ? "Unable to Send Outreach" : "Error",
                  text: errorMessage,
                  confirmButtonText: "OK",
                });
                if (
                  outreachErrorAlert.isConfirmed &&
                  err?.response?.status === 400 &&
                  /enable email or whatsapp in calling notification settings/i.test(errorMessage)
                ) {
                  navigate("/calling-notification-settings");
                }
              } finally {
                setIsSendingOutreach(false);
              }
            }}
        >
          {isSendingOutreach
            ? <><span className="spinner-border spinner-border-sm me-2" role="status" /><span>Sending...</span></>
            : <><span>🚀</span> Send Outreach</>}
        </button>
      )}
    </div>
  </ModalFooter>
</Modal>
<Modal
  isOpen={showOutreachResultsModal}
  toggle={() => setShowOutreachResultsModal(false)}
  size="xl"
  centered
  scrollable
>
  <ModalBody style={{ padding: 0, background: "#f8fbff", borderRadius: 18 }}>
    <div style={{ padding: 18, borderBottom: "1px solid #d9e4f5", display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 16, flexWrap: "wrap" }}>
      <div>
        <div style={{ fontSize: 22, fontWeight: 800, color: "#1e293b", display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 15 }}>Outreach Results - {configureCallJob?.job_title || "Job Role"}</span>
        </div>
        <div style={{ color: "#7c8aa5", marginTop: 4, fontSize: 12 }}>
          Job ID: {outreachAnalytics?.job_id || configureCallJob?.id || "--"}  Candidates: {outreachAnalytics?.candidates_count ?? outreachTrackerRows.length}
        </div>
      </div>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <button className="bo-btn-secondary" onClick={exportOutreachResultsToExcel} disabled={outreachAnalyticsLoading || !outreachAnalytics}>Export Report</button>
        {/* <button className="bo-btn-primary">New Outreach</button> */}
        <button className="bo-btn-secondary" onClick={() => setShowOutreachResultsModal(false)}>X</button>
      </div>
    </div>

    {outreachAnalyticsLoading ? (
      <div style={{ padding: 40, textAlign: "center" }}>
        <Spinner color="primary" />
        <div style={{ marginTop: 12, color: "#64748b" }}>Loading outreach analytics...</div>
      </div>
    ) : outreachAnalyticsError ? (
      <div style={{ padding: 18 }}>
        <div style={{ background: "#fff1f2", color: "#be123c", border: "1px solid #fecdd3", borderRadius: 12, padding: 16 }}>
          {outreachAnalyticsError}
        </div>
      </div>
    ) : (
      <div style={{ padding: 18 }}>
        <div style={{ display: "flex", gap: 10, marginBottom: 18, overflowX: "auto", flexWrap: "nowrap", paddingBottom: 4 }}>
          {outreachSummaryCards.map(card => (
            <div key={card.label} style={{ background: card.bg, border: `1px solid ${card.accent}33`, borderTop: `3px solid ${card.accent}`, borderRadius: 14, padding: "16px 12px", textAlign: "center", minWidth: 132, flex: "0 0 auto" }}>
              <div style={{ fontSize: 17, lineHeight: 1, fontWeight: 800, color: card.accent }}>{card.value}</div>
              <div style={{ fontSize: 11, fontWeight: 700, color: "#7382a0", marginTop: 6 }}>{card.label}</div>
              <div style={{ fontSize: 11, color: card.accent, marginTop: 4 }}>{card.sub || "\u00A0"}</div>
            </div>
          ))}
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 18 }}>
          <div style={{ background: "#fff", border: "1px solid #d9e4f5", borderRadius: 14, padding: 16 }}>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 14 }}>Channel Performance</div>
            <table style={{ width: "100%", fontSize: 12 }}>
              <thead>
                <tr style={{ color: "#8da0c2", textTransform: "uppercase", fontSize: 11 }}>
                  <th style={{ padding: "0 0 10px", textAlign: "left" }}>Channel</th>
                  <th style={{ padding: "0 0 10px", textAlign: "left" }}>Sent</th>
                  <th style={{ padding: "0 0 10px", textAlign: "left" }}>Delivered</th>
                  <th style={{ padding: "0 0 10px", textAlign: "left" }}>Opened</th>
                  <th style={{ padding: "0 0 10px", textAlign: "left" }}>Responded</th>
                </tr>
              </thead>
              <tbody>
                {outreachChannelsTable.map(row => (
                  <tr key={row.channel}>
                    <td style={{ padding: "12px 0", borderTop: "1px solid #edf2f7", fontWeight: 600 }}>{row.channel}</td>
                    <td style={{ padding: "12px 0", borderTop: "1px solid #edf2f7" }}>{row.sent}</td>
                    <td style={{ padding: "12px 0", borderTop: "1px solid #edf2f7" }}><span style={{ background: "#eef2ff", color: "#4f6df5", borderRadius: 999, padding: "2px 8px", fontSize: 11 }}>{row.delivered}</span></td>
                    <td style={{ padding: "12px 0", borderTop: "1px solid #edf2f7" }}>{row.opened}</td>
                    <td style={{ padding: "12px 0", borderTop: "1px solid #edf2f7" }}><span style={{ background: "#dcfce7", color: "#10b981", borderRadius: 999, padding: "2px 8px", fontSize: 11 }}>{row.responded}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ background: "#fff", border: "1px solid #d9e4f5", borderRadius: 14, padding: 16 }}>
            <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 14 }}>Reminder Status</div>
            <div style={{ display: "grid", gap: 10 }}>
              {outreachReminderRows.length ? outreachReminderRows.map(row => (
                <div key={row.label} style={{ background: row.bg, border: `1px solid ${row.tone}33`, borderRadius: 12, padding: "12px 14px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontWeight: 400, color: "#1e293b" }}>{normalizeReminderText(row.label)}</span>
                  <span style={{ color: row.tone, fontSize: 11, fontWeight: 700, background: "#fff", borderRadius: 999, padding: "4px 10px" }}>{normalizeReminderText(row.status)}</span>
                </div>
              )) : (
                <div style={{ color: "#7c8aa5", fontSize: 12 }}>No reminder activity found.</div>
              )}
            </div>
          </div>
        </div>

        <div style={{ background: "#fff", border: "1px solid #d9e4f5", borderRadius: 14, padding: 16, marginBottom: 18,}}>
          <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 14 }}>Screening Progress</div>
          <div style={{ display: "grid", gap: 14 }}>
            {outreachScreeningSections.map(section => {
              const maxValue = Math.max(...section.rows.map(row => row.value), 1);
              return (
                <div key={section.title} style={{ border: `1px solid ${section.accent}55`, borderRadius: 14, padding: 14,}}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10,width: "100%", }}>
                    <div style={{ fontWeight: 500 }}>{section.title}</div>
                  </div>
                  {section.rows.map(row => (
                    <div key={row.label} style={{ display: "grid", gridTemplateColumns: "90px 1fr 28px", alignItems: "center", gap: 8, marginBottom: 8 }}>
                      <span style={{ color: row.color, fontWeight: row.label.includes("Passed") ? 700 : 500 }}>{row.label}</span>
                      <div style={{ height: 6, borderRadius: 999, background: "#e9eef8", overflow: "hidden" }}>
                        <div style={{ width: `${(row.value / maxValue) * 100}%`, height: "100%", background: row.color, borderRadius: 999 }} />
                      </div>
                      <span style={{ color: row.color, fontWeight: 700 }}>{row.value}</span>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
          {/* <div style={{ marginTop: 14, background: "#ecfdf5", border: "1px solid #a7f3d0", borderRadius: 12, padding: "12px 14px", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
            <span style={{ color: "#059669", fontWeight: 450 }}>{outreachFooterStats.s2Passed} candidates cleared both screenings and are ready for the next round.</span>
            <button className="bo-btn-primary" style={{ background: "#d1fae5", color: "#059669", border: "1px solid #86efac" }}>Schedule Interview Rounds</button>
          </div> */}
        </div>

        <div style={{ background: "#fff", border: "1px solid #d9e4f5", borderRadius: 14, overflow: "hidden" }}>
          <div style={{ padding: 16, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "nowrap", whiteSpace: "nowrap", borderBottom: "1px solid #e6edf8" }}>
            <div style={{ fontSize: 14, fontWeight: 700 }}>
              All Candidates - Consent & Screening Tracker
            </div>
{/* 
            <div style={{ display: "flex", gap: 10, flexWrap: "nowrap" }}>
              <button className="bo-btn-secondary" onClick={exportOutreachResultsToExcel}>Export</button>
              <button className="bo-btn-secondary" style={{ borderColor: "#f7c873", color: "#d97706" }}>
                Send Bulk Reminder
              </button>
            </div> */}
          </div>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", minWidth: 980 }}>
              <thead style={{ background: "#fbfdff" }}>
                  <tr>
                  {["Candidate", "Email", "Phone", "Email", "WhatsApp",  "Reminders", "Consent", , "Screening", "Action"].map(head => (
                    <th key={head} style={{ padding: "14px 16px", textAlign: "left", fontSize: 11, textTransform: "uppercase", color: "#8da0c2", borderBottom: "1px solid #edf2f7" }}>{head}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                {outreachTrackerRows.length ? outreachTrackerRows.map(row => (
                      <tr key={`${row.email}-${row.name}`}>
                    <td style={{ padding: "14px 16px", borderBottom: "1px solid #edf2f7", fontWeight: 400, color: "#0f172a" }}>{cleanOutreachValue(row.name)}</td>
                    <td style={{ padding: "14px 16px", borderBottom: "1px solid #edf2f7", color: "#7c8aa5" }}>{cleanOutreachValue(row.email)}</td>
                    <td style={{ padding: "14px 16px", borderBottom: "1px solid #edf2f7", color: "#7c8aa5" }}>{cleanOutreachValue(row.phone)}</td>
                    <td style={{ padding: "14px 16px", borderBottom: "1px solid #edf2f7" }}>{cleanOutreachValue(row.emailStatus)}</td>
                    <td style={{ padding: "14px 16px", borderBottom: "1px solid #edf2f7" }}>{cleanOutreachValue(row.whatsappStatus)}</td>
                    {/* <td style={{ padding: "14px 16px", borderBottom: "1px solid #edf2f7" }}>{row.smsStatus}</td> */}
                    <td style={{ padding: "14px 16px", borderBottom: "1px solid #edf2f7" }}>{row.reminders}</td>
                    <td style={{ padding: "14px 16px", borderBottom: "1px solid #edf2f7" }}><span style={{ background: row.consent.bg, color: row.consent.color, borderRadius: 999, padding: "6px 12px", fontWeight: 700, fontSize: 11 }}>{cleanOutreachValue(row.consent.text)}</span></td>
                    {/* <td style={{ padding: "14px 16px", borderBottom: "1px solid #edf2f7" }}><span style={{ background: row.s1.bg, color: row.s1.color, borderRadius: 999, padding: "6px 12px", fontWeight: 700, fontSize: 11 }}>{cleanOutreachValue(row.s1.text)}</span></td> */}
                    <td style={{ padding: "14px 16px", borderBottom: "1px solid #edf2f7" }}><span style={{ background: row.s2.bg, color: row.s2.color, borderRadius: 999, padding: "6px 12px", fontWeight: 700, fontSize: 11 }}>{cleanOutreachValue(row.s2.text)}</span></td>
                    <td style={{ padding: "14px 16px", borderBottom: "1px solid #edf2f7", color: "#7c8aa5" }}>{cleanOutreachValue(row.action)}</td>
                      </tr>
                )) : (
                    <tr>
                    <td colSpan={11} style={{ padding: "20px 16px", textAlign: "center", color: "#7c8aa5" }}>No candidate analytics found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          {/* <div style={{ padding: 16, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap", color: "#7c8aa5", fontSize: 12 }}>
            <div>
              Showing {outreachTrackerRows.length} of {outreachFooterStats.total}   <span style={{ color: "#10b981", fontWeight: 700 }}>{outreachFooterStats.accepted} Accepted</span>   <span style={{ color: "#ef4444", fontWeight: 700 }}>{outreachFooterStats.declined} Declined</span>   <span style={{ color: "#f59e0b", fontWeight: 700 }}>{outreachFooterStats.pending} Pending</span>   <span style={{ color: "#4f6df5", fontWeight: 700 }}>{outreachFooterStats.s1Passed} S1 Passed</span>   <span style={{ color: "#8b5cf6", fontWeight: 700 }}>{outreachFooterStats.s2Passed} S2 Passed</span>
            </div>
          </div> */}
        </div>
      </div>
    )}
  </ModalBody>
  <ModalFooter style={{ justifyContent: "center", gap: 12 }}>
    <button className="bo-btn-secondary" onClick={() => setShowOutreachResultsModal(false)}>Close</button>
    {/* <button className="bo-btn-secondary" onClick={exportOutreachResultsToExcel} disabled={outreachAnalyticsLoading || !outreachAnalytics}>Export Full Report</button> */}
    {/* <button className="bo-btn-primary" style={{ background: "#d1fae5", color: "#059669", border: "1px solid #86efac" }}>Schedule AI Calls for {outreachFooterStats.accepted} Accepted</button> */}
  </ModalFooter>
</Modal>
<Modal
  isOpen={pipelineLogsModal}
  toggle={() => setPipelineLogsModal(false)}
  centered
  size="lg"
>
  <ModalHeader
    toggle={() => setPipelineLogsModal(false)}
    style={{
      border: "none",
      background: "linear-gradient(135deg, #eef2ff, #f5f3ff)",
      borderRadius: "0.3rem 0.3rem 0 0",
    }}
  >
    <div style={{ display: "grid", gridTemplateColumns: "minmax(0, 1fr) auto", alignItems: "center", gap: 18, width: "100%", paddingRight: 38 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
        {pipelineLogsCandidate && (
          <div
            style={{
              width: 42,
              height: 42,
              borderRadius: "50%",
              background: getCandidateInitialColor(pipelineLogsCandidate).background,
              border: `1px solid ${getCandidateInitialColor(pipelineLogsCandidate).border}`,
              color: getCandidateInitialColor(pipelineLogsCandidate).color,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 800,
              fontSize: 15,
              boxShadow: "0 8px 18px rgba(79, 70, 229, 0.18)",
              flex: "0 0 auto",
            }}
          >
            {getCandidateInitials(pipelineLogsCandidate) || "C"}
          </div>
        )}
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              color: "#64748b",
              fontSize: 12,
              fontWeight: 700,
              lineHeight: 1.2,
              marginBottom: 3,
            }}
          >
            Pipeline History
          </div>
          <div
            style={{
              fontWeight: 800,
              color: "#0f172a",
              fontSize: 18,
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={pipelineLogsCandidate ? getCandidateFullName(pipelineLogsCandidate) : ""}
          >
            {pipelineLogsCandidate ? getCandidateFullName(pipelineLogsCandidate) : ""}
          </div>
        </div>
      </div>
    </div>
  </ModalHeader>
  <ModalBody style={{ maxHeight: "70vh", overflowY: "auto", background: "#fbfbfe" }}>
    <PipelineHistoryTimeline
      items={(pipelineLogsCandidate?.pipeline_logs || []).map(log => ({
        ...log,
        rejected_round: log.rejected_round || pipelineLogsCandidate?.rejected_round,
        jobTitle: log.jobTitle || log.job_title || pipelineLogsCandidate?.job_title || selectedJobDetails?.job_title || "-",
      }))}
      emptyMessage="No pipeline history available."
    />
    <div style={{ display: "none" }}>
    {pipelineLogsCandidate &&
    Array.isArray(pipelineLogsCandidate.pipeline_logs) &&
    pipelineLogsCandidate.pipeline_logs.length > 0 ? (
      <div style={{ position: "relative", paddingLeft: 28 }}>
        <div
          style={{
            position: "absolute",
            left: 10,
            top: 8,
            bottom: 8,
            width: 2,
            background: "#e2e8f0",
          }}
        />
        {pipelineLogsCandidate.pipeline_logs.map((log, idx) => {
  const isLast = idx === pipelineLogsCandidate.pipeline_logs.length - 1;

  const stage = log.to_stage?.toLowerCase();

  const bgColor =
    stage === "offered"
      ? "#dcfce7"
      : stage === "rejected"
      ? "#fee2e2"
      : stage === "interview"
      ? "#dbeafe"
      : "#eef2ff";

  const textColor =
    stage === "offered"
      ? "#166534"
      : stage === "rejected"
      ? "#991b1b"
      : stage === "interview"
      ? "#1d4ed8"
      : "#4338ca";

  return (
    <div key={idx} style={{ position: "relative", marginBottom: 16 }}>
      
      {/* Timeline Dot */}
      <div
        style={{
          position: "absolute",
          left: -22,
          top: 12,
          width: 12,
          height: 12,
          borderRadius: "50%",
          background: isLast ? "#22c55e" : "#6366f1", // green for current
          border: "2px solid #fff",
          boxShadow: "0 0 0 2px #6366f133",
        }}
      />

      {/* Card */}
      <div
        style={{
          background: isLast ? "#ecfdf5" : "#f8fafc",
          border: isLast ? "1px solid #22c55e" : "1px solid #e2e8f0",
          borderRadius: 8,
          padding: "10px 14px",
        }}
      >
        {/* Header Row */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 6,
            marginBottom: 4,
          }}
        >
          {/* Stage Badge */}
          <span
            style={{
              background: bgColor,
              color: isLast ? "#16a34a" : textColor, // ✅ fix here
              borderRadius: 999,
              padding: "2px 10px",
              fontSize: 12,
              fontWeight: 600,
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
            }}
          >
            {isLast ? (
              <>
                <span style={{ opacity: 0.8 }}>Current Stage :</span>
                <span style={{ fontWeight: 700 }}>
                  {log.to_stage || "--"}
                </span>
              </>
            ) : (
              log.to_stage || "--"
            )}
          </span>

          {/* Time */}
          <span style={{ fontSize: 11, color: "#000" }}>
            {log.updated_at || "--"}
          </span>
        </div>

        {/* Reason */}
        {log.reason && (
          <div style={{ fontSize: 13, color: "#0f172a", marginTop: 8, lineHeight: 1.45 }}>
            <strong style={{ color: "#334155", fontWeight: 800 }}>Reason:</strong>{" "}
            <span style={{ fontWeight: 600 }}>{log.reason}</span>
          </div>
        )}

        {/* Updated By */}
        <div style={{ fontSize: 13, color: "#0f172a", marginTop: 6, lineHeight: 1.45 }}>
          <strong style={{ color: "#334155", fontWeight: 800 }}>Updated By:</strong>{" "}
          <span style={{ fontWeight: 600 }}>{log.updated_by || "--"}</span>
        </div>
      </div>
    </div>
  );
})}
      </div>
    ) : (
      <p className="text-muted text-center py-3 mb-0">
        No pipeline history available.
      </p>
    )}
    </div>
  </ModalBody>
  <ModalFooter className="justify-content-center">
    <Button
      style={{ background: "#4f46e5", border: "none", borderRadius: 10, padding: "0.45rem 1.35rem" }}
      onClick={() => setPipelineLogsModal(false)}
    >
      Close
    </Button>
  </ModalFooter>
</Modal>
      <Modal
  isOpen={ViewCandidatePopupShow}
  toggle={() => setViewCandidatePopupShow(false)}
  size="xl"
  centered
  className="candidate-modal"
  style={{ maxWidth: "96vw", width: "96vw" }}
  >
  {/* HEADER */}
  <ModalHeader
    toggle={() => setViewCandidatePopupShow(false)}
    style={{
      border: "none",
      paddingBottom: 12,
      background: "linear-gradient(135deg, #eef2ff, #f5f3ff)",
      borderRadius: "0.3rem 0.3rem 0 0",
    }}
  >
    <div className="d-flex align-items-center gap-3">
      <div
        style={{
          width: 40,
          height: 40,
          borderRadius: "50%",
          background: "linear-gradient(135deg, #6366f1, #7c3aed)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 700,
          fontSize: 13,
          color: "#fff",
          boxShadow: "0 6px 14px rgba(99,102,241,0.35)",
        }}
      >
        {selectedCandidate?.first_name?.[0]}
        {selectedCandidate?.last_name?.[0]}
      </div>

      <div>
        <h5 className="mb-0" style={{ fontWeight: 700, color: "#0f172a", fontSize: 16, lineHeight: 1.25 }}>
          {selectedCandidate?.first_name}{" "}
          {selectedCandidate?.middle_name || ""}{" "}
          {selectedCandidate?.last_name}
        </h5>
        <small style={{ color: "#64748b", fontSize: 12.5, lineHeight: 1.35 }}>
          {/* {selectedCandidate?.current_company || "—"} ·{" "} */}
          {selectedCandidate?.total_experience} Years Experience
        </small>
      </div>
    </div>
  </ModalHeader>

  {/* BODY */}
  <ModalBody className="p-0 d-flex flex-column" style={{ flex: 1 }}>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "0.65fr 1.85fr",
        height: "100%",
      }}
    >
      {/* LEFT PANEL */}
      <div className="ats-candidate-detail-side" style={{ borderRight: "1px solid #e6e9f0" }}>
        <div
          className="ats-candidate-detail-switch"
          style={{
            display: "flex",
            gap: 6,
            padding: 14,
            background: "#f1f5f9",
            margin: 14,
            borderRadius: 10,
          }}
        >
          <button
            type="button"
            className={candidateDetailPanel === "contact" ? "active" : ""}
            onClick={() => setCandidateDetailPanel("contact")}
            style={{
              flex: 1,
              border: "none",
              borderRadius: 8,
              padding: "8px 10px",
              fontSize: 13,
              fontWeight: 600,
              cursor: "pointer",
              background: candidateDetailPanel === "contact" ? "#fff" : "transparent",
              color: candidateDetailPanel === "contact" ? "#4f46e5" : "#64748b",
              boxShadow: candidateDetailPanel === "contact" ? "0 2px 10px rgba(15, 23, 42, 0.06)" : "none",
            }}
          >
            Contact & History
          </button>
          <button
            type="button"
            className={candidateDetailPanel === "skills" ? "active" : ""}
            onClick={() => setCandidateDetailPanel("skills")}
            style={{
              flex: 1,
              border: "none",
              borderRadius: 8,
              padding: "8px 10px",
              fontSize: 13,
              fontWeight: 600,
              cursor: "pointer",
              background: candidateDetailPanel === "skills" ? "#fff" : "transparent",
              color: candidateDetailPanel === "skills" ? "#4f46e5" : "#64748b",
              boxShadow: candidateDetailPanel === "skills" ? "0 2px 10px rgba(15, 23, 42, 0.06)" : "none",
            }}
          >
            Skills
          </button>
        </div>
        <div className="ats-candidate-detail-content" style={{ padding: "0 18px 18px" }}>
        {/* Contact */}
        {candidateDetailPanel === "contact" && (
          <section style={sectionDivider}>
            <p style={sectionLabel}>Contact</p>

            <div className="d-flex flex-column gap-2">
              {[
                { Icon: FiMail, val: selectedCandidate?.email },
                { Icon: FiPhone, val: selectedCandidate?.mobile_phone },
                {
                  Icon: FiBriefcase,
                  val: `${selectedCandidate?.total_experience || 0} Years Total Experience`,
                },
              ].map(({ Icon, val }, index) => (
                <div key={index} className="d-flex align-items-center gap-2">
                  <Icon
                    size={16}
                    color="#4f46e5"
                    className="candidate-contact-icon"
                    style={{ minWidth: 16, color: "#4f46e5", stroke: "#4f46e5" }}
                  />
                  <span>{val || "—"}</span>
                </div>
              ))}
            </div>
          </section>
        )}
        {/* Skills */}
        {candidateDetailPanel === "skills" && (
        <>
        <section style={sectionDivider}>
          <p style={sectionLabel}>Primary skills</p>
          <div className="d-flex flex-wrap gap-2">
            {selectedPrimarySkills.length > 0
              ? selectedPrimarySkills.map((s, i) => (
                  <SkillPill key={i} label={s} color="blue" />
                ))
              : "—"}
          </div>
        </section>

        <section style={sectionDivider}>
          <p style={sectionLabel}>Secondary skills</p>
          <div className="d-flex flex-wrap gap-2">
            {selectedSecondarySkills.length > 0
              ? selectedSecondarySkills.map((s, i) => (
                  <SkillPill key={i} label={s} color="teal" />
                ))
              : "—"}
          </div>
        </section>

        <section style={sectionDivider}>
          <p style={sectionLabel}>Other skills</p>
          <div className="d-flex flex-wrap gap-2">
            {selectedOtherSkills.length > 0
              ? selectedOtherSkills.map((s, i) => (
                  <SkillPill key={i} label={s} color="gray" />
                ))
              : "—"}
          </div>
        </section>
        </>
        )}

        {/* History */}
        {candidateDetailPanel === "contact" && (
        <>
        <section style={sectionDivider}>
          <p style={sectionLabel}>Education</p>
          {renderCandidateHistoryItems(selectedEducationHistory, "education")}
        </section>

        <section style={sectionDivider}>
          <p style={sectionLabel}>Employment</p>
          {renderCandidateHistoryItems(selectedEmploymentHistory, "employment")}
        </section>

        <section style={sectionDivider}>
          <p style={sectionLabel}>Certificates</p>
          {renderCandidateHistoryItems(
            selectedCertificateHistory,
            "certificates"
          )}
        </section>
        </>
        )}
        </div>
      </div>

      {/* RIGHT PANEL */}
      <ResumePreviewPanel resumeUrl={selectedCandidate?.resume} minHeight="100%" />
    </div>
  </ModalBody>

  {/* FOOTER */}
  <ModalFooter
    className="border-0"
    style={{
      padding: "0.75rem 1.5rem",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <div style={{ fontSize: 13, color: "#718096" }}>
      {viewCandidateIndex !== null && viewCandidateJobId !== null && (
        <>
          {viewCandidateIndex + 1} / {(candidateDataMap[viewCandidateJobId] ?? []).length}
        </>
      )}
    </div>
    <div style={{ display: "flex", gap: 4,justifyContent: "center",alignItems:"center",width:"100%",margin: "0 auto",}}>
      <Button
        color="secondary"
       className="btn btn-sm px-4 blueBtn"
        disabled={viewCandidateIndex === null || viewCandidateIndex === 0}
        onClick={() => {
          const candidates = candidateDataMap[viewCandidateJobId] ?? []
          const prevIndex = viewCandidateIndex - 1
          if (prevIndex >= 0) {
            setSelectedCandidate(candidates[prevIndex])
            setViewCandidateIndex(prevIndex)
            setJobCandidateDetailsTab("skills")
            setCandidateDetailPanel("contact")
          }
        }}
      >
        ← Prev
      </Button>
       <Button
        color="secondary"
        className=" btn btn-sm px-4 blueBtn"
        onClick={() => setViewCandidatePopupShow(false)}
      >
        Close
      </Button>
      <Button
        color="secondary"
        className="btn btn-sm px-4 blueBtn"
        disabled={
          viewCandidateIndex === null ||
          viewCandidateIndex >= (candidateDataMap[viewCandidateJobId] ?? []).length - 1
        }
        onClick={() => {
          const candidates = candidateDataMap[viewCandidateJobId] ?? []
          const nextIndex = viewCandidateIndex + 1
          if (nextIndex < candidates.length) {
            setSelectedCandidate(candidates[nextIndex])
            setViewCandidateIndex(nextIndex)
            setJobCandidateDetailsTab("skills")
            setCandidateDetailPanel("contact")
          }
        }}
      >
        Next →
      </Button>
    </div>
  </ModalFooter>
</Modal>
<TestResultsModal />
<JobScreeningResultsModal
  show={screeningResultsModal}
  onClose={() => setScreeningResultsModal(false)}
  job={screeningResultsJob}
  companyId={companyId}
/>
<Modal
  isOpen={offerLetterModal}
  toggle={!isSendingOfferLetter ? closeOfferLetterModal : undefined}
  centered
  size="xl"
  backdrop={isSendingOfferLetter ? "static" : true}
   className="offer-letter-modal"
   id="OfferLetterModal"
>
  <ModalHeader
    toggle={!isSendingOfferLetter ? closeOfferLetterModal : undefined}
    style={{
      background: "#12395c",
      color: "#fff",
      borderBottom: "none",
      padding: "16px 20px",
    }}
  >
    <div>
      <div style={{ fontSize: 17, fontWeight: 700, lineHeight: 1.2 }}>
       Send Offer Letter — {offerLetterJob?.position_name || offerLetterJob?.job_title || ""}
      </div>
      <div style={{ fontSize: 12, fontWeight: 400, opacity: 0.82, marginTop: 3 }}>
        Review recipient details before sending
      </div>
    </div>
  </ModalHeader>

  <ModalBody style={{ background: "#f6f8fb", padding: 20 }}>
    <div
      style={{
        background: "#fff",
        border: "1px solid #dbe4ef",
        borderRadius: 8,
        // height: "80vh",
        overflowY: "auto",
        padding: 20,
      }}
    >
      <Row className="g-3">
        <Col md={6}>
        <Label className="fw-semibold mb-1">Designation</Label>
        <Input
          value={offerLetterJob?.position_name || offerLetterJob?.job_title || ""}
          readOnly
          disabled
          style={{
            background: "#f1f5f9",
            borderColor: "#cbd5e1",
            borderRadius: 6,
            fontSize: 13,
            color: "#64748b",
            cursor: "not-allowed",
          }}
        />
      </Col>
      <Col md={6}>
        <Label className="fw-semibold mb-1">From</Label>
        <Input
          value={userInfos?.user_details?.email || ""}
          readOnly
          disabled
          style={{
            background: "#f1f5f9",
            borderColor: "#cbd5e1",
            borderRadius: 6,
            fontSize: 13,
            color: "#64748b",
            cursor: "not-allowed",
          }}
        />
      </Col>
       <Col md={6}>
  <Label className="fw-semibold mb-1">
    To (Primary Email) <span className="text-danger">*</span>
  </Label>
  <Input
    type="email"
    value={offerLetterCandidate?.email || offerLetterCandidate?.candidate_email || ""}
    readOnly
    style={{
      background: "#f1f5f9",
      borderColor: "#cbd5e1",
      borderRadius: 6,
      fontSize: 13,
      fontWeight: 600,
      color: "#0f172a",
    }}
  />
</Col>
        <Col md={6}>
          <Label className="fw-semibold mb-1">CC</Label>
          <Input
            placeholder="name@company.com, hr@company.com"
            value={offerLetterCC}
            onChange={handleOfferLetterCCChange}
            style={{ borderRadius: 6, fontSize: 13 }}
          />
        </Col>
        <Col md={12}>
          <Label className="fw-semibold mb-1">
            Subject <span className="text-danger">*</span>
          </Label>
          <Input
            value={offerLetterSubject}
            onChange={handleOfferLetterSubjectChange}
            style={{ borderRadius: 6, fontSize: 13 }}
          />
        </Col>
        <Col md={12}>
          <Label className="fw-semibold mb-1">
            Offer Letter <span className="text-danger">*</span>
          </Label>
          <OfferLetterEditor
            value={offerLetterContent}
            onChange={setOfferLetterContent}
          />
        </Col>
      </Row>
    </div>
  </ModalBody>

  <ModalFooter style={{ padding: "14px 20px", borderTop: "1px solid #e2e8f0", background: "#fff",justifyContent:"center" }}>

    {/* CANCEL */}
    <Button
      outline
      color="secondary"
      disabled={isSendingOfferLetter}
      style={{ borderRadius: 6, minWidth: 92 }}
      onClick={() => {
        setOfferLetterModal(false);
        setOfferLetterCandidate(null);
        setOfferLetterJob(null);
        setOfferLetterContent("");
        setOfferLetterSubject(""); // ✅ FIXED
        setOfferLetterCC("");
      }}
    >
      Cancel
    </Button>

    {/* SEND */}
    <Button
      style={{
        background: "#0b5cab",
        border: "none",
        borderRadius: 6,
        padding: "9px 22px",
        fontWeight: 700,
        minWidth: 140,
      }}
      disabled={isSendingOfferLetter}
      onClick={handleSendOfferLetter}
    >
      {isSendingOfferLetter ? (
        <>
          <Spinner size="sm" className="me-2" />
          Sending
        </>
      ) : (
        "Send Offer Letter"
      )}
    </Button>

  </ModalFooter>
</Modal>
<Modal
  isOpen={showFeedbackModal}
  toggle={() => setShowFeedbackModal(false)}
  centered
  size="lg"
>
  <ModalHeader
    toggle={() => setShowFeedbackModal(false)}
    className="feedback-panel-modal-header"
    style={{
      border: "none",
      background: "#12395c",
      color: "#fff",
      padding: "16px 20px",
    }}
  >
    <div className="feedback-panel-modal-title">
      <span
        style={{
          width: 38,
          height: 38,
          borderRadius: 8,
          background: "rgba(255,255,255,0.14)",
          color: "#fff",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <MdRateReview size={18}/>
      </span>
      <div style={{ minWidth: 0, flex: "1 1 auto", maxWidth: "100%" }}>
        <div style={{ fontWeight: 700, fontSize: 16, lineHeight: 1.2 }}>
          Panel Feedback
        </div>
        <div
          style={{
            fontSize: 12,
            fontWeight: 400,
            opacity: 0.82,
            marginTop: 3,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%",
            width: "calc(100% - 12px)",
            display: "block",
          }}
          title={[
            selectedFeedback?.candidate_name?.trim() || "Candidate",
            ...getFeedbackPanelNames(selectedFeedback?.feedbacks),
          ].join(" | ")}
        >
          {(() => {
            const panelNames = getFeedbackPanelNames(selectedFeedback?.feedbacks)
            const candidateName = selectedFeedback?.candidate_name?.trim() || "Candidate"
            const panelTitle = panelNames.length ? `Panel Name : ${panelNames.join(", ")}` : ""

            return (
              <span style={{ display: "flex", alignItems: "center", gap: 4, minWidth: 0, width: "100%" }}>
                <span style={{ flex: "0 0 auto" }}>Candidate Name : {candidateName}</span>
                {panelNames.length ? (
                  <>
                    <span style={{ flex: "0 0 auto" }}>|</span>
                    <span
                      title={panelTitle}
                      style={{
                        minWidth: 0,
                        flex: "1 1 auto",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "block",
                      }}
                    >
                      {panelTitle}
                    </span>
                  </>
                ) : null}
              </span>
            )
          })()}
        </div>
      </div>
    </div>
  </ModalHeader>

  <ModalBody style={{ background: "#f6f8fb", padding: 18, maxHeight: "70vh", overflowY: "auto" }}>
    {selectedFeedback?.feedbacks?.length ? (
      <div style={{ display: "grid", gap: 14 }}>
        {selectedFeedback.feedbacks.map((item, index) => {
          const recommendation = getRecommendationLabel(
            item.recommendation_display || item.recommendation
          )
          const submittedBy = getFeedbackSubmittedBy(item)
          const interviewDateTime = [
            formatFeedbackDate(item.interview_date),
            item.start_time && item.end_time ? `${item.start_time} - ${item.end_time}` : item.start_time || item.end_time || "",
          ].filter(Boolean).join(" | ")

          return (
            <div
              key={item.feedback_id || index}
              style={{
                background: "#fff",
                border: "1px solid #dbe4ef",
                borderRadius: 8,
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  gap: 12,
                  padding: "14px 16px",
                  borderBottom: "1px solid #e5edf6",
                }}
              >
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: "#0f172a" }}>
                    Panel Name : {item.panel_name || "Panel Member"}
                  </div>
                  <div style={{ fontSize: 12, color: "#64748b", marginTop: 3 }}>
                    Panel Email : {item.panel_email || "--"}
                  </div>
                </div>
                <span
                  style={{
                    border: "1px solid #b7d4ec",
                    background: "#e8f2fb",
                    color: "#145b84",
                    borderRadius: 999,
                    padding: "4px 10px",
                    fontSize: 12,
                    fontWeight: 700,
                    whiteSpace: "nowrap",
                  }}
                >
                  {recommendation}
                </span>
              </div>

              <div style={{ padding: 16 }}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
                    gap: 12,
                    marginBottom: 14,
                  }}
                >
                  <div>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700, textTransform: "uppercase" }}>
                      Submitted By
                    </div>
                    <div style={{ fontSize: 13, color: "#0f172a", marginTop: 4, fontWeight: 600 }}>
                      {submittedBy}
                    </div>
                    {item.panel_email ? (
                      <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>
                        Panel Email : {item.panel_email}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700, textTransform: "uppercase" }}>
                      Submitted At
                    </div>
                    <div style={{ fontSize: 13, color: "#0f172a", marginTop: 4 }}>
                      {formatFeedbackDateTime(item.submitted_at)}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700, textTransform: "uppercase" }}>
                      Interview Date & Time
                    </div>
                    <div style={{ fontSize: 13, color: "#0f172a", marginTop: 4 }}>
                      {interviewDateTime || "--"}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700, textTransform: "uppercase" }}>
                      Rating
                    </div>
                    <div style={{ fontSize: 13, color: "#0f172a", marginTop: 4 }}>
                      {item.rating ? `${item.rating}/5` : "--"}
                    </div>
                  </div>
                   <div>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700, textTransform: "uppercase" }}>
                      Recommendation
                    </div>
                    <div style={{ fontSize: 13, color: "#0f172a", marginTop: 4 }}>
                      {getRecommendationLabel(
                        item.recommendation_display || item.recommendation
                      )}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700, textTransform: "uppercase" }}>
                      Interview Type
                    </div>
                    <div style={{ fontSize: 13, color: "#0f172a", marginTop: 4 }}>
                      {[item.interview_type, item.interview_sub_type].filter(Boolean).join(" / ") || "--"}
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    border: "1px solid #e2e8f0",
                    borderRadius: 8,
                    background: "#f8fafc",
                    padding: "12px 14px",
                    minWidth: 0,
                    maxWidth: "100%",
                    overflow: "hidden",
                  }}
                >
                  <div style={{ fontSize: 11, color: "#64748b", fontWeight: 700, textTransform: "uppercase", marginBottom: 6 }}>
                    Feedback
                  </div>
                  <div
                    style={{
                      fontSize: 13,
                      color: "#0f172a",
                      whiteSpace: "pre-wrap",
                      overflowWrap: "anywhere",
                      wordBreak: "break-word",
                      lineHeight: 1.55,
                    }}
                  >
                    {item.feedback || item.feedback_notes || "--"}
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    ) : (
      <p className="text-center text-muted mb-0 py-3">No feedback available.</p>
    )}
  </ModalBody>

  <ModalFooter style={{ borderTop: "1px solid #e2e8f0", justifyContent: "center" }}>
    <Button className="btn blueBtn" onClick={() => setShowFeedbackModal(false)}>
      Close
    </Button>
  </ModalFooter>
</Modal>
      <Modal
        isOpen={questionReviewHistoryModal.open}
        toggle={() => setQuestionReviewHistoryModal(prev => ({ ...prev, open: false }))}
        centered
        size="lg"
      >
        <ModalHeader
          toggle={() => setQuestionReviewHistoryModal(prev => ({ ...prev, open: false }))}
          className="modal-header_box blueBtn d-flex justify-content-between m-0 modal-header"
        >
          Question Review History
        </ModalHeader>
        <ModalBody style={{ background: "#f8fafc", maxHeight: "70vh", overflowY: "auto" }}>
          {questionReviewHistoryModal.loading ? (
            <div className="text-center text-muted py-4">Loading question review history...</div>
          ) : questionReviewHistoryModal.error ? (
            <div className="alert alert-danger mb-0">{questionReviewHistoryModal.error}</div>
          ) : !questionReviewHistoryModal.records.length ? (
            <p className="text-center text-muted py-4 mb-0">No review history available.</p>
          ) : (
            <div style={{ display: "grid", gap: 12 }}>
              {questionReviewHistoryModal.records.map((record, index) => {
                const details = record?.details || {};
                const sentBy = record?.sent_by || {};
                const approvedBy = record?.approved_by || null;
                const sentAt = record?.sent_at;
                const approvedAt = record?.approved_at;
                const recordedAt = sentAt || approvedAt;
                const formatHistoryTime = value => value ? new Date(value).toLocaleString() : "--";
                const screeningSections = getReviewQuestionSections(record, "screening");
                const talentScanSections = getReviewQuestionSections(record, "talent");
                const screeningCount = record?.screening_question_count ?? record?.screening_questions_count ?? record?.screening_count ?? details?.screening_question_count ?? details?.screening_questions_count ?? (screeningSections.length ? screeningSections.reduce((total, section) => total + section.questions.length, 0) : null);
                const talentScanCount = record?.talent_scan_question_count ?? record?.talentscan_question_count ?? record?.talent_scan_questions_count ?? record?.talent_scan_count ?? details?.talent_scan_question_count ?? details?.talentscan_question_count ?? details?.talent_scan_questions_count ?? (talentScanSections.length ? talentScanSections.reduce((total, section) => total + section.questions.length, 0) : null);
                return (
                  <div key={`${recordedAt || "history"}-${index}`} style={{ background: "#fff", border: "1px solid #dbe4ef", borderRadius: 10, padding: "14px 16px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "flex-start", marginBottom: 12 }}>
                      <span style={{ color: "#145b84", fontWeight: 700, fontSize: 15 }}>Review Request</span>
                      <span style={{ color: "#64748b", fontSize: 12, whiteSpace: "nowrap" }}>{formatHistoryTime(recordedAt)}</span>
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 10, fontSize: 13, color: "#334155" }}>
                      <div><strong>Sent by:</strong> {sentBy?.name || "Unknown sender"}</div>
                      {sentBy?.email && <div><strong>Email:</strong> {sentBy.email}</div>}
                      {sentAt && <div><strong>Sent at:</strong> {formatHistoryTime(sentAt)}</div>}
                      {approvedBy && (
                        <>
                          <div style={{ gridColumn: "1 / -1", borderTop: "1px solid #e2e8f0", paddingTop: 10, marginTop: 2 }}>
                            <strong>Approval</strong>
                          </div>
                          <div><strong>Approved by:</strong> {approvedBy.name || "Unknown reviewer"}</div>
                          {approvedBy.email && <div><strong>Email:</strong> {approvedBy.email}</div>}
                          {approvedAt && <div><strong>Approved at:</strong> {formatHistoryTime(approvedAt)}</div>}
                        </>
                      )}
                      {screeningCount !== null && <div><strong>Screening Questions:</strong> {screeningCount}</div>}
                      {talentScanCount !== null && <div><strong>TalentScan Questions:</strong> {talentScanCount}</div>}
                    </div>
                    {screeningSections.length > 0 && (
                      <div style={{ marginTop: 14 }}>
                        <div style={{ color: "#145b84", fontSize: 12, fontWeight: 800, textTransform: "uppercase", marginBottom: 8 }}>
                          Screening Questions Added
                        </div>
                        {screeningSections.map(section => (
                          <div key={section.name} style={{ marginBottom: 10 }}>
                            <div style={{ color: "#334155", fontSize: 13, fontWeight: 700, marginBottom: 4 }}>{section.name}</div>
                            <ol style={{ margin: 0, paddingLeft: 22, color: "#475569", fontSize: 13 }}>
                              {section.questions.map((question, questionIndex) => (
                                <li key={`${section.name}-${questionIndex}`} style={{ marginBottom: 4, lineHeight: 1.45 }}>
                                  {question}
                                </li>
                              ))}
                            </ol>
                          </div>
                        ))}
                      </div>
                    )}
                    {talentScanSections.length > 0 && (
                      <div style={{ marginTop: 14 }}>
                        <div style={{ color: "#145b84", fontSize: 12, fontWeight: 800, textTransform: "uppercase", marginBottom: 8 }}>
                          TalentScan Questions Added
                        </div>
                        {talentScanSections.map(section => (
                          <div key={section.name} style={{ marginBottom: 10 }}>
                            <div style={{ color: "#334155", fontSize: 13, fontWeight: 700, marginBottom: 4 }}>{section.name}</div>
                            <ol style={{ margin: 0, paddingLeft: 22, color: "#475569", fontSize: 13 }}>
                              {section.questions.map((question, questionIndex) => (
                                <li key={`${question.text}-${questionIndex}`} style={{ marginBottom: 8, lineHeight: 1.45 }}>
                                  {question.skill && <div><strong>Skill:</strong> {question.skill}</div>}
                                  {question.level && <div><strong>Level:</strong> {question.level}</div>}
                                  <div><strong>Question:</strong> {question.text}</div>
                                </li>
                              ))}
                            </ol>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <Button className="btn blueBtn" onClick={() => setQuestionReviewHistoryModal(prev => ({ ...prev, open: false }))}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default JobOrdersView







  const ReviewEmployeeOption = props => {
    const { isSelected, label } = props;

    return (
      <components.Option {...props}>
        <div className="d-flex align-items-center gap-2">
          <input type="checkbox" checked={isSelected} readOnly />
          <span>{label}</span>
        </div>
      </components.Option>
    );
  };

  const ReviewEmployeeValueContainer = ({ children, ...props }) => {
    const selectedValues = props.getValue();
    const selectedCount = selectedValues.length;
    const selectedLabels = selectedValues.map(option => option.label).join(", ");
    const childArray = Array.isArray(children) ? children : [children];
    const inputChild = childArray[1] || null;

    if (!selectedCount) {
      return (
        <components.ValueContainer {...props}>
          {children}
        </components.ValueContainer>
      );
    }

    return (
      <components.ValueContainer {...props}>
        <span
          title={selectedLabels}
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "4px 10px",
            borderRadius: 999,
            background: "#e8f1ff",
            color: "#145b84",
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1.2,
          }}
        >
          {`${selectedCount} item${selectedCount > 1 ? "s" : ""} selected`}
        </span>
        {inputChild}
      </components.ValueContainer>
    );
  };
const OfferLetterEditor = ({ value, onChange }) => {
  return (
    <div style={{
      border: "1px solid #e5e7eb",
      borderRadius: 8,
      overflow: "hidden",
      background: "#fff"
    }}>
      <style>{`
        .sun-editor-editable img,
        .sun-editor-editable img[data-proportion],
        .sun-editor-editable figure img,
        .sun-editor .se-wrapper img,
        .sun-editor img {
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
          background: none !important;
        }
        .sun-editor-editable img.se-image-selected {
          outline: 2px solid #1a5fa8 !important;
          box-shadow: none !important;
        }
        .sun-editor-editable figure {
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
          background: none !important;
          margin: 0 !important;
          padding: 0 !important;
        }
        .sun-editor-editable .se-component {
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
        }
      `}</style>
      <SunEditor
        setContents={value || ""}
        onChange={onChange}
        setOptions={{
          height: 360,
          iframe: false,
          fullPage: false,
          resizingBar: false,
          charCounter: false,
          buttonList: [
            ['undo', 'redo'],
            ['font', 'fontSize', 'formatBlock'],
            ['bold', 'underline', 'italic', 'strike'],
            ['fontColor', 'hiliteColor'],
            ['removeFormat'],
            ['outdent', 'indent'],
            ['align', 'horizontalRule', 'list', 'lineHeight'],
            ['table', 'link', 'image'],
            ['fullScreen', 'showBlocks', 'codeView'],
            ['preview'],
          ],
          defaultStyle: "font-family: Arial, sans-serif; font-size: 14px; line-height: 1.55;",
        }}
      />
    </div>
  );
};
